(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9a70"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9a70"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dPzto", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $a11b8e00a1eb43b5$export$ffb0004e005737fa, (v) => $a11b8e00a1eb43b5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $a11b8e00a1eb43b5$export$34b9dba7ce09269b, (v) => $a11b8e00a1eb43b5$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $a11b8e00a1eb43b5$export$25062201e9e25d76, (v) => $a11b8e00a1eb43b5$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a11b8e00a1eb43b5$export$ffb0004e005737fa;
var $a11b8e00a1eb43b5$export$34b9dba7ce09269b;
var $a11b8e00a1eb43b5$export$25062201e9e25d76;
'use strict';

var $iDiRE = parcelRequire("iDiRE");
var $a11b8e00a1eb43b5$var$k = Symbol.for("react.element"), $a11b8e00a1eb43b5$var$l = Symbol.for("react.fragment"), $a11b8e00a1eb43b5$var$m = Object.prototype.hasOwnProperty, $a11b8e00a1eb43b5$var$n = $iDiRE.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $a11b8e00a1eb43b5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a11b8e00a1eb43b5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$a11b8e00a1eb43b5$var$m.call(a, b) && !$a11b8e00a1eb43b5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $a11b8e00a1eb43b5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $a11b8e00a1eb43b5$var$n.current
    };
}
$a11b8e00a1eb43b5$export$ffb0004e005737fa = $a11b8e00a1eb43b5$var$l;
$a11b8e00a1eb43b5$export$34b9dba7ce09269b = $a11b8e00a1eb43b5$var$q;
$a11b8e00a1eb43b5$export$25062201e9e25d76 = $a11b8e00a1eb43b5$var$q;

});
parcelRegister("iDiRE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1bPle"));

});
parcelRegister("1bPle", function(module, exports) {

$parcel$export(module.exports, "Children", () => $0ddea4e1d711573f$export$dca3b0875bd9a954, (v) => $0ddea4e1d711573f$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $0ddea4e1d711573f$export$16fa2f45be04daa8, (v) => $0ddea4e1d711573f$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $0ddea4e1d711573f$export$ffb0004e005737fa, (v) => $0ddea4e1d711573f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $0ddea4e1d711573f$export$e2c29f18771995cb, (v) => $0ddea4e1d711573f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $0ddea4e1d711573f$export$221d75b3f55bb0bd, (v) => $0ddea4e1d711573f$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $0ddea4e1d711573f$export$5f8d39834fd61797, (v) => $0ddea4e1d711573f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0ddea4e1d711573f$export$74bf444e3cd11ea5, (v) => $0ddea4e1d711573f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0ddea4e1d711573f$export$ae55be85d98224ed, (v) => $0ddea4e1d711573f$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $0ddea4e1d711573f$export$3ba232387fd5d6dd, (v) => $0ddea4e1d711573f$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $0ddea4e1d711573f$export$e530037191fcd5d7, (v) => $0ddea4e1d711573f$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $0ddea4e1d711573f$export$fd42f52fd3ae1109, (v) => $0ddea4e1d711573f$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $0ddea4e1d711573f$export$c8a8987d4410bf2d, (v) => $0ddea4e1d711573f$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $0ddea4e1d711573f$export$d38cd72104c1f0e9, (v) => $0ddea4e1d711573f$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $0ddea4e1d711573f$export$7d1e3a5e95ceca43, (v) => $0ddea4e1d711573f$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $0ddea4e1d711573f$export$257a8862b851cb5b, (v) => $0ddea4e1d711573f$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $0ddea4e1d711573f$export$a8257692ac88316c, (v) => $0ddea4e1d711573f$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $0ddea4e1d711573f$export$488013bae63b21da, (v) => $0ddea4e1d711573f$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $0ddea4e1d711573f$export$7c73462e0d25e514, (v) => $0ddea4e1d711573f$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $0ddea4e1d711573f$export$7568632d0d33d16d, (v) => $0ddea4e1d711573f$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $0ddea4e1d711573f$export$88948ce120ea2619, (v) => $0ddea4e1d711573f$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $0ddea4e1d711573f$export$35808ee640e87ca7, (v) => $0ddea4e1d711573f$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $0ddea4e1d711573f$export$fae74005e78b1a27, (v) => $0ddea4e1d711573f$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $0ddea4e1d711573f$export$dc8fbce3eb94dc1e, (v) => $0ddea4e1d711573f$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $0ddea4e1d711573f$export$6a7bc4e911dc01cf, (v) => $0ddea4e1d711573f$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $0ddea4e1d711573f$export$6d9c69b0de29b591, (v) => $0ddea4e1d711573f$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $0ddea4e1d711573f$export$f680877a34711e37, (v) => $0ddea4e1d711573f$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $0ddea4e1d711573f$export$d5a552a76deda3c2, (v) => $0ddea4e1d711573f$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $0ddea4e1d711573f$export$aaabe4eda9ed9969, (v) => $0ddea4e1d711573f$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $0ddea4e1d711573f$export$e5c5a5f917a5871c, (v) => $0ddea4e1d711573f$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $0ddea4e1d711573f$export$1538c33de8887b59, (v) => $0ddea4e1d711573f$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $0ddea4e1d711573f$export$13e3392192263954, (v) => $0ddea4e1d711573f$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $0ddea4e1d711573f$export$b8f5890fc79d6aca, (v) => $0ddea4e1d711573f$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $0ddea4e1d711573f$export$60241385465d0a34, (v) => $0ddea4e1d711573f$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $0ddea4e1d711573f$export$306c0aa65ff9ec16, (v) => $0ddea4e1d711573f$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $0ddea4e1d711573f$export$7b286972b8d8ccbf, (v) => $0ddea4e1d711573f$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $0ddea4e1d711573f$export$83d89fbfd8236492, (v) => $0ddea4e1d711573f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0ddea4e1d711573f$export$dca3b0875bd9a954;
var $0ddea4e1d711573f$export$16fa2f45be04daa8;
var $0ddea4e1d711573f$export$ffb0004e005737fa;
var $0ddea4e1d711573f$export$e2c29f18771995cb;
var $0ddea4e1d711573f$export$221d75b3f55bb0bd;
var $0ddea4e1d711573f$export$5f8d39834fd61797;
var $0ddea4e1d711573f$export$74bf444e3cd11ea5;
var $0ddea4e1d711573f$export$ae55be85d98224ed;
var $0ddea4e1d711573f$export$3ba232387fd5d6dd;
var $0ddea4e1d711573f$export$e530037191fcd5d7;
var $0ddea4e1d711573f$export$fd42f52fd3ae1109;
var $0ddea4e1d711573f$export$c8a8987d4410bf2d;
var $0ddea4e1d711573f$export$d38cd72104c1f0e9;
var $0ddea4e1d711573f$export$7d1e3a5e95ceca43;
var $0ddea4e1d711573f$export$257a8862b851cb5b;
var $0ddea4e1d711573f$export$a8257692ac88316c;
var $0ddea4e1d711573f$export$488013bae63b21da;
var $0ddea4e1d711573f$export$7c73462e0d25e514;
var $0ddea4e1d711573f$export$7568632d0d33d16d;
var $0ddea4e1d711573f$export$88948ce120ea2619;
var $0ddea4e1d711573f$export$35808ee640e87ca7;
var $0ddea4e1d711573f$export$fae74005e78b1a27;
var $0ddea4e1d711573f$export$dc8fbce3eb94dc1e;
var $0ddea4e1d711573f$export$6a7bc4e911dc01cf;
var $0ddea4e1d711573f$export$6d9c69b0de29b591;
var $0ddea4e1d711573f$export$f680877a34711e37;
var $0ddea4e1d711573f$export$d5a552a76deda3c2;
var $0ddea4e1d711573f$export$aaabe4eda9ed9969;
var $0ddea4e1d711573f$export$e5c5a5f917a5871c;
var $0ddea4e1d711573f$export$1538c33de8887b59;
var $0ddea4e1d711573f$export$13e3392192263954;
var $0ddea4e1d711573f$export$b8f5890fc79d6aca;
var $0ddea4e1d711573f$export$60241385465d0a34;
var $0ddea4e1d711573f$export$306c0aa65ff9ec16;
var $0ddea4e1d711573f$export$7b286972b8d8ccbf;
var $0ddea4e1d711573f$export$83d89fbfd8236492;
'use strict';
var $0ddea4e1d711573f$var$l = Symbol.for("react.element"), $0ddea4e1d711573f$var$n = Symbol.for("react.portal"), $0ddea4e1d711573f$var$p = Symbol.for("react.fragment"), $0ddea4e1d711573f$var$q = Symbol.for("react.strict_mode"), $0ddea4e1d711573f$var$r = Symbol.for("react.profiler"), $0ddea4e1d711573f$var$t = Symbol.for("react.provider"), $0ddea4e1d711573f$var$u = Symbol.for("react.context"), $0ddea4e1d711573f$var$v = Symbol.for("react.forward_ref"), $0ddea4e1d711573f$var$w = Symbol.for("react.suspense"), $0ddea4e1d711573f$var$x = Symbol.for("react.memo"), $0ddea4e1d711573f$var$y = Symbol.for("react.lazy"), $0ddea4e1d711573f$var$z = Symbol.iterator;
function $0ddea4e1d711573f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0ddea4e1d711573f$var$z && a[$0ddea4e1d711573f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0ddea4e1d711573f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0ddea4e1d711573f$var$C = Object.assign, $0ddea4e1d711573f$var$D = {};
function $0ddea4e1d711573f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0ddea4e1d711573f$var$D;
    this.updater = e || $0ddea4e1d711573f$var$B;
}
$0ddea4e1d711573f$var$E.prototype.isReactComponent = {};
$0ddea4e1d711573f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0ddea4e1d711573f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0ddea4e1d711573f$var$F() {}
$0ddea4e1d711573f$var$F.prototype = $0ddea4e1d711573f$var$E.prototype;
function $0ddea4e1d711573f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0ddea4e1d711573f$var$D;
    this.updater = e || $0ddea4e1d711573f$var$B;
}
var $0ddea4e1d711573f$var$H = $0ddea4e1d711573f$var$G.prototype = new $0ddea4e1d711573f$var$F;
$0ddea4e1d711573f$var$H.constructor = $0ddea4e1d711573f$var$G;
$0ddea4e1d711573f$var$C($0ddea4e1d711573f$var$H, $0ddea4e1d711573f$var$E.prototype);
$0ddea4e1d711573f$var$H.isPureReactComponent = !0;
var $0ddea4e1d711573f$var$I = Array.isArray, $0ddea4e1d711573f$var$J = Object.prototype.hasOwnProperty, $0ddea4e1d711573f$var$K = {
    current: null
}, $0ddea4e1d711573f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0ddea4e1d711573f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0ddea4e1d711573f$var$J.call(b, d) && !$0ddea4e1d711573f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0ddea4e1d711573f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0ddea4e1d711573f$var$K.current
    };
}
function $0ddea4e1d711573f$var$N(a, b) {
    return {
        $$typeof: $0ddea4e1d711573f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0ddea4e1d711573f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0ddea4e1d711573f$var$l;
}
function $0ddea4e1d711573f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0ddea4e1d711573f$var$P = /\/+/g;
function $0ddea4e1d711573f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0ddea4e1d711573f$var$escape("" + a.key) : b.toString(36);
}
function $0ddea4e1d711573f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0ddea4e1d711573f$var$l:
                case $0ddea4e1d711573f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0ddea4e1d711573f$var$Q(h, 0) : d, $0ddea4e1d711573f$var$I(c) ? (e = "", null != a && (e = a.replace($0ddea4e1d711573f$var$P, "$&/") + "/"), $0ddea4e1d711573f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0ddea4e1d711573f$var$O(c) && (c = $0ddea4e1d711573f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0ddea4e1d711573f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0ddea4e1d711573f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0ddea4e1d711573f$var$Q(k, g);
        h += $0ddea4e1d711573f$var$R(k, b, e, f, c);
    }
    else if (f = $0ddea4e1d711573f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0ddea4e1d711573f$var$Q(k, g++), h += $0ddea4e1d711573f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0ddea4e1d711573f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0ddea4e1d711573f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0ddea4e1d711573f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0ddea4e1d711573f$var$U = {
    current: null
}, $0ddea4e1d711573f$var$V = {
    transition: null
}, $0ddea4e1d711573f$var$W = {
    ReactCurrentDispatcher: $0ddea4e1d711573f$var$U,
    ReactCurrentBatchConfig: $0ddea4e1d711573f$var$V,
    ReactCurrentOwner: $0ddea4e1d711573f$var$K
};
function $0ddea4e1d711573f$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0ddea4e1d711573f$export$dca3b0875bd9a954 = {
    map: $0ddea4e1d711573f$var$S,
    forEach: function(a, b, e) {
        $0ddea4e1d711573f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0ddea4e1d711573f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0ddea4e1d711573f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0ddea4e1d711573f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0ddea4e1d711573f$export$16fa2f45be04daa8 = $0ddea4e1d711573f$var$E;
$0ddea4e1d711573f$export$ffb0004e005737fa = $0ddea4e1d711573f$var$p;
$0ddea4e1d711573f$export$e2c29f18771995cb = $0ddea4e1d711573f$var$r;
$0ddea4e1d711573f$export$221d75b3f55bb0bd = $0ddea4e1d711573f$var$G;
$0ddea4e1d711573f$export$5f8d39834fd61797 = $0ddea4e1d711573f$var$q;
$0ddea4e1d711573f$export$74bf444e3cd11ea5 = $0ddea4e1d711573f$var$w;
$0ddea4e1d711573f$export$ae55be85d98224ed = $0ddea4e1d711573f$var$W;
$0ddea4e1d711573f$export$3ba232387fd5d6dd = $0ddea4e1d711573f$var$X;
$0ddea4e1d711573f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0ddea4e1d711573f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0ddea4e1d711573f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0ddea4e1d711573f$var$J.call(b, f) && !$0ddea4e1d711573f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0ddea4e1d711573f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0ddea4e1d711573f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0ddea4e1d711573f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0ddea4e1d711573f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0ddea4e1d711573f$export$c8a8987d4410bf2d = $0ddea4e1d711573f$var$M;
$0ddea4e1d711573f$export$d38cd72104c1f0e9 = function(a) {
    var b = $0ddea4e1d711573f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0ddea4e1d711573f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0ddea4e1d711573f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0ddea4e1d711573f$var$v,
        render: a
    };
};
$0ddea4e1d711573f$export$a8257692ac88316c = $0ddea4e1d711573f$var$O;
$0ddea4e1d711573f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0ddea4e1d711573f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0ddea4e1d711573f$var$T
    };
};
$0ddea4e1d711573f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0ddea4e1d711573f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0ddea4e1d711573f$export$7568632d0d33d16d = function(a) {
    var b = $0ddea4e1d711573f$var$V.transition;
    $0ddea4e1d711573f$var$V.transition = {};
    try {
        a();
    } finally{
        $0ddea4e1d711573f$var$V.transition = b;
    }
};
$0ddea4e1d711573f$export$88948ce120ea2619 = $0ddea4e1d711573f$var$X;
$0ddea4e1d711573f$export$35808ee640e87ca7 = function(a, b) {
    return $0ddea4e1d711573f$var$U.current.useCallback(a, b);
};
$0ddea4e1d711573f$export$fae74005e78b1a27 = function(a) {
    return $0ddea4e1d711573f$var$U.current.useContext(a);
};
$0ddea4e1d711573f$export$dc8fbce3eb94dc1e = function() {};
$0ddea4e1d711573f$export$6a7bc4e911dc01cf = function(a) {
    return $0ddea4e1d711573f$var$U.current.useDeferredValue(a);
};
$0ddea4e1d711573f$export$6d9c69b0de29b591 = function(a, b) {
    return $0ddea4e1d711573f$var$U.current.useEffect(a, b);
};
$0ddea4e1d711573f$export$f680877a34711e37 = function() {
    return $0ddea4e1d711573f$var$U.current.useId();
};
$0ddea4e1d711573f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0ddea4e1d711573f$var$U.current.useImperativeHandle(a, b, e);
};
$0ddea4e1d711573f$export$aaabe4eda9ed9969 = function(a, b) {
    return $0ddea4e1d711573f$var$U.current.useInsertionEffect(a, b);
};
$0ddea4e1d711573f$export$e5c5a5f917a5871c = function(a, b) {
    return $0ddea4e1d711573f$var$U.current.useLayoutEffect(a, b);
};
$0ddea4e1d711573f$export$1538c33de8887b59 = function(a, b) {
    return $0ddea4e1d711573f$var$U.current.useMemo(a, b);
};
$0ddea4e1d711573f$export$13e3392192263954 = function(a, b, e) {
    return $0ddea4e1d711573f$var$U.current.useReducer(a, b, e);
};
$0ddea4e1d711573f$export$b8f5890fc79d6aca = function(a) {
    return $0ddea4e1d711573f$var$U.current.useRef(a);
};
$0ddea4e1d711573f$export$60241385465d0a34 = function(a) {
    return $0ddea4e1d711573f$var$U.current.useState(a);
};
$0ddea4e1d711573f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0ddea4e1d711573f$var$U.current.useSyncExternalStore(a, b, e);
};
$0ddea4e1d711573f$export$7b286972b8d8ccbf = function() {
    return $0ddea4e1d711573f$var$U.current.useTransition();
};
$0ddea4e1d711573f$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("67aGM", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $473bb02057a7af41$export$ae55be85d98224ed, (v) => $473bb02057a7af41$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $473bb02057a7af41$export$d39a5bbd09211389, (v) => $473bb02057a7af41$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $473bb02057a7af41$export$882461b6382ed46c, (v) => $473bb02057a7af41$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $473bb02057a7af41$export$466bfc07425424d5, (v) => $473bb02057a7af41$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $473bb02057a7af41$export$cd75ccfd720a3cd4, (v) => $473bb02057a7af41$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $473bb02057a7af41$export$fa8d919ba61d84db, (v) => $473bb02057a7af41$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $473bb02057a7af41$export$757ceba2d55c277e, (v) => $473bb02057a7af41$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $473bb02057a7af41$export$b3890eb0ae9dca99, (v) => $473bb02057a7af41$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $473bb02057a7af41$export$502457920280e6be, (v) => $473bb02057a7af41$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $473bb02057a7af41$export$c78a37762a8d58e1, (v) => $473bb02057a7af41$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $473bb02057a7af41$export$dc54d992c10e8a18, (v) => $473bb02057a7af41$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $473bb02057a7af41$export$83d89fbfd8236492, (v) => $473bb02057a7af41$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $473bb02057a7af41$export$ae55be85d98224ed;
var $473bb02057a7af41$export$d39a5bbd09211389;
var $473bb02057a7af41$export$882461b6382ed46c;
var $473bb02057a7af41$export$466bfc07425424d5;
var $473bb02057a7af41$export$cd75ccfd720a3cd4;
var $473bb02057a7af41$export$fa8d919ba61d84db;
var $473bb02057a7af41$export$757ceba2d55c277e;
var $473bb02057a7af41$export$b3890eb0ae9dca99;
var $473bb02057a7af41$export$502457920280e6be;
var $473bb02057a7af41$export$c78a37762a8d58e1;
var $473bb02057a7af41$export$dc54d992c10e8a18;
var $473bb02057a7af41$export$83d89fbfd8236492;
'use strict';

var $iDiRE = parcelRequire("iDiRE");

var $hTW2z = parcelRequire("hTW2z");
function $473bb02057a7af41$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $473bb02057a7af41$var$da = new Set, $473bb02057a7af41$var$ea = {};
function $473bb02057a7af41$var$fa(a, b) {
    $473bb02057a7af41$var$ha(a, b);
    $473bb02057a7af41$var$ha(a + "Capture", b);
}
function $473bb02057a7af41$var$ha(a, b) {
    $473bb02057a7af41$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$473bb02057a7af41$var$da.add(b[a]);
}
var $473bb02057a7af41$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $473bb02057a7af41$var$ja = Object.prototype.hasOwnProperty, $473bb02057a7af41$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $473bb02057a7af41$var$la = {}, $473bb02057a7af41$var$ma = {};
function $473bb02057a7af41$var$oa(a) {
    if ($473bb02057a7af41$var$ja.call($473bb02057a7af41$var$ma, a)) return !0;
    if ($473bb02057a7af41$var$ja.call($473bb02057a7af41$var$la, a)) return !1;
    if ($473bb02057a7af41$var$ka.test(a)) return $473bb02057a7af41$var$ma[a] = !0;
    $473bb02057a7af41$var$la[a] = !0;
    return !1;
}
function $473bb02057a7af41$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $473bb02057a7af41$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $473bb02057a7af41$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $473bb02057a7af41$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $473bb02057a7af41$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $473bb02057a7af41$var$z[b] = new $473bb02057a7af41$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $473bb02057a7af41$var$ra = /[\-:]([a-z])/g;
function $473bb02057a7af41$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($473bb02057a7af41$var$ra, $473bb02057a7af41$var$sa);
    $473bb02057a7af41$var$z[b] = new $473bb02057a7af41$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($473bb02057a7af41$var$ra, $473bb02057a7af41$var$sa);
    $473bb02057a7af41$var$z[b] = new $473bb02057a7af41$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($473bb02057a7af41$var$ra, $473bb02057a7af41$var$sa);
    $473bb02057a7af41$var$z[b] = new $473bb02057a7af41$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$473bb02057a7af41$var$z.xlinkHref = new $473bb02057a7af41$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $473bb02057a7af41$var$z[a] = new $473bb02057a7af41$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $473bb02057a7af41$var$ta(a, b, c, d) {
    var e = $473bb02057a7af41$var$z.hasOwnProperty(b) ? $473bb02057a7af41$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $473bb02057a7af41$var$qa(b, c, e, d) && (c = null), d || null === e ? $473bb02057a7af41$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $473bb02057a7af41$var$ua = $iDiRE.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $473bb02057a7af41$var$va = Symbol.for("react.element"), $473bb02057a7af41$var$wa = Symbol.for("react.portal"), $473bb02057a7af41$var$ya = Symbol.for("react.fragment"), $473bb02057a7af41$var$za = Symbol.for("react.strict_mode"), $473bb02057a7af41$var$Aa = Symbol.for("react.profiler"), $473bb02057a7af41$var$Ba = Symbol.for("react.provider"), $473bb02057a7af41$var$Ca = Symbol.for("react.context"), $473bb02057a7af41$var$Da = Symbol.for("react.forward_ref"), $473bb02057a7af41$var$Ea = Symbol.for("react.suspense"), $473bb02057a7af41$var$Fa = Symbol.for("react.suspense_list"), $473bb02057a7af41$var$Ga = Symbol.for("react.memo"), $473bb02057a7af41$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $473bb02057a7af41$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $473bb02057a7af41$var$Ja = Symbol.iterator;
function $473bb02057a7af41$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $473bb02057a7af41$var$Ja && a[$473bb02057a7af41$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $473bb02057a7af41$var$A = Object.assign, $473bb02057a7af41$var$La;
function $473bb02057a7af41$var$Ma(a) {
    if (void 0 === $473bb02057a7af41$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $473bb02057a7af41$var$La = b && b[1] || "";
    }
    return "\n" + $473bb02057a7af41$var$La + a;
}
var $473bb02057a7af41$var$Na = !1;
function $473bb02057a7af41$var$Oa(a, b) {
    if (!a || $473bb02057a7af41$var$Na) return "";
    $473bb02057a7af41$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $473bb02057a7af41$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $473bb02057a7af41$var$Ma(a) : "";
}
function $473bb02057a7af41$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $473bb02057a7af41$var$Ma(a.type);
        case 16:
            return $473bb02057a7af41$var$Ma("Lazy");
        case 13:
            return $473bb02057a7af41$var$Ma("Suspense");
        case 19:
            return $473bb02057a7af41$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $473bb02057a7af41$var$Oa(a.type, !1), a;
        case 11:
            return a = $473bb02057a7af41$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $473bb02057a7af41$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $473bb02057a7af41$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $473bb02057a7af41$var$ya:
            return "Fragment";
        case $473bb02057a7af41$var$wa:
            return "Portal";
        case $473bb02057a7af41$var$Aa:
            return "Profiler";
        case $473bb02057a7af41$var$za:
            return "StrictMode";
        case $473bb02057a7af41$var$Ea:
            return "Suspense";
        case $473bb02057a7af41$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $473bb02057a7af41$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $473bb02057a7af41$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $473bb02057a7af41$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $473bb02057a7af41$var$Ga:
            return b = a.displayName || null, null !== b ? b : $473bb02057a7af41$var$Qa(a.type) || "Memo";
        case $473bb02057a7af41$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $473bb02057a7af41$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $473bb02057a7af41$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $473bb02057a7af41$var$Qa(b);
        case 8:
            return b === $473bb02057a7af41$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $473bb02057a7af41$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $473bb02057a7af41$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $473bb02057a7af41$var$Ua(a) {
    var b = $473bb02057a7af41$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $473bb02057a7af41$var$Va(a) {
    a._valueTracker || (a._valueTracker = $473bb02057a7af41$var$Ua(a));
}
function $473bb02057a7af41$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $473bb02057a7af41$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $473bb02057a7af41$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $473bb02057a7af41$var$Ya(a, b) {
    var c = b.checked;
    return $473bb02057a7af41$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $473bb02057a7af41$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $473bb02057a7af41$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $473bb02057a7af41$var$ab(a, b) {
    b = b.checked;
    null != b && $473bb02057a7af41$var$ta(a, "checked", b, !1);
}
function $473bb02057a7af41$var$bb(a, b) {
    $473bb02057a7af41$var$ab(a, b);
    var c = $473bb02057a7af41$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $473bb02057a7af41$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $473bb02057a7af41$var$cb(a, b.type, $473bb02057a7af41$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $473bb02057a7af41$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $473bb02057a7af41$var$cb(a, b, c) {
    if ("number" !== b || $473bb02057a7af41$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $473bb02057a7af41$var$eb = Array.isArray;
function $473bb02057a7af41$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $473bb02057a7af41$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $473bb02057a7af41$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($473bb02057a7af41$var$p(91));
    return $473bb02057a7af41$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $473bb02057a7af41$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($473bb02057a7af41$var$p(92));
            if ($473bb02057a7af41$var$eb(c)) {
                if (1 < c.length) throw Error($473bb02057a7af41$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $473bb02057a7af41$var$Sa(c)
    };
}
function $473bb02057a7af41$var$ib(a, b) {
    var c = $473bb02057a7af41$var$Sa(b.value), d = $473bb02057a7af41$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $473bb02057a7af41$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $473bb02057a7af41$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $473bb02057a7af41$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $473bb02057a7af41$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $473bb02057a7af41$var$mb, $473bb02057a7af41$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $473bb02057a7af41$var$mb = $473bb02057a7af41$var$mb || document.createElement("div");
        $473bb02057a7af41$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $473bb02057a7af41$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $473bb02057a7af41$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $473bb02057a7af41$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $473bb02057a7af41$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($473bb02057a7af41$var$pb).forEach(function(a) {
    $473bb02057a7af41$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $473bb02057a7af41$var$pb[b] = $473bb02057a7af41$var$pb[a];
    });
});
function $473bb02057a7af41$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $473bb02057a7af41$var$pb.hasOwnProperty(a) && $473bb02057a7af41$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $473bb02057a7af41$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $473bb02057a7af41$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $473bb02057a7af41$var$tb = $473bb02057a7af41$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $473bb02057a7af41$var$ub(a, b) {
    if (b) {
        if ($473bb02057a7af41$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($473bb02057a7af41$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($473bb02057a7af41$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($473bb02057a7af41$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($473bb02057a7af41$var$p(62));
    }
}
function $473bb02057a7af41$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $473bb02057a7af41$var$wb = null;
function $473bb02057a7af41$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $473bb02057a7af41$var$yb = null, $473bb02057a7af41$var$zb = null, $473bb02057a7af41$var$Ab = null;
function $473bb02057a7af41$var$Bb(a) {
    if (a = $473bb02057a7af41$var$Cb(a)) {
        if ("function" !== typeof $473bb02057a7af41$var$yb) throw Error($473bb02057a7af41$var$p(280));
        var b = a.stateNode;
        b && (b = $473bb02057a7af41$var$Db(b), $473bb02057a7af41$var$yb(a.stateNode, a.type, b));
    }
}
function $473bb02057a7af41$var$Eb(a) {
    $473bb02057a7af41$var$zb ? $473bb02057a7af41$var$Ab ? $473bb02057a7af41$var$Ab.push(a) : $473bb02057a7af41$var$Ab = [
        a
    ] : $473bb02057a7af41$var$zb = a;
}
function $473bb02057a7af41$var$Fb() {
    if ($473bb02057a7af41$var$zb) {
        var a = $473bb02057a7af41$var$zb, b = $473bb02057a7af41$var$Ab;
        $473bb02057a7af41$var$Ab = $473bb02057a7af41$var$zb = null;
        $473bb02057a7af41$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$473bb02057a7af41$var$Bb(b[a]);
    }
}
function $473bb02057a7af41$var$Gb(a, b) {
    return a(b);
}
function $473bb02057a7af41$var$Hb() {}
var $473bb02057a7af41$var$Ib = !1;
function $473bb02057a7af41$var$Jb(a, b, c) {
    if ($473bb02057a7af41$var$Ib) return a(b, c);
    $473bb02057a7af41$var$Ib = !0;
    try {
        return $473bb02057a7af41$var$Gb(a, b, c);
    } finally{
        if ($473bb02057a7af41$var$Ib = !1, null !== $473bb02057a7af41$var$zb || null !== $473bb02057a7af41$var$Ab) $473bb02057a7af41$var$Hb(), $473bb02057a7af41$var$Fb();
    }
}
function $473bb02057a7af41$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $473bb02057a7af41$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($473bb02057a7af41$var$p(231, b, typeof c));
    return c;
}
var $473bb02057a7af41$var$Lb = !1;
if ($473bb02057a7af41$var$ia) try {
    var $473bb02057a7af41$var$Mb = {};
    Object.defineProperty($473bb02057a7af41$var$Mb, "passive", {
        get: function() {
            $473bb02057a7af41$var$Lb = !0;
        }
    });
    window.addEventListener("test", $473bb02057a7af41$var$Mb, $473bb02057a7af41$var$Mb);
    window.removeEventListener("test", $473bb02057a7af41$var$Mb, $473bb02057a7af41$var$Mb);
} catch (a) {
    $473bb02057a7af41$var$Lb = !1;
}
function $473bb02057a7af41$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $473bb02057a7af41$var$Ob = !1, $473bb02057a7af41$var$Pb = null, $473bb02057a7af41$var$Qb = !1, $473bb02057a7af41$var$Rb = null, $473bb02057a7af41$var$Sb = {
    onError: function(a) {
        $473bb02057a7af41$var$Ob = !0;
        $473bb02057a7af41$var$Pb = a;
    }
};
function $473bb02057a7af41$var$Tb(a, b, c, d, e, f, g, h, k) {
    $473bb02057a7af41$var$Ob = !1;
    $473bb02057a7af41$var$Pb = null;
    $473bb02057a7af41$var$Nb.apply($473bb02057a7af41$var$Sb, arguments);
}
function $473bb02057a7af41$var$Ub(a, b, c, d, e, f, g, h, k) {
    $473bb02057a7af41$var$Tb.apply(this, arguments);
    if ($473bb02057a7af41$var$Ob) {
        if ($473bb02057a7af41$var$Ob) {
            var l = $473bb02057a7af41$var$Pb;
            $473bb02057a7af41$var$Ob = !1;
            $473bb02057a7af41$var$Pb = null;
        } else throw Error($473bb02057a7af41$var$p(198));
        $473bb02057a7af41$var$Qb || ($473bb02057a7af41$var$Qb = !0, $473bb02057a7af41$var$Rb = l);
    }
}
function $473bb02057a7af41$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $473bb02057a7af41$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $473bb02057a7af41$var$Xb(a) {
    if ($473bb02057a7af41$var$Vb(a) !== a) throw Error($473bb02057a7af41$var$p(188));
}
function $473bb02057a7af41$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $473bb02057a7af41$var$Vb(a);
        if (null === b) throw Error($473bb02057a7af41$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $473bb02057a7af41$var$Xb(e), a;
                if (f === d) return $473bb02057a7af41$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($473bb02057a7af41$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($473bb02057a7af41$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($473bb02057a7af41$var$p(190));
    }
    if (3 !== c.tag) throw Error($473bb02057a7af41$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $473bb02057a7af41$var$Zb(a) {
    a = $473bb02057a7af41$var$Yb(a);
    return null !== a ? $473bb02057a7af41$var$$b(a) : null;
}
function $473bb02057a7af41$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $473bb02057a7af41$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $473bb02057a7af41$var$ac = $hTW2z.unstable_scheduleCallback, $473bb02057a7af41$var$bc = $hTW2z.unstable_cancelCallback, $473bb02057a7af41$var$cc = $hTW2z.unstable_shouldYield, $473bb02057a7af41$var$dc = $hTW2z.unstable_requestPaint, $473bb02057a7af41$var$B = $hTW2z.unstable_now, $473bb02057a7af41$var$ec = $hTW2z.unstable_getCurrentPriorityLevel, $473bb02057a7af41$var$fc = $hTW2z.unstable_ImmediatePriority, $473bb02057a7af41$var$gc = $hTW2z.unstable_UserBlockingPriority, $473bb02057a7af41$var$hc = $hTW2z.unstable_NormalPriority, $473bb02057a7af41$var$ic = $hTW2z.unstable_LowPriority, $473bb02057a7af41$var$jc = $hTW2z.unstable_IdlePriority, $473bb02057a7af41$var$kc = null, $473bb02057a7af41$var$lc = null;
function $473bb02057a7af41$var$mc(a) {
    if ($473bb02057a7af41$var$lc && "function" === typeof $473bb02057a7af41$var$lc.onCommitFiberRoot) try {
        $473bb02057a7af41$var$lc.onCommitFiberRoot($473bb02057a7af41$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $473bb02057a7af41$var$oc = Math.clz32 ? Math.clz32 : $473bb02057a7af41$var$nc, $473bb02057a7af41$var$pc = Math.log, $473bb02057a7af41$var$qc = Math.LN2;
function $473bb02057a7af41$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($473bb02057a7af41$var$pc(a) / $473bb02057a7af41$var$qc | 0) | 0;
}
var $473bb02057a7af41$var$rc = 64, $473bb02057a7af41$var$sc = 4194304;
function $473bb02057a7af41$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $473bb02057a7af41$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $473bb02057a7af41$var$tc(h) : (f &= g, 0 !== f && (d = $473bb02057a7af41$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $473bb02057a7af41$var$tc(g) : 0 !== f && (d = $473bb02057a7af41$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $473bb02057a7af41$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $473bb02057a7af41$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $473bb02057a7af41$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $473bb02057a7af41$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $473bb02057a7af41$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $473bb02057a7af41$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $473bb02057a7af41$var$yc() {
    var a = $473bb02057a7af41$var$rc;
    $473bb02057a7af41$var$rc <<= 1;
    0 === ($473bb02057a7af41$var$rc & 4194240) && ($473bb02057a7af41$var$rc = 64);
    return a;
}
function $473bb02057a7af41$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $473bb02057a7af41$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $473bb02057a7af41$var$oc(b);
    a[b] = c;
}
function $473bb02057a7af41$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $473bb02057a7af41$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $473bb02057a7af41$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $473bb02057a7af41$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $473bb02057a7af41$var$C = 0;
function $473bb02057a7af41$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $473bb02057a7af41$var$Ec, $473bb02057a7af41$var$Fc, $473bb02057a7af41$var$Gc, $473bb02057a7af41$var$Hc, $473bb02057a7af41$var$Ic, $473bb02057a7af41$var$Jc = !1, $473bb02057a7af41$var$Kc = [], $473bb02057a7af41$var$Lc = null, $473bb02057a7af41$var$Mc = null, $473bb02057a7af41$var$Nc = null, $473bb02057a7af41$var$Oc = new Map, $473bb02057a7af41$var$Pc = new Map, $473bb02057a7af41$var$Qc = [], $473bb02057a7af41$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $473bb02057a7af41$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $473bb02057a7af41$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $473bb02057a7af41$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $473bb02057a7af41$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $473bb02057a7af41$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $473bb02057a7af41$var$Pc.delete(b.pointerId);
    }
}
function $473bb02057a7af41$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $473bb02057a7af41$var$Cb(b), null !== b && $473bb02057a7af41$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $473bb02057a7af41$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $473bb02057a7af41$var$Lc = $473bb02057a7af41$var$Tc($473bb02057a7af41$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $473bb02057a7af41$var$Mc = $473bb02057a7af41$var$Tc($473bb02057a7af41$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $473bb02057a7af41$var$Nc = $473bb02057a7af41$var$Tc($473bb02057a7af41$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $473bb02057a7af41$var$Oc.set(f, $473bb02057a7af41$var$Tc($473bb02057a7af41$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $473bb02057a7af41$var$Pc.set(f, $473bb02057a7af41$var$Tc($473bb02057a7af41$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $473bb02057a7af41$var$Vc(a) {
    var b = $473bb02057a7af41$var$Wc(a.target);
    if (null !== b) {
        var c = $473bb02057a7af41$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $473bb02057a7af41$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $473bb02057a7af41$var$Ic(a.priority, function() {
                        $473bb02057a7af41$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $473bb02057a7af41$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $473bb02057a7af41$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $473bb02057a7af41$var$wb = d;
            c.target.dispatchEvent(d);
            $473bb02057a7af41$var$wb = null;
        } else return b = $473bb02057a7af41$var$Cb(c), null !== b && $473bb02057a7af41$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $473bb02057a7af41$var$Zc(a, b, c) {
    $473bb02057a7af41$var$Xc(a) && c.delete(b);
}
function $473bb02057a7af41$var$$c() {
    $473bb02057a7af41$var$Jc = !1;
    null !== $473bb02057a7af41$var$Lc && $473bb02057a7af41$var$Xc($473bb02057a7af41$var$Lc) && ($473bb02057a7af41$var$Lc = null);
    null !== $473bb02057a7af41$var$Mc && $473bb02057a7af41$var$Xc($473bb02057a7af41$var$Mc) && ($473bb02057a7af41$var$Mc = null);
    null !== $473bb02057a7af41$var$Nc && $473bb02057a7af41$var$Xc($473bb02057a7af41$var$Nc) && ($473bb02057a7af41$var$Nc = null);
    $473bb02057a7af41$var$Oc.forEach($473bb02057a7af41$var$Zc);
    $473bb02057a7af41$var$Pc.forEach($473bb02057a7af41$var$Zc);
}
function $473bb02057a7af41$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $473bb02057a7af41$var$Jc || ($473bb02057a7af41$var$Jc = !0, $hTW2z.unstable_scheduleCallback($hTW2z.unstable_NormalPriority, $473bb02057a7af41$var$$c)));
}
function $473bb02057a7af41$var$bd(a) {
    function b(b) {
        return $473bb02057a7af41$var$ad(b, a);
    }
    if (0 < $473bb02057a7af41$var$Kc.length) {
        $473bb02057a7af41$var$ad($473bb02057a7af41$var$Kc[0], a);
        for(var c = 1; c < $473bb02057a7af41$var$Kc.length; c++){
            var d = $473bb02057a7af41$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $473bb02057a7af41$var$Lc && $473bb02057a7af41$var$ad($473bb02057a7af41$var$Lc, a);
    null !== $473bb02057a7af41$var$Mc && $473bb02057a7af41$var$ad($473bb02057a7af41$var$Mc, a);
    null !== $473bb02057a7af41$var$Nc && $473bb02057a7af41$var$ad($473bb02057a7af41$var$Nc, a);
    $473bb02057a7af41$var$Oc.forEach(b);
    $473bb02057a7af41$var$Pc.forEach(b);
    for(c = 0; c < $473bb02057a7af41$var$Qc.length; c++)d = $473bb02057a7af41$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $473bb02057a7af41$var$Qc.length && (c = $473bb02057a7af41$var$Qc[0], null === c.blockedOn);)$473bb02057a7af41$var$Vc(c), null === c.blockedOn && $473bb02057a7af41$var$Qc.shift();
}
var $473bb02057a7af41$var$cd = $473bb02057a7af41$var$ua.ReactCurrentBatchConfig, $473bb02057a7af41$var$dd = !0;
function $473bb02057a7af41$var$ed(a, b, c, d) {
    var e = $473bb02057a7af41$var$C, f = $473bb02057a7af41$var$cd.transition;
    $473bb02057a7af41$var$cd.transition = null;
    try {
        $473bb02057a7af41$var$C = 1, $473bb02057a7af41$var$fd(a, b, c, d);
    } finally{
        $473bb02057a7af41$var$C = e, $473bb02057a7af41$var$cd.transition = f;
    }
}
function $473bb02057a7af41$var$gd(a, b, c, d) {
    var e = $473bb02057a7af41$var$C, f = $473bb02057a7af41$var$cd.transition;
    $473bb02057a7af41$var$cd.transition = null;
    try {
        $473bb02057a7af41$var$C = 4, $473bb02057a7af41$var$fd(a, b, c, d);
    } finally{
        $473bb02057a7af41$var$C = e, $473bb02057a7af41$var$cd.transition = f;
    }
}
function $473bb02057a7af41$var$fd(a, b, c, d) {
    if ($473bb02057a7af41$var$dd) {
        var e = $473bb02057a7af41$var$Yc(a, b, c, d);
        if (null === e) $473bb02057a7af41$var$hd(a, b, d, $473bb02057a7af41$var$id, c), $473bb02057a7af41$var$Sc(a, d);
        else if ($473bb02057a7af41$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($473bb02057a7af41$var$Sc(a, d), b & 4 && -1 < $473bb02057a7af41$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $473bb02057a7af41$var$Cb(e);
                null !== f && $473bb02057a7af41$var$Ec(f);
                f = $473bb02057a7af41$var$Yc(a, b, c, d);
                null === f && $473bb02057a7af41$var$hd(a, b, d, $473bb02057a7af41$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $473bb02057a7af41$var$hd(a, b, d, null, c);
    }
}
var $473bb02057a7af41$var$id = null;
function $473bb02057a7af41$var$Yc(a, b, c, d) {
    $473bb02057a7af41$var$id = null;
    a = $473bb02057a7af41$var$xb(d);
    a = $473bb02057a7af41$var$Wc(a);
    if (null !== a) {
        if (b = $473bb02057a7af41$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $473bb02057a7af41$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $473bb02057a7af41$var$id = a;
    return null;
}
function $473bb02057a7af41$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($473bb02057a7af41$var$ec()){
                case $473bb02057a7af41$var$fc:
                    return 1;
                case $473bb02057a7af41$var$gc:
                    return 4;
                case $473bb02057a7af41$var$hc:
                case $473bb02057a7af41$var$ic:
                    return 16;
                case $473bb02057a7af41$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $473bb02057a7af41$var$kd = null, $473bb02057a7af41$var$ld = null, $473bb02057a7af41$var$md = null;
function $473bb02057a7af41$var$nd() {
    if ($473bb02057a7af41$var$md) return $473bb02057a7af41$var$md;
    var a, b = $473bb02057a7af41$var$ld, c = b.length, d, e = "value" in $473bb02057a7af41$var$kd ? $473bb02057a7af41$var$kd.value : $473bb02057a7af41$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $473bb02057a7af41$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $473bb02057a7af41$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $473bb02057a7af41$var$pd() {
    return !0;
}
function $473bb02057a7af41$var$qd() {
    return !1;
}
function $473bb02057a7af41$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $473bb02057a7af41$var$pd : $473bb02057a7af41$var$qd;
        this.isPropagationStopped = $473bb02057a7af41$var$qd;
        return this;
    }
    $473bb02057a7af41$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $473bb02057a7af41$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $473bb02057a7af41$var$pd);
        },
        persist: function() {},
        isPersistent: $473bb02057a7af41$var$pd
    });
    return b;
}
var $473bb02057a7af41$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $473bb02057a7af41$var$td = $473bb02057a7af41$var$rd($473bb02057a7af41$var$sd), $473bb02057a7af41$var$ud = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$sd, {
    view: 0,
    detail: 0
}), $473bb02057a7af41$var$vd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$ud), $473bb02057a7af41$var$wd, $473bb02057a7af41$var$xd, $473bb02057a7af41$var$yd, $473bb02057a7af41$var$Ad = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $473bb02057a7af41$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $473bb02057a7af41$var$yd && ($473bb02057a7af41$var$yd && "mousemove" === a.type ? ($473bb02057a7af41$var$wd = a.screenX - $473bb02057a7af41$var$yd.screenX, $473bb02057a7af41$var$xd = a.screenY - $473bb02057a7af41$var$yd.screenY) : $473bb02057a7af41$var$xd = $473bb02057a7af41$var$wd = 0, $473bb02057a7af41$var$yd = a);
        return $473bb02057a7af41$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $473bb02057a7af41$var$xd;
    }
}), $473bb02057a7af41$var$Bd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Ad), $473bb02057a7af41$var$Cd = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$Ad, {
    dataTransfer: 0
}), $473bb02057a7af41$var$Dd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Cd), $473bb02057a7af41$var$Ed = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$ud, {
    relatedTarget: 0
}), $473bb02057a7af41$var$Fd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Ed), $473bb02057a7af41$var$Gd = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $473bb02057a7af41$var$Hd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Gd), $473bb02057a7af41$var$Id = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $473bb02057a7af41$var$Jd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Id), $473bb02057a7af41$var$Kd = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$sd, {
    data: 0
}), $473bb02057a7af41$var$Ld = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Kd), $473bb02057a7af41$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $473bb02057a7af41$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $473bb02057a7af41$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $473bb02057a7af41$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $473bb02057a7af41$var$Od[a]) ? !!b[a] : !1;
}
function $473bb02057a7af41$var$zd() {
    return $473bb02057a7af41$var$Pd;
}
var $473bb02057a7af41$var$Qd = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $473bb02057a7af41$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $473bb02057a7af41$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $473bb02057a7af41$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $473bb02057a7af41$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $473bb02057a7af41$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $473bb02057a7af41$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $473bb02057a7af41$var$Rd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Qd), $473bb02057a7af41$var$Sd = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $473bb02057a7af41$var$Td = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Sd), $473bb02057a7af41$var$Ud = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $473bb02057a7af41$var$zd
}), $473bb02057a7af41$var$Vd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Ud), $473bb02057a7af41$var$Wd = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $473bb02057a7af41$var$Xd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Wd), $473bb02057a7af41$var$Yd = $473bb02057a7af41$var$A({}, $473bb02057a7af41$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $473bb02057a7af41$var$Zd = $473bb02057a7af41$var$rd($473bb02057a7af41$var$Yd), $473bb02057a7af41$var$$d = [
    9,
    13,
    27,
    32
], $473bb02057a7af41$var$ae = $473bb02057a7af41$var$ia && "CompositionEvent" in window, $473bb02057a7af41$var$be = null;
$473bb02057a7af41$var$ia && "documentMode" in document && ($473bb02057a7af41$var$be = document.documentMode);
var $473bb02057a7af41$var$ce = $473bb02057a7af41$var$ia && "TextEvent" in window && !$473bb02057a7af41$var$be, $473bb02057a7af41$var$de = $473bb02057a7af41$var$ia && (!$473bb02057a7af41$var$ae || $473bb02057a7af41$var$be && 8 < $473bb02057a7af41$var$be && 11 >= $473bb02057a7af41$var$be), $473bb02057a7af41$var$ee = String.fromCharCode(32), $473bb02057a7af41$var$fe = !1;
function $473bb02057a7af41$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $473bb02057a7af41$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $473bb02057a7af41$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $473bb02057a7af41$var$ie = !1;
function $473bb02057a7af41$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $473bb02057a7af41$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $473bb02057a7af41$var$fe = !0;
            return $473bb02057a7af41$var$ee;
        case "textInput":
            return a = b.data, a === $473bb02057a7af41$var$ee && $473bb02057a7af41$var$fe ? null : a;
        default:
            return null;
    }
}
function $473bb02057a7af41$var$ke(a, b) {
    if ($473bb02057a7af41$var$ie) return "compositionend" === a || !$473bb02057a7af41$var$ae && $473bb02057a7af41$var$ge(a, b) ? (a = $473bb02057a7af41$var$nd(), $473bb02057a7af41$var$md = $473bb02057a7af41$var$ld = $473bb02057a7af41$var$kd = null, $473bb02057a7af41$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $473bb02057a7af41$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $473bb02057a7af41$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $473bb02057a7af41$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$473bb02057a7af41$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $473bb02057a7af41$var$ne(a, b, c, d) {
    $473bb02057a7af41$var$Eb(d);
    b = $473bb02057a7af41$var$oe(b, "onChange");
    0 < b.length && (c = new $473bb02057a7af41$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $473bb02057a7af41$var$pe = null, $473bb02057a7af41$var$qe = null;
function $473bb02057a7af41$var$re(a) {
    $473bb02057a7af41$var$se(a, 0);
}
function $473bb02057a7af41$var$te(a) {
    var b = $473bb02057a7af41$var$ue(a);
    if ($473bb02057a7af41$var$Wa(b)) return a;
}
function $473bb02057a7af41$var$ve(a, b) {
    if ("change" === a) return b;
}
var $473bb02057a7af41$var$we = !1;
if ($473bb02057a7af41$var$ia) {
    var $473bb02057a7af41$var$xe;
    if ($473bb02057a7af41$var$ia) {
        var $473bb02057a7af41$var$ye = "oninput" in document;
        if (!$473bb02057a7af41$var$ye) {
            var $473bb02057a7af41$var$ze = document.createElement("div");
            $473bb02057a7af41$var$ze.setAttribute("oninput", "return;");
            $473bb02057a7af41$var$ye = "function" === typeof $473bb02057a7af41$var$ze.oninput;
        }
        $473bb02057a7af41$var$xe = $473bb02057a7af41$var$ye;
    } else $473bb02057a7af41$var$xe = !1;
    $473bb02057a7af41$var$we = $473bb02057a7af41$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $473bb02057a7af41$var$Ae() {
    $473bb02057a7af41$var$pe && ($473bb02057a7af41$var$pe.detachEvent("onpropertychange", $473bb02057a7af41$var$Be), $473bb02057a7af41$var$qe = $473bb02057a7af41$var$pe = null);
}
function $473bb02057a7af41$var$Be(a) {
    if ("value" === a.propertyName && $473bb02057a7af41$var$te($473bb02057a7af41$var$qe)) {
        var b = [];
        $473bb02057a7af41$var$ne(b, $473bb02057a7af41$var$qe, a, $473bb02057a7af41$var$xb(a));
        $473bb02057a7af41$var$Jb($473bb02057a7af41$var$re, b);
    }
}
function $473bb02057a7af41$var$Ce(a, b, c) {
    "focusin" === a ? ($473bb02057a7af41$var$Ae(), $473bb02057a7af41$var$pe = b, $473bb02057a7af41$var$qe = c, $473bb02057a7af41$var$pe.attachEvent("onpropertychange", $473bb02057a7af41$var$Be)) : "focusout" === a && $473bb02057a7af41$var$Ae();
}
function $473bb02057a7af41$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $473bb02057a7af41$var$te($473bb02057a7af41$var$qe);
}
function $473bb02057a7af41$var$Ee(a, b) {
    if ("click" === a) return $473bb02057a7af41$var$te(b);
}
function $473bb02057a7af41$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $473bb02057a7af41$var$te(b);
}
function $473bb02057a7af41$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $473bb02057a7af41$var$He = "function" === typeof Object.is ? Object.is : $473bb02057a7af41$var$Ge;
function $473bb02057a7af41$var$Ie(a, b) {
    if ($473bb02057a7af41$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$473bb02057a7af41$var$ja.call(b, e) || !$473bb02057a7af41$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $473bb02057a7af41$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $473bb02057a7af41$var$Ke(a, b) {
    var c = $473bb02057a7af41$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $473bb02057a7af41$var$Je(c);
    }
}
function $473bb02057a7af41$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $473bb02057a7af41$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $473bb02057a7af41$var$Me() {
    for(var a = window, b = $473bb02057a7af41$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $473bb02057a7af41$var$Xa(a.document);
    }
    return b;
}
function $473bb02057a7af41$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $473bb02057a7af41$var$Oe(a) {
    var b = $473bb02057a7af41$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $473bb02057a7af41$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $473bb02057a7af41$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $473bb02057a7af41$var$Ke(c, f);
                var g = $473bb02057a7af41$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $473bb02057a7af41$var$Pe = $473bb02057a7af41$var$ia && "documentMode" in document && 11 >= document.documentMode, $473bb02057a7af41$var$Qe = null, $473bb02057a7af41$var$Re = null, $473bb02057a7af41$var$Se = null, $473bb02057a7af41$var$Te = !1;
function $473bb02057a7af41$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $473bb02057a7af41$var$Te || null == $473bb02057a7af41$var$Qe || $473bb02057a7af41$var$Qe !== $473bb02057a7af41$var$Xa(d) || (d = $473bb02057a7af41$var$Qe, "selectionStart" in d && $473bb02057a7af41$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $473bb02057a7af41$var$Se && $473bb02057a7af41$var$Ie($473bb02057a7af41$var$Se, d) || ($473bb02057a7af41$var$Se = d, d = $473bb02057a7af41$var$oe($473bb02057a7af41$var$Re, "onSelect"), 0 < d.length && (b = new $473bb02057a7af41$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $473bb02057a7af41$var$Qe)));
}
function $473bb02057a7af41$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $473bb02057a7af41$var$We = {
    animationend: $473bb02057a7af41$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $473bb02057a7af41$var$Ve("Animation", "AnimationIteration"),
    animationstart: $473bb02057a7af41$var$Ve("Animation", "AnimationStart"),
    transitionend: $473bb02057a7af41$var$Ve("Transition", "TransitionEnd")
}, $473bb02057a7af41$var$Xe = {}, $473bb02057a7af41$var$Ye = {};
$473bb02057a7af41$var$ia && ($473bb02057a7af41$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $473bb02057a7af41$var$We.animationend.animation, delete $473bb02057a7af41$var$We.animationiteration.animation, delete $473bb02057a7af41$var$We.animationstart.animation), "TransitionEvent" in window || delete $473bb02057a7af41$var$We.transitionend.transition);
function $473bb02057a7af41$var$Ze(a) {
    if ($473bb02057a7af41$var$Xe[a]) return $473bb02057a7af41$var$Xe[a];
    if (!$473bb02057a7af41$var$We[a]) return a;
    var b = $473bb02057a7af41$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $473bb02057a7af41$var$Ye) return $473bb02057a7af41$var$Xe[a] = b[c];
    return a;
}
var $473bb02057a7af41$var$$e = $473bb02057a7af41$var$Ze("animationend"), $473bb02057a7af41$var$af = $473bb02057a7af41$var$Ze("animationiteration"), $473bb02057a7af41$var$bf = $473bb02057a7af41$var$Ze("animationstart"), $473bb02057a7af41$var$cf = $473bb02057a7af41$var$Ze("transitionend"), $473bb02057a7af41$var$df = new Map, $473bb02057a7af41$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $473bb02057a7af41$var$ff(a, b) {
    $473bb02057a7af41$var$df.set(a, b);
    $473bb02057a7af41$var$fa(b, [
        a
    ]);
}
for(var $473bb02057a7af41$var$gf = 0; $473bb02057a7af41$var$gf < $473bb02057a7af41$var$ef.length; $473bb02057a7af41$var$gf++){
    var $473bb02057a7af41$var$hf = $473bb02057a7af41$var$ef[$473bb02057a7af41$var$gf], $473bb02057a7af41$var$jf = $473bb02057a7af41$var$hf.toLowerCase(), $473bb02057a7af41$var$kf = $473bb02057a7af41$var$hf[0].toUpperCase() + $473bb02057a7af41$var$hf.slice(1);
    $473bb02057a7af41$var$ff($473bb02057a7af41$var$jf, "on" + $473bb02057a7af41$var$kf);
}
$473bb02057a7af41$var$ff($473bb02057a7af41$var$$e, "onAnimationEnd");
$473bb02057a7af41$var$ff($473bb02057a7af41$var$af, "onAnimationIteration");
$473bb02057a7af41$var$ff($473bb02057a7af41$var$bf, "onAnimationStart");
$473bb02057a7af41$var$ff("dblclick", "onDoubleClick");
$473bb02057a7af41$var$ff("focusin", "onFocus");
$473bb02057a7af41$var$ff("focusout", "onBlur");
$473bb02057a7af41$var$ff($473bb02057a7af41$var$cf, "onTransitionEnd");
$473bb02057a7af41$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$473bb02057a7af41$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$473bb02057a7af41$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$473bb02057a7af41$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$473bb02057a7af41$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$473bb02057a7af41$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$473bb02057a7af41$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$473bb02057a7af41$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$473bb02057a7af41$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$473bb02057a7af41$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $473bb02057a7af41$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $473bb02057a7af41$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($473bb02057a7af41$var$lf));
function $473bb02057a7af41$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $473bb02057a7af41$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $473bb02057a7af41$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $473bb02057a7af41$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $473bb02057a7af41$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($473bb02057a7af41$var$Qb) throw a = $473bb02057a7af41$var$Rb, $473bb02057a7af41$var$Qb = !1, $473bb02057a7af41$var$Rb = null, a;
}
function $473bb02057a7af41$var$D(a, b) {
    var c = b[$473bb02057a7af41$var$of];
    void 0 === c && (c = b[$473bb02057a7af41$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($473bb02057a7af41$var$pf(b, a, 2, !1), c.add(d));
}
function $473bb02057a7af41$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $473bb02057a7af41$var$pf(c, a, d, b);
}
var $473bb02057a7af41$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $473bb02057a7af41$var$sf(a) {
    if (!a[$473bb02057a7af41$var$rf]) {
        a[$473bb02057a7af41$var$rf] = !0;
        $473bb02057a7af41$var$da.forEach(function(b) {
            "selectionchange" !== b && ($473bb02057a7af41$var$mf.has(b) || $473bb02057a7af41$var$qf(b, !1, a), $473bb02057a7af41$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$473bb02057a7af41$var$rf] || (b[$473bb02057a7af41$var$rf] = !0, $473bb02057a7af41$var$qf("selectionchange", !1, b));
    }
}
function $473bb02057a7af41$var$pf(a, b, c, d) {
    switch($473bb02057a7af41$var$jd(b)){
        case 1:
            var e = $473bb02057a7af41$var$ed;
            break;
        case 4:
            e = $473bb02057a7af41$var$gd;
            break;
        default:
            e = $473bb02057a7af41$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$473bb02057a7af41$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $473bb02057a7af41$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $473bb02057a7af41$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $473bb02057a7af41$var$Jb(function() {
        var d = f, e = $473bb02057a7af41$var$xb(c), g = [];
        a: {
            var h = $473bb02057a7af41$var$df.get(a);
            if (void 0 !== h) {
                var k = $473bb02057a7af41$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $473bb02057a7af41$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $473bb02057a7af41$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $473bb02057a7af41$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $473bb02057a7af41$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $473bb02057a7af41$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $473bb02057a7af41$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $473bb02057a7af41$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $473bb02057a7af41$var$Vd;
                        break;
                    case $473bb02057a7af41$var$$e:
                    case $473bb02057a7af41$var$af:
                    case $473bb02057a7af41$var$bf:
                        k = $473bb02057a7af41$var$Hd;
                        break;
                    case $473bb02057a7af41$var$cf:
                        k = $473bb02057a7af41$var$Xd;
                        break;
                    case "scroll":
                        k = $473bb02057a7af41$var$vd;
                        break;
                    case "wheel":
                        k = $473bb02057a7af41$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $473bb02057a7af41$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $473bb02057a7af41$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $473bb02057a7af41$var$Kb(w, x), null != F && t.push($473bb02057a7af41$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $473bb02057a7af41$var$wb && (n = c.relatedTarget || c.fromElement) && ($473bb02057a7af41$var$Wc(n) || n[$473bb02057a7af41$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $473bb02057a7af41$var$Wc(n) : null, null !== n && (J = $473bb02057a7af41$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $473bb02057a7af41$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $473bb02057a7af41$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $473bb02057a7af41$var$ue(k);
                        u = null == n ? h : $473bb02057a7af41$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $473bb02057a7af41$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $473bb02057a7af41$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $473bb02057a7af41$var$vf(F))u++;
                            for(; 0 < w - u;)t = $473bb02057a7af41$var$vf(t), w--;
                            for(; 0 < u - w;)x = $473bb02057a7af41$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $473bb02057a7af41$var$vf(t);
                                x = $473bb02057a7af41$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $473bb02057a7af41$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $473bb02057a7af41$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $473bb02057a7af41$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $473bb02057a7af41$var$ve;
                else if ($473bb02057a7af41$var$me(h)) {
                    if ($473bb02057a7af41$var$we) na = $473bb02057a7af41$var$Fe;
                    else {
                        na = $473bb02057a7af41$var$De;
                        var xa = $473bb02057a7af41$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $473bb02057a7af41$var$Ee);
                if (na && (na = na(a, d))) {
                    $473bb02057a7af41$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $473bb02057a7af41$var$cb(h, "number", h.value);
            }
            xa = d ? $473bb02057a7af41$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($473bb02057a7af41$var$me(xa) || "true" === xa.contentEditable) $473bb02057a7af41$var$Qe = xa, $473bb02057a7af41$var$Re = d, $473bb02057a7af41$var$Se = null;
                    break;
                case "focusout":
                    $473bb02057a7af41$var$Se = $473bb02057a7af41$var$Re = $473bb02057a7af41$var$Qe = null;
                    break;
                case "mousedown":
                    $473bb02057a7af41$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $473bb02057a7af41$var$Te = !1;
                    $473bb02057a7af41$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($473bb02057a7af41$var$Pe) break;
                case "keydown":
                case "keyup":
                    $473bb02057a7af41$var$Ue(g, c, e);
            }
            var $a;
            if ($473bb02057a7af41$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $473bb02057a7af41$var$ie ? $473bb02057a7af41$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($473bb02057a7af41$var$de && "ko" !== c.locale && ($473bb02057a7af41$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $473bb02057a7af41$var$ie && ($a = $473bb02057a7af41$var$nd()) : ($473bb02057a7af41$var$kd = e, $473bb02057a7af41$var$ld = "value" in $473bb02057a7af41$var$kd ? $473bb02057a7af41$var$kd.value : $473bb02057a7af41$var$kd.textContent, $473bb02057a7af41$var$ie = !0)), xa = $473bb02057a7af41$var$oe(d, ba), 0 < xa.length && (ba = new $473bb02057a7af41$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $473bb02057a7af41$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $473bb02057a7af41$var$ce ? $473bb02057a7af41$var$je(a, c) : $473bb02057a7af41$var$ke(a, c)) d = $473bb02057a7af41$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $473bb02057a7af41$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $473bb02057a7af41$var$se(g, b);
    });
}
function $473bb02057a7af41$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $473bb02057a7af41$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $473bb02057a7af41$var$Kb(a, c), null != f && d.unshift($473bb02057a7af41$var$tf(a, f, e)), f = $473bb02057a7af41$var$Kb(a, b), null != f && d.push($473bb02057a7af41$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $473bb02057a7af41$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $473bb02057a7af41$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $473bb02057a7af41$var$Kb(c, f), null != k && g.unshift($473bb02057a7af41$var$tf(c, k, h))) : e || (k = $473bb02057a7af41$var$Kb(c, f), null != k && g.push($473bb02057a7af41$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $473bb02057a7af41$var$xf = /\r\n?/g, $473bb02057a7af41$var$yf = /\u0000|\uFFFD/g;
function $473bb02057a7af41$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($473bb02057a7af41$var$xf, "\n").replace($473bb02057a7af41$var$yf, "");
}
function $473bb02057a7af41$var$Af(a, b, c) {
    b = $473bb02057a7af41$var$zf(b);
    if ($473bb02057a7af41$var$zf(a) !== b && c) throw Error($473bb02057a7af41$var$p(425));
}
function $473bb02057a7af41$var$Bf() {}
var $473bb02057a7af41$var$Cf = null, $473bb02057a7af41$var$Df = null;
function $473bb02057a7af41$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $473bb02057a7af41$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $473bb02057a7af41$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $473bb02057a7af41$var$Hf = "function" === typeof Promise ? Promise : void 0, $473bb02057a7af41$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $473bb02057a7af41$var$Hf ? function(a) {
    return $473bb02057a7af41$var$Hf.resolve(null).then(a).catch($473bb02057a7af41$var$If);
} : $473bb02057a7af41$var$Ff;
function $473bb02057a7af41$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $473bb02057a7af41$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $473bb02057a7af41$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $473bb02057a7af41$var$bd(b);
}
function $473bb02057a7af41$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $473bb02057a7af41$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $473bb02057a7af41$var$Nf = Math.random().toString(36).slice(2), $473bb02057a7af41$var$Of = "__reactFiber$" + $473bb02057a7af41$var$Nf, $473bb02057a7af41$var$Pf = "__reactProps$" + $473bb02057a7af41$var$Nf, $473bb02057a7af41$var$uf = "__reactContainer$" + $473bb02057a7af41$var$Nf, $473bb02057a7af41$var$of = "__reactEvents$" + $473bb02057a7af41$var$Nf, $473bb02057a7af41$var$Qf = "__reactListeners$" + $473bb02057a7af41$var$Nf, $473bb02057a7af41$var$Rf = "__reactHandles$" + $473bb02057a7af41$var$Nf;
function $473bb02057a7af41$var$Wc(a) {
    var b = a[$473bb02057a7af41$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$473bb02057a7af41$var$uf] || c[$473bb02057a7af41$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $473bb02057a7af41$var$Mf(a); null !== a;){
                if (c = a[$473bb02057a7af41$var$Of]) return c;
                a = $473bb02057a7af41$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $473bb02057a7af41$var$Cb(a) {
    a = a[$473bb02057a7af41$var$Of] || a[$473bb02057a7af41$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $473bb02057a7af41$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($473bb02057a7af41$var$p(33));
}
function $473bb02057a7af41$var$Db(a) {
    return a[$473bb02057a7af41$var$Pf] || null;
}
var $473bb02057a7af41$var$Sf = [], $473bb02057a7af41$var$Tf = -1;
function $473bb02057a7af41$var$Uf(a) {
    return {
        current: a
    };
}
function $473bb02057a7af41$var$E(a) {
    0 > $473bb02057a7af41$var$Tf || (a.current = $473bb02057a7af41$var$Sf[$473bb02057a7af41$var$Tf], $473bb02057a7af41$var$Sf[$473bb02057a7af41$var$Tf] = null, $473bb02057a7af41$var$Tf--);
}
function $473bb02057a7af41$var$G(a, b) {
    $473bb02057a7af41$var$Tf++;
    $473bb02057a7af41$var$Sf[$473bb02057a7af41$var$Tf] = a.current;
    a.current = b;
}
var $473bb02057a7af41$var$Vf = {}, $473bb02057a7af41$var$H = $473bb02057a7af41$var$Uf($473bb02057a7af41$var$Vf), $473bb02057a7af41$var$Wf = $473bb02057a7af41$var$Uf(!1), $473bb02057a7af41$var$Xf = $473bb02057a7af41$var$Vf;
function $473bb02057a7af41$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $473bb02057a7af41$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $473bb02057a7af41$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $473bb02057a7af41$var$$f() {
    $473bb02057a7af41$var$E($473bb02057a7af41$var$Wf);
    $473bb02057a7af41$var$E($473bb02057a7af41$var$H);
}
function $473bb02057a7af41$var$ag(a, b, c) {
    if ($473bb02057a7af41$var$H.current !== $473bb02057a7af41$var$Vf) throw Error($473bb02057a7af41$var$p(168));
    $473bb02057a7af41$var$G($473bb02057a7af41$var$H, b);
    $473bb02057a7af41$var$G($473bb02057a7af41$var$Wf, c);
}
function $473bb02057a7af41$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($473bb02057a7af41$var$p(108, $473bb02057a7af41$var$Ra(a) || "Unknown", e));
    return $473bb02057a7af41$var$A({}, c, d);
}
function $473bb02057a7af41$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $473bb02057a7af41$var$Vf;
    $473bb02057a7af41$var$Xf = $473bb02057a7af41$var$H.current;
    $473bb02057a7af41$var$G($473bb02057a7af41$var$H, a);
    $473bb02057a7af41$var$G($473bb02057a7af41$var$Wf, $473bb02057a7af41$var$Wf.current);
    return !0;
}
function $473bb02057a7af41$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($473bb02057a7af41$var$p(169));
    c ? (a = $473bb02057a7af41$var$bg(a, b, $473bb02057a7af41$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $473bb02057a7af41$var$E($473bb02057a7af41$var$Wf), $473bb02057a7af41$var$E($473bb02057a7af41$var$H), $473bb02057a7af41$var$G($473bb02057a7af41$var$H, a)) : $473bb02057a7af41$var$E($473bb02057a7af41$var$Wf);
    $473bb02057a7af41$var$G($473bb02057a7af41$var$Wf, c);
}
var $473bb02057a7af41$var$eg = null, $473bb02057a7af41$var$fg = !1, $473bb02057a7af41$var$gg = !1;
function $473bb02057a7af41$var$hg(a) {
    null === $473bb02057a7af41$var$eg ? $473bb02057a7af41$var$eg = [
        a
    ] : $473bb02057a7af41$var$eg.push(a);
}
function $473bb02057a7af41$var$ig(a) {
    $473bb02057a7af41$var$fg = !0;
    $473bb02057a7af41$var$hg(a);
}
function $473bb02057a7af41$var$jg() {
    if (!$473bb02057a7af41$var$gg && null !== $473bb02057a7af41$var$eg) {
        $473bb02057a7af41$var$gg = !0;
        var a = 0, b = $473bb02057a7af41$var$C;
        try {
            var c = $473bb02057a7af41$var$eg;
            for($473bb02057a7af41$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $473bb02057a7af41$var$eg = null;
            $473bb02057a7af41$var$fg = !1;
        } catch (e) {
            throw null !== $473bb02057a7af41$var$eg && ($473bb02057a7af41$var$eg = $473bb02057a7af41$var$eg.slice(a + 1)), $473bb02057a7af41$var$ac($473bb02057a7af41$var$fc, $473bb02057a7af41$var$jg), e;
        } finally{
            $473bb02057a7af41$var$C = b, $473bb02057a7af41$var$gg = !1;
        }
    }
    return null;
}
var $473bb02057a7af41$var$kg = [], $473bb02057a7af41$var$lg = 0, $473bb02057a7af41$var$mg = null, $473bb02057a7af41$var$ng = 0, $473bb02057a7af41$var$og = [], $473bb02057a7af41$var$pg = 0, $473bb02057a7af41$var$qg = null, $473bb02057a7af41$var$rg = 1, $473bb02057a7af41$var$sg = "";
function $473bb02057a7af41$var$tg(a, b) {
    $473bb02057a7af41$var$kg[$473bb02057a7af41$var$lg++] = $473bb02057a7af41$var$ng;
    $473bb02057a7af41$var$kg[$473bb02057a7af41$var$lg++] = $473bb02057a7af41$var$mg;
    $473bb02057a7af41$var$mg = a;
    $473bb02057a7af41$var$ng = b;
}
function $473bb02057a7af41$var$ug(a, b, c) {
    $473bb02057a7af41$var$og[$473bb02057a7af41$var$pg++] = $473bb02057a7af41$var$rg;
    $473bb02057a7af41$var$og[$473bb02057a7af41$var$pg++] = $473bb02057a7af41$var$sg;
    $473bb02057a7af41$var$og[$473bb02057a7af41$var$pg++] = $473bb02057a7af41$var$qg;
    $473bb02057a7af41$var$qg = a;
    var d = $473bb02057a7af41$var$rg;
    a = $473bb02057a7af41$var$sg;
    var e = 32 - $473bb02057a7af41$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $473bb02057a7af41$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $473bb02057a7af41$var$rg = 1 << 32 - $473bb02057a7af41$var$oc(b) + e | c << e | d;
        $473bb02057a7af41$var$sg = f + a;
    } else $473bb02057a7af41$var$rg = 1 << f | c << e | d, $473bb02057a7af41$var$sg = a;
}
function $473bb02057a7af41$var$vg(a) {
    null !== a.return && ($473bb02057a7af41$var$tg(a, 1), $473bb02057a7af41$var$ug(a, 1, 0));
}
function $473bb02057a7af41$var$wg(a) {
    for(; a === $473bb02057a7af41$var$mg;)$473bb02057a7af41$var$mg = $473bb02057a7af41$var$kg[--$473bb02057a7af41$var$lg], $473bb02057a7af41$var$kg[$473bb02057a7af41$var$lg] = null, $473bb02057a7af41$var$ng = $473bb02057a7af41$var$kg[--$473bb02057a7af41$var$lg], $473bb02057a7af41$var$kg[$473bb02057a7af41$var$lg] = null;
    for(; a === $473bb02057a7af41$var$qg;)$473bb02057a7af41$var$qg = $473bb02057a7af41$var$og[--$473bb02057a7af41$var$pg], $473bb02057a7af41$var$og[$473bb02057a7af41$var$pg] = null, $473bb02057a7af41$var$sg = $473bb02057a7af41$var$og[--$473bb02057a7af41$var$pg], $473bb02057a7af41$var$og[$473bb02057a7af41$var$pg] = null, $473bb02057a7af41$var$rg = $473bb02057a7af41$var$og[--$473bb02057a7af41$var$pg], $473bb02057a7af41$var$og[$473bb02057a7af41$var$pg] = null;
}
var $473bb02057a7af41$var$xg = null, $473bb02057a7af41$var$yg = null, $473bb02057a7af41$var$I = !1, $473bb02057a7af41$var$zg = null;
function $473bb02057a7af41$var$Ag(a, b) {
    var c = $473bb02057a7af41$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $473bb02057a7af41$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $473bb02057a7af41$var$xg = a, $473bb02057a7af41$var$yg = $473bb02057a7af41$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $473bb02057a7af41$var$xg = a, $473bb02057a7af41$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $473bb02057a7af41$var$qg ? {
                id: $473bb02057a7af41$var$rg,
                overflow: $473bb02057a7af41$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $473bb02057a7af41$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $473bb02057a7af41$var$xg = a, $473bb02057a7af41$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $473bb02057a7af41$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $473bb02057a7af41$var$Eg(a) {
    if ($473bb02057a7af41$var$I) {
        var b = $473bb02057a7af41$var$yg;
        if (b) {
            var c = b;
            if (!$473bb02057a7af41$var$Cg(a, b)) {
                if ($473bb02057a7af41$var$Dg(a)) throw Error($473bb02057a7af41$var$p(418));
                b = $473bb02057a7af41$var$Lf(c.nextSibling);
                var d = $473bb02057a7af41$var$xg;
                b && $473bb02057a7af41$var$Cg(a, b) ? $473bb02057a7af41$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $473bb02057a7af41$var$I = !1, $473bb02057a7af41$var$xg = a);
            }
        } else {
            if ($473bb02057a7af41$var$Dg(a)) throw Error($473bb02057a7af41$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $473bb02057a7af41$var$I = !1;
            $473bb02057a7af41$var$xg = a;
        }
    }
}
function $473bb02057a7af41$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $473bb02057a7af41$var$xg = a;
}
function $473bb02057a7af41$var$Gg(a) {
    if (a !== $473bb02057a7af41$var$xg) return !1;
    if (!$473bb02057a7af41$var$I) return $473bb02057a7af41$var$Fg(a), $473bb02057a7af41$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$473bb02057a7af41$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $473bb02057a7af41$var$yg)) {
        if ($473bb02057a7af41$var$Dg(a)) throw $473bb02057a7af41$var$Hg(), Error($473bb02057a7af41$var$p(418));
        for(; b;)$473bb02057a7af41$var$Ag(a, b), b = $473bb02057a7af41$var$Lf(b.nextSibling);
    }
    $473bb02057a7af41$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($473bb02057a7af41$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $473bb02057a7af41$var$yg = $473bb02057a7af41$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $473bb02057a7af41$var$yg = null;
        }
    } else $473bb02057a7af41$var$yg = $473bb02057a7af41$var$xg ? $473bb02057a7af41$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $473bb02057a7af41$var$Hg() {
    for(var a = $473bb02057a7af41$var$yg; a;)a = $473bb02057a7af41$var$Lf(a.nextSibling);
}
function $473bb02057a7af41$var$Ig() {
    $473bb02057a7af41$var$yg = $473bb02057a7af41$var$xg = null;
    $473bb02057a7af41$var$I = !1;
}
function $473bb02057a7af41$var$Jg(a) {
    null === $473bb02057a7af41$var$zg ? $473bb02057a7af41$var$zg = [
        a
    ] : $473bb02057a7af41$var$zg.push(a);
}
var $473bb02057a7af41$var$Kg = $473bb02057a7af41$var$ua.ReactCurrentBatchConfig;
function $473bb02057a7af41$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($473bb02057a7af41$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($473bb02057a7af41$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($473bb02057a7af41$var$p(284));
        if (!c._owner) throw Error($473bb02057a7af41$var$p(290, a));
    }
    return a;
}
function $473bb02057a7af41$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($473bb02057a7af41$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $473bb02057a7af41$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $473bb02057a7af41$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $473bb02057a7af41$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $473bb02057a7af41$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $473bb02057a7af41$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $473bb02057a7af41$var$Ha && $473bb02057a7af41$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $473bb02057a7af41$var$Lg(a, b, c), d.return = a, d;
        d = $473bb02057a7af41$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $473bb02057a7af41$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $473bb02057a7af41$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $473bb02057a7af41$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $473bb02057a7af41$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $473bb02057a7af41$var$va:
                    return c = $473bb02057a7af41$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $473bb02057a7af41$var$Lg(a, null, b), c.return = a, c;
                case $473bb02057a7af41$var$wa:
                    return b = $473bb02057a7af41$var$Sg(b, a.mode, c), b.return = a, b;
                case $473bb02057a7af41$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($473bb02057a7af41$var$eb(b) || $473bb02057a7af41$var$Ka(b)) return b = $473bb02057a7af41$var$Tg(b, a.mode, c, null), b.return = a, b;
            $473bb02057a7af41$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $473bb02057a7af41$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $473bb02057a7af41$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $473bb02057a7af41$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($473bb02057a7af41$var$eb(c) || $473bb02057a7af41$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $473bb02057a7af41$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $473bb02057a7af41$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $473bb02057a7af41$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $473bb02057a7af41$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($473bb02057a7af41$var$eb(d) || $473bb02057a7af41$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $473bb02057a7af41$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $473bb02057a7af41$var$I && $473bb02057a7af41$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $473bb02057a7af41$var$I && $473bb02057a7af41$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $473bb02057a7af41$var$I && $473bb02057a7af41$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $473bb02057a7af41$var$Ka(h);
        if ("function" !== typeof l) throw Error($473bb02057a7af41$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($473bb02057a7af41$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $473bb02057a7af41$var$I && $473bb02057a7af41$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $473bb02057a7af41$var$I && $473bb02057a7af41$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $473bb02057a7af41$var$I && $473bb02057a7af41$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $473bb02057a7af41$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $473bb02057a7af41$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $473bb02057a7af41$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $473bb02057a7af41$var$Ha && $473bb02057a7af41$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $473bb02057a7af41$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $473bb02057a7af41$var$ya ? (d = $473bb02057a7af41$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $473bb02057a7af41$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $473bb02057a7af41$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $473bb02057a7af41$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $473bb02057a7af41$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $473bb02057a7af41$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($473bb02057a7af41$var$eb(f)) return n(a, d, f, h);
            if ($473bb02057a7af41$var$Ka(f)) return t(a, d, f, h);
            $473bb02057a7af41$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $473bb02057a7af41$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $473bb02057a7af41$var$Ug = $473bb02057a7af41$var$Og(!0), $473bb02057a7af41$var$Vg = $473bb02057a7af41$var$Og(!1), $473bb02057a7af41$var$Wg = $473bb02057a7af41$var$Uf(null), $473bb02057a7af41$var$Xg = null, $473bb02057a7af41$var$Yg = null, $473bb02057a7af41$var$Zg = null;
function $473bb02057a7af41$var$$g() {
    $473bb02057a7af41$var$Zg = $473bb02057a7af41$var$Yg = $473bb02057a7af41$var$Xg = null;
}
function $473bb02057a7af41$var$ah(a) {
    var b = $473bb02057a7af41$var$Wg.current;
    $473bb02057a7af41$var$E($473bb02057a7af41$var$Wg);
    a._currentValue = b;
}
function $473bb02057a7af41$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $473bb02057a7af41$var$ch(a, b) {
    $473bb02057a7af41$var$Xg = a;
    $473bb02057a7af41$var$Zg = $473bb02057a7af41$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($473bb02057a7af41$var$dh = !0), a.firstContext = null);
}
function $473bb02057a7af41$var$eh(a) {
    var b = a._currentValue;
    if ($473bb02057a7af41$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $473bb02057a7af41$var$Yg) {
            if (null === $473bb02057a7af41$var$Xg) throw Error($473bb02057a7af41$var$p(308));
            $473bb02057a7af41$var$Yg = a;
            $473bb02057a7af41$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $473bb02057a7af41$var$Yg = $473bb02057a7af41$var$Yg.next = a;
    }
    return b;
}
var $473bb02057a7af41$var$fh = null;
function $473bb02057a7af41$var$gh(a) {
    null === $473bb02057a7af41$var$fh ? $473bb02057a7af41$var$fh = [
        a
    ] : $473bb02057a7af41$var$fh.push(a);
}
function $473bb02057a7af41$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $473bb02057a7af41$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $473bb02057a7af41$var$ih(a, d);
}
function $473bb02057a7af41$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $473bb02057a7af41$var$jh = !1;
function $473bb02057a7af41$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $473bb02057a7af41$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $473bb02057a7af41$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $473bb02057a7af41$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($473bb02057a7af41$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $473bb02057a7af41$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $473bb02057a7af41$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $473bb02057a7af41$var$ih(a, c);
}
function $473bb02057a7af41$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $473bb02057a7af41$var$Cc(a, c);
    }
}
function $473bb02057a7af41$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $473bb02057a7af41$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $473bb02057a7af41$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $473bb02057a7af41$var$A({}, q, r);
                            break a;
                        case 2:
                            $473bb02057a7af41$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $473bb02057a7af41$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $473bb02057a7af41$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($473bb02057a7af41$var$p(191, e));
            e.call(d);
        }
    }
}
var $473bb02057a7af41$var$th = {}, $473bb02057a7af41$var$uh = $473bb02057a7af41$var$Uf($473bb02057a7af41$var$th), $473bb02057a7af41$var$vh = $473bb02057a7af41$var$Uf($473bb02057a7af41$var$th), $473bb02057a7af41$var$wh = $473bb02057a7af41$var$Uf($473bb02057a7af41$var$th);
function $473bb02057a7af41$var$xh(a) {
    if (a === $473bb02057a7af41$var$th) throw Error($473bb02057a7af41$var$p(174));
    return a;
}
function $473bb02057a7af41$var$yh(a, b) {
    $473bb02057a7af41$var$G($473bb02057a7af41$var$wh, b);
    $473bb02057a7af41$var$G($473bb02057a7af41$var$vh, a);
    $473bb02057a7af41$var$G($473bb02057a7af41$var$uh, $473bb02057a7af41$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $473bb02057a7af41$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $473bb02057a7af41$var$lb(b, a);
    }
    $473bb02057a7af41$var$E($473bb02057a7af41$var$uh);
    $473bb02057a7af41$var$G($473bb02057a7af41$var$uh, b);
}
function $473bb02057a7af41$var$zh() {
    $473bb02057a7af41$var$E($473bb02057a7af41$var$uh);
    $473bb02057a7af41$var$E($473bb02057a7af41$var$vh);
    $473bb02057a7af41$var$E($473bb02057a7af41$var$wh);
}
function $473bb02057a7af41$var$Ah(a) {
    $473bb02057a7af41$var$xh($473bb02057a7af41$var$wh.current);
    var b = $473bb02057a7af41$var$xh($473bb02057a7af41$var$uh.current);
    var c = $473bb02057a7af41$var$lb(b, a.type);
    b !== c && ($473bb02057a7af41$var$G($473bb02057a7af41$var$vh, a), $473bb02057a7af41$var$G($473bb02057a7af41$var$uh, c));
}
function $473bb02057a7af41$var$Bh(a) {
    $473bb02057a7af41$var$vh.current === a && ($473bb02057a7af41$var$E($473bb02057a7af41$var$uh), $473bb02057a7af41$var$E($473bb02057a7af41$var$vh));
}
var $473bb02057a7af41$var$L = $473bb02057a7af41$var$Uf(0);
function $473bb02057a7af41$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $473bb02057a7af41$var$Dh = [];
function $473bb02057a7af41$var$Eh() {
    for(var a = 0; a < $473bb02057a7af41$var$Dh.length; a++)$473bb02057a7af41$var$Dh[a]._workInProgressVersionPrimary = null;
    $473bb02057a7af41$var$Dh.length = 0;
}
var $473bb02057a7af41$var$Fh = $473bb02057a7af41$var$ua.ReactCurrentDispatcher, $473bb02057a7af41$var$Gh = $473bb02057a7af41$var$ua.ReactCurrentBatchConfig, $473bb02057a7af41$var$Hh = 0, $473bb02057a7af41$var$M = null, $473bb02057a7af41$var$N = null, $473bb02057a7af41$var$O = null, $473bb02057a7af41$var$Ih = !1, $473bb02057a7af41$var$Jh = !1, $473bb02057a7af41$var$Kh = 0, $473bb02057a7af41$var$Lh = 0;
function $473bb02057a7af41$var$P() {
    throw Error($473bb02057a7af41$var$p(321));
}
function $473bb02057a7af41$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$473bb02057a7af41$var$He(a[c], b[c])) return !1;
    return !0;
}
function $473bb02057a7af41$var$Nh(a, b, c, d, e, f) {
    $473bb02057a7af41$var$Hh = f;
    $473bb02057a7af41$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $473bb02057a7af41$var$Fh.current = null === a || null === a.memoizedState ? $473bb02057a7af41$var$Oh : $473bb02057a7af41$var$Ph;
    a = c(d, e);
    if ($473bb02057a7af41$var$Jh) {
        f = 0;
        do {
            $473bb02057a7af41$var$Jh = !1;
            $473bb02057a7af41$var$Kh = 0;
            if (25 <= f) throw Error($473bb02057a7af41$var$p(301));
            f += 1;
            $473bb02057a7af41$var$O = $473bb02057a7af41$var$N = null;
            b.updateQueue = null;
            $473bb02057a7af41$var$Fh.current = $473bb02057a7af41$var$Qh;
            a = c(d, e);
        }while ($473bb02057a7af41$var$Jh);
    }
    $473bb02057a7af41$var$Fh.current = $473bb02057a7af41$var$Rh;
    b = null !== $473bb02057a7af41$var$N && null !== $473bb02057a7af41$var$N.next;
    $473bb02057a7af41$var$Hh = 0;
    $473bb02057a7af41$var$O = $473bb02057a7af41$var$N = $473bb02057a7af41$var$M = null;
    $473bb02057a7af41$var$Ih = !1;
    if (b) throw Error($473bb02057a7af41$var$p(300));
    return a;
}
function $473bb02057a7af41$var$Sh() {
    var a = 0 !== $473bb02057a7af41$var$Kh;
    $473bb02057a7af41$var$Kh = 0;
    return a;
}
function $473bb02057a7af41$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $473bb02057a7af41$var$O ? $473bb02057a7af41$var$M.memoizedState = $473bb02057a7af41$var$O = a : $473bb02057a7af41$var$O = $473bb02057a7af41$var$O.next = a;
    return $473bb02057a7af41$var$O;
}
function $473bb02057a7af41$var$Uh() {
    if (null === $473bb02057a7af41$var$N) {
        var a = $473bb02057a7af41$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $473bb02057a7af41$var$N.next;
    var b = null === $473bb02057a7af41$var$O ? $473bb02057a7af41$var$M.memoizedState : $473bb02057a7af41$var$O.next;
    if (null !== b) $473bb02057a7af41$var$O = b, $473bb02057a7af41$var$N = a;
    else {
        if (null === a) throw Error($473bb02057a7af41$var$p(310));
        $473bb02057a7af41$var$N = a;
        a = {
            memoizedState: $473bb02057a7af41$var$N.memoizedState,
            baseState: $473bb02057a7af41$var$N.baseState,
            baseQueue: $473bb02057a7af41$var$N.baseQueue,
            queue: $473bb02057a7af41$var$N.queue,
            next: null
        };
        null === $473bb02057a7af41$var$O ? $473bb02057a7af41$var$M.memoizedState = $473bb02057a7af41$var$O = a : $473bb02057a7af41$var$O = $473bb02057a7af41$var$O.next = a;
    }
    return $473bb02057a7af41$var$O;
}
function $473bb02057a7af41$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $473bb02057a7af41$var$Wh(a) {
    var b = $473bb02057a7af41$var$Uh(), c = b.queue;
    if (null === c) throw Error($473bb02057a7af41$var$p(311));
    c.lastRenderedReducer = a;
    var d = $473bb02057a7af41$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($473bb02057a7af41$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $473bb02057a7af41$var$M.lanes |= m;
                $473bb02057a7af41$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $473bb02057a7af41$var$He(d, b.memoizedState) || ($473bb02057a7af41$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $473bb02057a7af41$var$M.lanes |= f, $473bb02057a7af41$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $473bb02057a7af41$var$Xh(a) {
    var b = $473bb02057a7af41$var$Uh(), c = b.queue;
    if (null === c) throw Error($473bb02057a7af41$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $473bb02057a7af41$var$He(f, b.memoizedState) || ($473bb02057a7af41$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $473bb02057a7af41$var$Yh() {}
function $473bb02057a7af41$var$Zh(a, b) {
    var c = $473bb02057a7af41$var$M, d = $473bb02057a7af41$var$Uh(), e = b(), f = !$473bb02057a7af41$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $473bb02057a7af41$var$dh = !0);
    d = d.queue;
    $473bb02057a7af41$var$$h($473bb02057a7af41$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $473bb02057a7af41$var$O && $473bb02057a7af41$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $473bb02057a7af41$var$bi(9, $473bb02057a7af41$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $473bb02057a7af41$var$Q) throw Error($473bb02057a7af41$var$p(349));
        0 !== ($473bb02057a7af41$var$Hh & 30) || $473bb02057a7af41$var$di(c, b, e);
    }
    return e;
}
function $473bb02057a7af41$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $473bb02057a7af41$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $473bb02057a7af41$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $473bb02057a7af41$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $473bb02057a7af41$var$ei(b) && $473bb02057a7af41$var$fi(a);
}
function $473bb02057a7af41$var$ai(a, b, c) {
    return c(function() {
        $473bb02057a7af41$var$ei(b) && $473bb02057a7af41$var$fi(a);
    });
}
function $473bb02057a7af41$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$473bb02057a7af41$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $473bb02057a7af41$var$fi(a) {
    var b = $473bb02057a7af41$var$ih(a, 1);
    null !== b && $473bb02057a7af41$var$gi(b, a, 1, -1);
}
function $473bb02057a7af41$var$hi(a) {
    var b = $473bb02057a7af41$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $473bb02057a7af41$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $473bb02057a7af41$var$ii.bind(null, $473bb02057a7af41$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $473bb02057a7af41$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $473bb02057a7af41$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $473bb02057a7af41$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $473bb02057a7af41$var$ji() {
    return $473bb02057a7af41$var$Uh().memoizedState;
}
function $473bb02057a7af41$var$ki(a, b, c, d) {
    var e = $473bb02057a7af41$var$Th();
    $473bb02057a7af41$var$M.flags |= a;
    e.memoizedState = $473bb02057a7af41$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $473bb02057a7af41$var$li(a, b, c, d) {
    var e = $473bb02057a7af41$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $473bb02057a7af41$var$N) {
        var g = $473bb02057a7af41$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $473bb02057a7af41$var$Mh(d, g.deps)) {
            e.memoizedState = $473bb02057a7af41$var$bi(b, c, f, d);
            return;
        }
    }
    $473bb02057a7af41$var$M.flags |= a;
    e.memoizedState = $473bb02057a7af41$var$bi(1 | b, c, f, d);
}
function $473bb02057a7af41$var$mi(a, b) {
    return $473bb02057a7af41$var$ki(8390656, 8, a, b);
}
function $473bb02057a7af41$var$$h(a, b) {
    return $473bb02057a7af41$var$li(2048, 8, a, b);
}
function $473bb02057a7af41$var$ni(a, b) {
    return $473bb02057a7af41$var$li(4, 2, a, b);
}
function $473bb02057a7af41$var$oi(a, b) {
    return $473bb02057a7af41$var$li(4, 4, a, b);
}
function $473bb02057a7af41$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $473bb02057a7af41$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $473bb02057a7af41$var$li(4, 4, $473bb02057a7af41$var$pi.bind(null, b, a), c);
}
function $473bb02057a7af41$var$ri() {}
function $473bb02057a7af41$var$si(a, b) {
    var c = $473bb02057a7af41$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $473bb02057a7af41$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $473bb02057a7af41$var$ti(a, b) {
    var c = $473bb02057a7af41$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $473bb02057a7af41$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $473bb02057a7af41$var$ui(a, b, c) {
    if (0 === ($473bb02057a7af41$var$Hh & 21)) return a.baseState && (a.baseState = !1, $473bb02057a7af41$var$dh = !0), a.memoizedState = c;
    $473bb02057a7af41$var$He(c, b) || (c = $473bb02057a7af41$var$yc(), $473bb02057a7af41$var$M.lanes |= c, $473bb02057a7af41$var$rh |= c, a.baseState = !0);
    return b;
}
function $473bb02057a7af41$var$vi(a, b) {
    var c = $473bb02057a7af41$var$C;
    $473bb02057a7af41$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $473bb02057a7af41$var$Gh.transition;
    $473bb02057a7af41$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $473bb02057a7af41$var$C = c, $473bb02057a7af41$var$Gh.transition = d;
    }
}
function $473bb02057a7af41$var$wi() {
    return $473bb02057a7af41$var$Uh().memoizedState;
}
function $473bb02057a7af41$var$xi(a, b, c) {
    var d = $473bb02057a7af41$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($473bb02057a7af41$var$zi(a)) $473bb02057a7af41$var$Ai(b, c);
    else if (c = $473bb02057a7af41$var$hh(a, b, c, d), null !== c) {
        var e = $473bb02057a7af41$var$R();
        $473bb02057a7af41$var$gi(c, a, d, e);
        $473bb02057a7af41$var$Bi(c, b, d);
    }
}
function $473bb02057a7af41$var$ii(a, b, c) {
    var d = $473bb02057a7af41$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($473bb02057a7af41$var$zi(a)) $473bb02057a7af41$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($473bb02057a7af41$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $473bb02057a7af41$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $473bb02057a7af41$var$hh(a, b, e, d);
        null !== c && (e = $473bb02057a7af41$var$R(), $473bb02057a7af41$var$gi(c, a, d, e), $473bb02057a7af41$var$Bi(c, b, d));
    }
}
function $473bb02057a7af41$var$zi(a) {
    var b = a.alternate;
    return a === $473bb02057a7af41$var$M || null !== b && b === $473bb02057a7af41$var$M;
}
function $473bb02057a7af41$var$Ai(a, b) {
    $473bb02057a7af41$var$Jh = $473bb02057a7af41$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $473bb02057a7af41$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $473bb02057a7af41$var$Cc(a, c);
    }
}
var $473bb02057a7af41$var$Rh = {
    readContext: $473bb02057a7af41$var$eh,
    useCallback: $473bb02057a7af41$var$P,
    useContext: $473bb02057a7af41$var$P,
    useEffect: $473bb02057a7af41$var$P,
    useImperativeHandle: $473bb02057a7af41$var$P,
    useInsertionEffect: $473bb02057a7af41$var$P,
    useLayoutEffect: $473bb02057a7af41$var$P,
    useMemo: $473bb02057a7af41$var$P,
    useReducer: $473bb02057a7af41$var$P,
    useRef: $473bb02057a7af41$var$P,
    useState: $473bb02057a7af41$var$P,
    useDebugValue: $473bb02057a7af41$var$P,
    useDeferredValue: $473bb02057a7af41$var$P,
    useTransition: $473bb02057a7af41$var$P,
    useMutableSource: $473bb02057a7af41$var$P,
    useSyncExternalStore: $473bb02057a7af41$var$P,
    useId: $473bb02057a7af41$var$P,
    unstable_isNewReconciler: !1
}, $473bb02057a7af41$var$Oh = {
    readContext: $473bb02057a7af41$var$eh,
    useCallback: function(a, b) {
        $473bb02057a7af41$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $473bb02057a7af41$var$eh,
    useEffect: $473bb02057a7af41$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $473bb02057a7af41$var$ki(4194308, 4, $473bb02057a7af41$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $473bb02057a7af41$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $473bb02057a7af41$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $473bb02057a7af41$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $473bb02057a7af41$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $473bb02057a7af41$var$xi.bind(null, $473bb02057a7af41$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $473bb02057a7af41$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $473bb02057a7af41$var$hi,
    useDebugValue: $473bb02057a7af41$var$ri,
    useDeferredValue: function(a) {
        return $473bb02057a7af41$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $473bb02057a7af41$var$hi(!1), b = a[0];
        a = $473bb02057a7af41$var$vi.bind(null, a[1]);
        $473bb02057a7af41$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $473bb02057a7af41$var$M, e = $473bb02057a7af41$var$Th();
        if ($473bb02057a7af41$var$I) {
            if (void 0 === c) throw Error($473bb02057a7af41$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $473bb02057a7af41$var$Q) throw Error($473bb02057a7af41$var$p(349));
            0 !== ($473bb02057a7af41$var$Hh & 30) || $473bb02057a7af41$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $473bb02057a7af41$var$mi($473bb02057a7af41$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $473bb02057a7af41$var$bi(9, $473bb02057a7af41$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $473bb02057a7af41$var$Th(), b = $473bb02057a7af41$var$Q.identifierPrefix;
        if ($473bb02057a7af41$var$I) {
            var c = $473bb02057a7af41$var$sg;
            var d = $473bb02057a7af41$var$rg;
            c = (d & ~(1 << 32 - $473bb02057a7af41$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $473bb02057a7af41$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $473bb02057a7af41$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $473bb02057a7af41$var$Ph = {
    readContext: $473bb02057a7af41$var$eh,
    useCallback: $473bb02057a7af41$var$si,
    useContext: $473bb02057a7af41$var$eh,
    useEffect: $473bb02057a7af41$var$$h,
    useImperativeHandle: $473bb02057a7af41$var$qi,
    useInsertionEffect: $473bb02057a7af41$var$ni,
    useLayoutEffect: $473bb02057a7af41$var$oi,
    useMemo: $473bb02057a7af41$var$ti,
    useReducer: $473bb02057a7af41$var$Wh,
    useRef: $473bb02057a7af41$var$ji,
    useState: function() {
        return $473bb02057a7af41$var$Wh($473bb02057a7af41$var$Vh);
    },
    useDebugValue: $473bb02057a7af41$var$ri,
    useDeferredValue: function(a) {
        var b = $473bb02057a7af41$var$Uh();
        return $473bb02057a7af41$var$ui(b, $473bb02057a7af41$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $473bb02057a7af41$var$Wh($473bb02057a7af41$var$Vh)[0], b = $473bb02057a7af41$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $473bb02057a7af41$var$Yh,
    useSyncExternalStore: $473bb02057a7af41$var$Zh,
    useId: $473bb02057a7af41$var$wi,
    unstable_isNewReconciler: !1
}, $473bb02057a7af41$var$Qh = {
    readContext: $473bb02057a7af41$var$eh,
    useCallback: $473bb02057a7af41$var$si,
    useContext: $473bb02057a7af41$var$eh,
    useEffect: $473bb02057a7af41$var$$h,
    useImperativeHandle: $473bb02057a7af41$var$qi,
    useInsertionEffect: $473bb02057a7af41$var$ni,
    useLayoutEffect: $473bb02057a7af41$var$oi,
    useMemo: $473bb02057a7af41$var$ti,
    useReducer: $473bb02057a7af41$var$Xh,
    useRef: $473bb02057a7af41$var$ji,
    useState: function() {
        return $473bb02057a7af41$var$Xh($473bb02057a7af41$var$Vh);
    },
    useDebugValue: $473bb02057a7af41$var$ri,
    useDeferredValue: function(a) {
        var b = $473bb02057a7af41$var$Uh();
        return null === $473bb02057a7af41$var$N ? b.memoizedState = a : $473bb02057a7af41$var$ui(b, $473bb02057a7af41$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $473bb02057a7af41$var$Xh($473bb02057a7af41$var$Vh)[0], b = $473bb02057a7af41$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $473bb02057a7af41$var$Yh,
    useSyncExternalStore: $473bb02057a7af41$var$Zh,
    useId: $473bb02057a7af41$var$wi,
    unstable_isNewReconciler: !1
};
function $473bb02057a7af41$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $473bb02057a7af41$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $473bb02057a7af41$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $473bb02057a7af41$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $473bb02057a7af41$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $473bb02057a7af41$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $473bb02057a7af41$var$R(), e = $473bb02057a7af41$var$yi(a), f = $473bb02057a7af41$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $473bb02057a7af41$var$nh(a, f, e);
        null !== b && ($473bb02057a7af41$var$gi(b, a, e, d), $473bb02057a7af41$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $473bb02057a7af41$var$R(), e = $473bb02057a7af41$var$yi(a), f = $473bb02057a7af41$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $473bb02057a7af41$var$nh(a, f, e);
        null !== b && ($473bb02057a7af41$var$gi(b, a, e, d), $473bb02057a7af41$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $473bb02057a7af41$var$R(), d = $473bb02057a7af41$var$yi(a), e = $473bb02057a7af41$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $473bb02057a7af41$var$nh(a, e, d);
        null !== b && ($473bb02057a7af41$var$gi(b, a, d, c), $473bb02057a7af41$var$oh(b, a, d));
    }
};
function $473bb02057a7af41$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$473bb02057a7af41$var$Ie(c, d) || !$473bb02057a7af41$var$Ie(e, f) : !0;
}
function $473bb02057a7af41$var$Gi(a, b, c) {
    var d = !1, e = $473bb02057a7af41$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $473bb02057a7af41$var$eh(f) : (e = $473bb02057a7af41$var$Zf(b) ? $473bb02057a7af41$var$Xf : $473bb02057a7af41$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $473bb02057a7af41$var$Yf(a, e) : $473bb02057a7af41$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $473bb02057a7af41$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $473bb02057a7af41$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $473bb02057a7af41$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $473bb02057a7af41$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $473bb02057a7af41$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $473bb02057a7af41$var$eh(f) : (f = $473bb02057a7af41$var$Zf(b) ? $473bb02057a7af41$var$Xf : $473bb02057a7af41$var$H.current, e.context = $473bb02057a7af41$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($473bb02057a7af41$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $473bb02057a7af41$var$Ei.enqueueReplaceState(e, e.state, null), $473bb02057a7af41$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $473bb02057a7af41$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $473bb02057a7af41$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $473bb02057a7af41$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $473bb02057a7af41$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $473bb02057a7af41$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $473bb02057a7af41$var$Ni(a, b, c) {
    c = $473bb02057a7af41$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $473bb02057a7af41$var$Oi || ($473bb02057a7af41$var$Oi = !0, $473bb02057a7af41$var$Pi = d);
        $473bb02057a7af41$var$Li(a, b);
    };
    return c;
}
function $473bb02057a7af41$var$Qi(a, b, c) {
    c = $473bb02057a7af41$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $473bb02057a7af41$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $473bb02057a7af41$var$Li(a, b);
        "function" !== typeof d && (null === $473bb02057a7af41$var$Ri ? $473bb02057a7af41$var$Ri = new Set([
            this
        ]) : $473bb02057a7af41$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $473bb02057a7af41$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $473bb02057a7af41$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $473bb02057a7af41$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $473bb02057a7af41$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $473bb02057a7af41$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $473bb02057a7af41$var$mh(-1, 1), b.tag = 2, $473bb02057a7af41$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $473bb02057a7af41$var$Wi = $473bb02057a7af41$var$ua.ReactCurrentOwner, $473bb02057a7af41$var$dh = !1;
function $473bb02057a7af41$var$Xi(a, b, c, d) {
    b.child = null === a ? $473bb02057a7af41$var$Vg(b, null, c, d) : $473bb02057a7af41$var$Ug(b, a.child, c, d);
}
function $473bb02057a7af41$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $473bb02057a7af41$var$ch(b, e);
    d = $473bb02057a7af41$var$Nh(a, b, c, d, f, e);
    c = $473bb02057a7af41$var$Sh();
    if (null !== a && !$473bb02057a7af41$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $473bb02057a7af41$var$Zi(a, b, e);
    $473bb02057a7af41$var$I && c && $473bb02057a7af41$var$vg(b);
    b.flags |= 1;
    $473bb02057a7af41$var$Xi(a, b, d, e);
    return b.child;
}
function $473bb02057a7af41$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$473bb02057a7af41$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $473bb02057a7af41$var$bj(a, b, f, d, e);
        a = $473bb02057a7af41$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $473bb02057a7af41$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $473bb02057a7af41$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $473bb02057a7af41$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $473bb02057a7af41$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($473bb02057a7af41$var$Ie(f, d) && a.ref === b.ref) {
            if ($473bb02057a7af41$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($473bb02057a7af41$var$dh = !0);
            else return b.lanes = a.lanes, $473bb02057a7af41$var$Zi(a, b, e);
        }
    }
    return $473bb02057a7af41$var$cj(a, b, c, d, e);
}
function $473bb02057a7af41$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $473bb02057a7af41$var$G($473bb02057a7af41$var$ej, $473bb02057a7af41$var$fj), $473bb02057a7af41$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $473bb02057a7af41$var$G($473bb02057a7af41$var$ej, $473bb02057a7af41$var$fj), $473bb02057a7af41$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $473bb02057a7af41$var$G($473bb02057a7af41$var$ej, $473bb02057a7af41$var$fj);
            $473bb02057a7af41$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $473bb02057a7af41$var$G($473bb02057a7af41$var$ej, $473bb02057a7af41$var$fj), $473bb02057a7af41$var$fj |= d;
    $473bb02057a7af41$var$Xi(a, b, e, c);
    return b.child;
}
function $473bb02057a7af41$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $473bb02057a7af41$var$cj(a, b, c, d, e) {
    var f = $473bb02057a7af41$var$Zf(c) ? $473bb02057a7af41$var$Xf : $473bb02057a7af41$var$H.current;
    f = $473bb02057a7af41$var$Yf(b, f);
    $473bb02057a7af41$var$ch(b, e);
    c = $473bb02057a7af41$var$Nh(a, b, c, d, f, e);
    d = $473bb02057a7af41$var$Sh();
    if (null !== a && !$473bb02057a7af41$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $473bb02057a7af41$var$Zi(a, b, e);
    $473bb02057a7af41$var$I && d && $473bb02057a7af41$var$vg(b);
    b.flags |= 1;
    $473bb02057a7af41$var$Xi(a, b, c, e);
    return b.child;
}
function $473bb02057a7af41$var$hj(a, b, c, d, e) {
    if ($473bb02057a7af41$var$Zf(c)) {
        var f = !0;
        $473bb02057a7af41$var$cg(b);
    } else f = !1;
    $473bb02057a7af41$var$ch(b, e);
    if (null === b.stateNode) $473bb02057a7af41$var$ij(a, b), $473bb02057a7af41$var$Gi(b, c, d), $473bb02057a7af41$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $473bb02057a7af41$var$eh(l) : (l = $473bb02057a7af41$var$Zf(c) ? $473bb02057a7af41$var$Xf : $473bb02057a7af41$var$H.current, l = $473bb02057a7af41$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $473bb02057a7af41$var$Hi(b, g, d, l);
        $473bb02057a7af41$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $473bb02057a7af41$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $473bb02057a7af41$var$Wf.current || $473bb02057a7af41$var$jh ? ("function" === typeof m && ($473bb02057a7af41$var$Di(b, c, m, d), k = b.memoizedState), (h = $473bb02057a7af41$var$jh || $473bb02057a7af41$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $473bb02057a7af41$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $473bb02057a7af41$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $473bb02057a7af41$var$eh(k) : (k = $473bb02057a7af41$var$Zf(c) ? $473bb02057a7af41$var$Xf : $473bb02057a7af41$var$H.current, k = $473bb02057a7af41$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $473bb02057a7af41$var$Hi(b, g, d, k);
        $473bb02057a7af41$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $473bb02057a7af41$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $473bb02057a7af41$var$Wf.current || $473bb02057a7af41$var$jh ? ("function" === typeof y && ($473bb02057a7af41$var$Di(b, c, y, d), n = b.memoizedState), (l = $473bb02057a7af41$var$jh || $473bb02057a7af41$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $473bb02057a7af41$var$jj(a, b, c, d, f, e);
}
function $473bb02057a7af41$var$jj(a, b, c, d, e, f) {
    $473bb02057a7af41$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $473bb02057a7af41$var$dg(b, c, !1), $473bb02057a7af41$var$Zi(a, b, f);
    d = b.stateNode;
    $473bb02057a7af41$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $473bb02057a7af41$var$Ug(b, a.child, null, f), b.child = $473bb02057a7af41$var$Ug(b, null, h, f)) : $473bb02057a7af41$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $473bb02057a7af41$var$dg(b, c, !0);
    return b.child;
}
function $473bb02057a7af41$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $473bb02057a7af41$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $473bb02057a7af41$var$ag(a, b.context, !1);
    $473bb02057a7af41$var$yh(a, b.containerInfo);
}
function $473bb02057a7af41$var$lj(a, b, c, d, e) {
    $473bb02057a7af41$var$Ig();
    $473bb02057a7af41$var$Jg(e);
    b.flags |= 256;
    $473bb02057a7af41$var$Xi(a, b, c, d);
    return b.child;
}
var $473bb02057a7af41$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $473bb02057a7af41$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $473bb02057a7af41$var$oj(a, b, c) {
    var d = b.pendingProps, e = $473bb02057a7af41$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $473bb02057a7af41$var$G($473bb02057a7af41$var$L, e & 1);
    if (null === a) {
        $473bb02057a7af41$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $473bb02057a7af41$var$pj(g, d, 0, null), a = $473bb02057a7af41$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $473bb02057a7af41$var$nj(c), b.memoizedState = $473bb02057a7af41$var$mj, a) : $473bb02057a7af41$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $473bb02057a7af41$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $473bb02057a7af41$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $473bb02057a7af41$var$Pg(h, f) : (f = $473bb02057a7af41$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $473bb02057a7af41$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $473bb02057a7af41$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $473bb02057a7af41$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $473bb02057a7af41$var$qj(a, b) {
    b = $473bb02057a7af41$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $473bb02057a7af41$var$sj(a, b, c, d) {
    null !== d && $473bb02057a7af41$var$Jg(d);
    $473bb02057a7af41$var$Ug(b, a.child, null, c);
    a = $473bb02057a7af41$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $473bb02057a7af41$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $473bb02057a7af41$var$Ki(Error($473bb02057a7af41$var$p(422))), $473bb02057a7af41$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $473bb02057a7af41$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $473bb02057a7af41$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $473bb02057a7af41$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $473bb02057a7af41$var$nj(g);
        b.memoizedState = $473bb02057a7af41$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $473bb02057a7af41$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($473bb02057a7af41$var$p(419));
        d = $473bb02057a7af41$var$Ki(f, d, void 0);
        return $473bb02057a7af41$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($473bb02057a7af41$var$dh || h) {
        d = $473bb02057a7af41$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $473bb02057a7af41$var$ih(a, e), $473bb02057a7af41$var$gi(d, a, e, -1));
        }
        $473bb02057a7af41$var$tj();
        d = $473bb02057a7af41$var$Ki(Error($473bb02057a7af41$var$p(421)));
        return $473bb02057a7af41$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $473bb02057a7af41$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $473bb02057a7af41$var$yg = $473bb02057a7af41$var$Lf(e.nextSibling);
    $473bb02057a7af41$var$xg = b;
    $473bb02057a7af41$var$I = !0;
    $473bb02057a7af41$var$zg = null;
    null !== a && ($473bb02057a7af41$var$og[$473bb02057a7af41$var$pg++] = $473bb02057a7af41$var$rg, $473bb02057a7af41$var$og[$473bb02057a7af41$var$pg++] = $473bb02057a7af41$var$sg, $473bb02057a7af41$var$og[$473bb02057a7af41$var$pg++] = $473bb02057a7af41$var$qg, $473bb02057a7af41$var$rg = a.id, $473bb02057a7af41$var$sg = a.overflow, $473bb02057a7af41$var$qg = b);
    b = $473bb02057a7af41$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $473bb02057a7af41$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $473bb02057a7af41$var$bh(a.return, b, c);
}
function $473bb02057a7af41$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $473bb02057a7af41$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $473bb02057a7af41$var$Xi(a, b, d.children, c);
    d = $473bb02057a7af41$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $473bb02057a7af41$var$vj(a, c, b);
            else if (19 === a.tag) $473bb02057a7af41$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $473bb02057a7af41$var$G($473bb02057a7af41$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $473bb02057a7af41$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $473bb02057a7af41$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $473bb02057a7af41$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $473bb02057a7af41$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $473bb02057a7af41$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $473bb02057a7af41$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $473bb02057a7af41$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $473bb02057a7af41$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($473bb02057a7af41$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $473bb02057a7af41$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $473bb02057a7af41$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $473bb02057a7af41$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $473bb02057a7af41$var$kj(b);
            $473bb02057a7af41$var$Ig();
            break;
        case 5:
            $473bb02057a7af41$var$Ah(b);
            break;
        case 1:
            $473bb02057a7af41$var$Zf(b.type) && $473bb02057a7af41$var$cg(b);
            break;
        case 4:
            $473bb02057a7af41$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $473bb02057a7af41$var$G($473bb02057a7af41$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $473bb02057a7af41$var$G($473bb02057a7af41$var$L, $473bb02057a7af41$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $473bb02057a7af41$var$oj(a, b, c);
                $473bb02057a7af41$var$G($473bb02057a7af41$var$L, $473bb02057a7af41$var$L.current & 1);
                a = $473bb02057a7af41$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $473bb02057a7af41$var$G($473bb02057a7af41$var$L, $473bb02057a7af41$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $473bb02057a7af41$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $473bb02057a7af41$var$G($473bb02057a7af41$var$L, $473bb02057a7af41$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $473bb02057a7af41$var$dj(a, b, c);
    }
    return $473bb02057a7af41$var$Zi(a, b, c);
}
var $473bb02057a7af41$var$zj, $473bb02057a7af41$var$Aj, $473bb02057a7af41$var$Bj, $473bb02057a7af41$var$Cj;
$473bb02057a7af41$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$473bb02057a7af41$var$Aj = function() {};
$473bb02057a7af41$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $473bb02057a7af41$var$xh($473bb02057a7af41$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $473bb02057a7af41$var$Ya(a, e);
                d = $473bb02057a7af41$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $473bb02057a7af41$var$A({}, e, {
                    value: void 0
                });
                d = $473bb02057a7af41$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $473bb02057a7af41$var$gb(a, e);
                d = $473bb02057a7af41$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $473bb02057a7af41$var$Bf);
        }
        $473bb02057a7af41$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($473bb02057a7af41$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($473bb02057a7af41$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $473bb02057a7af41$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$473bb02057a7af41$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $473bb02057a7af41$var$Dj(a, b) {
    if (!$473bb02057a7af41$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $473bb02057a7af41$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $473bb02057a7af41$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $473bb02057a7af41$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $473bb02057a7af41$var$S(b), null;
        case 1:
            return $473bb02057a7af41$var$Zf(b.type) && $473bb02057a7af41$var$$f(), $473bb02057a7af41$var$S(b), null;
        case 3:
            d = b.stateNode;
            $473bb02057a7af41$var$zh();
            $473bb02057a7af41$var$E($473bb02057a7af41$var$Wf);
            $473bb02057a7af41$var$E($473bb02057a7af41$var$H);
            $473bb02057a7af41$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $473bb02057a7af41$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $473bb02057a7af41$var$zg && ($473bb02057a7af41$var$Fj($473bb02057a7af41$var$zg), $473bb02057a7af41$var$zg = null));
            $473bb02057a7af41$var$Aj(a, b);
            $473bb02057a7af41$var$S(b);
            return null;
        case 5:
            $473bb02057a7af41$var$Bh(b);
            var e = $473bb02057a7af41$var$xh($473bb02057a7af41$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $473bb02057a7af41$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($473bb02057a7af41$var$p(166));
                    $473bb02057a7af41$var$S(b);
                    return null;
                }
                a = $473bb02057a7af41$var$xh($473bb02057a7af41$var$uh.current);
                if ($473bb02057a7af41$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$473bb02057a7af41$var$Of] = b;
                    d[$473bb02057a7af41$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $473bb02057a7af41$var$D("cancel", d);
                            $473bb02057a7af41$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $473bb02057a7af41$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $473bb02057a7af41$var$lf.length; e++)$473bb02057a7af41$var$D($473bb02057a7af41$var$lf[e], d);
                            break;
                        case "source":
                            $473bb02057a7af41$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $473bb02057a7af41$var$D("error", d);
                            $473bb02057a7af41$var$D("load", d);
                            break;
                        case "details":
                            $473bb02057a7af41$var$D("toggle", d);
                            break;
                        case "input":
                            $473bb02057a7af41$var$Za(d, f);
                            $473bb02057a7af41$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $473bb02057a7af41$var$D("invalid", d);
                            break;
                        case "textarea":
                            $473bb02057a7af41$var$hb(d, f), $473bb02057a7af41$var$D("invalid", d);
                    }
                    $473bb02057a7af41$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $473bb02057a7af41$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $473bb02057a7af41$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $473bb02057a7af41$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $473bb02057a7af41$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $473bb02057a7af41$var$Va(d);
                            $473bb02057a7af41$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $473bb02057a7af41$var$Va(d);
                            $473bb02057a7af41$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $473bb02057a7af41$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $473bb02057a7af41$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$473bb02057a7af41$var$Of] = b;
                    a[$473bb02057a7af41$var$Pf] = d;
                    $473bb02057a7af41$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $473bb02057a7af41$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $473bb02057a7af41$var$D("cancel", a);
                                $473bb02057a7af41$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $473bb02057a7af41$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $473bb02057a7af41$var$lf.length; e++)$473bb02057a7af41$var$D($473bb02057a7af41$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $473bb02057a7af41$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $473bb02057a7af41$var$D("error", a);
                                $473bb02057a7af41$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $473bb02057a7af41$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $473bb02057a7af41$var$Za(a, d);
                                e = $473bb02057a7af41$var$Ya(a, d);
                                $473bb02057a7af41$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $473bb02057a7af41$var$A({}, d, {
                                    value: void 0
                                });
                                $473bb02057a7af41$var$D("invalid", a);
                                break;
                            case "textarea":
                                $473bb02057a7af41$var$hb(a, d);
                                e = $473bb02057a7af41$var$gb(a, d);
                                $473bb02057a7af41$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $473bb02057a7af41$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $473bb02057a7af41$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $473bb02057a7af41$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $473bb02057a7af41$var$ob(a, k) : "number" === typeof k && $473bb02057a7af41$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($473bb02057a7af41$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $473bb02057a7af41$var$D("scroll", a) : null != k && $473bb02057a7af41$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $473bb02057a7af41$var$Va(a);
                                $473bb02057a7af41$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $473bb02057a7af41$var$Va(a);
                                $473bb02057a7af41$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $473bb02057a7af41$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $473bb02057a7af41$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $473bb02057a7af41$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $473bb02057a7af41$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $473bb02057a7af41$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $473bb02057a7af41$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($473bb02057a7af41$var$p(166));
                c = $473bb02057a7af41$var$xh($473bb02057a7af41$var$wh.current);
                $473bb02057a7af41$var$xh($473bb02057a7af41$var$uh.current);
                if ($473bb02057a7af41$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$473bb02057a7af41$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $473bb02057a7af41$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $473bb02057a7af41$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $473bb02057a7af41$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$473bb02057a7af41$var$Of] = b, b.stateNode = d;
            }
            $473bb02057a7af41$var$S(b);
            return null;
        case 13:
            $473bb02057a7af41$var$E($473bb02057a7af41$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($473bb02057a7af41$var$I && null !== $473bb02057a7af41$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $473bb02057a7af41$var$Hg(), $473bb02057a7af41$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $473bb02057a7af41$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($473bb02057a7af41$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($473bb02057a7af41$var$p(317));
                        f[$473bb02057a7af41$var$Of] = b;
                    } else $473bb02057a7af41$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $473bb02057a7af41$var$S(b);
                    f = !1;
                } else null !== $473bb02057a7af41$var$zg && ($473bb02057a7af41$var$Fj($473bb02057a7af41$var$zg), $473bb02057a7af41$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($473bb02057a7af41$var$L.current & 1) ? 0 === $473bb02057a7af41$var$T && ($473bb02057a7af41$var$T = 3) : $473bb02057a7af41$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $473bb02057a7af41$var$S(b);
            return null;
        case 4:
            return $473bb02057a7af41$var$zh(), $473bb02057a7af41$var$Aj(a, b), null === a && $473bb02057a7af41$var$sf(b.stateNode.containerInfo), $473bb02057a7af41$var$S(b), null;
        case 10:
            return $473bb02057a7af41$var$ah(b.type._context), $473bb02057a7af41$var$S(b), null;
        case 17:
            return $473bb02057a7af41$var$Zf(b.type) && $473bb02057a7af41$var$$f(), $473bb02057a7af41$var$S(b), null;
        case 19:
            $473bb02057a7af41$var$E($473bb02057a7af41$var$L);
            f = b.memoizedState;
            if (null === f) return $473bb02057a7af41$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $473bb02057a7af41$var$Dj(f, !1);
                else {
                    if (0 !== $473bb02057a7af41$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $473bb02057a7af41$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $473bb02057a7af41$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $473bb02057a7af41$var$G($473bb02057a7af41$var$L, $473bb02057a7af41$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $473bb02057a7af41$var$B() > $473bb02057a7af41$var$Gj && (b.flags |= 128, d = !0, $473bb02057a7af41$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $473bb02057a7af41$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $473bb02057a7af41$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$473bb02057a7af41$var$I) return $473bb02057a7af41$var$S(b), null;
                    } else 2 * $473bb02057a7af41$var$B() - f.renderingStartTime > $473bb02057a7af41$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $473bb02057a7af41$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $473bb02057a7af41$var$B(), b.sibling = null, c = $473bb02057a7af41$var$L.current, $473bb02057a7af41$var$G($473bb02057a7af41$var$L, d ? c & 1 | 2 : c & 1), b;
            $473bb02057a7af41$var$S(b);
            return null;
        case 22:
        case 23:
            return $473bb02057a7af41$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($473bb02057a7af41$var$fj & 1073741824) && ($473bb02057a7af41$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $473bb02057a7af41$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($473bb02057a7af41$var$p(156, b.tag));
}
function $473bb02057a7af41$var$Ij(a, b) {
    $473bb02057a7af41$var$wg(b);
    switch(b.tag){
        case 1:
            return $473bb02057a7af41$var$Zf(b.type) && $473bb02057a7af41$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $473bb02057a7af41$var$zh(), $473bb02057a7af41$var$E($473bb02057a7af41$var$Wf), $473bb02057a7af41$var$E($473bb02057a7af41$var$H), $473bb02057a7af41$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $473bb02057a7af41$var$Bh(b), null;
        case 13:
            $473bb02057a7af41$var$E($473bb02057a7af41$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($473bb02057a7af41$var$p(340));
                $473bb02057a7af41$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $473bb02057a7af41$var$E($473bb02057a7af41$var$L), null;
        case 4:
            return $473bb02057a7af41$var$zh(), null;
        case 10:
            return $473bb02057a7af41$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $473bb02057a7af41$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $473bb02057a7af41$var$Jj = !1, $473bb02057a7af41$var$U = !1, $473bb02057a7af41$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $473bb02057a7af41$var$V = null;
function $473bb02057a7af41$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $473bb02057a7af41$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $473bb02057a7af41$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $473bb02057a7af41$var$W(a, b, d);
    }
}
var $473bb02057a7af41$var$Nj = !1;
function $473bb02057a7af41$var$Oj(a, b) {
    $473bb02057a7af41$var$Cf = $473bb02057a7af41$var$dd;
    a = $473bb02057a7af41$var$Me();
    if ($473bb02057a7af41$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $473bb02057a7af41$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $473bb02057a7af41$var$dd = !1;
    for($473bb02057a7af41$var$V = b; null !== $473bb02057a7af41$var$V;)if (b = $473bb02057a7af41$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $473bb02057a7af41$var$V = a;
    else for(; null !== $473bb02057a7af41$var$V;){
        b = $473bb02057a7af41$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $473bb02057a7af41$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($473bb02057a7af41$var$p(163));
            }
        } catch (F) {
            $473bb02057a7af41$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $473bb02057a7af41$var$V = a;
            break;
        }
        $473bb02057a7af41$var$V = b.return;
    }
    n = $473bb02057a7af41$var$Nj;
    $473bb02057a7af41$var$Nj = !1;
    return n;
}
function $473bb02057a7af41$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $473bb02057a7af41$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $473bb02057a7af41$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $473bb02057a7af41$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $473bb02057a7af41$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $473bb02057a7af41$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$473bb02057a7af41$var$Of], delete b[$473bb02057a7af41$var$Pf], delete b[$473bb02057a7af41$var$of], delete b[$473bb02057a7af41$var$Qf], delete b[$473bb02057a7af41$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $473bb02057a7af41$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $473bb02057a7af41$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $473bb02057a7af41$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $473bb02057a7af41$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $473bb02057a7af41$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($473bb02057a7af41$var$Vj(a, b, c), a = a.sibling; null !== a;)$473bb02057a7af41$var$Vj(a, b, c), a = a.sibling;
}
function $473bb02057a7af41$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($473bb02057a7af41$var$Wj(a, b, c), a = a.sibling; null !== a;)$473bb02057a7af41$var$Wj(a, b, c), a = a.sibling;
}
var $473bb02057a7af41$var$X = null, $473bb02057a7af41$var$Xj = !1;
function $473bb02057a7af41$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$473bb02057a7af41$var$Zj(a, b, c), c = c.sibling;
}
function $473bb02057a7af41$var$Zj(a, b, c) {
    if ($473bb02057a7af41$var$lc && "function" === typeof $473bb02057a7af41$var$lc.onCommitFiberUnmount) try {
        $473bb02057a7af41$var$lc.onCommitFiberUnmount($473bb02057a7af41$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $473bb02057a7af41$var$U || $473bb02057a7af41$var$Lj(c, b);
        case 6:
            var d = $473bb02057a7af41$var$X, e = $473bb02057a7af41$var$Xj;
            $473bb02057a7af41$var$X = null;
            $473bb02057a7af41$var$Yj(a, b, c);
            $473bb02057a7af41$var$X = d;
            $473bb02057a7af41$var$Xj = e;
            null !== $473bb02057a7af41$var$X && ($473bb02057a7af41$var$Xj ? (a = $473bb02057a7af41$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $473bb02057a7af41$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $473bb02057a7af41$var$X && ($473bb02057a7af41$var$Xj ? (a = $473bb02057a7af41$var$X, c = c.stateNode, 8 === a.nodeType ? $473bb02057a7af41$var$Kf(a.parentNode, c) : 1 === a.nodeType && $473bb02057a7af41$var$Kf(a, c), $473bb02057a7af41$var$bd(a)) : $473bb02057a7af41$var$Kf($473bb02057a7af41$var$X, c.stateNode));
            break;
        case 4:
            d = $473bb02057a7af41$var$X;
            e = $473bb02057a7af41$var$Xj;
            $473bb02057a7af41$var$X = c.stateNode.containerInfo;
            $473bb02057a7af41$var$Xj = !0;
            $473bb02057a7af41$var$Yj(a, b, c);
            $473bb02057a7af41$var$X = d;
            $473bb02057a7af41$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$473bb02057a7af41$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $473bb02057a7af41$var$Mj(c, b, g) : 0 !== (f & 4) && $473bb02057a7af41$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $473bb02057a7af41$var$Yj(a, b, c);
            break;
        case 1:
            if (!$473bb02057a7af41$var$U && ($473bb02057a7af41$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $473bb02057a7af41$var$W(c, b, h);
            }
            $473bb02057a7af41$var$Yj(a, b, c);
            break;
        case 21:
            $473bb02057a7af41$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($473bb02057a7af41$var$U = (d = $473bb02057a7af41$var$U) || null !== c.memoizedState, $473bb02057a7af41$var$Yj(a, b, c), $473bb02057a7af41$var$U = d) : $473bb02057a7af41$var$Yj(a, b, c);
            break;
        default:
            $473bb02057a7af41$var$Yj(a, b, c);
    }
}
function $473bb02057a7af41$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $473bb02057a7af41$var$Kj);
        b.forEach(function(b) {
            var d = $473bb02057a7af41$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $473bb02057a7af41$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $473bb02057a7af41$var$X = h.stateNode;
                        $473bb02057a7af41$var$Xj = !1;
                        break a;
                    case 3:
                        $473bb02057a7af41$var$X = h.stateNode.containerInfo;
                        $473bb02057a7af41$var$Xj = !0;
                        break a;
                    case 4:
                        $473bb02057a7af41$var$X = h.stateNode.containerInfo;
                        $473bb02057a7af41$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $473bb02057a7af41$var$X) throw Error($473bb02057a7af41$var$p(160));
            $473bb02057a7af41$var$Zj(f, g, e);
            $473bb02057a7af41$var$X = null;
            $473bb02057a7af41$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $473bb02057a7af41$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$473bb02057a7af41$var$dk(b, a), b = b.sibling;
}
function $473bb02057a7af41$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $473bb02057a7af41$var$ck(b, a);
            $473bb02057a7af41$var$ek(a);
            if (d & 4) {
                try {
                    $473bb02057a7af41$var$Pj(3, a, a.return), $473bb02057a7af41$var$Qj(3, a);
                } catch (t) {
                    $473bb02057a7af41$var$W(a, a.return, t);
                }
                try {
                    $473bb02057a7af41$var$Pj(5, a, a.return);
                } catch (t) {
                    $473bb02057a7af41$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $473bb02057a7af41$var$ck(b, a);
            $473bb02057a7af41$var$ek(a);
            d & 512 && null !== c && $473bb02057a7af41$var$Lj(c, c.return);
            break;
        case 5:
            $473bb02057a7af41$var$ck(b, a);
            $473bb02057a7af41$var$ek(a);
            d & 512 && null !== c && $473bb02057a7af41$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $473bb02057a7af41$var$ob(e, "");
                } catch (t) {
                    $473bb02057a7af41$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $473bb02057a7af41$var$ab(e, f);
                    $473bb02057a7af41$var$vb(h, g);
                    var l = $473bb02057a7af41$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $473bb02057a7af41$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $473bb02057a7af41$var$nb(e, q) : "children" === m ? $473bb02057a7af41$var$ob(e, q) : $473bb02057a7af41$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $473bb02057a7af41$var$bb(e, f);
                            break;
                        case "textarea":
                            $473bb02057a7af41$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $473bb02057a7af41$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $473bb02057a7af41$var$fb(e, !!f.multiple, f.defaultValue, !0) : $473bb02057a7af41$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$473bb02057a7af41$var$Pf] = f;
                } catch (t) {
                    $473bb02057a7af41$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $473bb02057a7af41$var$ck(b, a);
            $473bb02057a7af41$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($473bb02057a7af41$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $473bb02057a7af41$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $473bb02057a7af41$var$ck(b, a);
            $473bb02057a7af41$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $473bb02057a7af41$var$bd(b.containerInfo);
            } catch (t) {
                $473bb02057a7af41$var$W(a, a.return, t);
            }
            break;
        case 4:
            $473bb02057a7af41$var$ck(b, a);
            $473bb02057a7af41$var$ek(a);
            break;
        case 13:
            $473bb02057a7af41$var$ck(b, a);
            $473bb02057a7af41$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($473bb02057a7af41$var$fk = $473bb02057a7af41$var$B()));
            d & 4 && $473bb02057a7af41$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($473bb02057a7af41$var$U = (l = $473bb02057a7af41$var$U) || m, $473bb02057a7af41$var$ck(b, a), $473bb02057a7af41$var$U = l) : $473bb02057a7af41$var$ck(b, a);
            $473bb02057a7af41$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($473bb02057a7af41$var$V = a, m = a.child; null !== m;){
                    for(q = $473bb02057a7af41$var$V = m; null !== $473bb02057a7af41$var$V;){
                        r = $473bb02057a7af41$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $473bb02057a7af41$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $473bb02057a7af41$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $473bb02057a7af41$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $473bb02057a7af41$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $473bb02057a7af41$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $473bb02057a7af41$var$V = y) : $473bb02057a7af41$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $473bb02057a7af41$var$rb("display", g));
                            } catch (t) {
                                $473bb02057a7af41$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $473bb02057a7af41$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $473bb02057a7af41$var$ck(b, a);
            $473bb02057a7af41$var$ek(a);
            d & 4 && $473bb02057a7af41$var$ak(a);
            break;
        case 21:
            break;
        default:
            $473bb02057a7af41$var$ck(b, a), $473bb02057a7af41$var$ek(a);
    }
}
function $473bb02057a7af41$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($473bb02057a7af41$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($473bb02057a7af41$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($473bb02057a7af41$var$ob(e, ""), d.flags &= -33);
                    var f = $473bb02057a7af41$var$Uj(a);
                    $473bb02057a7af41$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $473bb02057a7af41$var$Uj(a);
                    $473bb02057a7af41$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($473bb02057a7af41$var$p(161));
            }
        } catch (k) {
            $473bb02057a7af41$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $473bb02057a7af41$var$hk(a, b, c) {
    $473bb02057a7af41$var$V = a;
    $473bb02057a7af41$var$ik(a, b, c);
}
function $473bb02057a7af41$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $473bb02057a7af41$var$V;){
        var e = $473bb02057a7af41$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $473bb02057a7af41$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $473bb02057a7af41$var$U;
                h = $473bb02057a7af41$var$Jj;
                var l = $473bb02057a7af41$var$U;
                $473bb02057a7af41$var$Jj = g;
                if (($473bb02057a7af41$var$U = k) && !l) for($473bb02057a7af41$var$V = e; null !== $473bb02057a7af41$var$V;)g = $473bb02057a7af41$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $473bb02057a7af41$var$jk(e) : null !== k ? (k.return = g, $473bb02057a7af41$var$V = k) : $473bb02057a7af41$var$jk(e);
                for(; null !== f;)$473bb02057a7af41$var$V = f, $473bb02057a7af41$var$ik(f, b, c), f = f.sibling;
                $473bb02057a7af41$var$V = e;
                $473bb02057a7af41$var$Jj = h;
                $473bb02057a7af41$var$U = l;
            }
            $473bb02057a7af41$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $473bb02057a7af41$var$V = f) : $473bb02057a7af41$var$kk(a, b, c);
    }
}
function $473bb02057a7af41$var$kk(a) {
    for(; null !== $473bb02057a7af41$var$V;){
        var b = $473bb02057a7af41$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $473bb02057a7af41$var$U || $473bb02057a7af41$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$473bb02057a7af41$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $473bb02057a7af41$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $473bb02057a7af41$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $473bb02057a7af41$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $473bb02057a7af41$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($473bb02057a7af41$var$p(163));
                }
                $473bb02057a7af41$var$U || b.flags & 512 && $473bb02057a7af41$var$Rj(b);
            } catch (r) {
                $473bb02057a7af41$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $473bb02057a7af41$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $473bb02057a7af41$var$V = c;
            break;
        }
        $473bb02057a7af41$var$V = b.return;
    }
}
function $473bb02057a7af41$var$gk(a) {
    for(; null !== $473bb02057a7af41$var$V;){
        var b = $473bb02057a7af41$var$V;
        if (b === a) {
            $473bb02057a7af41$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $473bb02057a7af41$var$V = c;
            break;
        }
        $473bb02057a7af41$var$V = b.return;
    }
}
function $473bb02057a7af41$var$jk(a) {
    for(; null !== $473bb02057a7af41$var$V;){
        var b = $473bb02057a7af41$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $473bb02057a7af41$var$Qj(4, b);
                    } catch (k) {
                        $473bb02057a7af41$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $473bb02057a7af41$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $473bb02057a7af41$var$Rj(b);
                    } catch (k) {
                        $473bb02057a7af41$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $473bb02057a7af41$var$Rj(b);
                    } catch (k) {
                        $473bb02057a7af41$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $473bb02057a7af41$var$W(b, b.return, k);
        }
        if (b === a) {
            $473bb02057a7af41$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $473bb02057a7af41$var$V = h;
            break;
        }
        $473bb02057a7af41$var$V = b.return;
    }
}
var $473bb02057a7af41$var$lk = Math.ceil, $473bb02057a7af41$var$mk = $473bb02057a7af41$var$ua.ReactCurrentDispatcher, $473bb02057a7af41$var$nk = $473bb02057a7af41$var$ua.ReactCurrentOwner, $473bb02057a7af41$var$ok = $473bb02057a7af41$var$ua.ReactCurrentBatchConfig, $473bb02057a7af41$var$K = 0, $473bb02057a7af41$var$Q = null, $473bb02057a7af41$var$Y = null, $473bb02057a7af41$var$Z = 0, $473bb02057a7af41$var$fj = 0, $473bb02057a7af41$var$ej = $473bb02057a7af41$var$Uf(0), $473bb02057a7af41$var$T = 0, $473bb02057a7af41$var$pk = null, $473bb02057a7af41$var$rh = 0, $473bb02057a7af41$var$qk = 0, $473bb02057a7af41$var$rk = 0, $473bb02057a7af41$var$sk = null, $473bb02057a7af41$var$tk = null, $473bb02057a7af41$var$fk = 0, $473bb02057a7af41$var$Gj = Infinity, $473bb02057a7af41$var$uk = null, $473bb02057a7af41$var$Oi = !1, $473bb02057a7af41$var$Pi = null, $473bb02057a7af41$var$Ri = null, $473bb02057a7af41$var$vk = !1, $473bb02057a7af41$var$wk = null, $473bb02057a7af41$var$xk = 0, $473bb02057a7af41$var$yk = 0, $473bb02057a7af41$var$zk = null, $473bb02057a7af41$var$Ak = -1, $473bb02057a7af41$var$Bk = 0;
function $473bb02057a7af41$var$R() {
    return 0 !== ($473bb02057a7af41$var$K & 6) ? $473bb02057a7af41$var$B() : -1 !== $473bb02057a7af41$var$Ak ? $473bb02057a7af41$var$Ak : $473bb02057a7af41$var$Ak = $473bb02057a7af41$var$B();
}
function $473bb02057a7af41$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($473bb02057a7af41$var$K & 2) && 0 !== $473bb02057a7af41$var$Z) return $473bb02057a7af41$var$Z & -$473bb02057a7af41$var$Z;
    if (null !== $473bb02057a7af41$var$Kg.transition) return 0 === $473bb02057a7af41$var$Bk && ($473bb02057a7af41$var$Bk = $473bb02057a7af41$var$yc()), $473bb02057a7af41$var$Bk;
    a = $473bb02057a7af41$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $473bb02057a7af41$var$jd(a.type);
    return a;
}
function $473bb02057a7af41$var$gi(a, b, c, d) {
    if (50 < $473bb02057a7af41$var$yk) throw $473bb02057a7af41$var$yk = 0, $473bb02057a7af41$var$zk = null, Error($473bb02057a7af41$var$p(185));
    $473bb02057a7af41$var$Ac(a, c, d);
    if (0 === ($473bb02057a7af41$var$K & 2) || a !== $473bb02057a7af41$var$Q) a === $473bb02057a7af41$var$Q && (0 === ($473bb02057a7af41$var$K & 2) && ($473bb02057a7af41$var$qk |= c), 4 === $473bb02057a7af41$var$T && $473bb02057a7af41$var$Ck(a, $473bb02057a7af41$var$Z)), $473bb02057a7af41$var$Dk(a, d), 1 === c && 0 === $473bb02057a7af41$var$K && 0 === (b.mode & 1) && ($473bb02057a7af41$var$Gj = $473bb02057a7af41$var$B() + 500, $473bb02057a7af41$var$fg && $473bb02057a7af41$var$jg());
}
function $473bb02057a7af41$var$Dk(a, b) {
    var c = a.callbackNode;
    $473bb02057a7af41$var$wc(a, b);
    var d = $473bb02057a7af41$var$uc(a, a === $473bb02057a7af41$var$Q ? $473bb02057a7af41$var$Z : 0);
    if (0 === d) null !== c && $473bb02057a7af41$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $473bb02057a7af41$var$bc(c);
        if (1 === b) 0 === a.tag ? $473bb02057a7af41$var$ig($473bb02057a7af41$var$Ek.bind(null, a)) : $473bb02057a7af41$var$hg($473bb02057a7af41$var$Ek.bind(null, a)), $473bb02057a7af41$var$Jf(function() {
            0 === ($473bb02057a7af41$var$K & 6) && $473bb02057a7af41$var$jg();
        }), c = null;
        else {
            switch($473bb02057a7af41$var$Dc(d)){
                case 1:
                    c = $473bb02057a7af41$var$fc;
                    break;
                case 4:
                    c = $473bb02057a7af41$var$gc;
                    break;
                case 16:
                    c = $473bb02057a7af41$var$hc;
                    break;
                case 536870912:
                    c = $473bb02057a7af41$var$jc;
                    break;
                default:
                    c = $473bb02057a7af41$var$hc;
            }
            c = $473bb02057a7af41$var$Fk(c, $473bb02057a7af41$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $473bb02057a7af41$var$Gk(a, b) {
    $473bb02057a7af41$var$Ak = -1;
    $473bb02057a7af41$var$Bk = 0;
    if (0 !== ($473bb02057a7af41$var$K & 6)) throw Error($473bb02057a7af41$var$p(327));
    var c = a.callbackNode;
    if ($473bb02057a7af41$var$Hk() && a.callbackNode !== c) return null;
    var d = $473bb02057a7af41$var$uc(a, a === $473bb02057a7af41$var$Q ? $473bb02057a7af41$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $473bb02057a7af41$var$Ik(a, d);
    else {
        b = d;
        var e = $473bb02057a7af41$var$K;
        $473bb02057a7af41$var$K |= 2;
        var f = $473bb02057a7af41$var$Jk();
        if ($473bb02057a7af41$var$Q !== a || $473bb02057a7af41$var$Z !== b) $473bb02057a7af41$var$uk = null, $473bb02057a7af41$var$Gj = $473bb02057a7af41$var$B() + 500, $473bb02057a7af41$var$Kk(a, b);
        for(;;)try {
            $473bb02057a7af41$var$Lk();
            break;
        } catch (h) {
            $473bb02057a7af41$var$Mk(a, h);
        }
        $473bb02057a7af41$var$$g();
        $473bb02057a7af41$var$mk.current = f;
        $473bb02057a7af41$var$K = e;
        null !== $473bb02057a7af41$var$Y ? b = 0 : ($473bb02057a7af41$var$Q = null, $473bb02057a7af41$var$Z = 0, b = $473bb02057a7af41$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $473bb02057a7af41$var$xc(a), 0 !== e && (d = e, b = $473bb02057a7af41$var$Nk(a, e)));
        if (1 === b) throw c = $473bb02057a7af41$var$pk, $473bb02057a7af41$var$Kk(a, 0), $473bb02057a7af41$var$Ck(a, d), $473bb02057a7af41$var$Dk(a, $473bb02057a7af41$var$B()), c;
        if (6 === b) $473bb02057a7af41$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$473bb02057a7af41$var$Ok(e) && (b = $473bb02057a7af41$var$Ik(a, d), 2 === b && (f = $473bb02057a7af41$var$xc(a), 0 !== f && (d = f, b = $473bb02057a7af41$var$Nk(a, f))), 1 === b)) throw c = $473bb02057a7af41$var$pk, $473bb02057a7af41$var$Kk(a, 0), $473bb02057a7af41$var$Ck(a, d), $473bb02057a7af41$var$Dk(a, $473bb02057a7af41$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($473bb02057a7af41$var$p(345));
                case 2:
                    $473bb02057a7af41$var$Pk(a, $473bb02057a7af41$var$tk, $473bb02057a7af41$var$uk);
                    break;
                case 3:
                    $473bb02057a7af41$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $473bb02057a7af41$var$fk + 500 - $473bb02057a7af41$var$B(), 10 < b)) {
                        if (0 !== $473bb02057a7af41$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $473bb02057a7af41$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $473bb02057a7af41$var$Ff($473bb02057a7af41$var$Pk.bind(null, a, $473bb02057a7af41$var$tk, $473bb02057a7af41$var$uk), b);
                        break;
                    }
                    $473bb02057a7af41$var$Pk(a, $473bb02057a7af41$var$tk, $473bb02057a7af41$var$uk);
                    break;
                case 4:
                    $473bb02057a7af41$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $473bb02057a7af41$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $473bb02057a7af41$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $473bb02057a7af41$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $473bb02057a7af41$var$Ff($473bb02057a7af41$var$Pk.bind(null, a, $473bb02057a7af41$var$tk, $473bb02057a7af41$var$uk), d);
                        break;
                    }
                    $473bb02057a7af41$var$Pk(a, $473bb02057a7af41$var$tk, $473bb02057a7af41$var$uk);
                    break;
                case 5:
                    $473bb02057a7af41$var$Pk(a, $473bb02057a7af41$var$tk, $473bb02057a7af41$var$uk);
                    break;
                default:
                    throw Error($473bb02057a7af41$var$p(329));
            }
        }
    }
    $473bb02057a7af41$var$Dk(a, $473bb02057a7af41$var$B());
    return a.callbackNode === c ? $473bb02057a7af41$var$Gk.bind(null, a) : null;
}
function $473bb02057a7af41$var$Nk(a, b) {
    var c = $473bb02057a7af41$var$sk;
    a.current.memoizedState.isDehydrated && ($473bb02057a7af41$var$Kk(a, b).flags |= 256);
    a = $473bb02057a7af41$var$Ik(a, b);
    2 !== a && (b = $473bb02057a7af41$var$tk, $473bb02057a7af41$var$tk = c, null !== b && $473bb02057a7af41$var$Fj(b));
    return a;
}
function $473bb02057a7af41$var$Fj(a) {
    null === $473bb02057a7af41$var$tk ? $473bb02057a7af41$var$tk = a : $473bb02057a7af41$var$tk.push.apply($473bb02057a7af41$var$tk, a);
}
function $473bb02057a7af41$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$473bb02057a7af41$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $473bb02057a7af41$var$Ck(a, b) {
    b &= ~$473bb02057a7af41$var$rk;
    b &= ~$473bb02057a7af41$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $473bb02057a7af41$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $473bb02057a7af41$var$Ek(a) {
    if (0 !== ($473bb02057a7af41$var$K & 6)) throw Error($473bb02057a7af41$var$p(327));
    $473bb02057a7af41$var$Hk();
    var b = $473bb02057a7af41$var$uc(a, 0);
    if (0 === (b & 1)) return $473bb02057a7af41$var$Dk(a, $473bb02057a7af41$var$B()), null;
    var c = $473bb02057a7af41$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $473bb02057a7af41$var$xc(a);
        0 !== d && (b = d, c = $473bb02057a7af41$var$Nk(a, d));
    }
    if (1 === c) throw c = $473bb02057a7af41$var$pk, $473bb02057a7af41$var$Kk(a, 0), $473bb02057a7af41$var$Ck(a, b), $473bb02057a7af41$var$Dk(a, $473bb02057a7af41$var$B()), c;
    if (6 === c) throw Error($473bb02057a7af41$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $473bb02057a7af41$var$Pk(a, $473bb02057a7af41$var$tk, $473bb02057a7af41$var$uk);
    $473bb02057a7af41$var$Dk(a, $473bb02057a7af41$var$B());
    return null;
}
function $473bb02057a7af41$var$Qk(a, b) {
    var c = $473bb02057a7af41$var$K;
    $473bb02057a7af41$var$K |= 1;
    try {
        return a(b);
    } finally{
        $473bb02057a7af41$var$K = c, 0 === $473bb02057a7af41$var$K && ($473bb02057a7af41$var$Gj = $473bb02057a7af41$var$B() + 500, $473bb02057a7af41$var$fg && $473bb02057a7af41$var$jg());
    }
}
function $473bb02057a7af41$var$Rk(a) {
    null !== $473bb02057a7af41$var$wk && 0 === $473bb02057a7af41$var$wk.tag && 0 === ($473bb02057a7af41$var$K & 6) && $473bb02057a7af41$var$Hk();
    var b = $473bb02057a7af41$var$K;
    $473bb02057a7af41$var$K |= 1;
    var c = $473bb02057a7af41$var$ok.transition, d = $473bb02057a7af41$var$C;
    try {
        if ($473bb02057a7af41$var$ok.transition = null, $473bb02057a7af41$var$C = 1, a) return a();
    } finally{
        $473bb02057a7af41$var$C = d, $473bb02057a7af41$var$ok.transition = c, $473bb02057a7af41$var$K = b, 0 === ($473bb02057a7af41$var$K & 6) && $473bb02057a7af41$var$jg();
    }
}
function $473bb02057a7af41$var$Hj() {
    $473bb02057a7af41$var$fj = $473bb02057a7af41$var$ej.current;
    $473bb02057a7af41$var$E($473bb02057a7af41$var$ej);
}
function $473bb02057a7af41$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $473bb02057a7af41$var$Gf(c));
    if (null !== $473bb02057a7af41$var$Y) for(c = $473bb02057a7af41$var$Y.return; null !== c;){
        var d = c;
        $473bb02057a7af41$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $473bb02057a7af41$var$$f();
                break;
            case 3:
                $473bb02057a7af41$var$zh();
                $473bb02057a7af41$var$E($473bb02057a7af41$var$Wf);
                $473bb02057a7af41$var$E($473bb02057a7af41$var$H);
                $473bb02057a7af41$var$Eh();
                break;
            case 5:
                $473bb02057a7af41$var$Bh(d);
                break;
            case 4:
                $473bb02057a7af41$var$zh();
                break;
            case 13:
                $473bb02057a7af41$var$E($473bb02057a7af41$var$L);
                break;
            case 19:
                $473bb02057a7af41$var$E($473bb02057a7af41$var$L);
                break;
            case 10:
                $473bb02057a7af41$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $473bb02057a7af41$var$Hj();
        }
        c = c.return;
    }
    $473bb02057a7af41$var$Q = a;
    $473bb02057a7af41$var$Y = a = $473bb02057a7af41$var$Pg(a.current, null);
    $473bb02057a7af41$var$Z = $473bb02057a7af41$var$fj = b;
    $473bb02057a7af41$var$T = 0;
    $473bb02057a7af41$var$pk = null;
    $473bb02057a7af41$var$rk = $473bb02057a7af41$var$qk = $473bb02057a7af41$var$rh = 0;
    $473bb02057a7af41$var$tk = $473bb02057a7af41$var$sk = null;
    if (null !== $473bb02057a7af41$var$fh) {
        for(b = 0; b < $473bb02057a7af41$var$fh.length; b++)if (c = $473bb02057a7af41$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $473bb02057a7af41$var$fh = null;
    }
    return a;
}
function $473bb02057a7af41$var$Mk(a, b) {
    do {
        var c = $473bb02057a7af41$var$Y;
        try {
            $473bb02057a7af41$var$$g();
            $473bb02057a7af41$var$Fh.current = $473bb02057a7af41$var$Rh;
            if ($473bb02057a7af41$var$Ih) {
                for(var d = $473bb02057a7af41$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $473bb02057a7af41$var$Ih = !1;
            }
            $473bb02057a7af41$var$Hh = 0;
            $473bb02057a7af41$var$O = $473bb02057a7af41$var$N = $473bb02057a7af41$var$M = null;
            $473bb02057a7af41$var$Jh = !1;
            $473bb02057a7af41$var$Kh = 0;
            $473bb02057a7af41$var$nk.current = null;
            if (null === c || null === c.return) {
                $473bb02057a7af41$var$T = 1;
                $473bb02057a7af41$var$pk = b;
                $473bb02057a7af41$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $473bb02057a7af41$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $473bb02057a7af41$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $473bb02057a7af41$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $473bb02057a7af41$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $473bb02057a7af41$var$Si(f, l, b);
                            $473bb02057a7af41$var$tj();
                            break a;
                        }
                        k = Error($473bb02057a7af41$var$p(426));
                    }
                } else if ($473bb02057a7af41$var$I && h.mode & 1) {
                    var J = $473bb02057a7af41$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $473bb02057a7af41$var$Vi(J, g, h, f, b);
                        $473bb02057a7af41$var$Jg($473bb02057a7af41$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $473bb02057a7af41$var$Ji(k, h);
                4 !== $473bb02057a7af41$var$T && ($473bb02057a7af41$var$T = 2);
                null === $473bb02057a7af41$var$sk ? $473bb02057a7af41$var$sk = [
                    f
                ] : $473bb02057a7af41$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $473bb02057a7af41$var$Ni(f, k, b);
                            $473bb02057a7af41$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $473bb02057a7af41$var$Ri || !$473bb02057a7af41$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $473bb02057a7af41$var$Qi(f, h, b);
                                $473bb02057a7af41$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $473bb02057a7af41$var$Sk(c);
        } catch (na) {
            b = na;
            $473bb02057a7af41$var$Y === c && null !== c && ($473bb02057a7af41$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $473bb02057a7af41$var$Jk() {
    var a = $473bb02057a7af41$var$mk.current;
    $473bb02057a7af41$var$mk.current = $473bb02057a7af41$var$Rh;
    return null === a ? $473bb02057a7af41$var$Rh : a;
}
function $473bb02057a7af41$var$tj() {
    if (0 === $473bb02057a7af41$var$T || 3 === $473bb02057a7af41$var$T || 2 === $473bb02057a7af41$var$T) $473bb02057a7af41$var$T = 4;
    null === $473bb02057a7af41$var$Q || 0 === ($473bb02057a7af41$var$rh & 268435455) && 0 === ($473bb02057a7af41$var$qk & 268435455) || $473bb02057a7af41$var$Ck($473bb02057a7af41$var$Q, $473bb02057a7af41$var$Z);
}
function $473bb02057a7af41$var$Ik(a, b) {
    var c = $473bb02057a7af41$var$K;
    $473bb02057a7af41$var$K |= 2;
    var d = $473bb02057a7af41$var$Jk();
    if ($473bb02057a7af41$var$Q !== a || $473bb02057a7af41$var$Z !== b) $473bb02057a7af41$var$uk = null, $473bb02057a7af41$var$Kk(a, b);
    for(;;)try {
        $473bb02057a7af41$var$Tk();
        break;
    } catch (e) {
        $473bb02057a7af41$var$Mk(a, e);
    }
    $473bb02057a7af41$var$$g();
    $473bb02057a7af41$var$K = c;
    $473bb02057a7af41$var$mk.current = d;
    if (null !== $473bb02057a7af41$var$Y) throw Error($473bb02057a7af41$var$p(261));
    $473bb02057a7af41$var$Q = null;
    $473bb02057a7af41$var$Z = 0;
    return $473bb02057a7af41$var$T;
}
function $473bb02057a7af41$var$Tk() {
    for(; null !== $473bb02057a7af41$var$Y;)$473bb02057a7af41$var$Uk($473bb02057a7af41$var$Y);
}
function $473bb02057a7af41$var$Lk() {
    for(; null !== $473bb02057a7af41$var$Y && !$473bb02057a7af41$var$cc();)$473bb02057a7af41$var$Uk($473bb02057a7af41$var$Y);
}
function $473bb02057a7af41$var$Uk(a) {
    var b = $473bb02057a7af41$var$Vk(a.alternate, a, $473bb02057a7af41$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $473bb02057a7af41$var$Sk(a) : $473bb02057a7af41$var$Y = b;
    $473bb02057a7af41$var$nk.current = null;
}
function $473bb02057a7af41$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $473bb02057a7af41$var$Ej(c, b, $473bb02057a7af41$var$fj), null !== c) {
                $473bb02057a7af41$var$Y = c;
                return;
            }
        } else {
            c = $473bb02057a7af41$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $473bb02057a7af41$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $473bb02057a7af41$var$T = 6;
                $473bb02057a7af41$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $473bb02057a7af41$var$Y = b;
            return;
        }
        $473bb02057a7af41$var$Y = b = a;
    }while (null !== b);
    0 === $473bb02057a7af41$var$T && ($473bb02057a7af41$var$T = 5);
}
function $473bb02057a7af41$var$Pk(a, b, c) {
    var d = $473bb02057a7af41$var$C, e = $473bb02057a7af41$var$ok.transition;
    try {
        $473bb02057a7af41$var$ok.transition = null, $473bb02057a7af41$var$C = 1, $473bb02057a7af41$var$Wk(a, b, c, d);
    } finally{
        $473bb02057a7af41$var$ok.transition = e, $473bb02057a7af41$var$C = d;
    }
    return null;
}
function $473bb02057a7af41$var$Wk(a, b, c, d) {
    do $473bb02057a7af41$var$Hk();
    while (null !== $473bb02057a7af41$var$wk);
    if (0 !== ($473bb02057a7af41$var$K & 6)) throw Error($473bb02057a7af41$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($473bb02057a7af41$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $473bb02057a7af41$var$Bc(a, f);
    a === $473bb02057a7af41$var$Q && ($473bb02057a7af41$var$Y = $473bb02057a7af41$var$Q = null, $473bb02057a7af41$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $473bb02057a7af41$var$vk || ($473bb02057a7af41$var$vk = !0, $473bb02057a7af41$var$Fk($473bb02057a7af41$var$hc, function() {
        $473bb02057a7af41$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $473bb02057a7af41$var$ok.transition;
        $473bb02057a7af41$var$ok.transition = null;
        var g = $473bb02057a7af41$var$C;
        $473bb02057a7af41$var$C = 1;
        var h = $473bb02057a7af41$var$K;
        $473bb02057a7af41$var$K |= 4;
        $473bb02057a7af41$var$nk.current = null;
        $473bb02057a7af41$var$Oj(a, c);
        $473bb02057a7af41$var$dk(c, a);
        $473bb02057a7af41$var$Oe($473bb02057a7af41$var$Df);
        $473bb02057a7af41$var$dd = !!$473bb02057a7af41$var$Cf;
        $473bb02057a7af41$var$Df = $473bb02057a7af41$var$Cf = null;
        a.current = c;
        $473bb02057a7af41$var$hk(c, a, e);
        $473bb02057a7af41$var$dc();
        $473bb02057a7af41$var$K = h;
        $473bb02057a7af41$var$C = g;
        $473bb02057a7af41$var$ok.transition = f;
    } else a.current = c;
    $473bb02057a7af41$var$vk && ($473bb02057a7af41$var$vk = !1, $473bb02057a7af41$var$wk = a, $473bb02057a7af41$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($473bb02057a7af41$var$Ri = null);
    $473bb02057a7af41$var$mc(c.stateNode, d);
    $473bb02057a7af41$var$Dk(a, $473bb02057a7af41$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($473bb02057a7af41$var$Oi) throw $473bb02057a7af41$var$Oi = !1, a = $473bb02057a7af41$var$Pi, $473bb02057a7af41$var$Pi = null, a;
    0 !== ($473bb02057a7af41$var$xk & 1) && 0 !== a.tag && $473bb02057a7af41$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $473bb02057a7af41$var$zk ? $473bb02057a7af41$var$yk++ : ($473bb02057a7af41$var$yk = 0, $473bb02057a7af41$var$zk = a) : $473bb02057a7af41$var$yk = 0;
    $473bb02057a7af41$var$jg();
    return null;
}
function $473bb02057a7af41$var$Hk() {
    if (null !== $473bb02057a7af41$var$wk) {
        var a = $473bb02057a7af41$var$Dc($473bb02057a7af41$var$xk), b = $473bb02057a7af41$var$ok.transition, c = $473bb02057a7af41$var$C;
        try {
            $473bb02057a7af41$var$ok.transition = null;
            $473bb02057a7af41$var$C = 16 > a ? 16 : a;
            if (null === $473bb02057a7af41$var$wk) var d = !1;
            else {
                a = $473bb02057a7af41$var$wk;
                $473bb02057a7af41$var$wk = null;
                $473bb02057a7af41$var$xk = 0;
                if (0 !== ($473bb02057a7af41$var$K & 6)) throw Error($473bb02057a7af41$var$p(331));
                var e = $473bb02057a7af41$var$K;
                $473bb02057a7af41$var$K |= 4;
                for($473bb02057a7af41$var$V = a.current; null !== $473bb02057a7af41$var$V;){
                    var f = $473bb02057a7af41$var$V, g = f.child;
                    if (0 !== ($473bb02057a7af41$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($473bb02057a7af41$var$V = l; null !== $473bb02057a7af41$var$V;){
                                    var m = $473bb02057a7af41$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $473bb02057a7af41$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $473bb02057a7af41$var$V = q;
                                    else for(; null !== $473bb02057a7af41$var$V;){
                                        m = $473bb02057a7af41$var$V;
                                        var r = m.sibling, y = m.return;
                                        $473bb02057a7af41$var$Sj(m);
                                        if (m === l) {
                                            $473bb02057a7af41$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $473bb02057a7af41$var$V = r;
                                            break;
                                        }
                                        $473bb02057a7af41$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $473bb02057a7af41$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $473bb02057a7af41$var$V = g;
                    else b: for(; null !== $473bb02057a7af41$var$V;){
                        f = $473bb02057a7af41$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $473bb02057a7af41$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $473bb02057a7af41$var$V = x;
                            break b;
                        }
                        $473bb02057a7af41$var$V = f.return;
                    }
                }
                var w = a.current;
                for($473bb02057a7af41$var$V = w; null !== $473bb02057a7af41$var$V;){
                    g = $473bb02057a7af41$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $473bb02057a7af41$var$V = u;
                    else b: for(g = w; null !== $473bb02057a7af41$var$V;){
                        h = $473bb02057a7af41$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $473bb02057a7af41$var$Qj(9, h);
                            }
                        } catch (na) {
                            $473bb02057a7af41$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $473bb02057a7af41$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $473bb02057a7af41$var$V = F;
                            break b;
                        }
                        $473bb02057a7af41$var$V = h.return;
                    }
                }
                $473bb02057a7af41$var$K = e;
                $473bb02057a7af41$var$jg();
                if ($473bb02057a7af41$var$lc && "function" === typeof $473bb02057a7af41$var$lc.onPostCommitFiberRoot) try {
                    $473bb02057a7af41$var$lc.onPostCommitFiberRoot($473bb02057a7af41$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $473bb02057a7af41$var$C = c, $473bb02057a7af41$var$ok.transition = b;
        }
    }
    return !1;
}
function $473bb02057a7af41$var$Xk(a, b, c) {
    b = $473bb02057a7af41$var$Ji(c, b);
    b = $473bb02057a7af41$var$Ni(a, b, 1);
    a = $473bb02057a7af41$var$nh(a, b, 1);
    b = $473bb02057a7af41$var$R();
    null !== a && ($473bb02057a7af41$var$Ac(a, 1, b), $473bb02057a7af41$var$Dk(a, b));
}
function $473bb02057a7af41$var$W(a, b, c) {
    if (3 === a.tag) $473bb02057a7af41$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $473bb02057a7af41$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $473bb02057a7af41$var$Ri || !$473bb02057a7af41$var$Ri.has(d))) {
                a = $473bb02057a7af41$var$Ji(c, a);
                a = $473bb02057a7af41$var$Qi(b, a, 1);
                b = $473bb02057a7af41$var$nh(b, a, 1);
                a = $473bb02057a7af41$var$R();
                null !== b && ($473bb02057a7af41$var$Ac(b, 1, a), $473bb02057a7af41$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $473bb02057a7af41$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $473bb02057a7af41$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $473bb02057a7af41$var$Q === a && ($473bb02057a7af41$var$Z & c) === c && (4 === $473bb02057a7af41$var$T || 3 === $473bb02057a7af41$var$T && ($473bb02057a7af41$var$Z & 130023424) === $473bb02057a7af41$var$Z && 500 > $473bb02057a7af41$var$B() - $473bb02057a7af41$var$fk ? $473bb02057a7af41$var$Kk(a, 0) : $473bb02057a7af41$var$rk |= c);
    $473bb02057a7af41$var$Dk(a, b);
}
function $473bb02057a7af41$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $473bb02057a7af41$var$sc, $473bb02057a7af41$var$sc <<= 1, 0 === ($473bb02057a7af41$var$sc & 130023424) && ($473bb02057a7af41$var$sc = 4194304)));
    var c = $473bb02057a7af41$var$R();
    a = $473bb02057a7af41$var$ih(a, b);
    null !== a && ($473bb02057a7af41$var$Ac(a, b, c), $473bb02057a7af41$var$Dk(a, c));
}
function $473bb02057a7af41$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $473bb02057a7af41$var$Yk(a, c);
}
function $473bb02057a7af41$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($473bb02057a7af41$var$p(314));
    }
    null !== d && d.delete(b);
    $473bb02057a7af41$var$Yk(a, c);
}
var $473bb02057a7af41$var$Vk;
$473bb02057a7af41$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $473bb02057a7af41$var$Wf.current) $473bb02057a7af41$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $473bb02057a7af41$var$dh = !1, $473bb02057a7af41$var$yj(a, b, c);
            $473bb02057a7af41$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $473bb02057a7af41$var$dh = !1, $473bb02057a7af41$var$I && 0 !== (b.flags & 1048576) && $473bb02057a7af41$var$ug(b, $473bb02057a7af41$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $473bb02057a7af41$var$ij(a, b);
            a = b.pendingProps;
            var e = $473bb02057a7af41$var$Yf(b, $473bb02057a7af41$var$H.current);
            $473bb02057a7af41$var$ch(b, c);
            e = $473bb02057a7af41$var$Nh(null, b, d, a, e, c);
            var f = $473bb02057a7af41$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $473bb02057a7af41$var$Zf(d) ? (f = !0, $473bb02057a7af41$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $473bb02057a7af41$var$kh(b), e.updater = $473bb02057a7af41$var$Ei, b.stateNode = e, e._reactInternals = b, $473bb02057a7af41$var$Ii(b, d, a, c), b = $473bb02057a7af41$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $473bb02057a7af41$var$I && f && $473bb02057a7af41$var$vg(b), $473bb02057a7af41$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $473bb02057a7af41$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $473bb02057a7af41$var$Zk(d);
                a = $473bb02057a7af41$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $473bb02057a7af41$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $473bb02057a7af41$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $473bb02057a7af41$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $473bb02057a7af41$var$$i(null, b, d, $473bb02057a7af41$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($473bb02057a7af41$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $473bb02057a7af41$var$Ci(d, e), $473bb02057a7af41$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $473bb02057a7af41$var$Ci(d, e), $473bb02057a7af41$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $473bb02057a7af41$var$kj(b);
                if (null === a) throw Error($473bb02057a7af41$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $473bb02057a7af41$var$lh(a, b);
                $473bb02057a7af41$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $473bb02057a7af41$var$Ji(Error($473bb02057a7af41$var$p(423)), b);
                        b = $473bb02057a7af41$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $473bb02057a7af41$var$Ji(Error($473bb02057a7af41$var$p(424)), b);
                        b = $473bb02057a7af41$var$lj(a, b, d, c, e);
                        break a;
                    } else for($473bb02057a7af41$var$yg = $473bb02057a7af41$var$Lf(b.stateNode.containerInfo.firstChild), $473bb02057a7af41$var$xg = b, $473bb02057a7af41$var$I = !0, $473bb02057a7af41$var$zg = null, c = $473bb02057a7af41$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $473bb02057a7af41$var$Ig();
                    if (d === e) {
                        b = $473bb02057a7af41$var$Zi(a, b, c);
                        break a;
                    }
                    $473bb02057a7af41$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $473bb02057a7af41$var$Ah(b), null === a && $473bb02057a7af41$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $473bb02057a7af41$var$Ef(d, e) ? g = null : null !== f && $473bb02057a7af41$var$Ef(d, f) && (b.flags |= 32), $473bb02057a7af41$var$gj(a, b), $473bb02057a7af41$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $473bb02057a7af41$var$Eg(b), null;
        case 13:
            return $473bb02057a7af41$var$oj(a, b, c);
        case 4:
            return $473bb02057a7af41$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $473bb02057a7af41$var$Ug(b, null, d, c) : $473bb02057a7af41$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $473bb02057a7af41$var$Ci(d, e), $473bb02057a7af41$var$Yi(a, b, d, e, c);
        case 7:
            return $473bb02057a7af41$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $473bb02057a7af41$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $473bb02057a7af41$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $473bb02057a7af41$var$G($473bb02057a7af41$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($473bb02057a7af41$var$He(f.value, g)) {
                        if (f.children === e.children && !$473bb02057a7af41$var$Wf.current) {
                            b = $473bb02057a7af41$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $473bb02057a7af41$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $473bb02057a7af41$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($473bb02057a7af41$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $473bb02057a7af41$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $473bb02057a7af41$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $473bb02057a7af41$var$ch(b, c), e = $473bb02057a7af41$var$eh(e), d = d(e), b.flags |= 1, $473bb02057a7af41$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $473bb02057a7af41$var$Ci(d, b.pendingProps), e = $473bb02057a7af41$var$Ci(d.type, e), $473bb02057a7af41$var$$i(a, b, d, e, c);
        case 15:
            return $473bb02057a7af41$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $473bb02057a7af41$var$Ci(d, e), $473bb02057a7af41$var$ij(a, b), b.tag = 1, $473bb02057a7af41$var$Zf(d) ? (a = !0, $473bb02057a7af41$var$cg(b)) : a = !1, $473bb02057a7af41$var$ch(b, c), $473bb02057a7af41$var$Gi(b, d, e), $473bb02057a7af41$var$Ii(b, d, e, c), $473bb02057a7af41$var$jj(null, b, d, !0, a, c);
        case 19:
            return $473bb02057a7af41$var$xj(a, b, c);
        case 22:
            return $473bb02057a7af41$var$dj(a, b, c);
    }
    throw Error($473bb02057a7af41$var$p(156, b.tag));
};
function $473bb02057a7af41$var$Fk(a, b) {
    return $473bb02057a7af41$var$ac(a, b);
}
function $473bb02057a7af41$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $473bb02057a7af41$var$Bg(a, b, c, d) {
    return new $473bb02057a7af41$var$$k(a, b, c, d);
}
function $473bb02057a7af41$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $473bb02057a7af41$var$Zk(a) {
    if ("function" === typeof a) return $473bb02057a7af41$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $473bb02057a7af41$var$Da) return 11;
        if (a === $473bb02057a7af41$var$Ga) return 14;
    }
    return 2;
}
function $473bb02057a7af41$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $473bb02057a7af41$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $473bb02057a7af41$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $473bb02057a7af41$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $473bb02057a7af41$var$ya:
            return $473bb02057a7af41$var$Tg(c.children, e, f, b);
        case $473bb02057a7af41$var$za:
            g = 8;
            e |= 8;
            break;
        case $473bb02057a7af41$var$Aa:
            return a = $473bb02057a7af41$var$Bg(12, c, b, e | 2), a.elementType = $473bb02057a7af41$var$Aa, a.lanes = f, a;
        case $473bb02057a7af41$var$Ea:
            return a = $473bb02057a7af41$var$Bg(13, c, b, e), a.elementType = $473bb02057a7af41$var$Ea, a.lanes = f, a;
        case $473bb02057a7af41$var$Fa:
            return a = $473bb02057a7af41$var$Bg(19, c, b, e), a.elementType = $473bb02057a7af41$var$Fa, a.lanes = f, a;
        case $473bb02057a7af41$var$Ia:
            return $473bb02057a7af41$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $473bb02057a7af41$var$Ba:
                    g = 10;
                    break a;
                case $473bb02057a7af41$var$Ca:
                    g = 9;
                    break a;
                case $473bb02057a7af41$var$Da:
                    g = 11;
                    break a;
                case $473bb02057a7af41$var$Ga:
                    g = 14;
                    break a;
                case $473bb02057a7af41$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($473bb02057a7af41$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $473bb02057a7af41$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $473bb02057a7af41$var$Tg(a, b, c, d) {
    a = $473bb02057a7af41$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $473bb02057a7af41$var$pj(a, b, c, d) {
    a = $473bb02057a7af41$var$Bg(22, a, d, b);
    a.elementType = $473bb02057a7af41$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $473bb02057a7af41$var$Qg(a, b, c) {
    a = $473bb02057a7af41$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $473bb02057a7af41$var$Sg(a, b, c) {
    b = $473bb02057a7af41$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $473bb02057a7af41$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $473bb02057a7af41$var$zc(0);
    this.expirationTimes = $473bb02057a7af41$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $473bb02057a7af41$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $473bb02057a7af41$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $473bb02057a7af41$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $473bb02057a7af41$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $473bb02057a7af41$var$kh(f);
    return a;
}
function $473bb02057a7af41$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $473bb02057a7af41$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $473bb02057a7af41$var$dl(a) {
    if (!a) return $473bb02057a7af41$var$Vf;
    a = a._reactInternals;
    a: {
        if ($473bb02057a7af41$var$Vb(a) !== a || 1 !== a.tag) throw Error($473bb02057a7af41$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($473bb02057a7af41$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($473bb02057a7af41$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($473bb02057a7af41$var$Zf(c)) return $473bb02057a7af41$var$bg(a, c, b);
    }
    return b;
}
function $473bb02057a7af41$var$el(a, b, c, d, e, f, g, h, k) {
    a = $473bb02057a7af41$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $473bb02057a7af41$var$dl(null);
    c = a.current;
    d = $473bb02057a7af41$var$R();
    e = $473bb02057a7af41$var$yi(c);
    f = $473bb02057a7af41$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $473bb02057a7af41$var$nh(c, f, e);
    a.current.lanes = e;
    $473bb02057a7af41$var$Ac(a, e, d);
    $473bb02057a7af41$var$Dk(a, d);
    return a;
}
function $473bb02057a7af41$var$fl(a, b, c, d) {
    var e = b.current, f = $473bb02057a7af41$var$R(), g = $473bb02057a7af41$var$yi(e);
    c = $473bb02057a7af41$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $473bb02057a7af41$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $473bb02057a7af41$var$nh(e, b, g);
    null !== a && ($473bb02057a7af41$var$gi(a, e, g, f), $473bb02057a7af41$var$oh(a, e, g));
    return g;
}
function $473bb02057a7af41$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $473bb02057a7af41$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $473bb02057a7af41$var$il(a, b) {
    $473bb02057a7af41$var$hl(a, b);
    (a = a.alternate) && $473bb02057a7af41$var$hl(a, b);
}
function $473bb02057a7af41$var$jl() {
    return null;
}
var $473bb02057a7af41$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $473bb02057a7af41$var$ll(a) {
    this._internalRoot = a;
}
$473bb02057a7af41$var$ml.prototype.render = $473bb02057a7af41$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($473bb02057a7af41$var$p(409));
    $473bb02057a7af41$var$fl(a, b, null, null);
};
$473bb02057a7af41$var$ml.prototype.unmount = $473bb02057a7af41$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $473bb02057a7af41$var$Rk(function() {
            $473bb02057a7af41$var$fl(null, a, null, null);
        });
        b[$473bb02057a7af41$var$uf] = null;
    }
};
function $473bb02057a7af41$var$ml(a) {
    this._internalRoot = a;
}
$473bb02057a7af41$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $473bb02057a7af41$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $473bb02057a7af41$var$Qc.length && 0 !== b && b < $473bb02057a7af41$var$Qc[c].priority; c++);
        $473bb02057a7af41$var$Qc.splice(c, 0, a);
        0 === c && $473bb02057a7af41$var$Vc(a);
    }
};
function $473bb02057a7af41$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $473bb02057a7af41$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $473bb02057a7af41$var$pl() {}
function $473bb02057a7af41$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $473bb02057a7af41$var$gl(g);
                f.call(a);
            };
        }
        var g = $473bb02057a7af41$var$el(b, d, a, 0, null, !1, !1, "", $473bb02057a7af41$var$pl);
        a._reactRootContainer = g;
        a[$473bb02057a7af41$var$uf] = g.current;
        $473bb02057a7af41$var$sf(8 === a.nodeType ? a.parentNode : a);
        $473bb02057a7af41$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $473bb02057a7af41$var$gl(k);
            h.call(a);
        };
    }
    var k = $473bb02057a7af41$var$bl(a, 0, !1, null, null, !1, !1, "", $473bb02057a7af41$var$pl);
    a._reactRootContainer = k;
    a[$473bb02057a7af41$var$uf] = k.current;
    $473bb02057a7af41$var$sf(8 === a.nodeType ? a.parentNode : a);
    $473bb02057a7af41$var$Rk(function() {
        $473bb02057a7af41$var$fl(b, k, c, d);
    });
    return k;
}
function $473bb02057a7af41$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $473bb02057a7af41$var$gl(g);
                h.call(a);
            };
        }
        $473bb02057a7af41$var$fl(b, g, a, e);
    } else g = $473bb02057a7af41$var$ql(c, b, a, e, d);
    return $473bb02057a7af41$var$gl(g);
}
$473bb02057a7af41$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $473bb02057a7af41$var$tc(b.pendingLanes);
                0 !== c && ($473bb02057a7af41$var$Cc(b, c | 1), $473bb02057a7af41$var$Dk(b, $473bb02057a7af41$var$B()), 0 === ($473bb02057a7af41$var$K & 6) && ($473bb02057a7af41$var$Gj = $473bb02057a7af41$var$B() + 500, $473bb02057a7af41$var$jg()));
            }
            break;
        case 13:
            $473bb02057a7af41$var$Rk(function() {
                var b = $473bb02057a7af41$var$ih(a, 1);
                if (null !== b) {
                    var c = $473bb02057a7af41$var$R();
                    $473bb02057a7af41$var$gi(b, a, 1, c);
                }
            }), $473bb02057a7af41$var$il(a, 1);
    }
};
$473bb02057a7af41$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $473bb02057a7af41$var$ih(a, 134217728);
        if (null !== b) {
            var c = $473bb02057a7af41$var$R();
            $473bb02057a7af41$var$gi(b, a, 134217728, c);
        }
        $473bb02057a7af41$var$il(a, 134217728);
    }
};
$473bb02057a7af41$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $473bb02057a7af41$var$yi(a), c = $473bb02057a7af41$var$ih(a, b);
        if (null !== c) {
            var d = $473bb02057a7af41$var$R();
            $473bb02057a7af41$var$gi(c, a, b, d);
        }
        $473bb02057a7af41$var$il(a, b);
    }
};
$473bb02057a7af41$var$Hc = function() {
    return $473bb02057a7af41$var$C;
};
$473bb02057a7af41$var$Ic = function(a, b) {
    var c = $473bb02057a7af41$var$C;
    try {
        return $473bb02057a7af41$var$C = a, b();
    } finally{
        $473bb02057a7af41$var$C = c;
    }
};
$473bb02057a7af41$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $473bb02057a7af41$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $473bb02057a7af41$var$Db(d);
                        if (!e) throw Error($473bb02057a7af41$var$p(90));
                        $473bb02057a7af41$var$Wa(d);
                        $473bb02057a7af41$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $473bb02057a7af41$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $473bb02057a7af41$var$fb(a, !!c.multiple, b, !1);
    }
};
$473bb02057a7af41$var$Gb = $473bb02057a7af41$var$Qk;
$473bb02057a7af41$var$Hb = $473bb02057a7af41$var$Rk;
var $473bb02057a7af41$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $473bb02057a7af41$var$Cb,
        $473bb02057a7af41$var$ue,
        $473bb02057a7af41$var$Db,
        $473bb02057a7af41$var$Eb,
        $473bb02057a7af41$var$Fb,
        $473bb02057a7af41$var$Qk
    ]
}, $473bb02057a7af41$var$tl = {
    findFiberByHostInstance: $473bb02057a7af41$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $473bb02057a7af41$var$ul = {
    bundleType: $473bb02057a7af41$var$tl.bundleType,
    version: $473bb02057a7af41$var$tl.version,
    rendererPackageName: $473bb02057a7af41$var$tl.rendererPackageName,
    rendererConfig: $473bb02057a7af41$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $473bb02057a7af41$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $473bb02057a7af41$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $473bb02057a7af41$var$tl.findFiberByHostInstance || $473bb02057a7af41$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $473bb02057a7af41$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$473bb02057a7af41$var$vl.isDisabled && $473bb02057a7af41$var$vl.supportsFiber) try {
        $473bb02057a7af41$var$kc = $473bb02057a7af41$var$vl.inject($473bb02057a7af41$var$ul), $473bb02057a7af41$var$lc = $473bb02057a7af41$var$vl;
    } catch (a) {}
}
$473bb02057a7af41$export$ae55be85d98224ed = $473bb02057a7af41$var$sl;
$473bb02057a7af41$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$473bb02057a7af41$var$nl(b)) throw Error($473bb02057a7af41$var$p(200));
    return $473bb02057a7af41$var$cl(a, b, null, c);
};
$473bb02057a7af41$export$882461b6382ed46c = function(a, b) {
    if (!$473bb02057a7af41$var$nl(a)) throw Error($473bb02057a7af41$var$p(299));
    var c = !1, d = "", e = $473bb02057a7af41$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $473bb02057a7af41$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$473bb02057a7af41$var$uf] = b.current;
    $473bb02057a7af41$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $473bb02057a7af41$var$ll(b);
};
$473bb02057a7af41$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($473bb02057a7af41$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($473bb02057a7af41$var$p(268, a));
    }
    a = $473bb02057a7af41$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$473bb02057a7af41$export$cd75ccfd720a3cd4 = function(a) {
    return $473bb02057a7af41$var$Rk(a);
};
$473bb02057a7af41$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$473bb02057a7af41$var$ol(b)) throw Error($473bb02057a7af41$var$p(200));
    return $473bb02057a7af41$var$rl(null, a, b, !0, c);
};
$473bb02057a7af41$export$757ceba2d55c277e = function(a, b, c) {
    if (!$473bb02057a7af41$var$nl(a)) throw Error($473bb02057a7af41$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $473bb02057a7af41$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $473bb02057a7af41$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$473bb02057a7af41$var$uf] = b.current;
    $473bb02057a7af41$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $473bb02057a7af41$var$ml(b);
};
$473bb02057a7af41$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$473bb02057a7af41$var$ol(b)) throw Error($473bb02057a7af41$var$p(200));
    return $473bb02057a7af41$var$rl(null, a, b, !1, c);
};
$473bb02057a7af41$export$502457920280e6be = function(a) {
    if (!$473bb02057a7af41$var$ol(a)) throw Error($473bb02057a7af41$var$p(40));
    return a._reactRootContainer ? ($473bb02057a7af41$var$Rk(function() {
        $473bb02057a7af41$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$473bb02057a7af41$var$uf] = null;
        });
    }), !0) : !1;
};
$473bb02057a7af41$export$c78a37762a8d58e1 = $473bb02057a7af41$var$Qk;
$473bb02057a7af41$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$473bb02057a7af41$var$ol(c)) throw Error($473bb02057a7af41$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($473bb02057a7af41$var$p(38));
    return $473bb02057a7af41$var$rl(a, b, c, !1, d);
};
$473bb02057a7af41$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("hTW2z", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ezSh3"));

});
parcelRegister("ezSh3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a9ce6f492fe9a394$export$c4744153514ff05d, (v) => $a9ce6f492fe9a394$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a9ce6f492fe9a394$export$3e506c1ccc9cc1a7, (v) => $a9ce6f492fe9a394$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a9ce6f492fe9a394$export$e26fe2ed2fa76875, (v) => $a9ce6f492fe9a394$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a9ce6f492fe9a394$export$502329bbf4b505b1, (v) => $a9ce6f492fe9a394$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a9ce6f492fe9a394$export$6e3807111c4874c4, (v) => $a9ce6f492fe9a394$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a9ce6f492fe9a394$export$c27134553091fb3a, (v) => $a9ce6f492fe9a394$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a9ce6f492fe9a394$export$33ee1acdc04fd2a2, (v) => $a9ce6f492fe9a394$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a9ce6f492fe9a394$export$b00a404bbd5edef2, (v) => $a9ce6f492fe9a394$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $a9ce6f492fe9a394$export$8352ce38b91d0c62, (v) => $a9ce6f492fe9a394$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a9ce6f492fe9a394$export$d66a1c1c77bd778b, (v) => $a9ce6f492fe9a394$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a9ce6f492fe9a394$export$d3dfb8e4810cb555, (v) => $a9ce6f492fe9a394$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $a9ce6f492fe9a394$export$839f9183b0465a69, (v) => $a9ce6f492fe9a394$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $a9ce6f492fe9a394$export$72fdf0e06517287b, (v) => $a9ce6f492fe9a394$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $a9ce6f492fe9a394$export$4b844e58a3e414b4, (v) => $a9ce6f492fe9a394$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a9ce6f492fe9a394$export$816d2913ae6b83b1, (v) => $a9ce6f492fe9a394$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a9ce6f492fe9a394$export$61bcfe829111a1d0, (v) => $a9ce6f492fe9a394$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a9ce6f492fe9a394$export$7ee8c9beb337bc3f, (v) => $a9ce6f492fe9a394$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a9ce6f492fe9a394$export$b5836b71941fa3ed, (v) => $a9ce6f492fe9a394$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a9ce6f492fe9a394$export$cf845f2c119da08a, (v) => $a9ce6f492fe9a394$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a9ce6f492fe9a394$export$c4744153514ff05d;
var $a9ce6f492fe9a394$export$3e506c1ccc9cc1a7;
var $a9ce6f492fe9a394$export$e26fe2ed2fa76875;
var $a9ce6f492fe9a394$export$502329bbf4b505b1;
var $a9ce6f492fe9a394$export$6e3807111c4874c4;
var $a9ce6f492fe9a394$export$c27134553091fb3a;
var $a9ce6f492fe9a394$export$33ee1acdc04fd2a2;
var $a9ce6f492fe9a394$export$b00a404bbd5edef2;
var $a9ce6f492fe9a394$export$8352ce38b91d0c62;
var $a9ce6f492fe9a394$export$d66a1c1c77bd778b;
var $a9ce6f492fe9a394$export$d3dfb8e4810cb555;
var $a9ce6f492fe9a394$export$839f9183b0465a69;
var $a9ce6f492fe9a394$export$72fdf0e06517287b;
var $a9ce6f492fe9a394$export$4b844e58a3e414b4;
var $a9ce6f492fe9a394$export$816d2913ae6b83b1;
var $a9ce6f492fe9a394$export$61bcfe829111a1d0;
var $a9ce6f492fe9a394$export$7ee8c9beb337bc3f;
var $a9ce6f492fe9a394$export$b5836b71941fa3ed;
var $a9ce6f492fe9a394$export$cf845f2c119da08a;
'use strict';
function $a9ce6f492fe9a394$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a9ce6f492fe9a394$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a9ce6f492fe9a394$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a9ce6f492fe9a394$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a9ce6f492fe9a394$var$g(C, c)) n < e && 0 > $a9ce6f492fe9a394$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a9ce6f492fe9a394$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a9ce6f492fe9a394$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a9ce6f492fe9a394$var$l = performance;
    $a9ce6f492fe9a394$export$c4744153514ff05d = function() {
        return $a9ce6f492fe9a394$var$l.now();
    };
} else {
    var $a9ce6f492fe9a394$var$p = Date, $a9ce6f492fe9a394$var$q = $a9ce6f492fe9a394$var$p.now();
    $a9ce6f492fe9a394$export$c4744153514ff05d = function() {
        return $a9ce6f492fe9a394$var$p.now() - $a9ce6f492fe9a394$var$q;
    };
}
var $a9ce6f492fe9a394$var$r = [], $a9ce6f492fe9a394$var$t = [], $a9ce6f492fe9a394$var$u = 1, $a9ce6f492fe9a394$var$v = null, $a9ce6f492fe9a394$var$y = 3, $a9ce6f492fe9a394$var$z = !1, $a9ce6f492fe9a394$var$A = !1, $a9ce6f492fe9a394$var$B = !1, $a9ce6f492fe9a394$var$D = "function" === typeof setTimeout ? setTimeout : null, $a9ce6f492fe9a394$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a9ce6f492fe9a394$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a9ce6f492fe9a394$var$G(a) {
    for(var b = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t); null !== b;){
        if (null === b.callback) $a9ce6f492fe9a394$var$k($a9ce6f492fe9a394$var$t);
        else if (b.startTime <= a) $a9ce6f492fe9a394$var$k($a9ce6f492fe9a394$var$t), b.sortIndex = b.expirationTime, $a9ce6f492fe9a394$var$f($a9ce6f492fe9a394$var$r, b);
        else break;
        b = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t);
    }
}
function $a9ce6f492fe9a394$var$H(a) {
    $a9ce6f492fe9a394$var$B = !1;
    $a9ce6f492fe9a394$var$G(a);
    if (!$a9ce6f492fe9a394$var$A) {
        if (null !== $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r)) $a9ce6f492fe9a394$var$A = !0, $a9ce6f492fe9a394$var$I($a9ce6f492fe9a394$var$J);
        else {
            var b = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t);
            null !== b && $a9ce6f492fe9a394$var$K($a9ce6f492fe9a394$var$H, b.startTime - a);
        }
    }
}
function $a9ce6f492fe9a394$var$J(a, b) {
    $a9ce6f492fe9a394$var$A = !1;
    $a9ce6f492fe9a394$var$B && ($a9ce6f492fe9a394$var$B = !1, $a9ce6f492fe9a394$var$E($a9ce6f492fe9a394$var$L), $a9ce6f492fe9a394$var$L = -1);
    $a9ce6f492fe9a394$var$z = !0;
    var c = $a9ce6f492fe9a394$var$y;
    try {
        $a9ce6f492fe9a394$var$G(b);
        for($a9ce6f492fe9a394$var$v = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r); null !== $a9ce6f492fe9a394$var$v && (!($a9ce6f492fe9a394$var$v.expirationTime > b) || a && !$a9ce6f492fe9a394$var$M());){
            var d = $a9ce6f492fe9a394$var$v.callback;
            if ("function" === typeof d) {
                $a9ce6f492fe9a394$var$v.callback = null;
                $a9ce6f492fe9a394$var$y = $a9ce6f492fe9a394$var$v.priorityLevel;
                var e = d($a9ce6f492fe9a394$var$v.expirationTime <= b);
                b = $a9ce6f492fe9a394$export$c4744153514ff05d();
                "function" === typeof e ? $a9ce6f492fe9a394$var$v.callback = e : $a9ce6f492fe9a394$var$v === $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r) && $a9ce6f492fe9a394$var$k($a9ce6f492fe9a394$var$r);
                $a9ce6f492fe9a394$var$G(b);
            } else $a9ce6f492fe9a394$var$k($a9ce6f492fe9a394$var$r);
            $a9ce6f492fe9a394$var$v = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r);
        }
        if (null !== $a9ce6f492fe9a394$var$v) var w = !0;
        else {
            var m = $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t);
            null !== m && $a9ce6f492fe9a394$var$K($a9ce6f492fe9a394$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a9ce6f492fe9a394$var$v = null, $a9ce6f492fe9a394$var$y = c, $a9ce6f492fe9a394$var$z = !1;
    }
}
var $a9ce6f492fe9a394$var$N = !1, $a9ce6f492fe9a394$var$O = null, $a9ce6f492fe9a394$var$L = -1, $a9ce6f492fe9a394$var$P = 5, $a9ce6f492fe9a394$var$Q = -1;
function $a9ce6f492fe9a394$var$M() {
    return $a9ce6f492fe9a394$export$c4744153514ff05d() - $a9ce6f492fe9a394$var$Q < $a9ce6f492fe9a394$var$P ? !1 : !0;
}
function $a9ce6f492fe9a394$var$R() {
    if (null !== $a9ce6f492fe9a394$var$O) {
        var a = $a9ce6f492fe9a394$export$c4744153514ff05d();
        $a9ce6f492fe9a394$var$Q = a;
        var b = !0;
        try {
            b = $a9ce6f492fe9a394$var$O(!0, a);
        } finally{
            b ? $a9ce6f492fe9a394$var$S() : ($a9ce6f492fe9a394$var$N = !1, $a9ce6f492fe9a394$var$O = null);
        }
    } else $a9ce6f492fe9a394$var$N = !1;
}
var $a9ce6f492fe9a394$var$S;
if ("function" === typeof $a9ce6f492fe9a394$var$F) $a9ce6f492fe9a394$var$S = function() {
    $a9ce6f492fe9a394$var$F($a9ce6f492fe9a394$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a9ce6f492fe9a394$var$T = new MessageChannel, $a9ce6f492fe9a394$var$U = $a9ce6f492fe9a394$var$T.port2;
    $a9ce6f492fe9a394$var$T.port1.onmessage = $a9ce6f492fe9a394$var$R;
    $a9ce6f492fe9a394$var$S = function() {
        $a9ce6f492fe9a394$var$U.postMessage(null);
    };
} else $a9ce6f492fe9a394$var$S = function() {
    $a9ce6f492fe9a394$var$D($a9ce6f492fe9a394$var$R, 0);
};
function $a9ce6f492fe9a394$var$I(a) {
    $a9ce6f492fe9a394$var$O = a;
    $a9ce6f492fe9a394$var$N || ($a9ce6f492fe9a394$var$N = !0, $a9ce6f492fe9a394$var$S());
}
function $a9ce6f492fe9a394$var$K(a, b) {
    $a9ce6f492fe9a394$var$L = $a9ce6f492fe9a394$var$D(function() {
        a($a9ce6f492fe9a394$export$c4744153514ff05d());
    }, b);
}
$a9ce6f492fe9a394$export$3e506c1ccc9cc1a7 = 5;
$a9ce6f492fe9a394$export$e26fe2ed2fa76875 = 1;
$a9ce6f492fe9a394$export$502329bbf4b505b1 = 4;
$a9ce6f492fe9a394$export$6e3807111c4874c4 = 3;
$a9ce6f492fe9a394$export$c27134553091fb3a = null;
$a9ce6f492fe9a394$export$33ee1acdc04fd2a2 = 2;
$a9ce6f492fe9a394$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a9ce6f492fe9a394$export$8352ce38b91d0c62 = function() {
    $a9ce6f492fe9a394$var$A || $a9ce6f492fe9a394$var$z || ($a9ce6f492fe9a394$var$A = !0, $a9ce6f492fe9a394$var$I($a9ce6f492fe9a394$var$J));
};
$a9ce6f492fe9a394$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a9ce6f492fe9a394$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a9ce6f492fe9a394$export$d3dfb8e4810cb555 = function() {
    return $a9ce6f492fe9a394$var$y;
};
$a9ce6f492fe9a394$export$839f9183b0465a69 = function() {
    return $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r);
};
$a9ce6f492fe9a394$export$72fdf0e06517287b = function(a) {
    switch($a9ce6f492fe9a394$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a9ce6f492fe9a394$var$y;
    }
    var c = $a9ce6f492fe9a394$var$y;
    $a9ce6f492fe9a394$var$y = b;
    try {
        return a();
    } finally{
        $a9ce6f492fe9a394$var$y = c;
    }
};
$a9ce6f492fe9a394$export$4b844e58a3e414b4 = function() {};
$a9ce6f492fe9a394$export$816d2913ae6b83b1 = function() {};
$a9ce6f492fe9a394$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a9ce6f492fe9a394$var$y;
    $a9ce6f492fe9a394$var$y = a;
    try {
        return b();
    } finally{
        $a9ce6f492fe9a394$var$y = c;
    }
};
$a9ce6f492fe9a394$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a9ce6f492fe9a394$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a9ce6f492fe9a394$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a9ce6f492fe9a394$var$f($a9ce6f492fe9a394$var$t, a), null === $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$r) && a === $a9ce6f492fe9a394$var$h($a9ce6f492fe9a394$var$t) && ($a9ce6f492fe9a394$var$B ? ($a9ce6f492fe9a394$var$E($a9ce6f492fe9a394$var$L), $a9ce6f492fe9a394$var$L = -1) : $a9ce6f492fe9a394$var$B = !0, $a9ce6f492fe9a394$var$K($a9ce6f492fe9a394$var$H, c - d))) : (a.sortIndex = e, $a9ce6f492fe9a394$var$f($a9ce6f492fe9a394$var$r, a), $a9ce6f492fe9a394$var$A || $a9ce6f492fe9a394$var$z || ($a9ce6f492fe9a394$var$A = !0, $a9ce6f492fe9a394$var$I($a9ce6f492fe9a394$var$J)));
    return a;
};
$a9ce6f492fe9a394$export$b5836b71941fa3ed = $a9ce6f492fe9a394$var$M;
$a9ce6f492fe9a394$export$cf845f2c119da08a = function(a) {
    var b = $a9ce6f492fe9a394$var$y;
    return function() {
        var c = $a9ce6f492fe9a394$var$y;
        $a9ce6f492fe9a394$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a9ce6f492fe9a394$var$y = c;
        }
    };
};

});



function $923913c985b4b833$export$f0c3d11dfc819375(data, newTab = false) {
    const form = document.createElement("form");
    form.setAttribute("style", "display: none;");
    form.setAttribute("action", location.pathname);
    form.setAttribute("method", "POST");
    if (newTab) form.setAttribute("target", "_blank");
    for(const key in data){
        const inp = document.createElement("input");
        inp.setAttribute("type", "hidden");
        inp.setAttribute("name", key);
        inp.setAttribute("value", data[key]);
        form.appendChild(inp);
    }
    document.body.appendChild(form);
    form.submit();
}


function $b2661322620170b6$var$removeItem(itemIDs, toRemove) {
    const ind = itemIDs.indexOf(toRemove);
    itemIDs.splice(ind, 1);
    (0, $923913c985b4b833$export$f0c3d11dfc819375)({
        type: "item",
        items: itemIDs.join(",")
    });
}
function $b2661322620170b6$var$makeButton(label, code, target) {
    const $btt = document.createElement("button");
    $btt.innerText = label;
    $btt.addEventListener("click", ()=>{
        target.innerHTML += code + "\n";
    });
    return $btt;
}
const $b2661322620170b6$var$questRewardString = `## Nagroda z questa

Przedmiot jest nagrod\u{105} za uko\u{144}czenie questa: **QUESTNAME**.`;
function $b2661322620170b6$export$785798112f409e83() {
    const items = document.querySelectorAll(".margonem_item");
    const itemIDs = [];
    for (const it of items){
        const item = JSON.parse(it.getAttribute("data-itemtip"));
        itemIDs.push(item.id);
        it.addEventListener("contextmenu", (e)=>{
            if (e.ctrlKey) (0, $923913c985b4b833$export$f0c3d11dfc819375)({
                type: "item",
                items: `${item.id}`
            }, true);
            else $b2661322620170b6$var$removeItem(itemIDs, item.id);
            e.preventDefault();
        });
    }
    // Add helper buttons
    const $form = document.querySelector("form");
    const $buttonWrapper = document.createElement("div");
    $form.parentElement.insertBefore($buttonWrapper, $form);
    const $textarea = $form.querySelector("textarea");
    $buttonWrapper.appendChild($b2661322620170b6$var$makeButton("Tag", `async (item, helper) => await helper.addTag(item, "TAGID")`, $textarea));
    $buttonWrapper.appendChild($b2661322620170b6$var$makeButton("Loot", `async (item, helper) => {const loot = item.loot ?? []; loot.push("PSEUDOCLASS"); item.loot = loot;}`, $textarea));
    $buttonWrapper.appendChild($b2661322620170b6$var$makeButton("Quest-reward", `async (item, helper) => {\n\tawait helper.addTag(item, "quest-reward");\n\titem.notes = \`${$b2661322620170b6$var$questRewardString}\`\n}`, $textarea));
    $buttonWrapper.appendChild($b2661322620170b6$var$makeButton("Removed", `async (item, helper) => {\n\tawait helper.addTag(item, "removed");\n}`, $textarea));
    $buttonWrapper.appendChild($b2661322620170b6$var$makeButton("Event-other", `async (item, helper) => {\n\tawait helper.addTag(item, "event-other");\n\tawait helper.addTag(item, "event");\n}`, $textarea));
    $buttonWrapper.appendChild($b2661322620170b6$var$makeButton("MargoMini", `async (item, helper) => {\n\tawait helper.addTag(item, "removed");\n\tawait helper.addTag(item, "margomini");\n}`, $textarea));
}


var $e6cf7df2deb21e18$exports = {};
(function(name, root, factory) {
    $e6cf7df2deb21e18$exports = factory();
    $e6cf7df2deb21e18$exports['default'] = factory();
})('slugify', $e6cf7df2deb21e18$exports, function() {
    var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xa2":"cent","\xa3":"pound","\xa4":"currency","\xa5":"yen","\xa9":"(c)","\xaa":"a","\xae":"(r)","\xba":"o","\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xc6":"AE","\xc7":"C","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xd0":"D","\xd1":"N","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xdd":"Y","\xde":"TH","\xdf":"ss","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xe6":"ae","\xe7":"c","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xf0":"d","\xf1":"n","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xfd":"y","\xfe":"th","\xff":"y","\u0100":"A","\u0101":"a","\u0102":"A","\u0103":"a","\u0104":"A","\u0105":"a","\u0106":"C","\u0107":"c","\u010C":"C","\u010D":"c","\u010E":"D","\u010F":"d","\u0110":"DJ","\u0111":"dj","\u0112":"E","\u0113":"e","\u0116":"E","\u0117":"e","\u0118":"e","\u0119":"e","\u011A":"E","\u011B":"e","\u011E":"G","\u011F":"g","\u0122":"G","\u0123":"g","\u0128":"I","\u0129":"i","\u012A":"i","\u012B":"i","\u012E":"I","\u012F":"i","\u0130":"I","\u0131":"i","\u0136":"k","\u0137":"k","\u013B":"L","\u013C":"l","\u013D":"L","\u013E":"l","\u0141":"L","\u0142":"l","\u0143":"N","\u0144":"n","\u0145":"N","\u0146":"n","\u0147":"N","\u0148":"n","\u014C":"O","\u014D":"o","\u0150":"O","\u0151":"o","\u0152":"OE","\u0153":"oe","\u0154":"R","\u0155":"r","\u0158":"R","\u0159":"r","\u015A":"S","\u015B":"s","\u015E":"S","\u015F":"s","\u0160":"S","\u0161":"s","\u0162":"T","\u0163":"t","\u0164":"T","\u0165":"t","\u0168":"U","\u0169":"u","\u016A":"u","\u016B":"u","\u016E":"U","\u016F":"u","\u0170":"U","\u0171":"u","\u0172":"U","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017A":"z","\u017B":"Z","\u017C":"z","\u017D":"Z","\u017E":"z","\u018F":"E","\u0192":"f","\u01A0":"O","\u01A1":"o","\u01AF":"U","\u01B0":"u","\u01C8":"LJ","\u01C9":"lj","\u01CB":"NJ","\u01CC":"nj","\u0218":"S","\u0219":"s","\u021A":"T","\u021B":"t","\u0259":"e","\u02DA":"o","\u0386":"A","\u0388":"E","\u0389":"H","\u038A":"I","\u038C":"O","\u038E":"Y","\u038F":"W","\u0390":"i","\u0391":"A","\u0392":"B","\u0393":"G","\u0394":"D","\u0395":"E","\u0396":"Z","\u0397":"H","\u0398":"8","\u0399":"I","\u039A":"K","\u039B":"L","\u039C":"M","\u039D":"N","\u039E":"3","\u039F":"O","\u03A0":"P","\u03A1":"R","\u03A3":"S","\u03A4":"T","\u03A5":"Y","\u03A6":"F","\u03A7":"X","\u03A8":"PS","\u03A9":"W","\u03AA":"I","\u03AB":"Y","\u03AC":"a","\u03AD":"e","\u03AE":"h","\u03AF":"i","\u03B0":"y","\u03B1":"a","\u03B2":"b","\u03B3":"g","\u03B4":"d","\u03B5":"e","\u03B6":"z","\u03B7":"h","\u03B8":"8","\u03B9":"i","\u03BA":"k","\u03BB":"l","\u03BC":"m","\u03BD":"n","\u03BE":"3","\u03BF":"o","\u03C0":"p","\u03C1":"r","\u03C2":"s","\u03C3":"s","\u03C4":"t","\u03C5":"y","\u03C6":"f","\u03C7":"x","\u03C8":"ps","\u03C9":"w","\u03CA":"i","\u03CB":"y","\u03CC":"o","\u03CD":"y","\u03CE":"w","\u0401":"Yo","\u0402":"DJ","\u0404":"Ye","\u0406":"I","\u0407":"Yi","\u0408":"J","\u0409":"LJ","\u040A":"NJ","\u040B":"C","\u040F":"DZ","\u0410":"A","\u0411":"B","\u0412":"V","\u0413":"G","\u0414":"D","\u0415":"E","\u0416":"Zh","\u0417":"Z","\u0418":"I","\u0419":"J","\u041A":"K","\u041B":"L","\u041C":"M","\u041D":"N","\u041E":"O","\u041F":"P","\u0420":"R","\u0421":"S","\u0422":"T","\u0423":"U","\u0424":"F","\u0425":"H","\u0426":"C","\u0427":"Ch","\u0428":"Sh","\u0429":"Sh","\u042A":"U","\u042B":"Y","\u042C":"","\u042D":"E","\u042E":"Yu","\u042F":"Ya","\u0430":"a","\u0431":"b","\u0432":"v","\u0433":"g","\u0434":"d","\u0435":"e","\u0436":"zh","\u0437":"z","\u0438":"i","\u0439":"j","\u043A":"k","\u043B":"l","\u043C":"m","\u043D":"n","\u043E":"o","\u043F":"p","\u0440":"r","\u0441":"s","\u0442":"t","\u0443":"u","\u0444":"f","\u0445":"h","\u0446":"c","\u0447":"ch","\u0448":"sh","\u0449":"sh","\u044A":"u","\u044B":"y","\u044C":"","\u044D":"e","\u044E":"yu","\u044F":"ya","\u0451":"yo","\u0452":"dj","\u0454":"ye","\u0456":"i","\u0457":"yi","\u0458":"j","\u0459":"lj","\u045A":"nj","\u045B":"c","\u045D":"u","\u045F":"dz","\u0490":"G","\u0491":"g","\u0492":"GH","\u0493":"gh","\u049A":"KH","\u049B":"kh","\u04A2":"NG","\u04A3":"ng","\u04AE":"UE","\u04AF":"ue","\u04B0":"U","\u04B1":"u","\u04BA":"H","\u04BB":"h","\u04D8":"AE","\u04D9":"ae","\u04E8":"OE","\u04E9":"oe","\u0531":"A","\u0532":"B","\u0533":"G","\u0534":"D","\u0535":"E","\u0536":"Z","\u0537":"E\'","\u0538":"Y\'","\u0539":"T\'","\u053A":"JH","\u053B":"I","\u053C":"L","\u053D":"X","\u053E":"C\'","\u053F":"K","\u0540":"H","\u0541":"D\'","\u0542":"GH","\u0543":"TW","\u0544":"M","\u0545":"Y","\u0546":"N","\u0547":"SH","\u0549":"CH","\u054A":"P","\u054B":"J","\u054C":"R\'","\u054D":"S","\u054E":"V","\u054F":"T","\u0550":"R","\u0551":"C","\u0553":"P\'","\u0554":"Q\'","\u0555":"O\'\'","\u0556":"F","\u0587":"EV","\u0621":"a","\u0622":"aa","\u0623":"a","\u0624":"u","\u0625":"i","\u0626":"e","\u0627":"a","\u0628":"b","\u0629":"h","\u062A":"t","\u062B":"th","\u062C":"j","\u062D":"h","\u062E":"kh","\u062F":"d","\u0630":"th","\u0631":"r","\u0632":"z","\u0633":"s","\u0634":"sh","\u0635":"s","\u0636":"dh","\u0637":"t","\u0638":"z","\u0639":"a","\u063A":"gh","\u0641":"f","\u0642":"q","\u0643":"k","\u0644":"l","\u0645":"m","\u0646":"n","\u0647":"h","\u0648":"w","\u0649":"a","\u064A":"y","\u064B":"an","\u064C":"on","\u064D":"en","\u064E":"a","\u064F":"u","\u0650":"e","\u0652":"","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u067E":"p","\u0686":"ch","\u0698":"zh","\u06A9":"k","\u06AF":"g","\u06CC":"y","\u06F0":"0","\u06F1":"1","\u06F2":"2","\u06F3":"3","\u06F4":"4","\u06F5":"5","\u06F6":"6","\u06F7":"7","\u06F8":"8","\u06F9":"9","\u0E3F":"baht","\u10D0":"a","\u10D1":"b","\u10D2":"g","\u10D3":"d","\u10D4":"e","\u10D5":"v","\u10D6":"z","\u10D7":"t","\u10D8":"i","\u10D9":"k","\u10DA":"l","\u10DB":"m","\u10DC":"n","\u10DD":"o","\u10DE":"p","\u10DF":"zh","\u10E0":"r","\u10E1":"s","\u10E2":"t","\u10E3":"u","\u10E4":"f","\u10E5":"k","\u10E6":"gh","\u10E7":"q","\u10E8":"sh","\u10E9":"ch","\u10EA":"ts","\u10EB":"dz","\u10EC":"ts","\u10ED":"ch","\u10EE":"kh","\u10EF":"j","\u10F0":"h","\u1E62":"S","\u1E63":"s","\u1E80":"W","\u1E81":"w","\u1E82":"W","\u1E83":"w","\u1E84":"W","\u1E85":"w","\u1E9E":"SS","\u1EA0":"A","\u1EA1":"a","\u1EA2":"A","\u1EA3":"a","\u1EA4":"A","\u1EA5":"a","\u1EA6":"A","\u1EA7":"a","\u1EA8":"A","\u1EA9":"a","\u1EAA":"A","\u1EAB":"a","\u1EAC":"A","\u1EAD":"a","\u1EAE":"A","\u1EAF":"a","\u1EB0":"A","\u1EB1":"a","\u1EB2":"A","\u1EB3":"a","\u1EB4":"A","\u1EB5":"a","\u1EB6":"A","\u1EB7":"a","\u1EB8":"E","\u1EB9":"e","\u1EBA":"E","\u1EBB":"e","\u1EBC":"E","\u1EBD":"e","\u1EBE":"E","\u1EBF":"e","\u1EC0":"E","\u1EC1":"e","\u1EC2":"E","\u1EC3":"e","\u1EC4":"E","\u1EC5":"e","\u1EC6":"E","\u1EC7":"e","\u1EC8":"I","\u1EC9":"i","\u1ECA":"I","\u1ECB":"i","\u1ECC":"O","\u1ECD":"o","\u1ECE":"O","\u1ECF":"o","\u1ED0":"O","\u1ED1":"o","\u1ED2":"O","\u1ED3":"o","\u1ED4":"O","\u1ED5":"o","\u1ED6":"O","\u1ED7":"o","\u1ED8":"O","\u1ED9":"o","\u1EDA":"O","\u1EDB":"o","\u1EDC":"O","\u1EDD":"o","\u1EDE":"O","\u1EDF":"o","\u1EE0":"O","\u1EE1":"o","\u1EE2":"O","\u1EE3":"o","\u1EE4":"U","\u1EE5":"u","\u1EE6":"U","\u1EE7":"u","\u1EE8":"U","\u1EE9":"u","\u1EEA":"U","\u1EEB":"u","\u1EEC":"U","\u1EED":"u","\u1EEE":"U","\u1EEF":"u","\u1EF0":"U","\u1EF1":"u","\u1EF2":"Y","\u1EF3":"y","\u1EF4":"Y","\u1EF5":"y","\u1EF6":"Y","\u1EF7":"y","\u1EF8":"Y","\u1EF9":"y","\u2013":"-","\u2018":"\'","\u2019":"\'","\u201C":"\\"","\u201D":"\\"","\u201E":"\\"","\u2020":"+","\u2022":"*","\u2026":"...","\u20A0":"ecu","\u20A2":"cruzeiro","\u20A3":"french franc","\u20A4":"lira","\u20A5":"mill","\u20A6":"naira","\u20A7":"peseta","\u20A8":"rupee","\u20A9":"won","\u20AA":"new shequel","\u20AB":"dong","\u20AC":"euro","\u20AD":"kip","\u20AE":"tugrik","\u20AF":"drachma","\u20B0":"penny","\u20B1":"peso","\u20B2":"guarani","\u20B3":"austral","\u20B4":"hryvnia","\u20B5":"cedi","\u20B8":"kazakhstani tenge","\u20B9":"indian rupee","\u20BA":"turkish lira","\u20BD":"russian ruble","\u20BF":"bitcoin","\u2120":"sm","\u2122":"tm","\u2202":"d","\u2206":"delta","\u2211":"sum","\u221E":"infinity","\u2665":"love","\u5143":"yuan","\u5186":"yen","\uFDFC":"rial","\uFEF5":"laa","\uFEF7":"laa","\uFEF9":"lai","\uFEFB":"la"}');
    var locales = JSON.parse('{"bg":{"\u0419":"Y","\u0426":"Ts","\u0429":"Sht","\u042A":"A","\u042C":"Y","\u0439":"y","\u0446":"ts","\u0449":"sht","\u044A":"a","\u044C":"y"},"de":{"\xc4":"AE","\xe4":"ae","\xd6":"OE","\xf6":"oe","\xdc":"UE","\xfc":"ue","\xdf":"ss","%":"prozent","&":"und","|":"oder","\u2211":"summe","\u221E":"unendlich","\u2665":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","\xa2":"centavos","\xa3":"libras","\xa4":"moneda","\u20A3":"francos","\u2211":"suma","\u221E":"infinito","\u2665":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xa2":"centime","\xa3":"livre","\xa4":"devise","\u20A3":"franc","\u2211":"somme","\u221E":"infini","\u2665":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","\xa2":"centavo","\u2211":"soma","\xa3":"libra","\u221E":"infinito","\u2665":"amor"},"uk":{"\u0418":"Y","\u0438":"y","\u0419":"Y","\u0439":"y","\u0426":"Ts","\u0446":"ts","\u0425":"Kh","\u0445":"kh","\u0429":"Shch","\u0449":"shch","\u0413":"H","\u0433":"h"},"vi":{"\u0110":"D","\u0111":"d"},"da":{"\xd8":"OE","\xf8":"oe","\xc5":"AA","\xe5":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"st\xf8rre end"},"nb":{"&":"og","\xc5":"AA","\xc6":"AE","\xd8":"OE","\xe5":"aa","\xe6":"ae","\xf8":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","\xc5":"AA","\xc4":"AE","\xd6":"OE","\xe5":"aa","\xe4":"ae","\xf6":"oe"}}');
    function replace(string, options) {
        if (typeof string !== 'string') throw new Error('slugify: string argument expected');
        options = typeof options === 'string' ? {
            replacement: options
        } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === undefined ? '-' : options.replacement;
        var trim = options.trim === undefined ? true : options.trim;
        var slug = string.normalize().split('')// replace characters based on charMap
        .reduce(function(result, ch) {
            var appendChar = locale[ch];
            if (appendChar === undefined) appendChar = charMap[ch];
            if (appendChar === undefined) appendChar = ch;
            if (appendChar === replacement) appendChar = ' ';
            return result + appendChar// remove not allowed characters
            .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '');
        }, '');
        if (options.strict) slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
        if (trim) slug = slug.trim();
        // Replace spaces with replacement character, treating multiple consecutive
        // spaces as a single space.
        slug = slug.replace(/\s+/g, replacement);
        if (options.lower) slug = slug.toLowerCase();
        return slug;
    }
    replace.extend = function(customMap) {
        Object.assign(charMap, customMap);
    };
    return replace;
});


function $b1b3a5b6a44c1945$export$ca57dfcfc90744dd(name) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($e6cf7df2deb21e18$exports)))(name, {
        remove: /[*+~.()'"!:@<>]/g,
        lower: true
    });
}
function $b1b3a5b6a44c1945$export$306669456b7a6332(npc) {
    let lvl = npc.lvl ?? "auto";
    if (npc.lvl < 0) lvl = "auto";
    return $b1b3a5b6a44c1945$export$ca57dfcfc90744dd(`${npc.nick}-${lvl}lvl`);
}
function $b1b3a5b6a44c1945$export$c26822279c62e848(id, name, slugName, attribs = "") {
    return `<a ${attribs} href="/npc/view/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(slugName ?? name ?? "")}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$644eb82018f2a00b(id, name, slugName, attribs = "") {
    return `<a ${attribs} href="/world/view/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(slugName ?? name ?? "")}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$b8331a4ad4a2fd01(id, name, slugName, attribs = "") {
    if (typeof id == "string" && id.startsWith("blessing:")) return `<a ${attribs} href="/item/${id.replace(":", "?").replace(/;/g, "&")}">${name}</a>`;
    else return `<a ${attribs} href="/item/view/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(slugName ?? name ?? "")}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$c1b3e8922e77c45c(id, name, attribs = "") {
    return `<a ${attribs} href="/tags/view/${id}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$5db16ef4152f2638(id, name, attribs = "") {
    return `<a ${attribs} href="/shop/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(name)}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$a628b36f42681f0b(id, name, attribs = "") {
    return `<a ${attribs} href="/npc/barter/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(name)}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$bce7e4441458b8ab(path, name) {
    return `<a href="/guides${path}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$5a301cfd6176f7f3(id, name) {
    return `/quests/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(name)}`;
}
function $b1b3a5b6a44c1945$export$e2c6bf7d87abc288(id, name, attribs = "") {
    return `<a ${attribs} href="${$b1b3a5b6a44c1945$export$5a301cfd6176f7f3(id, name)}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$65d9332b83300b43(id, name, slugName, attribs = "") {
    return `<a ${attribs} target="_blank" href="https://experimental.margoworld.pl/npc/view/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(slugName ?? name ?? "")}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$ce6098b04a6d35c2(id, name, slugName, attribs = "") {
    return `<a ${attribs} target="_blank" href="https://experimental.margoworld.pl/world/view/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(slugName ?? name ?? "")}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$1cf890667c132a02(id, name, slugName, attribs = "") {
    return `<a ${attribs} target="_blank" href="https://experimental.margoworld.pl/item/view/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(slugName ?? name ?? "")}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$70aee3ec55b1a1b0(id, name, attribs = "") {
    return `<a ${attribs} target="_blank" href="https://experimental.margoworld.pl/tags/view/${id}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$e8ead4bb34cdf526(id, name, attribs = "") {
    return `<a ${attribs} target="_blank" href="https://experimental.margoworld.pl/shop/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(name)}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$8c769ecb9f913be3(id, name, attribs = "") {
    return `<a ${attribs} target="_blank" href="https://experimental.margoworld.pl/npc/barter/${id}/${$b1b3a5b6a44c1945$export$ca57dfcfc90744dd(name)}">${name}</a>`;
}
function $b1b3a5b6a44c1945$export$f45ea0c0e080ec1d(path, name) {
    return `<a target="_blank" href="https://experimental.margoworld.pl/guides${path}">${name}</a>`;
}


/**
 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ const { replace: $634f10d55e666f65$var$replace } = '';
// escape
const $634f10d55e666f65$var$es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
const $634f10d55e666f65$var$ca = /[&<>'"]/g;
const $634f10d55e666f65$var$esca = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
};
const $634f10d55e666f65$var$pe = (m)=>$634f10d55e666f65$var$esca[m];
const $634f10d55e666f65$export$4e7f196112fea3c5 = (es)=>$634f10d55e666f65$var$replace.call(es, $634f10d55e666f65$var$ca, $634f10d55e666f65$var$pe);
// unescape
const $634f10d55e666f65$var$unes = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"'
};
const $634f10d55e666f65$var$cape = (m)=>$634f10d55e666f65$var$unes[m];
const $634f10d55e666f65$export$e8bacd2802a88316 = (un)=>$634f10d55e666f65$var$replace.call(un, $634f10d55e666f65$var$es, $634f10d55e666f65$var$cape);


const $c2bdc760a1d746cf$export$2cc7ae7d4fb97c35 = {
    "img": "https://experimental.margonem.pl/img/",
    "playerPath": "https://micc.garmory-cdn.cloud/obrazki/postacie/",
    "npcPath": "https://micc.garmory-cdn.cloud/obrazki/npc/",
    "mapPath": "https://micc.garmory-cdn.cloud/obrazki/miasta/",
    "itemPath": "https://micc.garmory-cdn.cloud/obrazki/itemy/",
    "petPath": "https://micc.garmory-cdn.cloud/obrazki/pets",
    "emoPath": "https://micc.garmory-cdn.cloud/obrazki/interface/emo/",
    "effectPath": "https://micc.garmory-cdn.cloud/obrazki/interface/environmentalEffects/",
    "battlePath": "https://micc.garmory-cdn.cloud/obrazki/battle/"
};


var $d98f7bb170da977b$export$d2ffa9ea74cc769f;
(function(ItemRarity) {
    ItemRarity[ItemRarity["COMMON"] = 0] = "COMMON";
    ItemRarity[ItemRarity["UNIQUE"] = 1] = "UNIQUE";
    ItemRarity[ItemRarity["HEROIC"] = 2] = "HEROIC";
    ItemRarity[ItemRarity["UPGRADED"] = 3] = "UPGRADED";
    ItemRarity[ItemRarity["LEGENDARY"] = 4] = "LEGENDARY";
    ItemRarity[ItemRarity["ARTIFACT"] = 5] = "ARTIFACT";
})($d98f7bb170da977b$export$d2ffa9ea74cc769f || ($d98f7bb170da977b$export$d2ffa9ea74cc769f = {}));
var $d98f7bb170da977b$export$99a5dceb42a0a5f5;
(function(ItemClass) {
    ItemClass[ItemClass["NONE"] = 0] = "NONE";
    ItemClass[ItemClass["ONEHANDED"] = 1] = "ONEHANDED";
    ItemClass[ItemClass["TWOHANDED"] = 2] = "TWOHANDED";
    ItemClass[ItemClass["ONEANDAHALFHANDED"] = 3] = "ONEANDAHALFHANDED";
    ItemClass[ItemClass["RANGED"] = 4] = "RANGED";
    ItemClass[ItemClass["SECONDARY"] = 5] = "SECONDARY";
    ItemClass[ItemClass["WAND"] = 6] = "WAND";
    ItemClass[ItemClass["ORB"] = 7] = "ORB";
    ItemClass[ItemClass["ARMOR"] = 8] = "ARMOR";
    ItemClass[ItemClass["HELMET"] = 9] = "HELMET";
    ItemClass[ItemClass["BOOTS"] = 10] = "BOOTS";
    ItemClass[ItemClass["GLOVES"] = 11] = "GLOVES";
    ItemClass[ItemClass["RING"] = 12] = "RING";
    ItemClass[ItemClass["NECKLACE"] = 13] = "NECKLACE";
    ItemClass[ItemClass["SHIELD"] = 14] = "SHIELD";
    ItemClass[ItemClass["NEAUTRAL"] = 15] = "NEAUTRAL";
    ItemClass[ItemClass["CONSUMABLE"] = 16] = "CONSUMABLE";
    ItemClass[ItemClass["GOLD"] = 17] = "GOLD";
    ItemClass[ItemClass["KEY"] = 18] = "KEY";
    ItemClass[ItemClass["QUEST"] = 19] = "QUEST";
    ItemClass[ItemClass["RENEWABLE"] = 20] = "RENEWABLE";
    ItemClass[ItemClass["HEAL"] = 21] = "HEAL";
    ItemClass[ItemClass["CHARM"] = 22] = "CHARM";
    ItemClass[ItemClass["BOOK"] = 23] = "BOOK";
    ItemClass[ItemClass["BAG"] = 24] = "BAG";
    ItemClass[ItemClass["BLESSING"] = 25] = "BLESSING";
    ItemClass[ItemClass["ENHANCEMENT"] = 26] = "ENHANCEMENT";
    ItemClass[ItemClass["RECIPE"] = 27] = "RECIPE";
    ItemClass[ItemClass["CURRENCY"] = 28] = "CURRENCY";
    ItemClass[ItemClass["QUIVER"] = 29] = "QUIVER";
    // 2024-06-13 update
    ItemClass[ItemClass["OUTFIT"] = 30] = "OUTFIT";
    ItemClass[ItemClass["PET"] = 31] = "PET";
    ItemClass[ItemClass["TELEPORT"] = 32] = "TELEPORT";
})($d98f7bb170da977b$export$99a5dceb42a0a5f5 || ($d98f7bb170da977b$export$99a5dceb42a0a5f5 = {}));
var $d98f7bb170da977b$export$c2b08f0dad0547e0;
(function(ItemSlot) {
    ItemSlot[ItemSlot["BAG"] = 0] = "BAG";
    ItemSlot[ItemSlot["HELMET"] = 1] = "HELMET";
    ItemSlot[ItemSlot["RING"] = 2] = "RING";
    ItemSlot[ItemSlot["NECKLACE"] = 3] = "NECKLACE";
    ItemSlot[ItemSlot["GLOVES"] = 4] = "GLOVES";
    ItemSlot[ItemSlot["WEAPON"] = 5] = "WEAPON";
    ItemSlot[ItemSlot["ARMOR"] = 6] = "ARMOR";
    ItemSlot[ItemSlot["WEAPON_2"] = 7] = "WEAPON_2";
    ItemSlot[ItemSlot["BOOTS"] = 8] = "BOOTS";
    ItemSlot[ItemSlot["PURSE"] = 9] = "PURSE";
    ItemSlot[ItemSlot["BLESSING"] = 10] = "BLESSING";
    ItemSlot[ItemSlot["BAG1"] = 20] = "BAG1";
    ItemSlot[ItemSlot["BAG2"] = 21] = "BAG2";
    ItemSlot[ItemSlot["BAG3"] = 22] = "BAG3";
    ItemSlot[ItemSlot["BAG_KEYS"] = 26] = "BAG_KEYS";
})($d98f7bb170da977b$export$c2b08f0dad0547e0 || ($d98f7bb170da977b$export$c2b08f0dad0547e0 = {}));
var $d98f7bb170da977b$export$e2192f3d572f2f9a;
(function(ItemClassGroup) {
    ItemClassGroup[ItemClassGroup["NONE"] = 0] = "NONE";
    ItemClassGroup[ItemClassGroup["WEAPON"] = 1] = "WEAPON";
    ItemClassGroup[ItemClassGroup["ARMOR"] = 2] = "ARMOR";
    ItemClassGroup[ItemClassGroup["JEWELRY"] = 3] = "JEWELRY";
})($d98f7bb170da977b$export$e2192f3d572f2f9a || ($d98f7bb170da977b$export$e2192f3d572f2f9a = {}));
const $d98f7bb170da977b$var$ItemClassGroupByClass = {
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.NONE]: $d98f7bb170da977b$export$e2192f3d572f2f9a.NONE,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEHANDED]: $d98f7bb170da977b$export$e2192f3d572f2f9a.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.TWOHANDED]: $d98f7bb170da977b$export$e2192f3d572f2f9a.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEANDAHALFHANDED]: $d98f7bb170da977b$export$e2192f3d572f2f9a.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RANGED]: $d98f7bb170da977b$export$e2192f3d572f2f9a.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.SECONDARY]: $d98f7bb170da977b$export$e2192f3d572f2f9a.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.WAND]: $d98f7bb170da977b$export$e2192f3d572f2f9a.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ORB]: $d98f7bb170da977b$export$e2192f3d572f2f9a.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ARMOR]: $d98f7bb170da977b$export$e2192f3d572f2f9a.ARMOR,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.HELMET]: $d98f7bb170da977b$export$e2192f3d572f2f9a.ARMOR,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BOOTS]: $d98f7bb170da977b$export$e2192f3d572f2f9a.ARMOR,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.GLOVES]: $d98f7bb170da977b$export$e2192f3d572f2f9a.ARMOR,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RING]: $d98f7bb170da977b$export$e2192f3d572f2f9a.JEWELRY,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.NECKLACE]: $d98f7bb170da977b$export$e2192f3d572f2f9a.JEWELRY,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.SHIELD]: $d98f7bb170da977b$export$e2192f3d572f2f9a.ARMOR,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.QUIVER]: $d98f7bb170da977b$export$e2192f3d572f2f9a.WEAPON
};
function $d98f7bb170da977b$export$4d193602f93a7691(cl) {
    return $d98f7bb170da977b$var$ItemClassGroupByClass[cl] ?? $d98f7bb170da977b$export$e2192f3d572f2f9a.NONE;
}
const $d98f7bb170da977b$var$ItemClassBonuses = {
    [$d98f7bb170da977b$export$e2192f3d572f2f9a.NONE]: [],
    [$d98f7bb170da977b$export$e2192f3d572f2f9a.WEAPON]: [
        "da",
        "di",
        "ds",
        "dz",
        "sa",
        "crit",
        "resdmg",
        "acdmg",
        "abdest",
        "enfatig",
        "manafatig"
    ],
    [$d98f7bb170da977b$export$e2192f3d572f2f9a.ARMOR]: [
        "da",
        "di",
        "ds",
        "dz",
        "act",
        "resfire",
        "resfrost",
        "reslight",
        "ac",
        "blok",
        "hp",
        "absorb",
        "absorbm",
        "evade"
    ],
    [$d98f7bb170da977b$export$e2192f3d572f2f9a.JEWELRY]: [
        "da",
        "di",
        "ds",
        "dz",
        "energybon",
        "manabon",
        "critval",
        "critmval",
        "lowcrit",
        "lowevade",
        "heal",
        "slow"
    ]
};
const $d98f7bb170da977b$var$BonusFriendlyNames = {
    "da": "Wszystkie cechy",
    "di": "Intelekt",
    "ds": "Si\u0142a",
    "dz": "Zr\u0119czno\u015B\u0107",
    "energybon": "Energia",
    "manabon": "Mana",
    "critval": "Si\u0142a krytyka fizycznego",
    "critmval": "Si\u0142a krytyka magicznego",
    "lowcrit": "Obni\u017Canie szansy na cios krytyczny przeciwnika",
    "lowevade": "Obni\u017Canie uniku",
    "heal": "Leczenie",
    "slow": "Spowalnianie przeciwnika",
    "sa": "Szybko\u015B\u0107 ataku",
    "crit": "Cios krytyczny",
    "resdmg": "Niszczenie odporno\u015Bci magicznych",
    "acdmg": "Niszczenie pancerza",
    "abdest": "Niszczenie absorpcji",
    "endest": "Niszczenie energii (stare)",
    "manadest": "Niszczenie many (stare)",
    "enfatig": "Niszczenie energii",
    "manafatig": "Niszczenie many",
    "act": "Odporno\u015B\u0107 na trucizn\u0119",
    "resfire": "Odporno\u015B\u0107 na ogie\u0144",
    "resfrost": "Odporno\u015B\u0107 na zimno",
    "reslight": "Odporno\u015B\u0107 na b\u0142yskawice",
    "ac": "Pancerz",
    "blok": "Blok",
    "hp": "\u017Bycie",
    "absorb": "Absorpcja fizyczna",
    "absorbm": "Absorpcja magiczna",
    "evade": "Unik"
};
function $d98f7bb170da977b$export$76a5ab8b5cb8be92(bon) {
    return $d98f7bb170da977b$var$BonusFriendlyNames[bon] ?? `${bon}?`;
}
function $d98f7bb170da977b$export$f6af1e710a16481(clgrp) {
    return $d98f7bb170da977b$var$ItemClassBonuses[clgrp];
}
const $d98f7bb170da977b$export$b8192a0e534cca2b = [
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.ARMOR,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.BOOTS,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.GLOVES,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.HELMET,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.NECKLACE,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEANDAHALFHANDED,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEHANDED,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.ORB,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.RANGED,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.RING,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.SECONDARY,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.SHIELD,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.TWOHANDED,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.WAND,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.QUIVER
];
const $d98f7bb170da977b$export$36bf99e3bdf4469 = {
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ARMOR]: $d98f7bb170da977b$export$c2b08f0dad0547e0.ARMOR,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BOOTS]: $d98f7bb170da977b$export$c2b08f0dad0547e0.BOOTS,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.GLOVES]: $d98f7bb170da977b$export$c2b08f0dad0547e0.GLOVES,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.HELMET]: $d98f7bb170da977b$export$c2b08f0dad0547e0.HELMET,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.NECKLACE]: $d98f7bb170da977b$export$c2b08f0dad0547e0.NECKLACE,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEANDAHALFHANDED]: $d98f7bb170da977b$export$c2b08f0dad0547e0.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEHANDED]: $d98f7bb170da977b$export$c2b08f0dad0547e0.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ORB]: $d98f7bb170da977b$export$c2b08f0dad0547e0.WEAPON_2,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RANGED]: $d98f7bb170da977b$export$c2b08f0dad0547e0.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RING]: $d98f7bb170da977b$export$c2b08f0dad0547e0.RING,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.SECONDARY]: $d98f7bb170da977b$export$c2b08f0dad0547e0.WEAPON_2,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.SHIELD]: $d98f7bb170da977b$export$c2b08f0dad0547e0.WEAPON_2,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.TWOHANDED]: $d98f7bb170da977b$export$c2b08f0dad0547e0.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.WAND]: $d98f7bb170da977b$export$c2b08f0dad0547e0.WEAPON,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.QUIVER]: $d98f7bb170da977b$export$c2b08f0dad0547e0.WEAPON_2,
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BLESSING]: $d98f7bb170da977b$export$c2b08f0dad0547e0.BLESSING
};
const $d98f7bb170da977b$var$classNames = {
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.NONE]: "Wszystkie",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEHANDED]: "Jednor\u0119czne",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.TWOHANDED]: "Dwur\u0119czne",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEANDAHALFHANDED]: "P\xf3\u0142torar\u0119czne",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RANGED]: "Dystansowe",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.SECONDARY]: "Pomocnicze",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.WAND]: "R\xf3\u017Cd\u017Cki",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ORB]: "Orby",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ARMOR]: "Zbroje",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.HELMET]: "He\u0142my",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BOOTS]: "Buty",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.GLOVES]: "R\u0119kawice",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RING]: "Pier\u015Bcienie",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.NECKLACE]: "Naszyjniki",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.SHIELD]: "Tarcze",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.NEAUTRAL]: "Neutralne",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.CONSUMABLE]: "Konsumpcyjne",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.GOLD]: "Z\u0142oto",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.KEY]: "Klucze",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.QUEST]: "Questowe",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RENEWABLE]: "Odnawialne",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.HEAL]: "Lecz\u0105ce",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.CHARM]: "Talizmany",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BOOK]: "Ksi\u0105\u017Cki",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BAG]: "Torby",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BLESSING]: "B\u0142ogos\u0142awie\u0144stwa",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ENHANCEMENT]: "Ulepszenia",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RECIPE]: "Recepty",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.CURRENCY]: "Waluta",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.QUIVER]: "Strza\u0142y",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.OUTFIT]: "Stroje",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.PET]: "Maskotki",
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.TELEPORT]: "Teleporty"
};
const $d98f7bb170da977b$var$rarityNames = {
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.COMMON]: "Pospolite",
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.UNIQUE]: "Unikaty",
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.HEROIC]: "Heroiczne",
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.UPGRADED]: "Ulepszone",
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.LEGENDARY]: "Legendarne",
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.ARTIFACT]: "Artefakty"
};
const $d98f7bb170da977b$var$rarityDeclinatedNames = {
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.COMMON]: [
        "zwyk\u0142e",
        "zwyk\u0142y",
        "zwyk\u0142a"
    ],
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.UNIQUE]: [
        "unikatowe",
        "unikatowy",
        "unikatowa"
    ],
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.HEROIC]: [
        "heroiczne",
        "heroiczny",
        "heroiczna"
    ],
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.UPGRADED]: [
        "ulepszone",
        "ulepszony",
        "ulepszona"
    ],
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.LEGENDARY]: [
        "legendarne",
        "legendarny",
        "legandarna"
    ],
    [$d98f7bb170da977b$export$d2ffa9ea74cc769f.ARTIFACT]: [
        "artefakt",
        "artefakt",
        "artefakt"
    ]
};
var $d98f7bb170da977b$export$7d92142a7328def;
(function(Declination) {
    Declination[Declination["NEUTRAL"] = 0] = "NEUTRAL";
    Declination[Declination["MASCULINE"] = 1] = "MASCULINE";
    Declination[Declination["FEMININE"] = 2] = "FEMININE";
})($d98f7bb170da977b$export$7d92142a7328def || ($d98f7bb170da977b$export$7d92142a7328def = {}));
const $d98f7bb170da977b$var$itemClassDeclinatedNames = {
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.NONE]: [
        "",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEHANDED]: [
        "bro\u0144 jednor\u0119czna",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.TWOHANDED]: [
        "bro\u0144 dwur\u0119czna",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEANDAHALFHANDED]: [
        "bro\u0144 p\xf3\u0142torar\u0119czna",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RANGED]: [
        "bro\u0144 dystansowa",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.SECONDARY]: [
        "bro\u0144 pomocnicza",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.WAND]: [
        "r\xf3\u017Cd\u017Cka",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ORB]: [
        "orb",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ARMOR]: [
        "zbroja",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.HELMET]: [
        "he\u0142m",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BOOTS]: [
        "buty",
        $d98f7bb170da977b$export$7d92142a7328def.NEUTRAL
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.GLOVES]: [
        "r\u0119kawice",
        $d98f7bb170da977b$export$7d92142a7328def.NEUTRAL
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RING]: [
        "pier\u015Bcie\u0144",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.NECKLACE]: [
        "naszyjnik",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.SHIELD]: [
        "tarcza",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.NEAUTRAL]: [
        "",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.CONSUMABLE]: [
        "konsumpcyjny",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.GOLD]: [
        "z\u0142oto",
        $d98f7bb170da977b$export$7d92142a7328def.NEUTRAL
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.KEY]: [
        "klucz",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.QUEST]: [
        "",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RENEWABLE]: [
        "odnawialny",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.HEAL]: [
        "lecz\u0105ce",
        $d98f7bb170da977b$export$7d92142a7328def.NEUTRAL
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.CHARM]: [
        "talizman",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BOOK]: [
        "ksi\u0105\u017Cka",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BAG]: [
        "torba",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.BLESSING]: [
        "b\u0142ogos\u0142awie\u0144stwo",
        $d98f7bb170da977b$export$7d92142a7328def.NEUTRAL
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.ENHANCEMENT]: [
        "ulepszenie",
        $d98f7bb170da977b$export$7d92142a7328def.NEUTRAL
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.RECIPE]: [
        "recepta",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.CURRENCY]: [
        "waluta",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.QUIVER]: [
        "strza\u0142y",
        $d98f7bb170da977b$export$7d92142a7328def.NEUTRAL
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.OUTFIT]: [
        "str\xf3j",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.PET]: [
        "maskotka",
        $d98f7bb170da977b$export$7d92142a7328def.FEMININE
    ],
    [$d98f7bb170da977b$export$99a5dceb42a0a5f5.TELEPORT]: [
        "teleport",
        $d98f7bb170da977b$export$7d92142a7328def.MASCULINE
    ]
};
function $d98f7bb170da977b$export$b4279abb5ee62a0(cl, rarity) {
    const data = $d98f7bb170da977b$var$itemClassDeclinatedNames[cl];
    const name = data[0];
    const declinatedRarity = $d98f7bb170da977b$var$rarityDeclinatedNames[rarity][data[1]];
    if (name == "") return declinatedRarity;
    else return `${declinatedRarity} ${name}`;
}
function $d98f7bb170da977b$export$78580af256ef7aaf(rarity) {
    return $d98f7bb170da977b$var$rarityNames[rarity] ?? "-";
}
function $d98f7bb170da977b$export$3733321b7148f35f(cl) {
    return $d98f7bb170da977b$var$classNames[cl] ?? "-";
}
function $d98f7bb170da977b$export$255e9553606c7f5(stat) {
    const res = {};
    for (const entry of stat.split(";")){
        const pair = entry.split("=");
        res[pair[0]] = pair[1] ?? "_true";
    }
    return res;
}
function $d98f7bb170da977b$export$7ed7c43b9ea2ec61(stat) {
    let res = "";
    for(let key in stat){
        if (res.length) res += ";";
        res += key;
        if (stat[key] != "_true") res += `=${stat[key]}`;
    }
    return res;
}
const $d98f7bb170da977b$var$equippables = [
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.ARMOR,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.BOOTS,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.GLOVES,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.HELMET,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.NECKLACE,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEANDAHALFHANDED,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.ONEHANDED,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.ORB,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.RANGED,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.RING,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.SECONDARY,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.SHIELD,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.TWOHANDED,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.WAND,
    $d98f7bb170da977b$export$99a5dceb42a0a5f5.QUIVER
];
function $d98f7bb170da977b$export$8166c1aad47b3a26(item) {
    return $d98f7bb170da977b$var$equippables.includes(item.cl);
}
const $d98f7bb170da977b$var$keysToStrip = [
    "notes",
    "barterIngredient",
    "barterResult",
    "fromLootboxes",
    "fromRenewable",
    "loot",
    "version",
    "shops",
    "recipeResult",
    "recipeIngredient"
];
function $d98f7bb170da977b$export$413b395f72c393ba(item) {
    const strippedItem = Object.assign({}, item);
    for (const k of $d98f7bb170da977b$var$keysToStrip)delete strippedItem[k];
    return strippedItem;
}
function $d98f7bb170da977b$export$56b9510f95bec47f(item, attribs = "", classes = "", linkAttribs = "") {
    const strippedItem = $d98f7bb170da977b$export$413b395f72c393ba(item);
    const linkText = `<span class="margonem_item" data-item-id="${item.id}" data-itemtip='${(0, $634f10d55e666f65$export$4e7f196112fea3c5)(JSON.stringify(strippedItem))}'>
    <span class="item-inner" style="background: url(${(0, $c2bdc760a1d746cf$export$2cc7ae7d4fb97c35).itemPath + item.icon})"></span>
</span>`;
    const linkedItem = item.id >= 0 ? (0, $b1b3a5b6a44c1945$export$b8331a4ad4a2fd01)(item.extendedID ?? item.id, linkText, item.name, linkAttribs) : linkText;
    return `
<span class="itemborder ${classes}" ${attribs}>
    ${linkedItem}
</span>`;
}
function $d98f7bb170da977b$export$e182542ab2c7fe12(item) {
    const strippedItem = $d98f7bb170da977b$export$413b395f72c393ba(item);
    const linkText = `<img class="margonem_item" data-item-id="${item.id}" data-itemtip='${(0, $634f10d55e666f65$export$4e7f196112fea3c5)(JSON.stringify(strippedItem))}' src="https://micc.garmory-cdn.cloud/obrazki/itemy/${item.icon}">`;
    const linkedItem = item.id >= 0 ? (0, $b1b3a5b6a44c1945$export$b8331a4ad4a2fd01)(item.extendedID ?? item.id, linkText, item.name) : linkText;
    const span = document.createElement("span");
    span.classList.add("itemborder");
    span.innerHTML = linkedItem;
    return span;
}
function $d98f7bb170da977b$export$3ac44f6d9a0a3796(item) {
    if (item.stat.indexOf("rarity=common") > -1) return $d98f7bb170da977b$export$d2ffa9ea74cc769f.COMMON;
    else if (item.stat.indexOf("rarity=unique") > -1) return $d98f7bb170da977b$export$d2ffa9ea74cc769f.UNIQUE;
    else if (item.stat.indexOf("rarity=heroic") > -1) return $d98f7bb170da977b$export$d2ffa9ea74cc769f.HEROIC;
    else if (item.stat.indexOf("rarity=upgraded") > -1) return $d98f7bb170da977b$export$d2ffa9ea74cc769f.UPGRADED;
    else if (item.stat.indexOf("rarity=legendary") > -1) return $d98f7bb170da977b$export$d2ffa9ea74cc769f.LEGENDARY;
    else if (item.stat.indexOf("rarity=artefact") > -1) return $d98f7bb170da977b$export$d2ffa9ea74cc769f.ARTIFACT;
    return $d98f7bb170da977b$export$d2ffa9ea74cc769f.COMMON;
}
function $d98f7bb170da977b$export$3dc27271f5d5c629(amount) {
    if (amount < 10000) return String(amount);
    // less than 1m
    if (amount < 1000000) return `${Math.floor(amount / 10) / 100}k`;
    // less than 1g
    if (amount < 1000000000) return `${Math.floor(amount / 10000) / 100}m`;
    return `${Math.floor(amount / 10000000) / 100}g`;
}
const $d98f7bb170da977b$var$baterCurrencies = {
    1: "z\u0142ota",
    2: "S\u0141"
};
function $d98f7bb170da977b$export$4e881a62c1b8b5b1(currencyID) {
    return $d98f7bb170da977b$var$baterCurrencies[currencyID] ?? `[currencyError:${currencyID}]`;
}
function $d98f7bb170da977b$export$5ee0ebab1e85edcd(id, price) {
    // @ts-ignore
    return {
        "id": id,
        "name": "Zakup grupowy",
        "icon": "neu/paczka_otchlan.gif",
        "cl": 15,
        "pr": price,
        "stat": "rarity=common",
        "loot": []
    };
}
function $d98f7bb170da977b$export$60b8e02abc00f28(id) {
    const m = id.match(/([0-9]+)(x[0-9]+)?(@([0-9]+))?(\+([1-5]))?(!([a-z_-]+))?(\$([^<>\n]+))?(~([0-9]+))?/);
    if (!m) return null;
    return {
        extendedID: m[0],
        id: parseInt(m[1]),
        amount: m[2] ? parseInt(m[2].substring(1)) : 0,
        lvlOverride: m[4] ? parseInt(m[4]) : 0,
        upgrade: m[6] ? parseInt(m[6]) : 0,
        upgradeBonus: m[8] ? m[8] : "",
        statMod: m[10] ?? "",
        socketContent: m[12] ? parseInt(m[12]) : 0
    };
}
function $d98f7bb170da977b$export$8f4fb6d1d188b3f7(info) {
    let res = String(info.id);
    if (info.amount) res += `x${info.amount}`;
    if (info.lvlOverride) res += `@${info.lvlOverride}`;
    if (info.upgrade) res += `+${info.upgrade}`;
    if (info.upgradeBonus) res += `!${info.upgradeBonus}`;
    if (info.statMod) res += `$${info.statMod}`;
    if (info.socketContent) res += `~${info.socketContent}`;
    return res;
}
function $d98f7bb170da977b$export$96a397b4123e4382(targetItem, symbolItem) {
    const targetStats = $d98f7bb170da977b$export$255e9553606c7f5(targetItem.stat);
    const symbolStats = $d98f7bb170da977b$export$255e9553606c7f5(symbolItem.stat);
    if (symbolStats.target_class) {
        const allowedClasses = symbolStats.target_class.split(",").map(Number);
        if (!allowedClasses.includes(targetItem.cl)) return false;
    }
    if (symbolStats.target_max_lvl) {
        if (!targetStats.lvl) return false;
        if (Number(symbolStats.target_max_lvl) < Number(targetStats.lvl)) return false;
    }
    if (symbolStats.target_min_lvl) {
        if (!targetStats.lvl) return false;
        if (Number(symbolStats.target_min_lvl) > Number(targetStats.lvl)) return false;
    }
    if (symbolStats.target_rarity && targetStats.rarity != symbolStats.target_rarity) return false;
    return true;
}





var $00425124515acdd6$export$fbfaaced1beb795f;
(function(MargoNPCType) {
    MargoNPCType[MargoNPCType["DIALOG"] = 0] = "DIALOG";
    MargoNPCType[MargoNPCType["VOID"] = 1] = "VOID";
    MargoNPCType[MargoNPCType["ATTACKABLE"] = 2] = "ATTACKABLE";
    MargoNPCType[MargoNPCType["AGRESSIVE"] = 3] = "AGRESSIVE";
    MargoNPCType[MargoNPCType["OBJECT"] = 4] = "OBJECT";
    MargoNPCType[MargoNPCType["MACHINE"] = 5] = "MACHINE";
    MargoNPCType[MargoNPCType["AUTO_DIALOG"] = 6] = "AUTO_DIALOG";
    MargoNPCType[MargoNPCType["RENEWABLE"] = 7] = "RENEWABLE";
})($00425124515acdd6$export$fbfaaced1beb795f || ($00425124515acdd6$export$fbfaaced1beb795f = {}));
const $00425124515acdd6$export$522dacc837e10a47 = {
    [$00425124515acdd6$export$fbfaaced1beb795f.DIALOG]: `NPC z dialogiem`,
    [$00425124515acdd6$export$fbfaaced1beb795f.VOID]: `void`,
    [$00425124515acdd6$export$fbfaaced1beb795f.ATTACKABLE]: `potworek (nieagresywny)`,
    [$00425124515acdd6$export$fbfaaced1beb795f.AGRESSIVE]: `potworek (agresywny)`,
    [$00425124515acdd6$export$fbfaaced1beb795f.OBJECT]: "element mapy",
    [$00425124515acdd6$export$fbfaaced1beb795f.MACHINE]: "NPC z dialogiem",
    [$00425124515acdd6$export$fbfaaced1beb795f.AUTO_DIALOG]: `NPC z autodialogiem`,
    [$00425124515acdd6$export$fbfaaced1beb795f.RENEWABLE]: "odnawialne"
};
var $00425124515acdd6$export$69a30c57db4a71e2;
(function(NpcTypeCharacteristics) {
    NpcTypeCharacteristics[NpcTypeCharacteristics["TALKABLE"] = 0] = "TALKABLE";
    NpcTypeCharacteristics[NpcTypeCharacteristics["MOB"] = 1] = "MOB";
    NpcTypeCharacteristics[NpcTypeCharacteristics["OTHER"] = 2] = "OTHER";
})($00425124515acdd6$export$69a30c57db4a71e2 || ($00425124515acdd6$export$69a30c57db4a71e2 = {}));
const $00425124515acdd6$export$be626c69a295f7ff = {
    [$00425124515acdd6$export$69a30c57db4a71e2.TALKABLE]: [
        $00425124515acdd6$export$fbfaaced1beb795f.DIALOG,
        $00425124515acdd6$export$fbfaaced1beb795f.AUTO_DIALOG,
        $00425124515acdd6$export$fbfaaced1beb795f.VOID,
        $00425124515acdd6$export$fbfaaced1beb795f.MACHINE
    ],
    [$00425124515acdd6$export$69a30c57db4a71e2.MOB]: [
        $00425124515acdd6$export$fbfaaced1beb795f.AGRESSIVE,
        $00425124515acdd6$export$fbfaaced1beb795f.ATTACKABLE
    ],
    [$00425124515acdd6$export$69a30c57db4a71e2.OTHER]: [
        $00425124515acdd6$export$fbfaaced1beb795f.RENEWABLE,
        $00425124515acdd6$export$fbfaaced1beb795f.OBJECT
    ]
};
function $00425124515acdd6$export$c1f1e24ea39197cf(type) {
    if ($00425124515acdd6$export$be626c69a295f7ff[$00425124515acdd6$export$69a30c57db4a71e2.TALKABLE].includes(type)) return $00425124515acdd6$export$69a30c57db4a71e2.TALKABLE;
    if ($00425124515acdd6$export$be626c69a295f7ff[$00425124515acdd6$export$69a30c57db4a71e2.MOB].includes(type)) return $00425124515acdd6$export$69a30c57db4a71e2.MOB;
    return $00425124515acdd6$export$69a30c57db4a71e2.OTHER;
}
var $00425124515acdd6$export$bf0c174a5d32f4e0;
(function(MargoNpcWT) {
    MargoNpcWT[MargoNpcWT["COMMON"] = 0] = "COMMON";
    MargoNpcWT[MargoNpcWT["ELITE"] = 10] = "ELITE";
    MargoNpcWT[MargoNpcWT["ELITE2"] = 20] = "ELITE2";
    MargoNpcWT[MargoNpcWT["ELITE3"] = 30] = "ELITE3";
    MargoNpcWT[MargoNpcWT["HEROS"] = 80] = "HEROS";
    MargoNpcWT[MargoNpcWT["COLLOSUS"] = 90] = "COLLOSUS";
    MargoNpcWT[MargoNpcWT["TITAN"] = 100] = "TITAN";
})($00425124515acdd6$export$bf0c174a5d32f4e0 || ($00425124515acdd6$export$bf0c174a5d32f4e0 = {}));
function $00425124515acdd6$export$e069c3b69f7b94a(wt) {
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.TITAN) return "tytan";
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.COLLOSUS) return "kolos";
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.HEROS) return "heros";
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.ELITE3) return "elita III";
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.ELITE2) return "elita II";
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.ELITE) return "elita";
    return "zwyk\u0142y";
}
function $00425124515acdd6$export$7e1b37dea21965ef(wt) {
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.TITAN) return $00425124515acdd6$export$bf0c174a5d32f4e0.TITAN;
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.COLLOSUS) return $00425124515acdd6$export$bf0c174a5d32f4e0.COLLOSUS;
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.HEROS) return $00425124515acdd6$export$bf0c174a5d32f4e0.HEROS;
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.ELITE3) return $00425124515acdd6$export$bf0c174a5d32f4e0.ELITE3;
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.ELITE2) return $00425124515acdd6$export$bf0c174a5d32f4e0.ELITE2;
    if (wt >= $00425124515acdd6$export$bf0c174a5d32f4e0.ELITE) return $00425124515acdd6$export$bf0c174a5d32f4e0.ELITE;
    return $00425124515acdd6$export$bf0c174a5d32f4e0.COMMON;
}
var $00425124515acdd6$export$a696d57639f9db87;
(function(NpcEmoType) {
    NpcEmoType[NpcEmoType["NONE"] = 0] = "NONE";
    NpcEmoType[NpcEmoType["NPC_TALK"] = 1] = "NPC_TALK";
    NpcEmoType[NpcEmoType["DAILY_QUEST"] = 2] = "DAILY_QUEST";
    NpcEmoType[NpcEmoType["NORMAL_QUEST"] = 3] = "NORMAL_QUEST";
    NpcEmoType[NpcEmoType["AGGRESSIVE"] = 4] = "AGGRESSIVE";
    NpcEmoType[NpcEmoType["BATTLE"] = 5] = "BATTLE";
    NpcEmoType[NpcEmoType["AUCTION"] = 6] = "AUCTION";
    NpcEmoType[NpcEmoType["MAIL"] = 7] = "MAIL";
    NpcEmoType[NpcEmoType["SHOP"] = 8] = "SHOP";
    NpcEmoType[NpcEmoType["HEAL"] = 9] = "HEAL";
    NpcEmoType[NpcEmoType["DEPO"] = 10] = "DEPO";
    NpcEmoType[NpcEmoType["DEPO_CLAN"] = 11] = "DEPO_CLAN";
    NpcEmoType[NpcEmoType["INKEEPER"] = 12] = "INKEEPER";
    NpcEmoType[NpcEmoType["KILL_TIMER"] = 13] = "KILL_TIMER";
})($00425124515acdd6$export$a696d57639f9db87 || ($00425124515acdd6$export$a696d57639f9db87 = {}));
const $00425124515acdd6$export$1e9209103a170a6b = {
    [1]: $00425124515acdd6$export$a696d57639f9db87.INKEEPER,
    [2]: $00425124515acdd6$export$a696d57639f9db87.AUCTION,
    [4]: $00425124515acdd6$export$a696d57639f9db87.MAIL,
    [8]: $00425124515acdd6$export$a696d57639f9db87.DEPO,
    [16]: $00425124515acdd6$export$a696d57639f9db87.DEPO_CLAN,
    [32]: $00425124515acdd6$export$a696d57639f9db87.SHOP,
    //[1 << 6]: NpcEmoType.DAILY_QUEST,
    //[1 << 7]: NpcEmoType.NORMAL_QUEST,
    [256]: $00425124515acdd6$export$a696d57639f9db87.HEAL
};
const $00425124515acdd6$export$400b87c77667732a = {
    [$00425124515acdd6$export$a696d57639f9db87.AUCTION]: "aukcjoner",
    [$00425124515acdd6$export$a696d57639f9db87.MAIL]: "poczta",
    [$00425124515acdd6$export$a696d57639f9db87.SHOP]: "sklep",
    [$00425124515acdd6$export$a696d57639f9db87.HEAL]: "uzdrowiciel",
    [$00425124515acdd6$export$a696d57639f9db87.DEPO]: "depozyt",
    [$00425124515acdd6$export$a696d57639f9db87.DEPO_CLAN]: "depozyt klanowy",
    [$00425124515acdd6$export$a696d57639f9db87.INKEEPER]: "karczmarz"
};
const $00425124515acdd6$export$673c4c6275550c95 = {
    [$00425124515acdd6$export$a696d57639f9db87.NPC_TALK]: "talking_mark.gif",
    [$00425124515acdd6$export$a696d57639f9db87.DAILY_QUEST]: "daily_quest_mark.gif",
    [$00425124515acdd6$export$a696d57639f9db87.NORMAL_QUEST]: "quest_mark.gif",
    [$00425124515acdd6$export$a696d57639f9db87.AGGRESSIVE]: "angry-demon.gif",
    [$00425124515acdd6$export$a696d57639f9db87.BATTLE]: "battle.gif",
    [$00425124515acdd6$export$a696d57639f9db87.AUCTION]: "auctions_mark.gif",
    [$00425124515acdd6$export$a696d57639f9db87.MAIL]: "mail_mark.gif",
    [$00425124515acdd6$export$a696d57639f9db87.SHOP]: "shop_mark.gif",
    [$00425124515acdd6$export$a696d57639f9db87.HEAL]: "heal_mark.gif",
    [$00425124515acdd6$export$a696d57639f9db87.DEPO]: "depo_mark.gif",
    [$00425124515acdd6$export$a696d57639f9db87.DEPO_CLAN]: "depo_mark.gif",
    [$00425124515acdd6$export$a696d57639f9db87.INKEEPER]: "inn_mark.gif"
};
const $00425124515acdd6$export$89c1c974f6ada981 = {
    [$00425124515acdd6$export$a696d57639f9db87.MAIL]: 1,
    [$00425124515acdd6$export$a696d57639f9db87.INKEEPER]: 2,
    [$00425124515acdd6$export$a696d57639f9db87.DEPO_CLAN]: 3,
    [$00425124515acdd6$export$a696d57639f9db87.AUCTION]: 4,
    [$00425124515acdd6$export$a696d57639f9db87.DEPO]: 5,
    [$00425124515acdd6$export$a696d57639f9db87.SHOP]: 6,
    [$00425124515acdd6$export$a696d57639f9db87.HEAL]: 7,
    [$00425124515acdd6$export$a696d57639f9db87.DAILY_QUEST]: 8,
    [$00425124515acdd6$export$a696d57639f9db87.NORMAL_QUEST]: 9,
    [$00425124515acdd6$export$a696d57639f9db87.NPC_TALK]: 10,
    [$00425124515acdd6$export$a696d57639f9db87.AGGRESSIVE]: 11,
    [$00425124515acdd6$export$a696d57639f9db87.BATTLE]: 12,
    [$00425124515acdd6$export$a696d57639f9db87.KILL_TIMER]: 13
};
const $00425124515acdd6$export$954667c1a7ea79dd = {
    [$00425124515acdd6$export$a696d57639f9db87.AGGRESSIVE]: true,
    [$00425124515acdd6$export$a696d57639f9db87.BATTLE]: true,
    [$00425124515acdd6$export$a696d57639f9db87.KILL_TIMER]: true
};
function $00425124515acdd6$export$2eb72baf448ea9c1(filename) {
    return "https://micc.garmory-cdn.cloud/obrazki/interface/emo/" + filename;
}
function $00425124515acdd6$export$2fd9a7e081509ea1(emos) {
    let highest = 0;
    let highestEmo = $00425124515acdd6$export$a696d57639f9db87.NONE;
    for (const emo of emos.values())if ($00425124515acdd6$export$89c1c974f6ada981[emo] > highest) {
        highest = $00425124515acdd6$export$89c1c974f6ada981[emo];
        highestEmo = emo;
    }
    return highestEmo;
}
function $00425124515acdd6$export$e1b6ce52c265e3bc(npc) {
    const emos = [];
    for(const actionFlag in $00425124515acdd6$export$1e9209103a170a6b)if (npc.actions & parseInt(actionFlag)) emos.push($00425124515acdd6$export$1e9209103a170a6b[actionFlag]);
    // Agressive attack npcs
    if (npc.type == 3) emos.push($00425124515acdd6$export$a696d57639f9db87.AGGRESSIVE);
    return emos;
}
function $00425124515acdd6$export$3445e2d3e5193ec7(emo) {
    let extraClass = $00425124515acdd6$export$954667c1a7ea79dd[emo] ? "npc-emo-wrapper-no-bg" : "";
    if ($00425124515acdd6$export$673c4c6275550c95[emo]) {
        const url = $00425124515acdd6$export$2eb72baf448ea9c1($00425124515acdd6$export$673c4c6275550c95[emo]);
        return `<div class="npc-emo-wrapper ${extraClass}"><img src="${url}"></div>`;
    }
    return "";
}
function $00425124515acdd6$var$isNpcTransparent(npc) {
    return [
        `obj/cos.gif`
    ].includes(npc.icon);
}
function $00425124515acdd6$export$839e38c253d51652(npc) {
    return !$00425124515acdd6$var$isNpcTransparent(npc) ? `https://micc.garmory-cdn.cloud/obrazki/npc/${npc.icon}` : "https://aether.margonem.pl/img/cross.gif";
}
function $00425124515acdd6$export$f81261b02454add1(npc, extraText = "", attribs = "") {
    return (0, $b1b3a5b6a44c1945$export$c26822279c62e848)(npc.id, `<img class="npc" src='${$00425124515acdd6$export$839e38c253d51652(npc)}' data-tip='${(0, $634f10d55e666f65$export$4e7f196112fea3c5)($00425124515acdd6$export$17a73f9de485a981(npc))}'>${extraText}`, (0, $b1b3a5b6a44c1945$export$306669456b7a6332)(npc), attribs);
}
function $00425124515acdd6$export$b9c3a9e400bf2a0(npc) {
    return (0, $b1b3a5b6a44c1945$export$c26822279c62e848)(npc.id, `<span data-tip='${$00425124515acdd6$export$17a73f9de485a981(npc)}'>${npc.nick}</span>`, (0, $b1b3a5b6a44c1945$export$306669456b7a6332)(npc));
}
function $00425124515acdd6$export$1df96785884dc94a(flags) {
    let res = [];
    for(const flag in $00425124515acdd6$export$1e9209103a170a6b)if (flags & parseInt(flag)) res.push($00425124515acdd6$export$1e9209103a170a6b[flag]);
    let str = res.map((id)=>$00425124515acdd6$export$400b87c77667732a[id]).join(", ");
    return str == "" ? "brak" : str;
}
let $00425124515acdd6$var$maps = {};
function $00425124515acdd6$export$e44eff2231e2b6c7(mapNames) {
    $00425124515acdd6$var$maps = mapNames;
}
function $00425124515acdd6$export$17a73f9de485a981(npc, basicTip = false) {
    let tip = `<b>${npc.nick}</b>`;
    const friendlyWt = $00425124515acdd6$export$e069c3b69f7b94a(npc.wt);
    if (friendlyWt && friendlyWt != "zwyk\u0142y") tip += `<i>${friendlyWt}</i>`;
    if (npc.lvl > 0) tip += `${npc.lvl}lvl`;
    if (npc.grp) {
        if (npc.lvl > 0) tip += ", ";
        tip += "grp";
    }
    if (!basicTip) {
        const map = $00425124515acdd6$var$maps[npc.map];
        if (map) tip += `<div>${map} (${npc.x},${npc.y})</div>`;
    }
    return tip;
}






function $af478be0a72c5018$export$f5a31eaa781a5329(el, it, stats) {
    let rarity = stats.rarity;
    el.classList.add(`rarity-${rarity}`);
}
function $af478be0a72c5018$var$truncateNumber(n, decimals) {
    const s = String(n);
    const dot = s.indexOf(".");
    if (dot > -1) {
        if (decimals == 0) return s.substring(0, dot);
        let truncated = s.substring(0, dot + decimals + 1);
        while(truncated.charAt(truncated.length - 1) == "0")truncated = truncated.substring(0, truncated.length - 2);
        return truncated;
    } else return s;
}
function $af478be0a72c5018$var$getShortAmtText(amt) {
    if (amt < 1000) return String(amt);
    else if (amt < 1e4) return `${$af478be0a72c5018$var$truncateNumber(amt / 1000, 2)}k`;
    else if (amt < 1e5) return `${$af478be0a72c5018$var$truncateNumber(amt / 1000, 1)}k`;
    else if (amt < 1e6) return `${$af478be0a72c5018$var$truncateNumber(amt / 1000, 0)}k`;
    else // Engine max stack caps at 4m, so no need to go further
    return `${$af478be0a72c5018$var$truncateNumber(amt / 1e6, 2)}m`;
}
function $af478be0a72c5018$var$addItemQuantity(el, it, stats) {
    const amt = stats.amount ?? stats.ammo;
    if (typeof amt != "undefined") {
        const n = Number(amt);
        if (!isNaN(n) && n > 1) {
            const label = document.createElement("span");
            label.classList.add("item-quantity-label");
            label.innerText = $af478be0a72c5018$var$getShortAmtText(n);
            el.querySelector(".item-inner")?.appendChild(label);
        }
    }
}
function $af478be0a72c5018$export$e1406d39e5dbc761(item, existingDisplay) {
    const disp = existingDisplay ?? document.createElement("div");
    disp.classList.add("item-display");
    const tipContent = window.MargoTipsParser.getTip(item);
    const rarity = (0, $d98f7bb170da977b$export$255e9553606c7f5)(item.stat).rarity ?? "common";
    disp.innerHTML = `<div class="tip-wrapper normal-tip static custom" data-type="t_item" data-item-type="${rarity}"><div class="content">${tipContent}</div></div>`;
    const itemIcon = document.createElement("div");
    itemIcon.classList.add("item");
    itemIcon.innerHTML = `<img src="https://micc.garmory-cdn.cloud/obrazki/itemy/${item.icon}">`;
    itemIcon.dataset.tip = `PPM - dodaj do zestawu ekwipunku`;
    disp.querySelector(".item-head").prepend(itemIcon);
    return disp;
}
function $af478be0a72c5018$export$1222dfd87f1fe5fe(el) {
    for (const disp of Array.from(el.querySelectorAll(".item-display"))){
        if (!(disp instanceof HTMLElement)) continue;
        const data = disp.dataset.item;
        try {
            const item = JSON.parse(data);
            // @ts-ignore
            $af478be0a72c5018$export$e1406d39e5dbc761(item, disp);
        } catch (e) {
            console.error(e);
        }
    }
    for (const item of Array.from(el.querySelectorAll(".margonem_item"))){
        const json = item.getAttribute("data-itemtip");
        const it = JSON.parse(json);
        const stats = (0, $d98f7bb170da977b$export$255e9553606c7f5)(it.stat);
        $af478be0a72c5018$export$f5a31eaa781a5329(item, it, stats);
        $af478be0a72c5018$var$addItemQuantity(item, it, stats);
    }
}
function $af478be0a72c5018$export$45bbcd859c8e601f() {
    $af478be0a72c5018$export$1222dfd87f1fe5fe(document.body);
}


/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $a822e9daf520ce16$exports = {};

$parcel$export($a822e9daf520ce16$exports, "popperGenerator", () => $7b75cb1e8acb8ee8$export$ed5e13716264f202);
$parcel$export($a822e9daf520ce16$exports, "detectOverflow", () => $a22856bcb14b2f7a$export$2e2bcd8739ae039);
$parcel$export($a822e9daf520ce16$exports, "createPopperBase", () => $7b75cb1e8acb8ee8$export$8f7491d57c8f97a9);
$parcel$export($a822e9daf520ce16$exports, "createPopper", () => $d8f4cd95ecc841d0$export$8f7491d57c8f97a9);
$parcel$export($a822e9daf520ce16$exports, "createPopperLite", () => $94f91f7703ab9bfc$export$8f7491d57c8f97a9);
var $2d58ee1e3a88cf44$exports = {};

$parcel$export($2d58ee1e3a88cf44$exports, "top", () => $2d58ee1e3a88cf44$export$1e95b668f3b82d);
$parcel$export($2d58ee1e3a88cf44$exports, "bottom", () => $2d58ee1e3a88cf44$export$40e543e69a8b3fbb);
$parcel$export($2d58ee1e3a88cf44$exports, "right", () => $2d58ee1e3a88cf44$export$79ffe56a765070d2);
$parcel$export($2d58ee1e3a88cf44$exports, "left", () => $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4);
$parcel$export($2d58ee1e3a88cf44$exports, "auto", () => $2d58ee1e3a88cf44$export$dfb5619354ba860);
$parcel$export($2d58ee1e3a88cf44$exports, "basePlacements", () => $2d58ee1e3a88cf44$export$aec2ce47c367b8c3);
$parcel$export($2d58ee1e3a88cf44$exports, "start", () => $2d58ee1e3a88cf44$export$b3571188c770cc5a);
$parcel$export($2d58ee1e3a88cf44$exports, "end", () => $2d58ee1e3a88cf44$export$bd5df0f255a350f8);
$parcel$export($2d58ee1e3a88cf44$exports, "clippingParents", () => $2d58ee1e3a88cf44$export$390fd549c5303b4d);
$parcel$export($2d58ee1e3a88cf44$exports, "viewport", () => $2d58ee1e3a88cf44$export$d7b7311ec04a3e8f);
$parcel$export($2d58ee1e3a88cf44$exports, "popper", () => $2d58ee1e3a88cf44$export$ae5ab1c730825774);
$parcel$export($2d58ee1e3a88cf44$exports, "reference", () => $2d58ee1e3a88cf44$export$ca50aac9f3ba507f);
$parcel$export($2d58ee1e3a88cf44$exports, "variationPlacements", () => $2d58ee1e3a88cf44$export$368f9a87e87fa4e1);
$parcel$export($2d58ee1e3a88cf44$exports, "placements", () => $2d58ee1e3a88cf44$export$803cd8101b6c182b);
$parcel$export($2d58ee1e3a88cf44$exports, "beforeRead", () => $2d58ee1e3a88cf44$export$421679a7c3d56e);
$parcel$export($2d58ee1e3a88cf44$exports, "read", () => $2d58ee1e3a88cf44$export$aafa59e2e03f2942);
$parcel$export($2d58ee1e3a88cf44$exports, "afterRead", () => $2d58ee1e3a88cf44$export$6964f6c886723980);
$parcel$export($2d58ee1e3a88cf44$exports, "beforeMain", () => $2d58ee1e3a88cf44$export$c65e99957a05207c);
$parcel$export($2d58ee1e3a88cf44$exports, "main", () => $2d58ee1e3a88cf44$export$f22da7240b7add18);
$parcel$export($2d58ee1e3a88cf44$exports, "afterMain", () => $2d58ee1e3a88cf44$export$bab79516f2d662fe);
$parcel$export($2d58ee1e3a88cf44$exports, "beforeWrite", () => $2d58ee1e3a88cf44$export$8d4d2d70e7d46032);
$parcel$export($2d58ee1e3a88cf44$exports, "write", () => $2d58ee1e3a88cf44$export$68d8715fc104d294);
$parcel$export($2d58ee1e3a88cf44$exports, "afterWrite", () => $2d58ee1e3a88cf44$export$70a6e5159acce2e6);
$parcel$export($2d58ee1e3a88cf44$exports, "modifierPhases", () => $2d58ee1e3a88cf44$export$d087d3878fdf71d5);
var $2d58ee1e3a88cf44$export$1e95b668f3b82d = 'top';
var $2d58ee1e3a88cf44$export$40e543e69a8b3fbb = 'bottom';
var $2d58ee1e3a88cf44$export$79ffe56a765070d2 = 'right';
var $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4 = 'left';
var $2d58ee1e3a88cf44$export$dfb5619354ba860 = 'auto';
var $2d58ee1e3a88cf44$export$aec2ce47c367b8c3 = [
    $2d58ee1e3a88cf44$export$1e95b668f3b82d,
    $2d58ee1e3a88cf44$export$40e543e69a8b3fbb,
    $2d58ee1e3a88cf44$export$79ffe56a765070d2,
    $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4
];
var $2d58ee1e3a88cf44$export$b3571188c770cc5a = 'start';
var $2d58ee1e3a88cf44$export$bd5df0f255a350f8 = 'end';
var $2d58ee1e3a88cf44$export$390fd549c5303b4d = 'clippingParents';
var $2d58ee1e3a88cf44$export$d7b7311ec04a3e8f = 'viewport';
var $2d58ee1e3a88cf44$export$ae5ab1c730825774 = 'popper';
var $2d58ee1e3a88cf44$export$ca50aac9f3ba507f = 'reference';
var $2d58ee1e3a88cf44$export$368f9a87e87fa4e1 = /*#__PURE__*/ $2d58ee1e3a88cf44$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $2d58ee1e3a88cf44$export$b3571188c770cc5a,
        placement + "-" + $2d58ee1e3a88cf44$export$bd5df0f255a350f8
    ]);
}, []);
var $2d58ee1e3a88cf44$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($2d58ee1e3a88cf44$export$aec2ce47c367b8c3, [
    $2d58ee1e3a88cf44$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $2d58ee1e3a88cf44$export$b3571188c770cc5a,
        placement + "-" + $2d58ee1e3a88cf44$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $2d58ee1e3a88cf44$export$421679a7c3d56e = 'beforeRead';
var $2d58ee1e3a88cf44$export$aafa59e2e03f2942 = 'read';
var $2d58ee1e3a88cf44$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $2d58ee1e3a88cf44$export$c65e99957a05207c = 'beforeMain';
var $2d58ee1e3a88cf44$export$f22da7240b7add18 = 'main';
var $2d58ee1e3a88cf44$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $2d58ee1e3a88cf44$export$8d4d2d70e7d46032 = 'beforeWrite';
var $2d58ee1e3a88cf44$export$68d8715fc104d294 = 'write';
var $2d58ee1e3a88cf44$export$70a6e5159acce2e6 = 'afterWrite';
var $2d58ee1e3a88cf44$export$d087d3878fdf71d5 = [
    $2d58ee1e3a88cf44$export$421679a7c3d56e,
    $2d58ee1e3a88cf44$export$aafa59e2e03f2942,
    $2d58ee1e3a88cf44$export$6964f6c886723980,
    $2d58ee1e3a88cf44$export$c65e99957a05207c,
    $2d58ee1e3a88cf44$export$f22da7240b7add18,
    $2d58ee1e3a88cf44$export$bab79516f2d662fe,
    $2d58ee1e3a88cf44$export$8d4d2d70e7d46032,
    $2d58ee1e3a88cf44$export$68d8715fc104d294,
    $2d58ee1e3a88cf44$export$70a6e5159acce2e6
];


var $e6e3baeac2af55ef$exports = {};

$parcel$export($e6e3baeac2af55ef$exports, "applyStyles", () => $aa6f72c3650454fa$export$2e2bcd8739ae039);
$parcel$export($e6e3baeac2af55ef$exports, "arrow", () => $9b6f2ec1b91eb200$export$2e2bcd8739ae039);
$parcel$export($e6e3baeac2af55ef$exports, "computeStyles", () => $97a1726c8e436cc5$export$2e2bcd8739ae039);
$parcel$export($e6e3baeac2af55ef$exports, "eventListeners", () => $4fb2aa4e2777bded$export$2e2bcd8739ae039);
$parcel$export($e6e3baeac2af55ef$exports, "flip", () => $28c6e4c2a1a5279c$export$2e2bcd8739ae039);
$parcel$export($e6e3baeac2af55ef$exports, "hide", () => $a6c8180d440f8c62$export$2e2bcd8739ae039);
$parcel$export($e6e3baeac2af55ef$exports, "offset", () => $93bfdd9c40a934ec$export$2e2bcd8739ae039);
$parcel$export($e6e3baeac2af55ef$exports, "popperOffsets", () => $3e1187bb7ee11d2d$export$2e2bcd8739ae039);
$parcel$export($e6e3baeac2af55ef$exports, "preventOverflow", () => $e7f0b26576a8e7ff$export$2e2bcd8739ae039);
function $9228069310b451a1$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $01d4fd4af96aeb2d$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $4e29da0197f31c98$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $4e29da0197f31c98$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $4e29da0197f31c98$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $aa6f72c3650454fa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(element) || !(0, $9228069310b451a1$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $aa6f72c3650454fa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(element) || !(0, $9228069310b451a1$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $aa6f72c3650454fa$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $aa6f72c3650454fa$var$applyStyles,
    effect: $aa6f72c3650454fa$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $c79b2f76c7a28e68$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $63c202b046624845$export$8960430cfd85939f = Math.max;
var $63c202b046624845$export$96ec731ed4dcb222 = Math.min;
var $63c202b046624845$export$2077e0241d6afd3c = Math.round;



function $e7c2d2b7a1d4373d$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $e739d3c2a9bd8688$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $e7c2d2b7a1d4373d$export$2e2bcd8739ae039)());
}


function $50bb215dcdd3bb37$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $63c202b046624845$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $63c202b046624845$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $4e29da0197f31c98$export$45a5e7f76e0caa8d)(element) ? (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $e739d3c2a9bd8688$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $5c61fa1bca30f86e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $50bb215dcdd3bb37$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $b3869c2806b98ba6$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $4e29da0197f31c98$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $f69b0e00513b6631$export$2e2bcd8739ae039(element) {
    return (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $80612586d38170b7$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $9228069310b451a1$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3f68f0047e55663e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $4e29da0197f31c98$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $b2ada1bf076c5a0c$export$2e2bcd8739ae039(element) {
    if ((0, $9228069310b451a1$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $4e29da0197f31c98$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $3f68f0047e55663e$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $5850c0cd7a9ba20c$var$getTrueOffsetParent(element) {
    if (!(0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $f69b0e00513b6631$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5850c0cd7a9ba20c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $e7c2d2b7a1d4373d$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $e7c2d2b7a1d4373d$export$2e2bcd8739ae039)());
    if (isIE && (0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $f69b0e00513b6631$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $b2ada1bf076c5a0c$export$2e2bcd8739ae039)(element);
    if ((0, $4e29da0197f31c98$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $9228069310b451a1$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $f69b0e00513b6631$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5850c0cd7a9ba20c$export$2e2bcd8739ae039(element) {
    var window = (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(element);
    var offsetParent = $5850c0cd7a9ba20c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $80612586d38170b7$export$2e2bcd8739ae039)(offsetParent) && (0, $f69b0e00513b6631$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $5850c0cd7a9ba20c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $9228069310b451a1$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $9228069310b451a1$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $f69b0e00513b6631$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $5850c0cd7a9ba20c$var$getContainingBlock(element) || window;
}


function $759db4fd1b803021$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $d2205be173c5742c$export$f28d906d67a997f3(min, value, max) {
    return (0, $63c202b046624845$export$8960430cfd85939f)(min, (0, $63c202b046624845$export$96ec731ed4dcb222)(value, max));
}
function $d2205be173c5742c$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d2205be173c5742c$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $ebd4b493870e472d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $9a85b39a203526aa$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $ebd4b493870e472d$export$2e2bcd8739ae039)(), paddingObject);
}


function $6b5f44285ad70e26$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $9b6f2ec1b91eb200$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $9a85b39a203526aa$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $6b5f44285ad70e26$export$2e2bcd8739ae039)(padding, (0, $2d58ee1e3a88cf44$export$aec2ce47c367b8c3)));
};
function $9b6f2ec1b91eb200$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $759db4fd1b803021$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4),
        (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $9b6f2ec1b91eb200$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $5c61fa1bca30f86e$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d) : (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb) : (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5850c0cd7a9ba20c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $d2205be173c5742c$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $9b6f2ec1b91eb200$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $b3869c2806b98ba6$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $9b6f2ec1b91eb200$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $9b6f2ec1b91eb200$var$arrow,
    effect: $9b6f2ec1b91eb200$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $d4b7fbc266539607$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $97a1726c8e436cc5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $97a1726c8e436cc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $63c202b046624845$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $63c202b046624845$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $97a1726c8e436cc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4);
    var sideY = (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5850c0cd7a9ba20c$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $3f68f0047e55663e$export$2e2bcd8739ae039)(popper);
            if ((0, $f69b0e00513b6631$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d) || (placement === (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4) || placement === (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2)) && variation === (0, $2d58ee1e3a88cf44$export$bd5df0f255a350f8)) {
            sideY = (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4) || (placement === (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d) || placement === (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb)) && variation === (0, $2d58ee1e3a88cf44$export$bd5df0f255a350f8)) {
            sideX = (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $97a1726c8e436cc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $97a1726c8e436cc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $97a1726c8e436cc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $d4b7fbc266539607$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $97a1726c8e436cc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $97a1726c8e436cc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $97a1726c8e436cc5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $97a1726c8e436cc5$var$computeStyles,
    data: {}
};



var $4fb2aa4e2777bded$var$passive = {
    passive: true
};
function $4fb2aa4e2777bded$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $4fb2aa4e2777bded$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $4fb2aa4e2777bded$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $4fb2aa4e2777bded$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $4fb2aa4e2777bded$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $4fb2aa4e2777bded$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $4fb2aa4e2777bded$var$effect,
    data: {}
};


var $3bce478ae5ee188d$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $3bce478ae5ee188d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $3bce478ae5ee188d$var$hash[matched];
    });
}



var $d7c31a94a0233892$var$hash = {
    start: 'end',
    end: 'start'
};
function $d7c31a94a0233892$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $d7c31a94a0233892$var$hash[matched];
    });
}








function $d45124811fdf72b0$export$2e2bcd8739ae039(node) {
    var win = (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $20b7ed619d7b7a70$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $50bb215dcdd3bb37$export$2e2bcd8739ae039)((0, $3f68f0047e55663e$export$2e2bcd8739ae039)(element)).left + (0, $d45124811fdf72b0$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $c7f1dde485e47997$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(element);
    var html = (0, $3f68f0047e55663e$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $e739d3c2a9bd8688$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $20b7ed619d7b7a70$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $5d4913aff88affc8$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $3f68f0047e55663e$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $d45124811fdf72b0$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $63c202b046624845$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $63c202b046624845$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $20b7ed619d7b7a70$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $f69b0e00513b6631$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $63c202b046624845$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $d88bc6f7d6364228$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $f69b0e00513b6631$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $9c72f9b92e739cc0$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $9228069310b451a1$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(node) && (0, $d88bc6f7d6364228$export$2e2bcd8739ae039)(node)) return node;
    return $9c72f9b92e739cc0$export$2e2bcd8739ae039((0, $b2ada1bf076c5a0c$export$2e2bcd8739ae039)(node));
}





function $ff36eaff32684330$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $9c72f9b92e739cc0$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $d88bc6f7d6364228$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($ff36eaff32684330$export$2e2bcd8739ae039((0, $b2ada1bf076c5a0c$export$2e2bcd8739ae039)(target)));
}










function $4984db0020b227dd$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $c95ef63e9721d1e6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $50bb215dcdd3bb37$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $c95ef63e9721d1e6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $2d58ee1e3a88cf44$export$d7b7311ec04a3e8f) ? (0, $4984db0020b227dd$export$2e2bcd8739ae039)((0, $c7f1dde485e47997$export$2e2bcd8739ae039)(element, strategy)) : (0, $4e29da0197f31c98$export$45a5e7f76e0caa8d)(clippingParent) ? $c95ef63e9721d1e6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $4984db0020b227dd$export$2e2bcd8739ae039)((0, $5d4913aff88affc8$export$2e2bcd8739ae039)((0, $3f68f0047e55663e$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $c95ef63e9721d1e6$var$getClippingParents(element) {
    var clippingParents = (0, $ff36eaff32684330$export$2e2bcd8739ae039)((0, $b2ada1bf076c5a0c$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $f69b0e00513b6631$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(element) ? (0, $5850c0cd7a9ba20c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $4e29da0197f31c98$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $4e29da0197f31c98$export$45a5e7f76e0caa8d)(clippingParent) && (0, $b3869c2806b98ba6$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $9228069310b451a1$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $c95ef63e9721d1e6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $c95ef63e9721d1e6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $c95ef63e9721d1e6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $63c202b046624845$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $63c202b046624845$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $63c202b046624845$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $63c202b046624845$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $c95ef63e9721d1e6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $373a5ed7935ecb97$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $d4b7fbc266539607$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $2d58ee1e3a88cf44$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $2d58ee1e3a88cf44$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $759db4fd1b803021$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $2d58ee1e3a88cf44$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $2d58ee1e3a88cf44$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $a22856bcb14b2f7a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $2d58ee1e3a88cf44$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $2d58ee1e3a88cf44$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $2d58ee1e3a88cf44$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $9a85b39a203526aa$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $6b5f44285ad70e26$export$2e2bcd8739ae039)(padding, (0, $2d58ee1e3a88cf44$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $2d58ee1e3a88cf44$export$ae5ab1c730825774) ? (0, $2d58ee1e3a88cf44$export$ca50aac9f3ba507f) : (0, $2d58ee1e3a88cf44$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $c95ef63e9721d1e6$export$2e2bcd8739ae039)((0, $4e29da0197f31c98$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $3f68f0047e55663e$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $50bb215dcdd3bb37$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $373a5ed7935ecb97$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $4984db0020b227dd$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $2d58ee1e3a88cf44$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $2d58ee1e3a88cf44$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2),
                (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d),
                (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $ecd43f0f3ef129cc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $2d58ee1e3a88cf44$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $d4b7fbc266539607$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $2d58ee1e3a88cf44$export$368f9a87e87fa4e1) : (0, $2d58ee1e3a88cf44$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $d4b7fbc266539607$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $2d58ee1e3a88cf44$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $a22856bcb14b2f7a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $28c6e4c2a1a5279c$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(placement) === (0, $2d58ee1e3a88cf44$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $3bce478ae5ee188d$export$2e2bcd8739ae039)(placement);
    return [
        (0, $d7c31a94a0233892$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $d7c31a94a0233892$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $28c6e4c2a1a5279c$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3bce478ae5ee188d$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $28c6e4c2a1a5279c$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(placement) === (0, $2d58ee1e3a88cf44$export$dfb5619354ba860) ? (0, $ecd43f0f3ef129cc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $d4b7fbc266539607$export$2e2bcd8739ae039)(placement) === (0, $2d58ee1e3a88cf44$export$b3571188c770cc5a);
        var isVertical = [
            (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d),
            (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $a22856bcb14b2f7a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2) : (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb) : (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3bce478ae5ee188d$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $3bce478ae5ee188d$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $28c6e4c2a1a5279c$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $28c6e4c2a1a5279c$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $a6c8180d440f8c62$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $a6c8180d440f8c62$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d),
        (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2),
        (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb),
        (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $a6c8180d440f8c62$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $a22856bcb14b2f7a$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $a22856bcb14b2f7a$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $a6c8180d440f8c62$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $a6c8180d440f8c62$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $a6c8180d440f8c62$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $a6c8180d440f8c62$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $a6c8180d440f8c62$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $a6c8180d440f8c62$var$hide
};




function $93bfdd9c40a934ec$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4),
        (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4),
        (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $93bfdd9c40a934ec$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $2d58ee1e3a88cf44$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $93bfdd9c40a934ec$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $93bfdd9c40a934ec$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $93bfdd9c40a934ec$var$offset
};



function $3e1187bb7ee11d2d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $373a5ed7935ecb97$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3e1187bb7ee11d2d$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $3e1187bb7ee11d2d$var$popperOffsets,
    data: {}
};





function $94e9aded0a8df510$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $e7f0b26576a8e7ff$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $a22856bcb14b2f7a$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c79b2f76c7a28e68$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $d4b7fbc266539607$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $759db4fd1b803021$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $94e9aded0a8df510$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d) : (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb) : (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $2d58ee1e3a88cf44$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $2d58ee1e3a88cf44$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $5c61fa1bca30f86e$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $ebd4b493870e472d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $d2205be173c5742c$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5850c0cd7a9ba20c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $d2205be173c5742c$export$f28d906d67a997f3)(tether ? (0, $63c202b046624845$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $63c202b046624845$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d) : (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $2d58ee1e3a88cf44$export$40e543e69a8b3fbb) : (0, $2d58ee1e3a88cf44$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $2d58ee1e3a88cf44$export$1e95b668f3b82d),
            (0, $2d58ee1e3a88cf44$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $d2205be173c5742c$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $d2205be173c5742c$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $e7f0b26576a8e7ff$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $e7f0b26576a8e7ff$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $74e00daf4563face$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $4293eee2781e41b0$export$2e2bcd8739ae039(node) {
    if (node === (0, $01d4fd4af96aeb2d$export$2e2bcd8739ae039)(node) || !(0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(node)) return (0, $d45124811fdf72b0$export$2e2bcd8739ae039)(node);
    else return (0, $74e00daf4563face$export$2e2bcd8739ae039)(node);
}








function $1e828d20ab51aec1$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $63c202b046624845$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $63c202b046624845$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1e828d20ab51aec1$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(offsetParent) && $1e828d20ab51aec1$var$isElementScaled(offsetParent);
    var documentElement = (0, $3f68f0047e55663e$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $50bb215dcdd3bb37$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9228069310b451a1$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $d88bc6f7d6364228$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $4293eee2781e41b0$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $4e29da0197f31c98$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $50bb215dcdd3bb37$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $20b7ed619d7b7a70$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $e032946dffe6a9d8$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $e032946dffe6a9d8$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $e032946dffe6a9d8$var$order(modifiers); // order based on phase
    return (0, $2d58ee1e3a88cf44$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $4334cc9243c88be8$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f2fe502463022a93$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $7b75cb1e8acb8ee8$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $7b75cb1e8acb8ee8$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $7b75cb1e8acb8ee8$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $7b75cb1e8acb8ee8$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $7b75cb1e8acb8ee8$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $4e29da0197f31c98$export$45a5e7f76e0caa8d)(reference) ? (0, $ff36eaff32684330$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $ff36eaff32684330$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $ff36eaff32684330$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $e032946dffe6a9d8$export$2e2bcd8739ae039)((0, $f2fe502463022a93$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$7b75cb1e8acb8ee8$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1e828d20ab51aec1$export$2e2bcd8739ae039)(reference, (0, $5850c0cd7a9ba20c$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $5c61fa1bca30f86e$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4334cc9243c88be8$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$7b75cb1e8acb8ee8$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $7b75cb1e8acb8ee8$export$8f7491d57c8f97a9 = /*#__PURE__*/ $7b75cb1e8acb8ee8$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $d8f4cd95ecc841d0$export$d34966752335dd47 = [
    (0, $4fb2aa4e2777bded$export$2e2bcd8739ae039),
    (0, $3e1187bb7ee11d2d$export$2e2bcd8739ae039),
    (0, $97a1726c8e436cc5$export$2e2bcd8739ae039),
    (0, $aa6f72c3650454fa$export$2e2bcd8739ae039),
    (0, $93bfdd9c40a934ec$export$2e2bcd8739ae039),
    (0, $28c6e4c2a1a5279c$export$2e2bcd8739ae039),
    (0, $e7f0b26576a8e7ff$export$2e2bcd8739ae039),
    (0, $9b6f2ec1b91eb200$export$2e2bcd8739ae039),
    (0, $a6c8180d440f8c62$export$2e2bcd8739ae039)
];
var $d8f4cd95ecc841d0$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $7b75cb1e8acb8ee8$export$ed5e13716264f202)({
    defaultModifiers: $d8f4cd95ecc841d0$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $94f91f7703ab9bfc$export$d34966752335dd47 = [
    (0, $4fb2aa4e2777bded$export$2e2bcd8739ae039),
    (0, $3e1187bb7ee11d2d$export$2e2bcd8739ae039),
    (0, $97a1726c8e436cc5$export$2e2bcd8739ae039),
    (0, $aa6f72c3650454fa$export$2e2bcd8739ae039)
];
var $94f91f7703ab9bfc$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $7b75cb1e8acb8ee8$export$ed5e13716264f202)({
    defaultModifiers: $94f91f7703ab9bfc$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($a822e9daf520ce16$exports, $2d58ee1e3a88cf44$exports);
$parcel$exportWildcard($a822e9daf520ce16$exports, $e6e3baeac2af55ef$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$elementMap = new Map();
const $68e2a64123527646$var$Data = {
    set (element, key, instance) {
        if (!$68e2a64123527646$var$elementMap.has(element)) $68e2a64123527646$var$elementMap.set(element, new Map());
        const instanceMap = $68e2a64123527646$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($68e2a64123527646$var$elementMap.has(element)) return $68e2a64123527646$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$68e2a64123527646$var$elementMap.has(element)) return;
        const instanceMap = $68e2a64123527646$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $68e2a64123527646$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $68e2a64123527646$var$MAX_UID = 1000000;
const $68e2a64123527646$var$MILLISECONDS_MULTIPLIER = 1000;
const $68e2a64123527646$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $68e2a64123527646$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $68e2a64123527646$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $68e2a64123527646$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $68e2a64123527646$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $68e2a64123527646$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $68e2a64123527646$var$MILLISECONDS_MULTIPLIER;
};
const $68e2a64123527646$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($68e2a64123527646$var$TRANSITION_END));
};
const $68e2a64123527646$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $68e2a64123527646$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($68e2a64123527646$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($68e2a64123527646$var$parseSelector(object));
    return null;
};
const $68e2a64123527646$var$isVisible = (element)=>{
    if (!$68e2a64123527646$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $68e2a64123527646$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $68e2a64123527646$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $68e2a64123527646$var$findShadowRoot(element.parentNode);
};
const $68e2a64123527646$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $68e2a64123527646$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $68e2a64123527646$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $68e2a64123527646$var$DOMContentLoadedCallbacks = [];
const $68e2a64123527646$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$68e2a64123527646$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $68e2a64123527646$var$DOMContentLoadedCallbacks)callback();
        });
        $68e2a64123527646$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $68e2a64123527646$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $68e2a64123527646$var$defineJQueryPlugin = (plugin)=>{
    $68e2a64123527646$var$onDOMContentLoaded(()=>{
        const $ = $68e2a64123527646$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $68e2a64123527646$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $68e2a64123527646$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $68e2a64123527646$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $68e2a64123527646$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($68e2a64123527646$var$TRANSITION_END, handler);
        $68e2a64123527646$var$execute(callback);
    };
    transitionElement.addEventListener($68e2a64123527646$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $68e2a64123527646$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $68e2a64123527646$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $68e2a64123527646$var$stripNameRegex = /\..*/;
const $68e2a64123527646$var$stripUidRegex = /::\d+$/;
const $68e2a64123527646$var$eventRegistry = {}; // Events storage
let $68e2a64123527646$var$uidEvent = 1;
const $68e2a64123527646$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $68e2a64123527646$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $68e2a64123527646$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$68e2a64123527646$var$uidEvent++}` || element.uidEvent || $68e2a64123527646$var$uidEvent++;
}
function $68e2a64123527646$var$getElementEvents(element) {
    const uid = $68e2a64123527646$var$makeEventUid(element);
    element.uidEvent = uid;
    $68e2a64123527646$var$eventRegistry[uid] = $68e2a64123527646$var$eventRegistry[uid] || {};
    return $68e2a64123527646$var$eventRegistry[uid];
}
function $68e2a64123527646$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $68e2a64123527646$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $68e2a64123527646$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $68e2a64123527646$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $68e2a64123527646$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $68e2a64123527646$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $68e2a64123527646$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $68e2a64123527646$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $68e2a64123527646$var$getTypeEvent(originalTypeEvent);
    if (!$68e2a64123527646$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $68e2a64123527646$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $68e2a64123527646$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $68e2a64123527646$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $68e2a64123527646$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $68e2a64123527646$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $68e2a64123527646$var$makeEventUid(callable, originalTypeEvent.replace($68e2a64123527646$var$namespaceRegex, ''));
    const fn = isDelegated ? $68e2a64123527646$var$bootstrapDelegationHandler(element, handler, callable) : $68e2a64123527646$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $68e2a64123527646$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $68e2a64123527646$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $68e2a64123527646$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $68e2a64123527646$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $68e2a64123527646$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($68e2a64123527646$var$stripNameRegex, '');
    return $68e2a64123527646$var$customEvents[event] || event;
}
const $68e2a64123527646$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $68e2a64123527646$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $68e2a64123527646$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $68e2a64123527646$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $68e2a64123527646$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $68e2a64123527646$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$68e2a64123527646$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($68e2a64123527646$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $68e2a64123527646$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $68e2a64123527646$var$getjQuery();
        const typeEvent = $68e2a64123527646$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $68e2a64123527646$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $68e2a64123527646$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $68e2a64123527646$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $68e2a64123527646$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $68e2a64123527646$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$68e2a64123527646$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$68e2a64123527646$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $68e2a64123527646$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $68e2a64123527646$var$normalizeData(element.getAttribute(`data-bs-${$68e2a64123527646$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $68e2a64123527646$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $68e2a64123527646$var$isElement(element) ? $68e2a64123527646$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$68e2a64123527646$var$isElement(element) ? $68e2a64123527646$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $68e2a64123527646$var$isElement(value) ? 'element' : $68e2a64123527646$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $68e2a64123527646$var$BaseComponent extends $68e2a64123527646$var$Config {
    constructor(element, config){
        super();
        element = $68e2a64123527646$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $68e2a64123527646$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $68e2a64123527646$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $68e2a64123527646$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $68e2a64123527646$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $68e2a64123527646$var$Data.get($68e2a64123527646$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $68e2a64123527646$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $68e2a64123527646$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$68e2a64123527646$var$parseSelector(sel)).join(',') : null;
};
const $68e2a64123527646$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$68e2a64123527646$var$isDisabled(el) && $68e2a64123527646$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $68e2a64123527646$var$getSelector(element);
        if (selector) return $68e2a64123527646$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $68e2a64123527646$var$getSelector(element);
        return selector ? $68e2a64123527646$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $68e2a64123527646$var$getSelector(element);
        return selector ? $68e2a64123527646$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $68e2a64123527646$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $68e2a64123527646$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($68e2a64123527646$var$isDisabled(this)) return;
        const target = $68e2a64123527646$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$f = 'alert';
const $68e2a64123527646$var$DATA_KEY$a = 'bs.alert';
const $68e2a64123527646$var$EVENT_KEY$b = `.${$68e2a64123527646$var$DATA_KEY$a}`;
const $68e2a64123527646$var$EVENT_CLOSE = `close${$68e2a64123527646$var$EVENT_KEY$b}`;
const $68e2a64123527646$var$EVENT_CLOSED = `closed${$68e2a64123527646$var$EVENT_KEY$b}`;
const $68e2a64123527646$var$CLASS_NAME_FADE$5 = 'fade';
const $68e2a64123527646$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $68e2a64123527646$export$caec2af78bcc877f extends $68e2a64123527646$var$BaseComponent {
    // Getters
    static get NAME() {
        return $68e2a64123527646$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($68e2a64123527646$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$enableDismissTrigger($68e2a64123527646$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$e = 'button';
const $68e2a64123527646$var$DATA_KEY$9 = 'bs.button';
const $68e2a64123527646$var$EVENT_KEY$a = `.${$68e2a64123527646$var$DATA_KEY$9}`;
const $68e2a64123527646$var$DATA_API_KEY$6 = '.data-api';
const $68e2a64123527646$var$CLASS_NAME_ACTIVE$3 = 'active';
const $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $68e2a64123527646$var$EVENT_CLICK_DATA_API$6 = `click${$68e2a64123527646$var$EVENT_KEY$a}${$68e2a64123527646$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $68e2a64123527646$export$353f5b6fc5456de1 extends $68e2a64123527646$var$BaseComponent {
    // Getters
    static get NAME() {
        return $68e2a64123527646$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($68e2a64123527646$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_CLICK_DATA_API$6, $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($68e2a64123527646$var$SELECTOR_DATA_TOGGLE$5);
    const data = $68e2a64123527646$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$d = 'swipe';
const $68e2a64123527646$var$EVENT_KEY$9 = '.bs.swipe';
const $68e2a64123527646$var$EVENT_TOUCHSTART = `touchstart${$68e2a64123527646$var$EVENT_KEY$9}`;
const $68e2a64123527646$var$EVENT_TOUCHMOVE = `touchmove${$68e2a64123527646$var$EVENT_KEY$9}`;
const $68e2a64123527646$var$EVENT_TOUCHEND = `touchend${$68e2a64123527646$var$EVENT_KEY$9}`;
const $68e2a64123527646$var$EVENT_POINTERDOWN = `pointerdown${$68e2a64123527646$var$EVENT_KEY$9}`;
const $68e2a64123527646$var$EVENT_POINTERUP = `pointerup${$68e2a64123527646$var$EVENT_KEY$9}`;
const $68e2a64123527646$var$POINTER_TYPE_TOUCH = 'touch';
const $68e2a64123527646$var$POINTER_TYPE_PEN = 'pen';
const $68e2a64123527646$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $68e2a64123527646$var$SWIPE_THRESHOLD = 40;
const $68e2a64123527646$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $68e2a64123527646$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $68e2a64123527646$var$Swipe extends $68e2a64123527646$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$68e2a64123527646$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$c;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$c;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$d;
    }
    // Public
    dispose() {
        $68e2a64123527646$var$EventHandler.off(this._element, $68e2a64123527646$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $68e2a64123527646$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $68e2a64123527646$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $68e2a64123527646$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($68e2a64123527646$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $68e2a64123527646$var$POINTER_TYPE_PEN || event.pointerType === $68e2a64123527646$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$c = 'carousel';
const $68e2a64123527646$var$DATA_KEY$8 = 'bs.carousel';
const $68e2a64123527646$var$EVENT_KEY$8 = `.${$68e2a64123527646$var$DATA_KEY$8}`;
const $68e2a64123527646$var$DATA_API_KEY$5 = '.data-api';
const $68e2a64123527646$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $68e2a64123527646$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $68e2a64123527646$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $68e2a64123527646$var$ORDER_NEXT = 'next';
const $68e2a64123527646$var$ORDER_PREV = 'prev';
const $68e2a64123527646$var$DIRECTION_LEFT = 'left';
const $68e2a64123527646$var$DIRECTION_RIGHT = 'right';
const $68e2a64123527646$var$EVENT_SLIDE = `slide${$68e2a64123527646$var$EVENT_KEY$8}`;
const $68e2a64123527646$var$EVENT_SLID = `slid${$68e2a64123527646$var$EVENT_KEY$8}`;
const $68e2a64123527646$var$EVENT_KEYDOWN$1 = `keydown${$68e2a64123527646$var$EVENT_KEY$8}`;
const $68e2a64123527646$var$EVENT_MOUSEENTER$1 = `mouseenter${$68e2a64123527646$var$EVENT_KEY$8}`;
const $68e2a64123527646$var$EVENT_MOUSELEAVE$1 = `mouseleave${$68e2a64123527646$var$EVENT_KEY$8}`;
const $68e2a64123527646$var$EVENT_DRAG_START = `dragstart${$68e2a64123527646$var$EVENT_KEY$8}`;
const $68e2a64123527646$var$EVENT_LOAD_DATA_API$3 = `load${$68e2a64123527646$var$EVENT_KEY$8}${$68e2a64123527646$var$DATA_API_KEY$5}`;
const $68e2a64123527646$var$EVENT_CLICK_DATA_API$5 = `click${$68e2a64123527646$var$EVENT_KEY$8}${$68e2a64123527646$var$DATA_API_KEY$5}`;
const $68e2a64123527646$var$CLASS_NAME_CAROUSEL = 'carousel';
const $68e2a64123527646$var$CLASS_NAME_ACTIVE$2 = 'active';
const $68e2a64123527646$var$CLASS_NAME_SLIDE = 'slide';
const $68e2a64123527646$var$CLASS_NAME_END = 'carousel-item-end';
const $68e2a64123527646$var$CLASS_NAME_START = 'carousel-item-start';
const $68e2a64123527646$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $68e2a64123527646$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $68e2a64123527646$var$SELECTOR_ACTIVE = '.active';
const $68e2a64123527646$var$SELECTOR_ITEM = '.carousel-item';
const $68e2a64123527646$var$SELECTOR_ACTIVE_ITEM = $68e2a64123527646$var$SELECTOR_ACTIVE + $68e2a64123527646$var$SELECTOR_ITEM;
const $68e2a64123527646$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $68e2a64123527646$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $68e2a64123527646$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $68e2a64123527646$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $68e2a64123527646$var$KEY_TO_DIRECTION = {
    [$68e2a64123527646$var$ARROW_LEFT_KEY$1]: $68e2a64123527646$var$DIRECTION_RIGHT,
    [$68e2a64123527646$var$ARROW_RIGHT_KEY$1]: $68e2a64123527646$var$DIRECTION_LEFT
};
const $68e2a64123527646$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $68e2a64123527646$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $68e2a64123527646$export$144901db2ea8e967 extends $68e2a64123527646$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $68e2a64123527646$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$b;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$b;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$c;
    }
    // Public
    next() {
        this._slide($68e2a64123527646$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $68e2a64123527646$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($68e2a64123527646$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $68e2a64123527646$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $68e2a64123527646$var$EventHandler.one(this._element, $68e2a64123527646$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $68e2a64123527646$var$EventHandler.one(this._element, $68e2a64123527646$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $68e2a64123527646$var$ORDER_NEXT : $68e2a64123527646$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $68e2a64123527646$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_ITEM_IMG, this._element))$68e2a64123527646$var$EventHandler.on(img, $68e2a64123527646$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $68e2a64123527646$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($68e2a64123527646$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($68e2a64123527646$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $68e2a64123527646$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $68e2a64123527646$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($68e2a64123527646$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $68e2a64123527646$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($68e2a64123527646$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $68e2a64123527646$var$ORDER_NEXT;
        const nextElement = element || $68e2a64123527646$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $68e2a64123527646$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($68e2a64123527646$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $68e2a64123527646$var$CLASS_NAME_START : $68e2a64123527646$var$CLASS_NAME_END;
        const orderClassName = isNext ? $68e2a64123527646$var$CLASS_NAME_NEXT : $68e2a64123527646$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $68e2a64123527646$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($68e2a64123527646$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($68e2a64123527646$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($68e2a64123527646$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($68e2a64123527646$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($68e2a64123527646$var$isRTL()) return direction === $68e2a64123527646$var$DIRECTION_LEFT ? $68e2a64123527646$var$ORDER_PREV : $68e2a64123527646$var$ORDER_NEXT;
        return direction === $68e2a64123527646$var$DIRECTION_LEFT ? $68e2a64123527646$var$ORDER_NEXT : $68e2a64123527646$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($68e2a64123527646$var$isRTL()) return order === $68e2a64123527646$var$ORDER_PREV ? $68e2a64123527646$var$DIRECTION_LEFT : $68e2a64123527646$var$DIRECTION_RIGHT;
        return order === $68e2a64123527646$var$ORDER_PREV ? $68e2a64123527646$var$DIRECTION_RIGHT : $68e2a64123527646$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_CLICK_DATA_API$5, $68e2a64123527646$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $68e2a64123527646$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($68e2a64123527646$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $68e2a64123527646$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($68e2a64123527646$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$68e2a64123527646$var$EventHandler.on(window, $68e2a64123527646$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$68e2a64123527646$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$b = 'collapse';
const $68e2a64123527646$var$DATA_KEY$7 = 'bs.collapse';
const $68e2a64123527646$var$EVENT_KEY$7 = `.${$68e2a64123527646$var$DATA_KEY$7}`;
const $68e2a64123527646$var$DATA_API_KEY$4 = '.data-api';
const $68e2a64123527646$var$EVENT_SHOW$6 = `show${$68e2a64123527646$var$EVENT_KEY$7}`;
const $68e2a64123527646$var$EVENT_SHOWN$6 = `shown${$68e2a64123527646$var$EVENT_KEY$7}`;
const $68e2a64123527646$var$EVENT_HIDE$6 = `hide${$68e2a64123527646$var$EVENT_KEY$7}`;
const $68e2a64123527646$var$EVENT_HIDDEN$6 = `hidden${$68e2a64123527646$var$EVENT_KEY$7}`;
const $68e2a64123527646$var$EVENT_CLICK_DATA_API$4 = `click${$68e2a64123527646$var$EVENT_KEY$7}${$68e2a64123527646$var$DATA_API_KEY$4}`;
const $68e2a64123527646$var$CLASS_NAME_SHOW$7 = 'show';
const $68e2a64123527646$var$CLASS_NAME_COLLAPSE = 'collapse';
const $68e2a64123527646$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $68e2a64123527646$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $68e2a64123527646$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$68e2a64123527646$var$CLASS_NAME_COLLAPSE} .${$68e2a64123527646$var$CLASS_NAME_COLLAPSE}`;
const $68e2a64123527646$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $68e2a64123527646$var$WIDTH = 'width';
const $68e2a64123527646$var$HEIGHT = 'height';
const $68e2a64123527646$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $68e2a64123527646$var$Default$a = {
    parent: null,
    toggle: true
};
const $68e2a64123527646$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $68e2a64123527646$export$78768a9af065a7b extends $68e2a64123527646$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $68e2a64123527646$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $68e2a64123527646$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$a;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$a;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($68e2a64123527646$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$68e2a64123527646$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($68e2a64123527646$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($68e2a64123527646$var$CLASS_NAME_COLLAPSE, $68e2a64123527646$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $68e2a64123527646$var$reflow(this._element);
        this._element.classList.add($68e2a64123527646$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_COLLAPSE, $68e2a64123527646$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $68e2a64123527646$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($68e2a64123527646$var$CLASS_NAME_COLLAPSE);
            $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($68e2a64123527646$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $68e2a64123527646$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($68e2a64123527646$var$CLASS_NAME_HORIZONTAL) ? $68e2a64123527646$var$WIDTH : $68e2a64123527646$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($68e2a64123527646$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $68e2a64123527646$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $68e2a64123527646$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($68e2a64123527646$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $68e2a64123527646$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_CLICK_DATA_API$4, $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $68e2a64123527646$var$SelectorEngine.getMultipleElementsFromSelector(this))$68e2a64123527646$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$a = 'dropdown';
const $68e2a64123527646$var$DATA_KEY$6 = 'bs.dropdown';
const $68e2a64123527646$var$EVENT_KEY$6 = `.${$68e2a64123527646$var$DATA_KEY$6}`;
const $68e2a64123527646$var$DATA_API_KEY$3 = '.data-api';
const $68e2a64123527646$var$ESCAPE_KEY$2 = 'Escape';
const $68e2a64123527646$var$TAB_KEY$1 = 'Tab';
const $68e2a64123527646$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $68e2a64123527646$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $68e2a64123527646$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $68e2a64123527646$var$EVENT_HIDE$5 = `hide${$68e2a64123527646$var$EVENT_KEY$6}`;
const $68e2a64123527646$var$EVENT_HIDDEN$5 = `hidden${$68e2a64123527646$var$EVENT_KEY$6}`;
const $68e2a64123527646$var$EVENT_SHOW$5 = `show${$68e2a64123527646$var$EVENT_KEY$6}`;
const $68e2a64123527646$var$EVENT_SHOWN$5 = `shown${$68e2a64123527646$var$EVENT_KEY$6}`;
const $68e2a64123527646$var$EVENT_CLICK_DATA_API$3 = `click${$68e2a64123527646$var$EVENT_KEY$6}${$68e2a64123527646$var$DATA_API_KEY$3}`;
const $68e2a64123527646$var$EVENT_KEYDOWN_DATA_API = `keydown${$68e2a64123527646$var$EVENT_KEY$6}${$68e2a64123527646$var$DATA_API_KEY$3}`;
const $68e2a64123527646$var$EVENT_KEYUP_DATA_API = `keyup${$68e2a64123527646$var$EVENT_KEY$6}${$68e2a64123527646$var$DATA_API_KEY$3}`;
const $68e2a64123527646$var$CLASS_NAME_SHOW$6 = 'show';
const $68e2a64123527646$var$CLASS_NAME_DROPUP = 'dropup';
const $68e2a64123527646$var$CLASS_NAME_DROPEND = 'dropend';
const $68e2a64123527646$var$CLASS_NAME_DROPSTART = 'dropstart';
const $68e2a64123527646$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $68e2a64123527646$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $68e2a64123527646$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$68e2a64123527646$var$SELECTOR_DATA_TOGGLE$3}.${$68e2a64123527646$var$CLASS_NAME_SHOW$6}`;
const $68e2a64123527646$var$SELECTOR_MENU = '.dropdown-menu';
const $68e2a64123527646$var$SELECTOR_NAVBAR = '.navbar';
const $68e2a64123527646$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $68e2a64123527646$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $68e2a64123527646$var$PLACEMENT_TOP = $68e2a64123527646$var$isRTL() ? 'top-end' : 'top-start';
const $68e2a64123527646$var$PLACEMENT_TOPEND = $68e2a64123527646$var$isRTL() ? 'top-start' : 'top-end';
const $68e2a64123527646$var$PLACEMENT_BOTTOM = $68e2a64123527646$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $68e2a64123527646$var$PLACEMENT_BOTTOMEND = $68e2a64123527646$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $68e2a64123527646$var$PLACEMENT_RIGHT = $68e2a64123527646$var$isRTL() ? 'left-start' : 'right-start';
const $68e2a64123527646$var$PLACEMENT_LEFT = $68e2a64123527646$var$isRTL() ? 'right-start' : 'left-start';
const $68e2a64123527646$var$PLACEMENT_TOPCENTER = 'top';
const $68e2a64123527646$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $68e2a64123527646$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $68e2a64123527646$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $68e2a64123527646$export$931cbfb6bfb85fc extends $68e2a64123527646$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $68e2a64123527646$var$SelectorEngine.next(this._element, $68e2a64123527646$var$SELECTOR_MENU)[0] || $68e2a64123527646$var$SelectorEngine.prev(this._element, $68e2a64123527646$var$SELECTOR_MENU)[0] || $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$9;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$9;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($68e2a64123527646$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($68e2a64123527646$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$68e2a64123527646$var$EventHandler.on(element, 'mouseover', $68e2a64123527646$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($68e2a64123527646$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($68e2a64123527646$var$CLASS_NAME_SHOW$6);
        $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($68e2a64123527646$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$68e2a64123527646$var$EventHandler.off(element, 'mouseover', $68e2a64123527646$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $68e2a64123527646$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$68e2a64123527646$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$68e2a64123527646$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $a822e9daf520ce16$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($68e2a64123527646$var$isElement(this._config.reference)) referenceElement = $68e2a64123527646$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $a822e9daf520ce16$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($68e2a64123527646$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($68e2a64123527646$var$CLASS_NAME_DROPEND)) return $68e2a64123527646$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($68e2a64123527646$var$CLASS_NAME_DROPSTART)) return $68e2a64123527646$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($68e2a64123527646$var$CLASS_NAME_DROPUP_CENTER)) return $68e2a64123527646$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($68e2a64123527646$var$CLASS_NAME_DROPDOWN_CENTER)) return $68e2a64123527646$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($68e2a64123527646$var$CLASS_NAME_DROPUP)) return isEnd ? $68e2a64123527646$var$PLACEMENT_TOPEND : $68e2a64123527646$var$PLACEMENT_TOP;
        return isEnd ? $68e2a64123527646$var$PLACEMENT_BOTTOMEND : $68e2a64123527646$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($68e2a64123527646$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $68e2a64123527646$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$68e2a64123527646$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$68e2a64123527646$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $68e2a64123527646$var$getNextActiveElement(items, target, key === $68e2a64123527646$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $68e2a64123527646$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $68e2a64123527646$var$TAB_KEY$1) return;
        const openToggles = $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $68e2a64123527646$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $68e2a64123527646$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $68e2a64123527646$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $68e2a64123527646$var$ARROW_UP_KEY$1,
            $68e2a64123527646$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($68e2a64123527646$var$SELECTOR_DATA_TOGGLE$3) ? this : $68e2a64123527646$var$SelectorEngine.prev(this, $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$3)[0] || $68e2a64123527646$var$SelectorEngine.next(this, $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$3)[0] || $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $68e2a64123527646$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_KEYDOWN_DATA_API, $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$3, $68e2a64123527646$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_KEYDOWN_DATA_API, $68e2a64123527646$var$SELECTOR_MENU, $68e2a64123527646$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_CLICK_DATA_API$3, $68e2a64123527646$export$931cbfb6bfb85fc.clearMenus);
$68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_KEYUP_DATA_API, $68e2a64123527646$export$931cbfb6bfb85fc.clearMenus);
$68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_CLICK_DATA_API$3, $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $68e2a64123527646$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$9 = 'backdrop';
const $68e2a64123527646$var$CLASS_NAME_FADE$4 = 'fade';
const $68e2a64123527646$var$CLASS_NAME_SHOW$5 = 'show';
const $68e2a64123527646$var$EVENT_MOUSEDOWN = `mousedown.bs.${$68e2a64123527646$var$NAME$9}`;
const $68e2a64123527646$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $68e2a64123527646$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $68e2a64123527646$var$Backdrop extends $68e2a64123527646$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$8;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$8;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $68e2a64123527646$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $68e2a64123527646$var$reflow(element);
        element.classList.add($68e2a64123527646$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $68e2a64123527646$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $68e2a64123527646$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($68e2a64123527646$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $68e2a64123527646$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $68e2a64123527646$var$EventHandler.off(this._element, $68e2a64123527646$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($68e2a64123527646$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $68e2a64123527646$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $68e2a64123527646$var$EventHandler.on(element, $68e2a64123527646$var$EVENT_MOUSEDOWN, ()=>{
            $68e2a64123527646$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $68e2a64123527646$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$8 = 'focustrap';
const $68e2a64123527646$var$DATA_KEY$5 = 'bs.focustrap';
const $68e2a64123527646$var$EVENT_KEY$5 = `.${$68e2a64123527646$var$DATA_KEY$5}`;
const $68e2a64123527646$var$EVENT_FOCUSIN$2 = `focusin${$68e2a64123527646$var$EVENT_KEY$5}`;
const $68e2a64123527646$var$EVENT_KEYDOWN_TAB = `keydown.tab${$68e2a64123527646$var$EVENT_KEY$5}`;
const $68e2a64123527646$var$TAB_KEY = 'Tab';
const $68e2a64123527646$var$TAB_NAV_FORWARD = 'forward';
const $68e2a64123527646$var$TAB_NAV_BACKWARD = 'backward';
const $68e2a64123527646$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $68e2a64123527646$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $68e2a64123527646$var$FocusTrap extends $68e2a64123527646$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$7;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$7;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $68e2a64123527646$var$EventHandler.off(document, $68e2a64123527646$var$EVENT_KEY$5); // guard against infinite focus loop
        $68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $68e2a64123527646$var$EventHandler.off(document, $68e2a64123527646$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $68e2a64123527646$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $68e2a64123527646$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $68e2a64123527646$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $68e2a64123527646$var$TAB_NAV_BACKWARD : $68e2a64123527646$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $68e2a64123527646$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $68e2a64123527646$var$PROPERTY_PADDING = 'padding-right';
const $68e2a64123527646$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $68e2a64123527646$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $68e2a64123527646$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($68e2a64123527646$var$SELECTOR_FIXED_CONTENT, $68e2a64123527646$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($68e2a64123527646$var$SELECTOR_STICKY_CONTENT, $68e2a64123527646$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $68e2a64123527646$var$PROPERTY_PADDING);
        this._resetElementAttributes($68e2a64123527646$var$SELECTOR_FIXED_CONTENT, $68e2a64123527646$var$PROPERTY_PADDING);
        this._resetElementAttributes($68e2a64123527646$var$SELECTOR_STICKY_CONTENT, $68e2a64123527646$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $68e2a64123527646$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $68e2a64123527646$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $68e2a64123527646$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($68e2a64123527646$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $68e2a64123527646$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$7 = 'modal';
const $68e2a64123527646$var$DATA_KEY$4 = 'bs.modal';
const $68e2a64123527646$var$EVENT_KEY$4 = `.${$68e2a64123527646$var$DATA_KEY$4}`;
const $68e2a64123527646$var$DATA_API_KEY$2 = '.data-api';
const $68e2a64123527646$var$ESCAPE_KEY$1 = 'Escape';
const $68e2a64123527646$var$EVENT_HIDE$4 = `hide${$68e2a64123527646$var$EVENT_KEY$4}`;
const $68e2a64123527646$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$68e2a64123527646$var$EVENT_KEY$4}`;
const $68e2a64123527646$var$EVENT_HIDDEN$4 = `hidden${$68e2a64123527646$var$EVENT_KEY$4}`;
const $68e2a64123527646$var$EVENT_SHOW$4 = `show${$68e2a64123527646$var$EVENT_KEY$4}`;
const $68e2a64123527646$var$EVENT_SHOWN$4 = `shown${$68e2a64123527646$var$EVENT_KEY$4}`;
const $68e2a64123527646$var$EVENT_RESIZE$1 = `resize${$68e2a64123527646$var$EVENT_KEY$4}`;
const $68e2a64123527646$var$EVENT_CLICK_DISMISS = `click.dismiss${$68e2a64123527646$var$EVENT_KEY$4}`;
const $68e2a64123527646$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$68e2a64123527646$var$EVENT_KEY$4}`;
const $68e2a64123527646$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$68e2a64123527646$var$EVENT_KEY$4}`;
const $68e2a64123527646$var$EVENT_CLICK_DATA_API$2 = `click${$68e2a64123527646$var$EVENT_KEY$4}${$68e2a64123527646$var$DATA_API_KEY$2}`;
const $68e2a64123527646$var$CLASS_NAME_OPEN = 'modal-open';
const $68e2a64123527646$var$CLASS_NAME_FADE$3 = 'fade';
const $68e2a64123527646$var$CLASS_NAME_SHOW$4 = 'show';
const $68e2a64123527646$var$CLASS_NAME_STATIC = 'modal-static';
const $68e2a64123527646$var$OPEN_SELECTOR$1 = '.modal.show';
const $68e2a64123527646$var$SELECTOR_DIALOG = '.modal-dialog';
const $68e2a64123527646$var$SELECTOR_MODAL_BODY = '.modal-body';
const $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $68e2a64123527646$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $68e2a64123527646$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $68e2a64123527646$export$2b77a92f1a5ad772 extends $68e2a64123527646$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $68e2a64123527646$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$6;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$6;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($68e2a64123527646$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $68e2a64123527646$var$EventHandler.off(window, $68e2a64123527646$var$EVENT_KEY$4);
        $68e2a64123527646$var$EventHandler.off(this._dialog, $68e2a64123527646$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $68e2a64123527646$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $68e2a64123527646$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $68e2a64123527646$var$reflow(this._element);
        this._element.classList.add($68e2a64123527646$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $68e2a64123527646$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $68e2a64123527646$var$EventHandler.on(window, $68e2a64123527646$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $68e2a64123527646$var$EventHandler.one(this._element, $68e2a64123527646$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($68e2a64123527646$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($68e2a64123527646$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($68e2a64123527646$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($68e2a64123527646$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $68e2a64123527646$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $68e2a64123527646$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $68e2a64123527646$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_CLICK_DATA_API$2, $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $68e2a64123527646$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $68e2a64123527646$var$EventHandler.one(target, $68e2a64123527646$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $68e2a64123527646$var$EventHandler.one(target, $68e2a64123527646$var$EVENT_HIDDEN$4, ()=>{
            if ($68e2a64123527646$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $68e2a64123527646$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $68e2a64123527646$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$68e2a64123527646$var$enableDismissTrigger($68e2a64123527646$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$6 = 'offcanvas';
const $68e2a64123527646$var$DATA_KEY$3 = 'bs.offcanvas';
const $68e2a64123527646$var$EVENT_KEY$3 = `.${$68e2a64123527646$var$DATA_KEY$3}`;
const $68e2a64123527646$var$DATA_API_KEY$1 = '.data-api';
const $68e2a64123527646$var$EVENT_LOAD_DATA_API$2 = `load${$68e2a64123527646$var$EVENT_KEY$3}${$68e2a64123527646$var$DATA_API_KEY$1}`;
const $68e2a64123527646$var$ESCAPE_KEY = 'Escape';
const $68e2a64123527646$var$CLASS_NAME_SHOW$3 = 'show';
const $68e2a64123527646$var$CLASS_NAME_SHOWING$1 = 'showing';
const $68e2a64123527646$var$CLASS_NAME_HIDING = 'hiding';
const $68e2a64123527646$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $68e2a64123527646$var$OPEN_SELECTOR = '.offcanvas.show';
const $68e2a64123527646$var$EVENT_SHOW$3 = `show${$68e2a64123527646$var$EVENT_KEY$3}`;
const $68e2a64123527646$var$EVENT_SHOWN$3 = `shown${$68e2a64123527646$var$EVENT_KEY$3}`;
const $68e2a64123527646$var$EVENT_HIDE$3 = `hide${$68e2a64123527646$var$EVENT_KEY$3}`;
const $68e2a64123527646$var$EVENT_HIDE_PREVENTED = `hidePrevented${$68e2a64123527646$var$EVENT_KEY$3}`;
const $68e2a64123527646$var$EVENT_HIDDEN$3 = `hidden${$68e2a64123527646$var$EVENT_KEY$3}`;
const $68e2a64123527646$var$EVENT_RESIZE = `resize${$68e2a64123527646$var$EVENT_KEY$3}`;
const $68e2a64123527646$var$EVENT_CLICK_DATA_API$1 = `click${$68e2a64123527646$var$EVENT_KEY$3}${$68e2a64123527646$var$DATA_API_KEY$1}`;
const $68e2a64123527646$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$68e2a64123527646$var$EVENT_KEY$3}`;
const $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $68e2a64123527646$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $68e2a64123527646$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $68e2a64123527646$export$591ca0244c9dfcd4 extends $68e2a64123527646$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$5;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$5;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $68e2a64123527646$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($68e2a64123527646$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($68e2a64123527646$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOWING$1);
            $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($68e2a64123527646$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOW$3, $68e2a64123527646$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $68e2a64123527646$var$ScrollBarHelper().reset();
            $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $68e2a64123527646$var$Backdrop({
            className: $68e2a64123527646$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $68e2a64123527646$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $68e2a64123527646$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_CLICK_DATA_API$1, $68e2a64123527646$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $68e2a64123527646$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($68e2a64123527646$var$isDisabled(this)) return;
    $68e2a64123527646$var$EventHandler.one(target, $68e2a64123527646$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($68e2a64123527646$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $68e2a64123527646$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $68e2a64123527646$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$68e2a64123527646$var$EventHandler.on(window, $68e2a64123527646$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$OPEN_SELECTOR))$68e2a64123527646$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$68e2a64123527646$var$EventHandler.on(window, $68e2a64123527646$var$EVENT_RESIZE, ()=>{
    for (const element of $68e2a64123527646$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $68e2a64123527646$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$68e2a64123527646$var$enableDismissTrigger($68e2a64123527646$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $68e2a64123527646$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $68e2a64123527646$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $68e2a64123527646$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $68e2a64123527646$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $68e2a64123527646$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $68e2a64123527646$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($68e2a64123527646$var$uriAttributes.has(attributeName)) return Boolean($68e2a64123527646$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $68e2a64123527646$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$68e2a64123527646$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$5 = 'TemplateFactory';
const $68e2a64123527646$var$Default$4 = {
    allowList: $68e2a64123527646$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $68e2a64123527646$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $68e2a64123527646$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $68e2a64123527646$var$TemplateFactory extends $68e2a64123527646$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$4;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$4;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $68e2a64123527646$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $68e2a64123527646$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($68e2a64123527646$var$isElement(content)) {
            this._putElementInTemplate($68e2a64123527646$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $68e2a64123527646$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $68e2a64123527646$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$4 = 'tooltip';
const $68e2a64123527646$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $68e2a64123527646$var$CLASS_NAME_FADE$2 = 'fade';
const $68e2a64123527646$var$CLASS_NAME_MODAL = 'modal';
const $68e2a64123527646$var$CLASS_NAME_SHOW$2 = 'show';
const $68e2a64123527646$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $68e2a64123527646$var$SELECTOR_MODAL = `.${$68e2a64123527646$var$CLASS_NAME_MODAL}`;
const $68e2a64123527646$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $68e2a64123527646$var$TRIGGER_HOVER = 'hover';
const $68e2a64123527646$var$TRIGGER_FOCUS = 'focus';
const $68e2a64123527646$var$TRIGGER_CLICK = 'click';
const $68e2a64123527646$var$TRIGGER_MANUAL = 'manual';
const $68e2a64123527646$var$EVENT_HIDE$2 = 'hide';
const $68e2a64123527646$var$EVENT_HIDDEN$2 = 'hidden';
const $68e2a64123527646$var$EVENT_SHOW$2 = 'show';
const $68e2a64123527646$var$EVENT_SHOWN$2 = 'shown';
const $68e2a64123527646$var$EVENT_INSERTED = 'inserted';
const $68e2a64123527646$var$EVENT_CLICK$1 = 'click';
const $68e2a64123527646$var$EVENT_FOCUSIN$1 = 'focusin';
const $68e2a64123527646$var$EVENT_FOCUSOUT$1 = 'focusout';
const $68e2a64123527646$var$EVENT_MOUSEENTER = 'mouseenter';
const $68e2a64123527646$var$EVENT_MOUSELEAVE = 'mouseleave';
const $68e2a64123527646$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $68e2a64123527646$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $68e2a64123527646$var$isRTL() ? 'right' : 'left'
};
const $68e2a64123527646$var$Default$3 = {
    allowList: $68e2a64123527646$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $68e2a64123527646$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $68e2a64123527646$export$28c660c63b792dea extends $68e2a64123527646$var$BaseComponent {
    constructor(element, config){
        if (typeof $a822e9daf520ce16$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$3;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$3;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $68e2a64123527646$var$EventHandler.off(this._element.closest($68e2a64123527646$var$SELECTOR_MODAL), $68e2a64123527646$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, this.constructor.eventName($68e2a64123527646$var$EVENT_SHOW$2));
        const shadowRoot = $68e2a64123527646$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $68e2a64123527646$var$EventHandler.trigger(this._element, this.constructor.eventName($68e2a64123527646$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($68e2a64123527646$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$68e2a64123527646$var$EventHandler.on(element, 'mouseover', $68e2a64123527646$var$noop);
        const complete = ()=>{
            $68e2a64123527646$var$EventHandler.trigger(this._element, this.constructor.eventName($68e2a64123527646$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, this.constructor.eventName($68e2a64123527646$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$68e2a64123527646$var$EventHandler.off(element, 'mouseover', $68e2a64123527646$var$noop);
        this._activeTrigger[$68e2a64123527646$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$68e2a64123527646$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$68e2a64123527646$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $68e2a64123527646$var$EventHandler.trigger(this._element, this.constructor.eventName($68e2a64123527646$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($68e2a64123527646$var$CLASS_NAME_FADE$2, $68e2a64123527646$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $68e2a64123527646$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($68e2a64123527646$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $68e2a64123527646$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$68e2a64123527646$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($68e2a64123527646$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($68e2a64123527646$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $68e2a64123527646$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $68e2a64123527646$var$AttachmentMap[placement.toUpperCase()];
        return $a822e9daf520ce16$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $68e2a64123527646$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$68e2a64123527646$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $68e2a64123527646$var$EventHandler.on(this._element, this.constructor.eventName($68e2a64123527646$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$68e2a64123527646$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$68e2a64123527646$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $68e2a64123527646$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $68e2a64123527646$var$TRIGGER_HOVER ? this.constructor.eventName($68e2a64123527646$var$EVENT_MOUSEENTER) : this.constructor.eventName($68e2a64123527646$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $68e2a64123527646$var$TRIGGER_HOVER ? this.constructor.eventName($68e2a64123527646$var$EVENT_MOUSELEAVE) : this.constructor.eventName($68e2a64123527646$var$EVENT_FOCUSOUT$1);
                $68e2a64123527646$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $68e2a64123527646$var$TRIGGER_FOCUS : $68e2a64123527646$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $68e2a64123527646$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $68e2a64123527646$var$TRIGGER_FOCUS : $68e2a64123527646$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $68e2a64123527646$var$EventHandler.on(this._element.closest($68e2a64123527646$var$SELECTOR_MODAL), $68e2a64123527646$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $68e2a64123527646$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($68e2a64123527646$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $68e2a64123527646$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$3 = 'popover';
const $68e2a64123527646$var$SELECTOR_TITLE = '.popover-header';
const $68e2a64123527646$var$SELECTOR_CONTENT = '.popover-body';
const $68e2a64123527646$var$Default$2 = {
    ...$68e2a64123527646$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $68e2a64123527646$var$DefaultType$2 = {
    ...$68e2a64123527646$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $68e2a64123527646$export$5b6b19405a83ff9d extends $68e2a64123527646$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$2;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$2;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$68e2a64123527646$var$SELECTOR_TITLE]: this._getTitle(),
            [$68e2a64123527646$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$2 = 'scrollspy';
const $68e2a64123527646$var$DATA_KEY$2 = 'bs.scrollspy';
const $68e2a64123527646$var$EVENT_KEY$2 = `.${$68e2a64123527646$var$DATA_KEY$2}`;
const $68e2a64123527646$var$DATA_API_KEY = '.data-api';
const $68e2a64123527646$var$EVENT_ACTIVATE = `activate${$68e2a64123527646$var$EVENT_KEY$2}`;
const $68e2a64123527646$var$EVENT_CLICK = `click${$68e2a64123527646$var$EVENT_KEY$2}`;
const $68e2a64123527646$var$EVENT_LOAD_DATA_API$1 = `load${$68e2a64123527646$var$EVENT_KEY$2}${$68e2a64123527646$var$DATA_API_KEY}`;
const $68e2a64123527646$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $68e2a64123527646$var$CLASS_NAME_ACTIVE$1 = 'active';
const $68e2a64123527646$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $68e2a64123527646$var$SELECTOR_TARGET_LINKS = '[href]';
const $68e2a64123527646$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $68e2a64123527646$var$SELECTOR_NAV_LINKS = '.nav-link';
const $68e2a64123527646$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $68e2a64123527646$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $68e2a64123527646$var$SELECTOR_LINK_ITEMS = `${$68e2a64123527646$var$SELECTOR_NAV_LINKS}, ${$68e2a64123527646$var$SELECTOR_NAV_ITEMS} > ${$68e2a64123527646$var$SELECTOR_NAV_LINKS}, ${$68e2a64123527646$var$SELECTOR_LIST_ITEMS}`;
const $68e2a64123527646$var$SELECTOR_DROPDOWN = '.dropdown';
const $68e2a64123527646$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $68e2a64123527646$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $68e2a64123527646$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $68e2a64123527646$export$a6472a5298a374be extends $68e2a64123527646$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default$1;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType$1;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $68e2a64123527646$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $68e2a64123527646$var$EventHandler.off(this._config.target, $68e2a64123527646$var$EVENT_CLICK);
        $68e2a64123527646$var$EventHandler.on(this._config.target, $68e2a64123527646$var$EVENT_CLICK, $68e2a64123527646$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $68e2a64123527646$var$isDisabled(anchor)) continue;
            const observableSection = $68e2a64123527646$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($68e2a64123527646$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($68e2a64123527646$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($68e2a64123527646$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($68e2a64123527646$var$SELECTOR_DROPDOWN)).classList.add($68e2a64123527646$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $68e2a64123527646$var$SelectorEngine.parents(target, $68e2a64123527646$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $68e2a64123527646$var$SelectorEngine.prev(listGroup, $68e2a64123527646$var$SELECTOR_LINK_ITEMS))item.classList.add($68e2a64123527646$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($68e2a64123527646$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $68e2a64123527646$var$SelectorEngine.find(`${$68e2a64123527646$var$SELECTOR_TARGET_LINKS}.${$68e2a64123527646$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($68e2a64123527646$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$EventHandler.on(window, $68e2a64123527646$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_DATA_SPY))$68e2a64123527646$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME$1 = 'tab';
const $68e2a64123527646$var$DATA_KEY$1 = 'bs.tab';
const $68e2a64123527646$var$EVENT_KEY$1 = `.${$68e2a64123527646$var$DATA_KEY$1}`;
const $68e2a64123527646$var$EVENT_HIDE$1 = `hide${$68e2a64123527646$var$EVENT_KEY$1}`;
const $68e2a64123527646$var$EVENT_HIDDEN$1 = `hidden${$68e2a64123527646$var$EVENT_KEY$1}`;
const $68e2a64123527646$var$EVENT_SHOW$1 = `show${$68e2a64123527646$var$EVENT_KEY$1}`;
const $68e2a64123527646$var$EVENT_SHOWN$1 = `shown${$68e2a64123527646$var$EVENT_KEY$1}`;
const $68e2a64123527646$var$EVENT_CLICK_DATA_API = `click${$68e2a64123527646$var$EVENT_KEY$1}`;
const $68e2a64123527646$var$EVENT_KEYDOWN = `keydown${$68e2a64123527646$var$EVENT_KEY$1}`;
const $68e2a64123527646$var$EVENT_LOAD_DATA_API = `load${$68e2a64123527646$var$EVENT_KEY$1}`;
const $68e2a64123527646$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $68e2a64123527646$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $68e2a64123527646$var$ARROW_UP_KEY = 'ArrowUp';
const $68e2a64123527646$var$ARROW_DOWN_KEY = 'ArrowDown';
const $68e2a64123527646$var$HOME_KEY = 'Home';
const $68e2a64123527646$var$END_KEY = 'End';
const $68e2a64123527646$var$CLASS_NAME_ACTIVE = 'active';
const $68e2a64123527646$var$CLASS_NAME_FADE$1 = 'fade';
const $68e2a64123527646$var$CLASS_NAME_SHOW$1 = 'show';
const $68e2a64123527646$var$CLASS_DROPDOWN = 'dropdown';
const $68e2a64123527646$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $68e2a64123527646$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $68e2a64123527646$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$68e2a64123527646$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $68e2a64123527646$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $68e2a64123527646$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $68e2a64123527646$var$SELECTOR_INNER = `.nav-link${$68e2a64123527646$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$68e2a64123527646$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$68e2a64123527646$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $68e2a64123527646$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $68e2a64123527646$var$SELECTOR_INNER_ELEM = `${$68e2a64123527646$var$SELECTOR_INNER}, ${$68e2a64123527646$var$SELECTOR_DATA_TOGGLE}`;
const $68e2a64123527646$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$68e2a64123527646$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$68e2a64123527646$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$68e2a64123527646$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $68e2a64123527646$export$3e41faf802a29e71 extends $68e2a64123527646$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($68e2a64123527646$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $68e2a64123527646$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $68e2a64123527646$var$EventHandler.trigger(active, $68e2a64123527646$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $68e2a64123527646$var$EventHandler.trigger(innerElem, $68e2a64123527646$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($68e2a64123527646$var$CLASS_NAME_ACTIVE);
        this._activate($68e2a64123527646$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($68e2a64123527646$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $68e2a64123527646$var$EventHandler.trigger(element, $68e2a64123527646$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($68e2a64123527646$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($68e2a64123527646$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($68e2a64123527646$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $68e2a64123527646$var$EventHandler.trigger(element, $68e2a64123527646$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($68e2a64123527646$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $68e2a64123527646$var$ARROW_LEFT_KEY,
            $68e2a64123527646$var$ARROW_RIGHT_KEY,
            $68e2a64123527646$var$ARROW_UP_KEY,
            $68e2a64123527646$var$ARROW_DOWN_KEY,
            $68e2a64123527646$var$HOME_KEY,
            $68e2a64123527646$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$68e2a64123527646$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $68e2a64123527646$var$HOME_KEY,
            $68e2a64123527646$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $68e2a64123527646$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $68e2a64123527646$var$ARROW_RIGHT_KEY,
                $68e2a64123527646$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $68e2a64123527646$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $68e2a64123527646$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $68e2a64123527646$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($68e2a64123527646$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $68e2a64123527646$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($68e2a64123527646$var$SELECTOR_DROPDOWN_TOGGLE, $68e2a64123527646$var$CLASS_NAME_ACTIVE);
        toggle($68e2a64123527646$var$SELECTOR_DROPDOWN_MENU, $68e2a64123527646$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($68e2a64123527646$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($68e2a64123527646$var$SELECTOR_INNER_ELEM) ? elem : $68e2a64123527646$var$SelectorEngine.findOne($68e2a64123527646$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($68e2a64123527646$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$EventHandler.on(document, $68e2a64123527646$var$EVENT_CLICK_DATA_API, $68e2a64123527646$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($68e2a64123527646$var$isDisabled(this)) return;
    $68e2a64123527646$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $68e2a64123527646$var$EventHandler.on(window, $68e2a64123527646$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $68e2a64123527646$var$SelectorEngine.find($68e2a64123527646$var$SELECTOR_DATA_TOGGLE_ACTIVE))$68e2a64123527646$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $68e2a64123527646$var$NAME = 'toast';
const $68e2a64123527646$var$DATA_KEY = 'bs.toast';
const $68e2a64123527646$var$EVENT_KEY = `.${$68e2a64123527646$var$DATA_KEY}`;
const $68e2a64123527646$var$EVENT_MOUSEOVER = `mouseover${$68e2a64123527646$var$EVENT_KEY}`;
const $68e2a64123527646$var$EVENT_MOUSEOUT = `mouseout${$68e2a64123527646$var$EVENT_KEY}`;
const $68e2a64123527646$var$EVENT_FOCUSIN = `focusin${$68e2a64123527646$var$EVENT_KEY}`;
const $68e2a64123527646$var$EVENT_FOCUSOUT = `focusout${$68e2a64123527646$var$EVENT_KEY}`;
const $68e2a64123527646$var$EVENT_HIDE = `hide${$68e2a64123527646$var$EVENT_KEY}`;
const $68e2a64123527646$var$EVENT_HIDDEN = `hidden${$68e2a64123527646$var$EVENT_KEY}`;
const $68e2a64123527646$var$EVENT_SHOW = `show${$68e2a64123527646$var$EVENT_KEY}`;
const $68e2a64123527646$var$EVENT_SHOWN = `shown${$68e2a64123527646$var$EVENT_KEY}`;
const $68e2a64123527646$var$CLASS_NAME_FADE = 'fade';
const $68e2a64123527646$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $68e2a64123527646$var$CLASS_NAME_SHOW = 'show';
const $68e2a64123527646$var$CLASS_NAME_SHOWING = 'showing';
const $68e2a64123527646$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $68e2a64123527646$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $68e2a64123527646$export$8d8dc7d5f743331b extends $68e2a64123527646$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $68e2a64123527646$var$Default;
    }
    static get DefaultType() {
        return $68e2a64123527646$var$DefaultType;
    }
    static get NAME() {
        return $68e2a64123527646$var$NAME;
    }
    // Public
    show() {
        const showEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($68e2a64123527646$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOWING);
            $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_HIDE); // @deprecated
        $68e2a64123527646$var$reflow(this._element);
        this._element.classList.add($68e2a64123527646$var$CLASS_NAME_SHOW, $68e2a64123527646$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($68e2a64123527646$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOWING, $68e2a64123527646$var$CLASS_NAME_SHOW);
            $68e2a64123527646$var$EventHandler.trigger(this._element, $68e2a64123527646$var$EVENT_HIDDEN);
        };
        this._element.classList.add($68e2a64123527646$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($68e2a64123527646$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($68e2a64123527646$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $68e2a64123527646$var$EventHandler.on(this._element, $68e2a64123527646$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $68e2a64123527646$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $68e2a64123527646$var$enableDismissTrigger($68e2a64123527646$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $68e2a64123527646$var$defineJQueryPlugin($68e2a64123527646$export$8d8dc7d5f743331b);


var $ed1a45b1fdbc7633$export$23344047f1eff04b = /*#__PURE__*/ function(ModalType) {
    ModalType[ModalType["INFO"] = 0] = "INFO";
    ModalType[ModalType["CONFIRM"] = 1] = "CONFIRM";
    ModalType[ModalType["CUSTOM"] = 2] = "CUSTOM";
    ModalType[ModalType["FOOTLESS"] = 3] = "FOOTLESS";
    return ModalType;
}({});
function $ed1a45b1fdbc7633$var$createModal(opt) {
    const $modal = document.createElement("div");
    $modal.classList.add("modal");
    let buttonHtml = "";
    if (typeof opt.type == "undefined" || opt.type == 0) buttonHtml += `<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>`;
    else if (opt.type == 1) {
        buttonHtml += `<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Anuluj</button>`;
        buttonHtml += `<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Potwied\u{17A}</button>`;
    } else if (opt.type == 2) for (const entry of opt.options){
        const cl = entry.class ?? "secondary";
        buttonHtml += `<button type="button" class="btn btn-${cl}" data-bs-dismiss="modal">${entry.text}</button>`;
    }
    let footer = `<div class="modal-footer">${buttonHtml}</div>`;
    if (opt.type == 3) footer = "";
    $modal.innerHTML = `
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">${opt.title ?? "Uwaga"}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        ${opt.content}
      </div>
      ${footer}
    </div>
  </div>`;
    return $modal;
}
function $ed1a45b1fdbc7633$export$d7e8d4d4450c819c(opt) {
    const modal = $ed1a45b1fdbc7633$var$createModal(opt);
    document.body.appendChild(modal);
    if (typeof opt.type == "undefined") opt.type = 0;
    const m = new $68e2a64123527646$export$2b77a92f1a5ad772(modal, {
        backdrop: typeof opt.type == "undefined" || opt.type == 0 ? true : "static"
    });
    if (opt.type == 0 && opt.confirmClb) modal.addEventListener("hide.bs.modal", opt.confirmClb);
    else if (opt.type == 1) {
        if (opt.denyClb) {
            modal.querySelector(".btn-close")?.addEventListener("click", opt.denyClb);
            modal.querySelector(".btn-secondary")?.addEventListener("click", opt.denyClb);
        }
        if (opt.confirmClb) modal.querySelector(".btn-primary")?.addEventListener("click", opt.confirmClb);
    } else if (opt.type == 2) {
        let currBtt = modal.querySelector(".modal-footer")?.firstElementChild;
        for (const entry of opt.options){
            currBtt?.addEventListener("click", entry.clb);
            currBtt = currBtt?.nextSibling;
        }
    }
    modal.addEventListener("hidden.bs.modal", ()=>{
        m.dispose();
        document.body.removeChild(modal);
    });
    m.show();
    modal.querySelector(".modal-footer button")?.focus();
    return [
        m,
        modal
    ];
}


const $ae0fe12872f74041$var$STORAGE_KEY = `margoworld-eq-set-v1`;
function $ae0fe12872f74041$var$isAllowedEqItem(it) {
    return (0, $d98f7bb170da977b$export$b8192a0e534cca2b).includes(it.cl) || it.extendedID?.startsWith("blessing:");
}
function $ae0fe12872f74041$export$bec289829c0e6530() {
    if (!$ae0fe12872f74041$var$checkSetExists()) {
        // Eq set building disabled on current page - check for summary
        if (document.querySelector(".eq-set-summary")) {
            document.querySelector(".eq-set-summary").innerHTML = $ae0fe12872f74041$var$buildEqSetSummary();
            const btt = document.querySelector("#set-save-btt");
            btt.innerHTML = "Edytuj zestaw";
            btt.addEventListener("click", $ae0fe12872f74041$var$saveSetAsOwn);
        }
        return;
    }
    const items = $ae0fe12872f74041$var$readStoredItems().filter($ae0fe12872f74041$var$isAllowedEqItem);
    items.forEach($ae0fe12872f74041$var$insertEqItemElement);
    document.addEventListener("contextmenu", (e)=>{
        if (e.target instanceof HTMLElement) {
            let it = e.target.closest(".margonem_item");
            if (!it && e.target.closest(".item") && e.target.closest(".item-display")) it = e.target.closest(".item-display");
            if (it && $ae0fe12872f74041$var$checkSetExists() && !e.ctrlKey) {
                $ae0fe12872f74041$var$onItemClick(it);
                e.preventDefault();
            }
        }
    });
    document.querySelector(".eq-set-controls .btn-primary").addEventListener("click", ()=>{
        const ids = $ae0fe12872f74041$var$readStoredItems().map((it)=>it.extendedID ?? it.id);
        location.href = `/item/set/${ids.join(",")}`;
    });
    document.querySelector(".eq-set-controls .btn-danger").addEventListener("click", ()=>{
        (0, $ed1a45b1fdbc7633$export$d7e8d4d4450c819c)({
            type: (0, $ed1a45b1fdbc7633$export$23344047f1eff04b).CUSTOM,
            content: "Czy na pewno chcesz wyczy\u015Bci\u0107 aktualny zestaw ekwipunku?",
            options: [
                {
                    text: "Anuluj",
                    clb () {}
                },
                {
                    class: "danger",
                    text: "Potwierd\u017A",
                    clb () {
                        for (const it of $ae0fe12872f74041$var$readStoredItems())$ae0fe12872f74041$var$removeEqItem(it);
                        document.querySelectorAll(".eq-set-items .itemborder").forEach((el)=>el.remove());
                    }
                }
            ]
        });
    });
}
function $ae0fe12872f74041$export$7181e7951a8977f8(slot) {
    return $ae0fe12872f74041$var$readStoredItems().find((it)=>(0, $d98f7bb170da977b$export$36bf99e3bdf4469)[it.cl] == slot);
}
const $ae0fe12872f74041$var$summableStats = [
    "ac",
    "acdmg",
    "resacdmg",
    "absorb",
    "absorbm",
    "abdest",
    "resfire",
    "resfrost",
    "reslight",
    "act",
    "resdmg",
    "crit",
    "lowcrit",
    "critval",
    "critmval",
    "lowcritallval",
    "ds",
    "dz",
    "di",
    "da",
    "energybon",
    "endest",
    "manabon",
    "manadest",
    "resmanaendest",
    "hp",
    "heal",
    "lowheal2turns",
    "adest",
    "evade",
    "lowevade",
    "blok",
    "sa",
    "slow",
    "fire",
    "frost",
    "light",
    "dmg",
    "contra",
    "pierce",
    "pierceb",
    "wound",
    "poison",
    "legbon",
    "manafatig",
    "enfatig",
    "socket_injection_legbon",
    "socket_fleeting_legbon"
];
const $ae0fe12872f74041$var$StatOrder = [
    "ac",
    "abdest",
    "acdmg",
    "act",
    "adest",
    "ammo",
    "binds",
    "blok",
    "cansplit",
    "capacity",
    "crit",
    "critmval",
    "critval",
    "da",
    "dmg",
    "di",
    "ds",
    "dz",
    "endest",
    "enfatig",
    "energybon",
    "evade",
    "fire",
    "light",
    "frost",
    "heal",
    "hp",
    "hpbon",
    "legbon",
    "lowcrit",
    "lowevade",
    "amount",
    "cansplit",
    "capacity",
    "cursed",
    "lvl",
    "lvlnext",
    "lvlupgcost",
    "lvlupgs",
    "manabon",
    "manadest",
    "manafatig",
    "opis",
    "pdmg",
    "permbound",
    "pierce",
    "poison",
    "pierceb",
    "lowheal2turns",
    "resacdmg",
    "lowcritallval",
    "resmanaendest",
    "rarity",
    "reqp",
    "resdmg",
    "resfire",
    "resfrost",
    "reslight",
    "sa",
    "slow",
    "wound",
    "absorb",
    "absorbm"
];
function $ae0fe12872f74041$var$getEqItems() {
    return Array.from(document.querySelectorAll(".eq-set-items .margonem_item")).map((el)=>JSON.parse(el.getAttribute("data-itemtip")));
}
function $ae0fe12872f74041$var$saveSetAsOwn() {
    $ae0fe12872f74041$var$getEqItems().forEach($ae0fe12872f74041$var$saveEqItem);
    location.href = "/item";
}
function $ae0fe12872f74041$var$buildEqSetSummary() {
    const items = $ae0fe12872f74041$var$getEqItems();
    const nSections = 16;
    const summedStats = {};
    const legbons = [];
    const wounds = [];
    const profs = [
        "w",
        "b",
        "h",
        "m",
        "p",
        "t"
    ];
    for (const it of items){
        const stat = (0, $d98f7bb170da977b$export$255e9553606c7f5)(it.stat);
        for(const key in stat){
            if (key == "reqp") for(let i = 0; i < profs.length; ++i){
                const p = profs[i];
                if (!stat[key].includes(p)) {
                    profs.splice(i, 1);
                    --i;
                }
            }
            if (!$ae0fe12872f74041$var$summableStats.includes(key)) continue;
            const val = stat[key];
            if (key == "legbon" || key == "socket_fleeting_legbon" || key == "socket_injection_legbon") legbons.push(val);
            else if (key == "wound") wounds.push(val);
            else if (key == "frost" || key == "poison") {
                if (summedStats[key]) {
                    const [slow, dmg] = val.split(",");
                    const [existingSlow, existingDmg] = summedStats[key].split(",");
                    const newDmg = parseInt(dmg) + parseInt(existingDmg);
                    const newSlow = Math.max(parseInt(slow), parseInt(existingSlow));
                    summedStats[key] = `${newSlow},${newDmg}`;
                } else summedStats[key] = val;
            } else if (key == "light" || key == "dmg") {
                if (summedStats[key]) {
                    const [minDmg1, maxDmg1] = val.split(",");
                    const [minDmg2, maxDmg2] = summedStats[key].split(",");
                    summedStats[key] = `${parseInt(minDmg1) + parseInt(minDmg2)},${parseInt(maxDmg1) + parseInt(maxDmg2)}`;
                } else summedStats[key] = val;
            } else if (key == "enfatig" || key == "manafatig") {
                const existing = summedStats[key];
                if (existing) {
                    const [chance1, val1] = existing.split(",");
                    const [chance2, val2] = val.split(",");
                    const totalChance = Math.min(100, Number(chance1) + Number(chance2));
                    const totalVal = val1 > val2 ? val1 : val2;
                    summedStats[key] = `${totalChance},${totalVal}`;
                } else summedStats[key] = val;
            } else summedStats[key] = String((summedStats[key] ? parseInt(summedStats[key]) : 0) + parseInt(val));
        }
    }
    // @ts-ignore
    const h = createTipSectionsObject();
    const allSections = [];
    for(let i = 0; i < nSections; ++i)allSections[i] = "";
    const turboSwitchWrapper = (sections, stats)=>{
        // @ts-ignore
        const section = createTipSectionsObject();
        // @ts-ignore
        window.MargoTipsParser.turboSwich(section, h, {
            stat: stats
        });
        for(let i = 0; i < nSections; ++i){
            const data = section.getSectionDataByIndex(i);
            if (data && Object.keys(data)) for(const key in data)sections[i] += data[key];
        }
    };
    for (const key of $ae0fe12872f74041$var$StatOrder){
        if (key == "wound") for (const wnd of wounds){
            const sections = [];
            for(let i = 0; i < nSections; ++i)sections[i] = "";
            turboSwitchWrapper(sections, `wound=${wnd}`);
            for(let i = 0; i < 10; ++i)allSections[i] += sections[i];
        }
        if (summedStats[key]) {
            const sections = [];
            for(let i = 0; i < nSections; ++i)sections[i] = "";
            turboSwitchWrapper(sections, `${key}=${summedStats[key]}`);
            if (key == "absorb" || key == "absorbm") {
                sections[1] = sections[3];
                sections[3] = "";
            }
            if (key == "dmg") {
                sections[2] = sections[1];
                sections[1] = "";
            }
            for(let i = 0; i < 10; ++i)allSections[i] += sections[i];
        }
    }
    for (const legbon of legbons)// @ts-ignore
    turboSwitchWrapper(allSections, `legbon=${legbon}`);
    if (profs.length) turboSwitchWrapper(allSections, `reqp=${profs.join("")}`);
    else allSections[9] += `<span style="color:red">Zestaw zawiera konflikt profesji</span>`;
    for(let i = 0; i < nSections; ++i)if (allSections[i]) allSections[i] = `<div class="item-tip-section s-${i}">${allSections[i]}</div>`;
    return `<div data-type="t_item" class="summary static custom tip-wrapper normal-tip">
        <div class="content">
            <b>Statystyki zestawu ekwipunku</b>
            ${allSections.join("")}
        </div>
    </div>`;
}
function $ae0fe12872f74041$var$onItemClick(it) {
    const itemData = JSON.parse(it.getAttribute("data-itemtip") ?? it.getAttribute("data-item"));
    if ($ae0fe12872f74041$export$cabece90997f601a(itemData)) {
        if ($ae0fe12872f74041$var$isAllowedEqItem(itemData)) {
            if (it.closest(".eq-set-items")) {
                it.closest(".itemborder")?.remove();
                $ae0fe12872f74041$var$removeEqItem(itemData);
            } else {
                $ae0fe12872f74041$var$saveEqItem(itemData);
                $ae0fe12872f74041$var$insertEqItemElement(itemData);
            }
        } else if (itemData.cl == (0, $d98f7bb170da977b$export$99a5dceb42a0a5f5).BLESSING) (0, $ed1a45b1fdbc7633$export$d7e8d4d4450c819c)({
            content: 'Z przyczyn technicznych, dodawanie b\u0142ogos\u0142awie\u0144stw do ekwipunku jest mo\u017Cliwe tylko za pomoc\u0105 <a href="/item/blessing">specjalnego edytora</a>.'
        });
    }
}
function $ae0fe12872f74041$var$saveEqItem(it) {
    if ($ae0fe12872f74041$var$isAllowedEqItem(it)) {
        const items = $ae0fe12872f74041$var$readStoredItems();
        const slot = (0, $d98f7bb170da977b$export$36bf99e3bdf4469)[it.cl];
        const ind = items.findIndex((it)=>(0, $d98f7bb170da977b$export$36bf99e3bdf4469)[it.cl] == slot);
        if (ind > -1) items.splice(ind, 1);
        items.push(it);
        localStorage.setItem($ae0fe12872f74041$var$STORAGE_KEY, JSON.stringify(items));
    }
}
function $ae0fe12872f74041$var$removeEqItem(it) {
    const items = $ae0fe12872f74041$var$readStoredItems();
    const ind = items.findIndex((eqIt)=>eqIt.id == it.id);
    if (ind > -1) {
        items.splice(ind, 1);
        localStorage.setItem($ae0fe12872f74041$var$STORAGE_KEY, JSON.stringify(items));
    }
}
function $ae0fe12872f74041$var$checkSetExists() {
    return !!document.querySelector(".eq-set-items.builder");
}
function $ae0fe12872f74041$var$insertEqItemElement(it) {
    const wrapper = document.querySelector(".eq-set-items");
    if (!wrapper) {
        console.error(`insertEqItemElement called but eq-set-items does not exist on current page`);
        return;
    }
    const item = (0, $d98f7bb170da977b$export$e182542ab2c7fe12)(it);
    (0, $af478be0a72c5018$export$f5a31eaa781a5329)(item.querySelector(".margonem_item"), it, (0, $d98f7bb170da977b$export$255e9553606c7f5)(it.stat));
    const cl = `item-slot-${(0, $d98f7bb170da977b$export$36bf99e3bdf4469)[it.cl]}`;
    wrapper.querySelector(`.${cl}`)?.remove();
    item.classList.add(cl);
    wrapper.appendChild(item);
}
function $ae0fe12872f74041$var$verifyProps(data, props, type) {
    return !Object.keys(data).filter((p)=>props.includes(p)).some((p)=>typeof data[p] != type);
}
function $ae0fe12872f74041$var$verifyArray(arr, predicate) {
    return Array.isArray(arr) && !arr.some((val)=>!predicate(val));
}
function $ae0fe12872f74041$export$cabece90997f601a(data) {
    return $ae0fe12872f74041$var$verifyProps(data, [
        "id",
        "cl",
        "st",
        "version"
    ], "number") && $ae0fe12872f74041$var$verifyProps(data, [
        "icon",
        "stat"
    ], "string") && (data.pr == "" || typeof data.pr == "number");
}
function $ae0fe12872f74041$var$readStoredItems() {
    const itemData = localStorage.getItem($ae0fe12872f74041$var$STORAGE_KEY);
    if (!itemData) return [];
    try {
        const items = JSON.parse(itemData);
        if ($ae0fe12872f74041$var$verifyArray(items, $ae0fe12872f74041$export$cabece90997f601a) && items.length <= 9) return items;
        else {
            console.log(itemData, items);
            console.error(`Invalid item schema`);
            return [];
        }
    } catch (e) {
        console.error(`Stored item data is corrupted`, e);
        return [];
    }
}






const $0cc6883c437a790b$var$currentTip = {
    owner: null,
    el: null,
    posEl: null
};
function $0cc6883c437a790b$var$createBasicTip(txt, type = "t_npc") {
    const tip = document.createElement("div");
    tip.classList.add("tip-wrapper", "normal-tip", "custom");
    tip.dataset.type = type;
    tip.innerHTML = `<div class="content">${txt}</div>`;
    return tip;
}
function $0cc6883c437a790b$var$getItemRarity(item) {
    const st = (0, $d98f7bb170da977b$export$255e9553606c7f5)(item.stat);
    return st.rarity ?? "common";
}
function $0cc6883c437a790b$var$createBasicTipFromElement(el, type = "t_npc") {
    const tip = document.createElement("div");
    tip.classList.add("tip-wrapper", "normal-tip", "custom");
    tip.dataset.type = type;
    tip.appendChild(el);
    return tip;
}
const $0cc6883c437a790b$var$helper = document.createElement("div");
function $0cc6883c437a790b$var$getItemTip(item) {
    const baseHtml = window.MargoTipsParser.getTip(item);
    $0cc6883c437a790b$var$helper.innerHTML = `<div class="content">${baseHtml}</div>`;
    const head = $0cc6883c437a790b$var$helper.querySelector(".item-head");
    if (head instanceof HTMLElement) {
        const icon = document.createElement("span");
        icon.classList.add("item");
        const img = document.createElement("img");
        img.src = (0, $c2bdc760a1d746cf$export$2cc7ae7d4fb97c35).itemPath + item.icon;
        img.classList.add("margonem_item", `rarity-${$0cc6883c437a790b$var$getItemRarity(item)}`);
        icon.appendChild(img);
        head.prepend(icon);
    }
    const value = $0cc6883c437a790b$var$helper.querySelector(".value-item");
    const level = $0cc6883c437a790b$var$helper.querySelector(".level-required");
    if (value && level) {
        const wrapper = document.createElement("div");
        wrapper.classList.add("level-and-value");
        level.parentElement.insertBefore(wrapper, level);
        wrapper.appendChild(level);
        wrapper.appendChild(value);
    }
    return $0cc6883c437a790b$var$helper.firstChild;
}
function $0cc6883c437a790b$var$clamp(n1, n2, n3) {
    return Math.max(n1, Math.min(n2, n3));
}
function $0cc6883c437a790b$var$getPagePositionFromEvent(e) {
    if (e instanceof MouseEvent) return {
        x: e.pageX,
        y: e.pageY
    };
    else {
        let x = 0, y = 0, count = e.touches.length;
        for(let i = 0; i < count; ++i){
            const touch = e.touches.item(i);
            x += touch.pageX;
            y += touch.pageY;
        }
        x = x / count;
        y = y / count;
        return {
            x: x,
            y: y
        };
    }
}
function $0cc6883c437a790b$var$positionTip(tip, e, positionEl) {
    const maxX = document.body.scrollWidth;
    const maxY = document.body.scrollHeight;
    const w = tip.offsetWidth;
    const h = tip.offsetHeight;
    const pos = $0cc6883c437a790b$var$getPagePositionFromEvent(e);
    const x = pos.x;
    const y = pos.y;
    let left = 0;
    let top = 0;
    let flipX = 1;
    let flipY = 1;
    if (x + 15 + w > maxX) {
        left = x - 15 - w;
        flipX = -1;
    } else left = x + 15;
    if (y + 15 + h > maxY) {
        top = y - 15 - h;
        flipY = -1;
    } else top = y + 15;
    if (positionEl && positionEl != tip) {
        left -= positionEl.offsetLeft * flipX;
        top -= positionEl.offsetTop * flipY;
    }
    tip.style.left = $0cc6883c437a790b$var$clamp(10, left, maxX - w - 10) + "px";
    tip.style.top = $0cc6883c437a790b$var$clamp(10, top, maxY - h - 10) + "px";
}
function $0cc6883c437a790b$var$removeExistingTips() {
    Array.from(document.querySelectorAll(".tip-wrapper:not(.static)")).forEach((node)=>node.remove());
}
function $0cc6883c437a790b$var$createComparisonNote() {
    const el = document.createElement("div");
    el.classList.add("tip-comparison-note");
    el.innerText = "Przedmiot z zestawu ekwipunku.";
    return el;
}
function $0cc6883c437a790b$export$f0528aa6decdc692($el) {
    $el.querySelector(".content").prepend($0cc6883c437a790b$var$createComparisonNote());
}
function $0cc6883c437a790b$var$addTip(e, tipEl, owner, posEl) {
    $0cc6883c437a790b$var$removeExistingTips();
    document.body.appendChild(tipEl);
    $0cc6883c437a790b$var$currentTip.owner = owner;
    $0cc6883c437a790b$var$currentTip.el = tipEl;
    $0cc6883c437a790b$var$currentTip.posEl = posEl;
    $0cc6883c437a790b$var$positionTip(tipEl, e, posEl);
}
function $0cc6883c437a790b$var$clearTip() {
    $0cc6883c437a790b$var$currentTip.el.remove();
    $0cc6883c437a790b$var$currentTip.owner = null;
    $0cc6883c437a790b$var$currentTip.el = null;
    $0cc6883c437a790b$var$currentTip.posEl = null;
}
function $0cc6883c437a790b$var$tipStart(e) {
    if (!(e.target instanceof HTMLElement)) {
        console.log("Not html element...?", e.target);
        return;
    }
    // Comparison tips get rather big - disable them on mobile
    const isComparisonAllowed = window.innerWidth >= 768;
    const tipEl = e.target.closest("[data-tip]");
    if (tipEl && tipEl instanceof HTMLElement) {
        const tip = $0cc6883c437a790b$var$createBasicTip(tipEl.dataset.tip, tipEl.dataset.ctip ?? "t_npc");
        $0cc6883c437a790b$var$addTip(e, tip, tipEl);
    } else {
        const itemTipEl = e.target.closest("[data-itemtip]");
        if (itemTipEl && itemTipEl instanceof HTMLElement) {
            const item = JSON.parse(itemTipEl.dataset.itemtip);
            const tipContent = $0cc6883c437a790b$var$getItemTip(item);
            const tip = $0cc6883c437a790b$var$createBasicTipFromElement(tipContent, "t_item");
            tip.setAttribute("data-item-type", $0cc6883c437a790b$var$getItemRarity(item));
            const eqItem = isComparisonAllowed && (0, $ae0fe12872f74041$export$7181e7951a8977f8)((0, $d98f7bb170da977b$export$36bf99e3bdf4469)[item.cl]);
            if (!eqItem || eqItem.id == item.id && eqItem.extendedID == item.extendedID) // Single item tip
            $0cc6883c437a790b$var$addTip(e, tip, itemTipEl);
            else {
                // Double item tip (for comparison)
                const equippedTip = $0cc6883c437a790b$var$createBasicTipFromElement($0cc6883c437a790b$var$getItemTip(eqItem), "t_item");
                $0cc6883c437a790b$export$f0528aa6decdc692(equippedTip);
                equippedTip.setAttribute("data-item-type", $0cc6883c437a790b$var$getItemRarity(eqItem));
                const doubleTip = document.createElement("div");
                doubleTip.classList.add("tip-multiple-wrapper");
                doubleTip.appendChild(equippedTip);
                doubleTip.appendChild(tip);
                $0cc6883c437a790b$var$addTip(e, doubleTip, itemTipEl, tip);
            }
        }
    }
}
function $0cc6883c437a790b$var$tipMove(e) {
    if ($0cc6883c437a790b$var$currentTip.el) {
        if ($0cc6883c437a790b$var$currentTip.owner.closest("body")) $0cc6883c437a790b$var$positionTip($0cc6883c437a790b$var$currentTip.el, e, $0cc6883c437a790b$var$currentTip.posEl);
        else $0cc6883c437a790b$var$clearTip();
    }
}
function $0cc6883c437a790b$var$tipEnd(e) {
    if (!(e.target instanceof HTMLElement) || !$0cc6883c437a790b$var$currentTip.el) return;
    if ((e.target.closest("[data-tip]") ?? e.target.closest("[data-itemtip]")) == $0cc6883c437a790b$var$currentTip.owner && $0cc6883c437a790b$var$currentTip.owner != null) $0cc6883c437a790b$var$clearTip();
}
function $0cc6883c437a790b$export$608e2009510d032b() {
    document.addEventListener("mouseover", $0cc6883c437a790b$var$tipStart);
    document.addEventListener("touchstart", $0cc6883c437a790b$var$tipStart);
    document.addEventListener("mousemove", $0cc6883c437a790b$var$tipMove);
    // document.addEventListener("touchmove", tipMove);
    document.addEventListener("mouseout", $0cc6883c437a790b$var$tipEnd);
    document.addEventListener("touchend", $0cc6883c437a790b$var$tipEnd);
}


const $d66ce17d409dfd7e$var$outfitPreviewOffsets = [
    [
        0,
        0
    ],
    [
        -1,
        0
    ],
    [
        -2,
        0
    ],
    [
        -3,
        0
    ],
    [
        0,
        0
    ],
    [
        -1,
        0
    ],
    [
        -2,
        0
    ],
    [
        -3,
        0
    ],
    [
        0,
        -1
    ],
    [
        -1,
        -1
    ],
    [
        -2,
        -1
    ],
    [
        -3,
        -1
    ],
    [
        0,
        -1
    ],
    [
        -1,
        -1
    ],
    [
        -2,
        -1
    ],
    [
        -3,
        -1
    ],
    [
        0,
        -3
    ],
    [
        -1,
        -3
    ],
    [
        -2,
        -3
    ],
    [
        -3,
        -3
    ],
    [
        0,
        -3
    ],
    [
        -1,
        -3
    ],
    [
        -2,
        -3
    ],
    [
        -3,
        -3
    ],
    [
        0,
        -2
    ],
    [
        -1,
        -2
    ],
    [
        -2,
        -2
    ],
    [
        -3,
        -2
    ],
    [
        0,
        -2
    ],
    [
        -1,
        -2
    ],
    [
        -2,
        -2
    ],
    [
        -3,
        -2
    ]
];
function $d66ce17d409dfd7e$var$lvlAdjustHandler(info) {
    if (!info.data.hasLvlAdjust) {
        info.addLabel("Zmie\u0144 wy\u015Bwietlany poziom:");
        info.addHTML(`<div class="d-flex">`);
        info.addHTML(`<input class="me-1 form-control form-control-sm autolvl-change-input" type="number" value="${info.stat.lvl ?? 1}"> `);
        info.addHTML(`<button class="btn btn-secondary btn-sm autolvl-change-submit" data-item-info="${info.item.id}">Zmie\u{144}</button>`);
        info.addHTML(`</div>`);
        info.data.hasLvlAdjust = true;
    }
}
const $d66ce17d409dfd7e$var$statHandlers = {
    outfit: (info)=>{
        info.addLabel("Podgl\u0105d outfitu");
        const [_time, url] = info.stat.outfit.split(",");
        info.addOutfitPreviews([
            url
        ]);
    },
    outfit_selector: (info)=>{
        info.addLabel("Podgl\u0105d outfit\xf3w do wybrania");
        const urls = info.stat.outfit_selector.split("|").slice(1).map((e)=>e.split(",")[0]);
        info.addOutfitPreviews(urls);
    },
    lvlupgs: $d66ce17d409dfd7e$var$lvlAdjustHandler
};
const $d66ce17d409dfd7e$var$tagHandlers = {
    autolvl: $d66ce17d409dfd7e$var$lvlAdjustHandler
};
function $d66ce17d409dfd7e$var$getCurrentPageItemID() {
    const id = document.location.href.match(/view\/([^/]*)/)?.[1];
    if (!id) return null;
    else return (0, $d98f7bb170da977b$export$60b8e02abc00f28)(id);
}
function $d66ce17d409dfd7e$var$navigateToItemID(id) {
    const urlNamePart = document.location.href.match(/view\/([^/]*)\/(.*)/)?.[2];
    document.location.href = `/item/view/${(0, $d98f7bb170da977b$export$8f4fb6d1d188b3f7)(id)}/${urlNamePart ?? ""}`;
}
function $d66ce17d409dfd7e$var$handleButtonClick($btt) {
    if ($btt.classList.contains("autolvl-change-submit") || $btt.classList.contains("upgrade-change-btn") || $btt.classList.contains("bonus-change-submit")) {
        const info = $d66ce17d409dfd7e$var$getCurrentPageItemID();
        const lvlInput = document.querySelector(".autolvl-change-input");
        // const upgradeInput = (<HTMLInputElement>document.querySelector(".upgrade-change-input"));
        const upgradeLevel = parseInt($btt.dataset.upgrade);
        const bounsInput = document.querySelector(".bonus-change-input");
        if (lvlInput) info.lvlOverride = parseInt(lvlInput.value);
        if (!isNaN(upgradeLevel)) info.upgrade = upgradeLevel;
        if (bounsInput && !bounsInput.getAttribute("disabled")) info.upgradeBonus = bounsInput.value;
        if (info.lvlOverride < 0 || isNaN(info.lvlOverride)) alert(`Niepoprawny poziom przedmiotu!`);
        else if (info.upgrade < 0 || info.upgrade > 5 || isNaN(info.upgrade)) alert(`Niepoprawne ulepszenie przedmiotu!`);
        else $d66ce17d409dfd7e$var$navigateToItemID(info);
    } else if ($btt.classList.contains("compare-item")) {
        const $wrapper = document.querySelector(".item-display-wrapper");
        if (!$wrapper) {
            console.error(`.item-display-wrapper was not found`);
            return;
        }
        $btt.setAttribute("disabled", "");
        $btt.classList.remove("compare-item");
        const item = (0, $ae0fe12872f74041$export$7181e7951a8977f8)((0, $d98f7bb170da977b$export$36bf99e3bdf4469)[parseInt($btt.dataset.cl)]);
        const disp = (0, $af478be0a72c5018$export$e1406d39e5dbc761)(item);
        (0, $0cc6883c437a790b$export$f0528aa6decdc692)(disp);
        $wrapper.prepend(disp);
    }
}
function $d66ce17d409dfd7e$var$handleSymbolClick($symbol) {
    const info = $d66ce17d409dfd7e$var$getCurrentPageItemID();
    if ($symbol.classList.contains("selected")) info.socketContent = 0;
    else info.socketContent = Number($symbol.dataset.symbolId);
    $d66ce17d409dfd7e$var$navigateToItemID(info);
}
class $d66ce17d409dfd7e$export$f7aec1e4f807b604 {
    static{
        this.initDone = false;
    }
    static globalInit() {
        if (this.initDone) return;
        this.initDone = true;
        this.animatePreviews();
        setInterval(this.animatePreviews.bind(this), 200);
        document.addEventListener("click", (e)=>{
            if (e.target instanceof HTMLButtonElement && e.target.dataset.itemInfo) $d66ce17d409dfd7e$var$handleButtonClick(e.target);
            if (e.target instanceof HTMLElement) {
                const symbol = e.target.closest("[data-symbol-id]");
                if (symbol instanceof HTMLElement) $d66ce17d409dfd7e$var$handleSymbolClick(symbol);
            }
        });
    }
    static{
        this.outfitImages = {};
    }
    static{
        this.animationFrame = 0;
    }
    static animatePreviews() {
        for (const $el of Array.from(document.querySelectorAll(".outfit-preview"))){
            const url = (0, $c2bdc760a1d746cf$export$2cc7ae7d4fb97c35).playerPath + $el.dataset.outfit;
            let img = this.outfitImages[url];
            if (!img) {
                img = new Image();
                img.src = url;
                this.outfitImages[url] = img;
            }
            if (img.complete) {
                const h = img.height / 4;
                const w = img.width / 4;
                const x = $d66ce17d409dfd7e$var$outfitPreviewOffsets[this.animationFrame][0] * w + "px";
                const y = $d66ce17d409dfd7e$var$outfitPreviewOffsets[this.animationFrame][1] * h + "px";
                const oy = Math.max(-10, 74 - h);
                if (w > 48) $el.style.width = `${w}px`;
                $el.innerHTML = `<a target="_blank" href="${url}">
                <div class="outfit" style="margin-top: ${oy}px; width: ${w}px; height: ${h}px; background: url(${url}); background-position: ${x} ${y};"></div>
                </a>`;
            }
        }
        this.animationFrame += 1;
        if (this.animationFrame >= $d66ce17d409dfd7e$var$outfitPreviewOffsets.length) this.animationFrame = 0;
    }
    constructor(target, item){
        this.stat = null;
        this.data = {};
        this.html = "";
        this.item = item;
        this.$el = target;
        this.stat = (0, $d98f7bb170da977b$export$255e9553606c7f5)(item.stat);
        this.extendedId = (0, $d98f7bb170da977b$export$60b8e02abc00f28)(item.extendedID ?? String(item.id));
        for(const key in this.stat)if ($d66ce17d409dfd7e$var$statHandlers[key]) $d66ce17d409dfd7e$var$statHandlers[key](this);
        for (const tag of item.tags ?? [])if ($d66ce17d409dfd7e$var$tagHandlers[tag]) $d66ce17d409dfd7e$var$tagHandlers[tag](this);
        if ((0, $d98f7bb170da977b$export$b8192a0e534cca2b).includes(item.cl)) {
            this.addLabel("Poziom ulepszenia:");
            // this.addHTML(`<input type="number" class="upgrade-change-input" value="${this.stat.enhancement_upgrade_lvl ?? "0"}"> `);
            // this.addHTML(`<button data-item-info="${item.id}" class="upgrade-change-submit">Ulepsz</button>`)
            this.addHTML(`<div class="d-flex">`);
            // this.addHTML(`<input class="me-1 form-control form-control-sm upgrade-change-input" type="number"  value="${this.stat.enhancement_upgrade_lvl ?? "0"}"> `);
            // this.addHTML(`<button class="btn btn-secondary btn-sm upgrade-change-submit" data-item-info="${item.id}">Ulepsz</button>`)
            const currentLevel = Number(this.stat.enhancement_upgrade_lvl ?? "0");
            for(let i = 0; i <= 5; ++i){
                const active = currentLevel == i ? " active" : "";
                this.addHTML(`<button data-upgrade="${i}" class="${active} m-1 btn btn-secondary btn-sm upgrade-change-btn" data-item-info="${item.id}">+${i}</button>`);
            }
            this.addHTML(`</div>`);
        }
        const clgrp = (0, $d98f7bb170da977b$export$4d193602f93a7691)(item.cl);
        if (clgrp != (0, $d98f7bb170da977b$export$e2192f3d572f2f9a).NONE) {
            this.addLabel("Wybrany bonus:");
            const disabled = this.stat.enhancement_upgrade_lvl == "5" ? "" : "disabled";
            const bonuses = (0, $d98f7bb170da977b$export$f6af1e710a16481)(clgrp);
            const bonus = this.stat.bonus ? this.stat.bonus.split(",")[0] : "";
            const bonusesHtmlOptions = bonuses.map((b)=>`<option ${b == bonus ? "selected" : ""} value="${b}">${(0, $d98f7bb170da977b$export$76a5ab8b5cb8be92)(b)}</option>`).join("");
            this.addHTML(`<div class="d-flex">`);
            this.addHTML(`<select style="max-width:250px;" ${disabled} class="me-1 form-control form-control-sm bonus-change-input" type="number">`);
            this.addHTML(`<option value="">Brak${disabled ? " - ulepsz najpierw na +5" : ""}</option>`);
            this.addHTML(bonusesHtmlOptions);
            this.addHTML(`</select>`);
            this.addHTML(`<button ${disabled} class="btn btn-secondary btn-sm bonus-change-submit" data-item-info="${item.id}">Zmie\u{144}</button>`);
            this.addHTML(`</div>`);
        }
        if (target.dataset.availableSymbols) {
            const availableSymbols = JSON.parse(target.dataset.availableSymbols);
            if (availableSymbols.length) {
                this.addLabel("Wybrany symbol:");
                this.addHTML(`<div class="d-flex symbol-selector">`);
                for (const symbol of availableSymbols){
                    const activeSymbolClass = symbol.id == this.extendedId.socketContent ? "selected" : "";
                    // ID is negated to prevent link generation
                    symbol.id = -symbol.id;
                    this.addHTML((0, $d98f7bb170da977b$export$56b9510f95bec47f)(symbol, `data-symbol-id="${-symbol.id}"`, activeSymbolClass));
                }
                this.addHTML(`</div>`);
            }
        }
        if (target.hasAttribute("compare")) {
            const it = (0, $ae0fe12872f74041$export$7181e7951a8977f8)((0, $d98f7bb170da977b$export$36bf99e3bdf4469)[item.cl]);
            if (it && it.cl != (0, $d98f7bb170da977b$export$99a5dceb42a0a5f5).BLESSING && (it.id != item.id || it.extendedID != item.extendedID)) this.addHTML(`<button data-cl="${item.cl}" class="btn btn-sm btn-secondary compare-item mt-3" data-item-info="${item.id}">Por\xf3wnaj z przedmiotem z zestawu</button>`);
        }
        this.finalize();
    }
    addLabel(text) {
        this.html += `<h3>${text}</h3>`;
    }
    addOutfitPreviews(urls) {
        this.html += `<div class="outfit-preview-wrapper">`;
        for (const url of urls)this.html += `<div class="outfit-preview" data-outfit="${url}"></div>`;
        this.html += `</div>`;
    }
    finalize() {
        this.$el.innerHTML = this.html;
    }
    addHTML(html) {
        this.html += html;
    }
}


function $09054ec50e638aa9$var$findExtendedInfoTargets(el) {
    return Array.from((el ?? document).querySelectorAll(".extended-item-info"));
}
function $09054ec50e638aa9$var$findAssociatedItem(el) {
    const itEl = document.querySelector(`[data-item-id="${el.dataset.targetItem}"]`);
    if (!itEl) {
        console.error(`extended-info-loader: target item not found for element:`, el);
        return null;
    } else {
        const itJson = itEl.dataset.item ?? itEl.dataset.itemtip;
        try {
            return JSON.parse(itJson);
        } catch (e) {
            console.error(`extended-item-loader: item data not found or malformed for: `, el, e);
        }
    }
}
function $09054ec50e638aa9$export$793750adf3040f02(parent) {
    const els = $09054ec50e638aa9$var$findExtendedInfoTargets(parent);
    for (const el of els){
        const it = $09054ec50e638aa9$var$findAssociatedItem(el);
        if (it) new (0, $d66ce17d409dfd7e$export$f7aec1e4f807b604)(el, it);
    }
    (0, $d66ce17d409dfd7e$export$f7aec1e4f807b604).globalInit();
}



function $958a0f03abf1ab62$var$getEditorValue() {
    const editor = document.querySelector("#editor");
    if (editor instanceof HTMLTextAreaElement) return editor.value;
    return "";
}
function $958a0f03abf1ab62$var$updatePreview(html) {
    const preview = document.querySelector("#preview");
    preview.innerHTML = html;
    (0, $af478be0a72c5018$export$1222dfd87f1fe5fe)(preview);
    (0, $09054ec50e638aa9$export$793750adf3040f02)(preview);
}
async function $958a0f03abf1ab62$var$postUpdatePreview() {
    const url = `/admin/mdContent/preview`;
    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: `data=${encodeURIComponent($958a0f03abf1ab62$var$getEditorValue())}`
    });
    const text = await res.text();
    $958a0f03abf1ab62$var$updatePreview(text);
}
const $958a0f03abf1ab62$var$$helper = document.createElement("div");
$958a0f03abf1ab62$var$$helper.style.overflowY = "auto";
$958a0f03abf1ab62$var$$helper.style.height = "80vh";
let $958a0f03abf1ab62$var$$editor;
let $958a0f03abf1ab62$var$caretPos = 0;
function $958a0f03abf1ab62$var$parseSearchResult(data) {
    const $resultWrapper = $958a0f03abf1ab62$var$$helper.querySelector("div");
    const npcs = data.npc ? data.npc : [];
    const items = data.item ? data.item : [];
    const mapNames = data.mapNames ?? {};
    const maps = data.maps ?? {};
    let html = "";
    for (let npc of npcs)html += `<tr tabindex="0" data-write="NPC#${npc.id}"><td>${(0, $00425124515acdd6$export$f81261b02454add1)(npc, npc.nick, `tabindex="-1"`)} (${npc.lvl}lvl) - ${mapNames[npc.map]} (${npc.x},${npc.y})</td></tr>`;
    for (let item of items)html += `<tr tabindex="0" data-write="ITEM#${item.id}"><td>${(0, $d98f7bb170da977b$export$56b9510f95bec47f)(item, `tabindex="-1"`)} ${item.name}</td></tr>`;
    for(const id in maps)html += `<tr tabindex="0" data-write="MAP#${id}"><td>${(0, $b1b3a5b6a44c1945$export$644eb82018f2a00b)(parseInt(id), maps[id])}</td></tr>`;
    let extraInfo = "";
    if (data.error) extraInfo = `<i>${data.error}</i>`;
    else if (!html) extraInfo = "<i>Brak wynik\xf3w</i>";
    html = "<table style='width:100%;'>" + html + "</table>" + extraInfo;
    $resultWrapper.innerHTML = html;
    $resultWrapper.querySelector("tr")?.focus();
}
function $958a0f03abf1ab62$var$initSearchHelper() {
    const $input = document.createElement("input");
    $input.classList.add("form-control", "form-control-sm", "w-25", "m-auto");
    $958a0f03abf1ab62$var$$helper.appendChild(document.createTextNode("Wyszukaj npc, item lub map"));
    $958a0f03abf1ab62$var$$helper.appendChild(document.createElement("br"));
    $958a0f03abf1ab62$var$$helper.appendChild($input);
    const $searchResult = document.createElement("div");
    $958a0f03abf1ab62$var$$helper.appendChild($searchResult);
    function finishSearch(text, e) {
        $958a0f03abf1ab62$var$$editor.value = $958a0f03abf1ab62$var$$editor.value.substring(0, $958a0f03abf1ab62$var$caretPos) + text + $958a0f03abf1ab62$var$$editor.value.substring($958a0f03abf1ab62$var$caretPos);
        $958a0f03abf1ab62$var$$helper.style.display = "none";
        $958a0f03abf1ab62$var$$editor.setSelectionRange($958a0f03abf1ab62$var$caretPos + text.length, $958a0f03abf1ab62$var$caretPos + text.length, "none");
        $958a0f03abf1ab62$var$$editor.focus();
        e.preventDefault();
    }
    $searchResult.addEventListener("keydown", (e)=>{
        const focused = $searchResult.querySelector(":focus");
        if (e.key == "ArrowDown") {
            // @ts-ignore
            focused.nextElementSibling?.focus();
            e.preventDefault();
        } else if (e.key == "ArrowUp") {
            if (focused.previousElementSibling) // @ts-ignore
            focused.previousElementSibling.focus();
            else $input.focus();
            e.preventDefault();
        } else if (e.key == "Enter") {
            const text = focused.getAttribute("data-write");
            finishSearch(text, e);
        }
    });
    $searchResult.addEventListener("click", (e)=>{
        if (e.target instanceof HTMLElement) {
            const tr = e.target.closest("tr");
            if (tr) {
                const text = tr.getAttribute("data-write");
                finishSearch(text, e);
            }
        }
    });
    Object.assign($958a0f03abf1ab62$var$$helper.style, {
        position: "fixed",
        top: "100px",
        display: "none",
        width: "100%",
        textAlign: "center",
        padding: "10px",
        background: "rgba(0, 0, 0, 0.7)"
    });
    $input.addEventListener("keydown", async (e)=>{
        if (e.key == "Enter") {
            const res = await fetch("/admin/mdContent/search", {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                method: "POST",
                body: `q=${encodeURIComponent($input.value)}`
            });
            const json = await res.json();
            $958a0f03abf1ab62$var$parseSearchResult(json);
        } else if (e.key == "Escape") {
            $958a0f03abf1ab62$var$$helper.style.display = "none";
            $958a0f03abf1ab62$var$$editor.focus();
        }
    });
    document.body.appendChild($958a0f03abf1ab62$var$$helper);
}
function $958a0f03abf1ab62$var$showSearchHelper() {
    $958a0f03abf1ab62$var$caretPos = $958a0f03abf1ab62$var$$editor.selectionStart;
    $958a0f03abf1ab62$var$$helper.querySelector("div").innerHTML = "";
    $958a0f03abf1ab62$var$$helper.querySelector("input").value = "";
    $958a0f03abf1ab62$var$$helper.style.display = "block";
    $958a0f03abf1ab62$var$$helper.querySelector("input").focus();
}
function $958a0f03abf1ab62$export$3db423af1e2d51d0() {
    $958a0f03abf1ab62$var$$editor = document.querySelector("#editor");
    $958a0f03abf1ab62$var$initSearchHelper();
    if ($958a0f03abf1ab62$var$$editor instanceof HTMLTextAreaElement) {
        let changeTimeout = 0;
        $958a0f03abf1ab62$var$$editor.addEventListener("keyup", ()=>{
            if (changeTimeout) clearTimeout(changeTimeout);
            changeTimeout = window.setTimeout(()=>{
                $958a0f03abf1ab62$var$postUpdatePreview();
                changeTimeout = 0;
            }, 500);
        });
        $958a0f03abf1ab62$var$$editor.addEventListener("keypress", (e)=>{
            if (e.ctrlKey && e.code == "KeyI") $958a0f03abf1ab62$var$showSearchHelper();
        });
    }
}


const $85e05e42af88da43$var$DEMO_MODE = false;
function $85e05e42af88da43$var$setupConsentLink() {
    if (typeof window["__tcfapi"] == "undefined") // Consent API was not loaded by NitroAds, which means that it's not needed
    return true;
    const consentElement = document.querySelector(".consent-link-wrapper");
    if (!consentElement) return false;
    const a = document.createElement("a");
    a.setAttribute("href", "javascript:void 0");
    a.innerHTML = "Zaktualizuj preferencje cookies";
    a.addEventListener("click", ()=>{
        // @ts-ignore
        window.__cmp("showModal");
    });
    consentElement.appendChild(a);
    return true;
}
function $85e05e42af88da43$var$createRailAd(side) {
    window["nitroAds"].createAd(`ad-${side}-rail`, {
        demo: $85e05e42af88da43$var$DEMO_MODE,
        refreshTime: 30,
        format: "rail",
        rail: side,
        railOffsetTop: 0,
        railOffsetBottom: 0,
        railCollisionWhitelist: [
            ".no-rail-collision"
        ],
        sizes: [
            [
                "160",
                "600"
            ],
            [
                "300",
                "600"
            ]
        ],
        report: {
            enabled: true,
            icon: true,
            wording: "Report Ad",
            position: `bottom-${side}`
        },
        mediaQuery: "(min-width: 1025px), (min-width: 768px) and (max-width: 1024px)"
    });
}
function $85e05e42af88da43$var$fixRailCollisions() {
    // Margoworld does not use iframes, any iframes present are some weird loaders which should not collide
    const frames = document.querySelectorAll("iframe");
    for (const frame of Array.from(frames))frame.classList.add("no-rail-collision");
}
function $85e05e42af88da43$var$createBannerAd(container) {
    const id = container.getAttribute("id");
    if (typeof id != "string") {
        console.error(`createBannerAd: invalid id: ${id}`, container);
        return;
    }
    try {
        const sizes = JSON.parse(container.dataset.sizes);
        window["nitroAds"].createAd(id, {
            demo: $85e05e42af88da43$var$DEMO_MODE,
            refreshTime: 30,
            renderVisibleOnly: false,
            sizes: sizes,
            report: {
                enabled: true,
                icon: true,
                wording: "Report Ad",
                position: "bottom-right"
            },
            mediaQuery: container.dataset.query
        });
    } catch (e) {
        console.error(`createBannerAd failed: `, e);
    }
}
function $85e05e42af88da43$var$createAnchorAd() {
    window["nitroAds"].createAd("ad-mobile-anchor", {
        demo: $85e05e42af88da43$var$DEMO_MODE,
        refreshTime: 30,
        format: "anchor",
        anchor: "bottom",
        anchorPersistClose: false,
        report: {
            enabled: true,
            icon: true,
            wording: "Report Ad",
            position: "top-right"
        },
        mediaQuery: "(min-width: 320px) and (max-width: 767px)"
    });
    // Add bottom margin to footer, in order to make it visible
    const footer = document.querySelector("footer");
    if (footer) footer.style.marginBottom = "50px";
}
function $85e05e42af88da43$var$setupAds() {
    $85e05e42af88da43$var$fixRailCollisions();
    // Rail ads
    $85e05e42af88da43$var$createRailAd("left");
    $85e05e42af88da43$var$createRailAd("right");
    $85e05e42af88da43$var$createAnchorAd();
    for (const section of Array.from(document.querySelectorAll(".ad-section")))if (section instanceof HTMLDivElement) section.style.display = "block";
    for (const container of Array.from(document.querySelectorAll(".ad-banner-container")))if (container instanceof HTMLDivElement) $85e05e42af88da43$var$createBannerAd(container);
}
function $85e05e42af88da43$var$onAdsLoaded() {
    if (!$85e05e42af88da43$var$setupConsentLink()) {
        console.error(`Consent setup failed; not proceeding with ad code`);
        return;
    }
    $85e05e42af88da43$var$setupAds();
}
function $85e05e42af88da43$export$53266e3b62621cca() {
    if (window["nitroAds"] && window["nitroAds"].loaded) $85e05e42af88da43$var$onAdsLoaded();
    else document.addEventListener("nitroAds.loaded", $85e05e42af88da43$var$onAdsLoaded);
}





var $905ae7e1acf3a472$exports = {};
'use strict';

$905ae7e1acf3a472$exports = (parcelRequire("dPzto"));


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d7c85d362df61e1a$export$a143d493d941bafc;
var $d7c85d362df61e1a$export$e4cf37d7f6fb9e0a;
var $d7c85d362df61e1a$export$f99ded8fe4b79145;
var $d7c85d362df61e1a$export$599f31c3813fae4d;
'use strict';
var $e1d6b235675e4012$export$a48f0734ac7c2329;
var $e1d6b235675e4012$export$d622b2ad8d90c771;
var $e1d6b235675e4012$export$6100ba28696e12de;
'use strict';
$e1d6b235675e4012$export$a48f0734ac7c2329 = $e1d6b235675e4012$var$byteLength;
$e1d6b235675e4012$export$d622b2ad8d90c771 = $e1d6b235675e4012$var$toByteArray;
$e1d6b235675e4012$export$6100ba28696e12de = $e1d6b235675e4012$var$fromByteArray;
var $e1d6b235675e4012$var$lookup = [];
var $e1d6b235675e4012$var$revLookup = [];
var $e1d6b235675e4012$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e1d6b235675e4012$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e1d6b235675e4012$var$i = 0, $e1d6b235675e4012$var$len = $e1d6b235675e4012$var$code.length; $e1d6b235675e4012$var$i < $e1d6b235675e4012$var$len; ++$e1d6b235675e4012$var$i){
    $e1d6b235675e4012$var$lookup[$e1d6b235675e4012$var$i] = $e1d6b235675e4012$var$code[$e1d6b235675e4012$var$i];
    $e1d6b235675e4012$var$revLookup[$e1d6b235675e4012$var$code.charCodeAt($e1d6b235675e4012$var$i)] = $e1d6b235675e4012$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e1d6b235675e4012$var$revLookup['-'.charCodeAt(0)] = 62;
$e1d6b235675e4012$var$revLookup['_'.charCodeAt(0)] = 63;
function $e1d6b235675e4012$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e1d6b235675e4012$var$byteLength(b64) {
    var lens = $e1d6b235675e4012$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e1d6b235675e4012$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e1d6b235675e4012$var$toByteArray(b64) {
    var tmp;
    var lens = $e1d6b235675e4012$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e1d6b235675e4012$var$Arr($e1d6b235675e4012$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e1d6b235675e4012$var$revLookup[b64.charCodeAt(i)] << 18 | $e1d6b235675e4012$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e1d6b235675e4012$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e1d6b235675e4012$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e1d6b235675e4012$var$revLookup[b64.charCodeAt(i)] << 2 | $e1d6b235675e4012$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e1d6b235675e4012$var$revLookup[b64.charCodeAt(i)] << 10 | $e1d6b235675e4012$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e1d6b235675e4012$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e1d6b235675e4012$var$tripletToBase64(num) {
    return $e1d6b235675e4012$var$lookup[num >> 18 & 0x3F] + $e1d6b235675e4012$var$lookup[num >> 12 & 0x3F] + $e1d6b235675e4012$var$lookup[num >> 6 & 0x3F] + $e1d6b235675e4012$var$lookup[num & 0x3F];
}
function $e1d6b235675e4012$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e1d6b235675e4012$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e1d6b235675e4012$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e1d6b235675e4012$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e1d6b235675e4012$var$lookup[tmp >> 2] + $e1d6b235675e4012$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e1d6b235675e4012$var$lookup[tmp >> 10] + $e1d6b235675e4012$var$lookup[tmp >> 4 & 0x3F] + $e1d6b235675e4012$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $8eb383850036e479$export$aafa59e2e03f2942;
var $8eb383850036e479$export$68d8715fc104d294;
$8eb383850036e479$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$8eb383850036e479$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $d7c85d362df61e1a$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d7c85d362df61e1a$export$a143d493d941bafc = $d7c85d362df61e1a$var$Buffer;
$d7c85d362df61e1a$export$e4cf37d7f6fb9e0a = $d7c85d362df61e1a$var$SlowBuffer;
$d7c85d362df61e1a$export$f99ded8fe4b79145 = 50;
const $d7c85d362df61e1a$var$K_MAX_LENGTH = 0x7fffffff;
$d7c85d362df61e1a$export$599f31c3813fae4d = $d7c85d362df61e1a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d7c85d362df61e1a$var$Buffer.TYPED_ARRAY_SUPPORT = $d7c85d362df61e1a$var$typedArraySupport();
if (!$d7c85d362df61e1a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d7c85d362df61e1a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d7c85d362df61e1a$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d7c85d362df61e1a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d7c85d362df61e1a$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d7c85d362df61e1a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d7c85d362df61e1a$var$createBuffer(length) {
    if (length > $d7c85d362df61e1a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d7c85d362df61e1a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d7c85d362df61e1a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d7c85d362df61e1a$var$allocUnsafe(arg);
    }
    return $d7c85d362df61e1a$var$from(arg, encodingOrOffset, length);
}
$d7c85d362df61e1a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d7c85d362df61e1a$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d7c85d362df61e1a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d7c85d362df61e1a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d7c85d362df61e1a$var$isInstance(value, ArrayBuffer) || value && $d7c85d362df61e1a$var$isInstance(value.buffer, ArrayBuffer)) return $d7c85d362df61e1a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d7c85d362df61e1a$var$isInstance(value, SharedArrayBuffer) || value && $d7c85d362df61e1a$var$isInstance(value.buffer, SharedArrayBuffer))) return $d7c85d362df61e1a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d7c85d362df61e1a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d7c85d362df61e1a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d7c85d362df61e1a$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d7c85d362df61e1a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d7c85d362df61e1a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d7c85d362df61e1a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d7c85d362df61e1a$var$Buffer, Uint8Array);
function $d7c85d362df61e1a$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d7c85d362df61e1a$var$alloc(size, fill, encoding) {
    $d7c85d362df61e1a$var$assertSize(size);
    if (size <= 0) return $d7c85d362df61e1a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d7c85d362df61e1a$var$createBuffer(size).fill(fill, encoding) : $d7c85d362df61e1a$var$createBuffer(size).fill(fill);
    return $d7c85d362df61e1a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d7c85d362df61e1a$var$Buffer.alloc = function(size, fill, encoding) {
    return $d7c85d362df61e1a$var$alloc(size, fill, encoding);
};
function $d7c85d362df61e1a$var$allocUnsafe(size) {
    $d7c85d362df61e1a$var$assertSize(size);
    return $d7c85d362df61e1a$var$createBuffer(size < 0 ? 0 : $d7c85d362df61e1a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d7c85d362df61e1a$var$Buffer.allocUnsafe = function(size) {
    return $d7c85d362df61e1a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d7c85d362df61e1a$var$Buffer.allocUnsafeSlow = function(size) {
    return $d7c85d362df61e1a$var$allocUnsafe(size);
};
function $d7c85d362df61e1a$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d7c85d362df61e1a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $d7c85d362df61e1a$var$byteLength(string, encoding) | 0;
    let buf = $d7c85d362df61e1a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d7c85d362df61e1a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d7c85d362df61e1a$var$checked(array.length) | 0;
    const buf = $d7c85d362df61e1a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d7c85d362df61e1a$var$fromArrayView(arrayView) {
    if ($d7c85d362df61e1a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d7c85d362df61e1a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d7c85d362df61e1a$var$fromArrayLike(arrayView);
}
function $d7c85d362df61e1a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d7c85d362df61e1a$var$Buffer.prototype);
    return buf;
}
function $d7c85d362df61e1a$var$fromObject(obj) {
    if ($d7c85d362df61e1a$var$Buffer.isBuffer(obj)) {
        const len = $d7c85d362df61e1a$var$checked(obj.length) | 0;
        const buf = $d7c85d362df61e1a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d7c85d362df61e1a$var$numberIsNaN(obj.length)) return $d7c85d362df61e1a$var$createBuffer(0);
        return $d7c85d362df61e1a$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d7c85d362df61e1a$var$fromArrayLike(obj.data);
}
function $d7c85d362df61e1a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d7c85d362df61e1a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d7c85d362df61e1a$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d7c85d362df61e1a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d7c85d362df61e1a$var$Buffer.alloc(+length);
}
$d7c85d362df61e1a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d7c85d362df61e1a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d7c85d362df61e1a$var$Buffer.compare = function compare(a, b) {
    if ($d7c85d362df61e1a$var$isInstance(a, Uint8Array)) a = $d7c85d362df61e1a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d7c85d362df61e1a$var$isInstance(b, Uint8Array)) b = $d7c85d362df61e1a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d7c85d362df61e1a$var$Buffer.isBuffer(a) || !$d7c85d362df61e1a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d7c85d362df61e1a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d7c85d362df61e1a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d7c85d362df61e1a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d7c85d362df61e1a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d7c85d362df61e1a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d7c85d362df61e1a$var$Buffer.isBuffer(buf)) buf = $d7c85d362df61e1a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d7c85d362df61e1a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d7c85d362df61e1a$var$byteLength(string, encoding) {
    if ($d7c85d362df61e1a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d7c85d362df61e1a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d7c85d362df61e1a$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d7c85d362df61e1a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d7c85d362df61e1a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d7c85d362df61e1a$var$Buffer.byteLength = $d7c85d362df61e1a$var$byteLength;
function $d7c85d362df61e1a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d7c85d362df61e1a$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d7c85d362df61e1a$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d7c85d362df61e1a$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d7c85d362df61e1a$var$latin1Slice(this, start, end);
        case 'base64':
            return $d7c85d362df61e1a$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d7c85d362df61e1a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d7c85d362df61e1a$var$Buffer.prototype._isBuffer = true;
function $d7c85d362df61e1a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d7c85d362df61e1a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$d7c85d362df61e1a$var$swap(this, i, i + 1);
    return this;
};
$d7c85d362df61e1a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $d7c85d362df61e1a$var$swap(this, i, i + 3);
        $d7c85d362df61e1a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d7c85d362df61e1a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $d7c85d362df61e1a$var$swap(this, i, i + 7);
        $d7c85d362df61e1a$var$swap(this, i + 1, i + 6);
        $d7c85d362df61e1a$var$swap(this, i + 2, i + 5);
        $d7c85d362df61e1a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d7c85d362df61e1a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d7c85d362df61e1a$var$utf8Slice(this, 0, length);
    return $d7c85d362df61e1a$var$slowToString.apply(this, arguments);
};
$d7c85d362df61e1a$var$Buffer.prototype.toLocaleString = $d7c85d362df61e1a$var$Buffer.prototype.toString;
$d7c85d362df61e1a$var$Buffer.prototype.equals = function equals(b) {
    if (!$d7c85d362df61e1a$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d7c85d362df61e1a$var$Buffer.compare(this, b) === 0;
};
$d7c85d362df61e1a$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $d7c85d362df61e1a$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d7c85d362df61e1a$var$customInspectSymbol) $d7c85d362df61e1a$var$Buffer.prototype[$d7c85d362df61e1a$var$customInspectSymbol] = $d7c85d362df61e1a$var$Buffer.prototype.inspect;
$d7c85d362df61e1a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d7c85d362df61e1a$var$isInstance(target, Uint8Array)) target = $d7c85d362df61e1a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d7c85d362df61e1a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d7c85d362df61e1a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d7c85d362df61e1a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d7c85d362df61e1a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d7c85d362df61e1a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d7c85d362df61e1a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d7c85d362df61e1a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d7c85d362df61e1a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d7c85d362df61e1a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d7c85d362df61e1a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d7c85d362df61e1a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d7c85d362df61e1a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d7c85d362df61e1a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d7c85d362df61e1a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d7c85d362df61e1a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d7c85d362df61e1a$var$utf8Write(buf, string, offset, length) {
    return $d7c85d362df61e1a$var$blitBuffer($d7c85d362df61e1a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d7c85d362df61e1a$var$asciiWrite(buf, string, offset, length) {
    return $d7c85d362df61e1a$var$blitBuffer($d7c85d362df61e1a$var$asciiToBytes(string), buf, offset, length);
}
function $d7c85d362df61e1a$var$base64Write(buf, string, offset, length) {
    return $d7c85d362df61e1a$var$blitBuffer($d7c85d362df61e1a$var$base64ToBytes(string), buf, offset, length);
}
function $d7c85d362df61e1a$var$ucs2Write(buf, string, offset, length) {
    return $d7c85d362df61e1a$var$blitBuffer($d7c85d362df61e1a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d7c85d362df61e1a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d7c85d362df61e1a$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d7c85d362df61e1a$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d7c85d362df61e1a$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d7c85d362df61e1a$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d7c85d362df61e1a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d7c85d362df61e1a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d7c85d362df61e1a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $e1d6b235675e4012$export$6100ba28696e12de(buf);
    else return $e1d6b235675e4012$export$6100ba28696e12de(buf.slice(start, end));
}
function $d7c85d362df61e1a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d7c85d362df61e1a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d7c85d362df61e1a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d7c85d362df61e1a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d7c85d362df61e1a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d7c85d362df61e1a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d7c85d362df61e1a$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d7c85d362df61e1a$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d7c85d362df61e1a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $d7c85d362df61e1a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d7c85d362df61e1a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d7c85d362df61e1a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d7c85d362df61e1a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d7c85d362df61e1a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d7c85d362df61e1a$var$Buffer.prototype.readUintLE = $d7c85d362df61e1a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d7c85d362df61e1a$var$Buffer.prototype.readUintBE = $d7c85d362df61e1a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d7c85d362df61e1a$var$Buffer.prototype.readUint8 = $d7c85d362df61e1a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d7c85d362df61e1a$var$Buffer.prototype.readUint16LE = $d7c85d362df61e1a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d7c85d362df61e1a$var$Buffer.prototype.readUint16BE = $d7c85d362df61e1a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d7c85d362df61e1a$var$Buffer.prototype.readUint32LE = $d7c85d362df61e1a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d7c85d362df61e1a$var$Buffer.prototype.readUint32BE = $d7c85d362df61e1a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d7c85d362df61e1a$var$Buffer.prototype.readBigUInt64LE = $d7c85d362df61e1a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d7c85d362df61e1a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d7c85d362df61e1a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d7c85d362df61e1a$var$Buffer.prototype.readBigUInt64BE = $d7c85d362df61e1a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d7c85d362df61e1a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d7c85d362df61e1a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d7c85d362df61e1a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d7c85d362df61e1a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d7c85d362df61e1a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d7c85d362df61e1a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d7c85d362df61e1a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d7c85d362df61e1a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d7c85d362df61e1a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d7c85d362df61e1a$var$Buffer.prototype.readBigInt64LE = $d7c85d362df61e1a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d7c85d362df61e1a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d7c85d362df61e1a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d7c85d362df61e1a$var$Buffer.prototype.readBigInt64BE = $d7c85d362df61e1a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d7c85d362df61e1a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d7c85d362df61e1a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d7c85d362df61e1a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 4, this.length);
    return $8eb383850036e479$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d7c85d362df61e1a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 4, this.length);
    return $8eb383850036e479$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d7c85d362df61e1a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 8, this.length);
    return $8eb383850036e479$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d7c85d362df61e1a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkOffset(offset, 8, this.length);
    return $8eb383850036e479$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d7c85d362df61e1a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d7c85d362df61e1a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d7c85d362df61e1a$var$Buffer.prototype.writeUintLE = $d7c85d362df61e1a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d7c85d362df61e1a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeUintBE = $d7c85d362df61e1a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d7c85d362df61e1a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeUint8 = $d7c85d362df61e1a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeUint16LE = $d7c85d362df61e1a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeUint16BE = $d7c85d362df61e1a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeUint32LE = $d7c85d362df61e1a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeUint32BE = $d7c85d362df61e1a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d7c85d362df61e1a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d7c85d362df61e1a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d7c85d362df61e1a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d7c85d362df61e1a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d7c85d362df61e1a$var$Buffer.prototype.writeBigUInt64LE = $d7c85d362df61e1a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d7c85d362df61e1a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d7c85d362df61e1a$var$Buffer.prototype.writeBigUInt64BE = $d7c85d362df61e1a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d7c85d362df61e1a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d7c85d362df61e1a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d7c85d362df61e1a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d7c85d362df61e1a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d7c85d362df61e1a$var$Buffer.prototype.writeBigInt64LE = $d7c85d362df61e1a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d7c85d362df61e1a$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d7c85d362df61e1a$var$Buffer.prototype.writeBigInt64BE = $d7c85d362df61e1a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d7c85d362df61e1a$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d7c85d362df61e1a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d7c85d362df61e1a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8eb383850036e479$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d7c85d362df61e1a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d7c85d362df61e1a$var$writeFloat(this, value, offset, true, noAssert);
};
$d7c85d362df61e1a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d7c85d362df61e1a$var$writeFloat(this, value, offset, false, noAssert);
};
function $d7c85d362df61e1a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d7c85d362df61e1a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8eb383850036e479$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d7c85d362df61e1a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d7c85d362df61e1a$var$writeDouble(this, value, offset, true, noAssert);
};
$d7c85d362df61e1a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d7c85d362df61e1a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d7c85d362df61e1a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d7c85d362df61e1a$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d7c85d362df61e1a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d7c85d362df61e1a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d7c85d362df61e1a$var$Buffer.isBuffer(val) ? val : $d7c85d362df61e1a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d7c85d362df61e1a$var$errors = {};
function $d7c85d362df61e1a$var$E(sym, getMessage, Base) {
    $d7c85d362df61e1a$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$d7c85d362df61e1a$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d7c85d362df61e1a$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d7c85d362df61e1a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d7c85d362df61e1a$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d7c85d362df61e1a$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d7c85d362df61e1a$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d7c85d362df61e1a$var$checkBounds(buf, offset, byteLength) {
    $d7c85d362df61e1a$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d7c85d362df61e1a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d7c85d362df61e1a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d7c85d362df61e1a$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d7c85d362df61e1a$var$checkBounds(buf, offset, byteLength);
}
function $d7c85d362df61e1a$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d7c85d362df61e1a$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d7c85d362df61e1a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d7c85d362df61e1a$var$validateNumber(value, type);
        throw new $d7c85d362df61e1a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d7c85d362df61e1a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d7c85d362df61e1a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d7c85d362df61e1a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d7c85d362df61e1a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d7c85d362df61e1a$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d7c85d362df61e1a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d7c85d362df61e1a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d7c85d362df61e1a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d7c85d362df61e1a$var$base64ToBytes(str) {
    return $e1d6b235675e4012$export$d622b2ad8d90c771($d7c85d362df61e1a$var$base64clean(str));
}
function $d7c85d362df61e1a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d7c85d362df61e1a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d7c85d362df61e1a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d7c85d362df61e1a$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d7c85d362df61e1a$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d7c85d362df61e1a$var$BufferBigIntNotDefined : fn;
}
function $d7c85d362df61e1a$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $b02d5da943513c89$require$Buffer = $d7c85d362df61e1a$export$a143d493d941bafc;
var $b02d5da943513c89$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $b02d5da943513c89$var$maskMap;
class $b02d5da943513c89$export$899fe4f7927c31a0 {
    constructor(){
        this.buffers = [];
        this.bufferedLength = 0;
        this.blockedRequest = null;
        this._offsetIntoBuffer = 0;
        this._bufferIndex = 0;
        this._offset = 0;
        this._spentBufferSize = 0;
        /**
         * When true, buffers are not removed, which allows the user to
         * "rewind" the current offset back into buffers that have already been
         * visited. If you enable this, you will need to remove buffers manually using
         * clean()
         */ this.retainBuffers = false;
        this.textDecoder = new TextDecoder();
        this.skippedLength = 0;
        this._ended = false;
    }
    /**
     * Get the index of the buffer currently being read. This will always be zero unless retainBuffers=true
     */ get bufferIndex() {
        return this._bufferIndex;
    }
    /**
     * Get the current offset in bits, starting from the very first bit read by this reader (across all
     * buffers added)
     */ get offset() {
        return this._offset;
    }
    /**
     * The total number of bits which were in buffers that have previously been read, and have since been discarded.
     */ get spentBufferSize() {
        return this._spentBufferSize;
    }
    /**
     * Set the current offset in bits, as measured from the very first bit read by this reader (across all buffers
     * added). If the given offset points into a previously discarded buffer, an error will be thrown. See the
     * retainBuffers option if you need to seek back into previous buffers. If the desired offset is in a previous
     * buffer which has not been discarded, the current read head is moved into the appropriate offset of that buffer.
     */ set offset(value) {
        if (value < this._spentBufferSize) throw new Error(`Offset ${value} points into a discarded buffer! ` + `If you need to seek backwards outside the current buffer, make sure to set retainBuffers=true`);
        let offsetIntoBuffer = value - this._spentBufferSize;
        let bufferIndex = 0;
        for(let i = 0, max = this.buffers.length; i < max; ++i){
            let buf = this.buffers[i];
            let size = buf.length * 8;
            if (offsetIntoBuffer < size) {
                this._bufferIndex = bufferIndex;
                this._offset = value;
                this._offsetIntoBuffer = offsetIntoBuffer;
                this.bufferedLength = buf.length * 8 - this._offsetIntoBuffer;
                for(let j = i + 1; j < max; ++j)this.bufferedLength += this.buffers[j].length * 8;
                return;
            }
            offsetIntoBuffer -= size;
            ++bufferIndex;
        }
    }
    /**
     * Run a function which can synchronously read bits without affecting the read head after the function
     * has finished.
     * @param func
     */ simulateSync(func) {
        let oldRetainBuffers = this.retainBuffers;
        let originalOffset = this.offset;
        this.retainBuffers = true;
        try {
            return func();
        } finally{
            this.retainBuffers = oldRetainBuffers;
            this.offset = originalOffset;
        }
    }
    /**
     * Run a function which can asynchronously read bits without affecting the read head after the function
     * has finished.
     * @param func
     */ simulate(func) {
        return $b02d5da943513c89$var$__awaiter(this, void 0, void 0, function*() {
            let oldRetainBuffers = this.retainBuffers;
            let originalOffset = this.offset;
            this.retainBuffers = true;
            try {
                return yield func();
            } finally{
                this.retainBuffers = oldRetainBuffers;
                this.offset = originalOffset;
            }
        });
    }
    /**
     * Remove any fully used up buffers. Only has an effect if retainBuffers is true.
     * Optional `count` parameter lets you control how many buffers can be freed.
     */ clean(count) {
        /**
         * PERFORMANCE SENSITIVE
         * Previous versions of this function caused as much as an 18% overhead on top of simple
         * byte-aligned reads.
         */ let spent = count !== void 0 ? Math.min(count, this._bufferIndex) : this._bufferIndex;
        for(let i = 0, max = spent; i < max; ++i){
            this._spentBufferSize += this.buffers[0].length * 8;
            this.buffers.shift();
        }
        this._bufferIndex -= spent;
    }
    /**
     * The number of bits that are currently available.
     */ get available() {
        return this.bufferedLength - this.skippedLength;
    }
    /**
     * Check if the given number of bits are currently available.
     * @param length The number of bits to check for
     * @returns True if the required number of bits is available, false otherwise
     */ isAvailable(length) {
        return this.bufferedLength >= length;
    }
    ensureNoReadPending() {
        if (this.blockedRequest) throw new Error(`Only one read() can be outstanding at a time.`);
    }
    /**
     * Asynchronously read the given number of bytes, encode it into a string, and return the result,
     * optionally using a specific text encoding.
     * @param length The number of bytes to read
     * @param options A set of options to control conversion into a string. @see StringEncodingOptions
     * @returns The resulting string
     */ readString(length, options) {
        return $b02d5da943513c89$var$__awaiter(this, void 0, void 0, function*() {
            this.ensureNoReadPending();
            yield this.assure(8 * length);
            return this.readStringSync(length, options);
        });
    }
    /**
     * Synchronously read the given number of bytes, encode it into a string, and return the result,
     * optionally using a specific text encoding.
     * @param length The number of bytes to read
     * @param options A set of options to control conversion into a string. @see StringEncodingOptions
     * @returns The resulting string
     */ readStringSync(length, options) {
        var _a, _b;
        if (!options) options = {};
        this.ensureNoReadPending();
        let buffer = new Uint8Array(length);
        let firstTerminator = -1;
        let charLength = 1;
        let encoding = (_a = options.encoding) !== null && _a !== void 0 ? _a : 'utf-8';
        if ([
            'utf16le',
            'ucs-2',
            'ucs2'
        ].includes(encoding)) charLength = 2;
        for(let i = 0, max = length; i < max; ++i)buffer[i] = this.readSync(8);
        for(let i = 0, max = length; i < max; i += charLength){
            let char = buffer[i];
            if (charLength === 2) char = char << 8 | ((_b = buffer[i + 1]) !== null && _b !== void 0 ? _b : 0);
            if (char === 0) {
                firstTerminator = i;
                break;
            }
        }
        if (options.nullTerminated !== false) {
            if (firstTerminator >= 0) buffer = buffer.subarray(0, firstTerminator);
        }
        if (encoding === 'utf-8') return this.textDecoder.decode(buffer);
        else {
            if (typeof $b02d5da943513c89$require$Buffer === 'undefined') throw new Error(`Encoding '${encoding}' is not supported: No Node.js Buffer implementation and TextDecoder only supports utf-8`);
            return $b02d5da943513c89$require$Buffer.from(buffer).toString(encoding);
        }
    }
    /**
     * Read a number of the given bitlength synchronously without advancing
     * the read head.
     * @param length The number of bits to read
     * @returns The number read from the bitstream
     */ peekSync(length) {
        return this.readCoreSync(length, false);
    }
    /**
     * Skip the given number of bits.
     * @param length The number of bits to skip
     */ skip(length) {
        this.skippedLength += length;
    }
    /**
     * Read an unsigned integer of the given bit length synchronously. If there are not enough
     * bits available, an error is thrown.
     *
     * @param length The number of bits to read
     * @returns The unsigned integer that was read
     */ readSync(length) {
        return this.readCoreSync(length, true);
    }
    /**
     * Read a number of bytes from the stream. Returns a generator that ends when the read is complete,
     * and yields a number of *bytes* still to be read (not bits like in other read methods)
     *
     * @param buffer The buffer/typed array to write to
     * @param offset The offset into the buffer to write to. Defaults to zero
     * @param length The length of bytes to read. Defaults to the length of the array (sans the offset)
     */ *readBytes(buffer, offset = 0, length) {
        var _a;
        length !== null && length !== void 0 ? length : length = buffer.length - offset;
        let bitOffset = this._offsetIntoBuffer % 8;
        // If this is a byte-aligned read, we can do this more optimally than using readSync
        if (bitOffset === 0) {
            if (globalThis.BITSTREAM_TRACE) {
                console.log(`------------------------------------------------------------    Byte-aligned readBytes(), length=${length}`);
                console.log(`------------------------------------------------------------    readBytes(): Pre-operation: buffered=${this.bufferedLength} bits, bufferIndex=${this._bufferIndex}, bufferOffset=${this._offsetIntoBuffer}, bufferLength=${((_a = this.buffers[this._bufferIndex]) === null || _a === void 0 ? void 0 : _a.length) || '<none>'} bufferCount=${this.buffers.length}`);
            }
            let remainingLength = length;
            let destBufferOffset = 0;
            while(remainingLength > 0){
                if (this.available < remainingLength * 8) yield Math.max((remainingLength * 8 - this.available) / 8);
                let bufferOffset = Math.floor(this._offsetIntoBuffer / 8);
                let contributionBuffer = this.buffers[this._bufferIndex];
                let contribution = Math.min(remainingLength, contributionBuffer.length);
                for(let i = 0; i < contribution; ++i)buffer[destBufferOffset + i] = contributionBuffer[bufferOffset + i];
                destBufferOffset += contribution;
                let contributionBits = contribution * 8;
                this.consume(contributionBits);
                remainingLength -= contributionBits;
                if (globalThis.BITSTREAM_TRACE) {
                    console.log(`------------------------------------------------------------    readBytes(): consumed=${contribution} bytes, remaining=${remainingLength}`);
                    console.log(`------------------------------------------------------------    readBytes(): buffered=${this.bufferedLength} bits, bufferIndex=${this._bufferIndex}, bufferOffset=${this._offsetIntoBuffer}, bufferCount=${this.buffers.length}`);
                }
            }
        } else // Non-byte-aligned, we need to construct bytes using bit-wise operations.
        // readSync is perfect for this 
        for(let i = offset, max = Math.min(buffer.length, offset + length); i < max; ++i){
            if (!this.isAvailable(8)) yield max - i;
            buffer[i] = this.readSync(8);
        }
        return buffer;
    }
    /**
     * Read a number of bytes from the stream synchronously. If not enough bytes are available, an
     * exception is thrown.
     *
     * @param buffer The buffer/typed array to write to
     * @param offset The offset into the buffer to write to. Defaults to zero
     * @param length The length of bytes to read. Defaults to the length of the array (sans the offset)
     */ readBytesSync(buffer, offset = 0, length) {
        length !== null && length !== void 0 ? length : length = buffer.length - offset;
        let gen = this.readBytes(buffer, offset, length);
        while(true){
            let result = gen.next();
            if (result.done === false) throw new Error(`underrun: Not enough bits are available (requested ${length} bytes)`);
            else break;
        }
        return buffer;
    }
    /**
     * Read a number of bytes from the stream. Blocks and waits for more bytes if not enough bytes are available.
     *
     * @param buffer The buffer/typed array to write to
     * @param offset The offset into the buffer to write to. Defaults to zero
     * @param length The length of bytes to read. Defaults to the length of the array (sans the offset)
     */ readBytesBlocking(buffer, offset = 0, length) {
        return $b02d5da943513c89$var$__awaiter(this, void 0, void 0, function*() {
            length !== null && length !== void 0 ? length : length = buffer.length - offset;
            let gen = this.readBytes(buffer, offset, length);
            while(true){
                let result = gen.next();
                if (result.done === false) yield this.assure(result.value * 8);
                else break;
            }
            return buffer;
        });
    }
    /**
     * Read a two's complement signed integer of the given bit length synchronously. If there are not
     * enough bits available, an error is thrown.
     *
     * @param length The number of bits to read
     * @returns The signed integer that was read
     */ readSignedSync(length) {
        const u = this.readSync(length);
        const signBit = 2 ** (length - 1);
        const mask = signBit - 1;
        return (u & signBit) === 0 ? u : -((~(u - 1) & mask) >>> 0);
    }
    maskOf(bits) {
        var _a;
        if (!$b02d5da943513c89$var$maskMap) {
            $b02d5da943513c89$var$maskMap = new Map();
            for(let i = 0; i <= 64; ++i)$b02d5da943513c89$var$maskMap.set(i, Math.pow(0x2, i) - 1);
        }
        return (_a = $b02d5da943513c89$var$maskMap.get(bits)) !== null && _a !== void 0 ? _a : Math.pow(0x2, bits) - 1;
    }
    /**
     * Read an IEEE 754 floating point value with the given bit length (32 or 64). If there are not
     * enough bits available, an error is thrown.
     *
     * @param length Must be 32 for 32-bit single-precision or 64 for 64-bit double-precision. All
     *        other values result in TypeError
     * @returns The floating point value that was read
     */ readFloatSync(length) {
        if (length !== 32 && length !== 64) throw new TypeError(`Invalid length (${length} bits) Only 4-byte (32 bit / single-precision) and 8-byte (64 bit / double-precision) IEEE 754 values are supported`);
        if (!this.isAvailable(length)) throw new Error(`underrun: Not enough bits are available (requested=${length}, available=${this.bufferedLength}, buffers=${this.buffers.length})`);
        let buf = new ArrayBuffer(length / 8);
        let view = new DataView(buf);
        for(let i = 0, max = buf.byteLength; i < max; ++i)view.setUint8(i, this.readSync(8));
        if (length === 32) return view.getFloat32(0, false);
        else if (length === 64) return view.getFloat64(0, false);
    }
    readByteAligned(consume) {
        let buffer = this.buffers[this._bufferIndex];
        let value = buffer[this._offsetIntoBuffer / 8];
        if (consume) {
            this.bufferedLength -= 8;
            this._offsetIntoBuffer += 8;
            this._offset += 8;
            if (this._offsetIntoBuffer >= buffer.length * 8) {
                this._bufferIndex += 1;
                this._offsetIntoBuffer = 0;
                if (!this.retainBuffers) this.clean();
            }
        }
        return value;
    }
    consume(length) {
        this.bufferedLength -= length;
        this._offsetIntoBuffer += length;
        this._offset += length;
        let buffer = this.buffers[this._bufferIndex];
        while(buffer && this._offsetIntoBuffer >= buffer.length * 8){
            this._bufferIndex += 1;
            this._offsetIntoBuffer -= buffer.length * 8;
            buffer = this.buffers[this._bufferIndex];
            if (!this.retainBuffers) this.clean();
        }
    }
    readShortByteAligned(consume, byteOrder) {
        let buffer = this.buffers[this._bufferIndex];
        let bufferOffset = this._offsetIntoBuffer / 8;
        let firstByte = buffer[bufferOffset];
        let secondByte;
        if (bufferOffset + 1 >= buffer.length) secondByte = this.buffers[this._bufferIndex + 1][0];
        else secondByte = buffer[bufferOffset + 1];
        if (consume) this.consume(16);
        if (byteOrder === 'lsb') {
            let carry = firstByte;
            firstByte = secondByte;
            secondByte = carry;
        }
        return firstByte << 8 | secondByte;
    }
    readLongByteAligned(consume, byteOrder) {
        let bufferIndex = this._bufferIndex;
        let buffer = this.buffers[bufferIndex];
        let bufferOffset = this._offsetIntoBuffer / 8;
        let firstByte = buffer[bufferOffset++];
        if (bufferOffset >= buffer.length) {
            buffer = this.buffers[++bufferIndex];
            bufferOffset = 0;
        }
        let secondByte = buffer[bufferOffset++];
        if (bufferOffset >= buffer.length) {
            buffer = this.buffers[++bufferIndex];
            bufferOffset = 0;
        }
        let thirdByte = buffer[bufferOffset++];
        if (bufferOffset >= buffer.length) {
            buffer = this.buffers[++bufferIndex];
            bufferOffset = 0;
        }
        let fourthByte = buffer[bufferOffset++];
        if (bufferOffset >= buffer.length) {
            buffer = this.buffers[++bufferIndex];
            bufferOffset = 0;
        }
        if (consume) this.consume(32);
        let highBit = (firstByte & 0x80) !== 0;
        firstByte &= -129;
        if (byteOrder === 'lsb') {
            let b1 = fourthByte;
            let b2 = thirdByte;
            let b3 = secondByte;
            let b4 = firstByte;
            firstByte = b1;
            secondByte = b2;
            thirdByte = b3;
            fourthByte = b4;
        }
        let value = firstByte << 24 | secondByte << 16 | thirdByte << 8 | fourthByte;
        if (highBit) value += 2 ** 31;
        return value;
    }
    read3ByteAligned(consume, byteOrder) {
        let bufferIndex = this._bufferIndex;
        let buffer = this.buffers[bufferIndex];
        let bufferOffset = this._offsetIntoBuffer / 8;
        let firstByte = buffer[bufferOffset++];
        if (bufferOffset >= buffer.length) {
            buffer = this.buffers[++bufferIndex];
            bufferOffset = 0;
        }
        let secondByte = buffer[bufferOffset++];
        if (bufferOffset >= buffer.length) {
            buffer = this.buffers[++bufferIndex];
            bufferOffset = 0;
        }
        let thirdByte = buffer[bufferOffset++];
        if (bufferOffset >= buffer.length) {
            buffer = this.buffers[++bufferIndex];
            bufferOffset = 0;
        }
        if (consume) this.consume(24);
        if (byteOrder === 'lsb') {
            let carry = firstByte;
            firstByte = thirdByte;
            thirdByte = carry;
        }
        return firstByte << 16 | secondByte << 8 | thirdByte;
    }
    readPartialByte(length, consume) {
        let buffer = this.buffers[this._bufferIndex];
        let byte = buffer[Math.floor(this._offsetIntoBuffer / 8)];
        let bitOffset = this._offsetIntoBuffer % 8 | 0;
        if (consume) this.consume(length);
        return byte >> 8 - length - bitOffset & this.maskOf(length) | 0;
    }
    /**
     * @param length
     * @param consume
     * @param byteOrder The byte order to use when the length is greater than 8 and is a multiple of 8.
     *                  Defaults to MSB (most significant byte). If the length is not a multiple of 8,
     *                  this is unused
     * @returns
     */ readCoreSync(length, consume, byteOrder = 'msb') {
        this.ensureNoReadPending();
        if (this.available < length) throw new Error(`underrun: Not enough bits are available (requested=${length}, available=${this.bufferedLength}, buffers=${this.buffers.length})`);
        this.adjustSkip();
        let offsetIntoByte = this._offsetIntoBuffer % 8;
        // Optimization cases //////////////////////////////////////////////////////////////////////////////
        if (offsetIntoByte === 0) {
            if (length === 8) return this.readByteAligned(consume);
            else if (length === 16) return this.readShortByteAligned(consume, byteOrder);
            else if (length === 24) return this.read3ByteAligned(consume, byteOrder);
            else if (length === 32) return this.readLongByteAligned(consume, byteOrder);
        }
        if (length < 8 && (8 - offsetIntoByte | 0) >= length) return this.readPartialByte(length, consume);
        // The remaining path covers reads which are larger than one byte or which cross over byte boundaries.
        let remainingLength = length;
        let offset = this._offsetIntoBuffer;
        let bufferIndex = this._bufferIndex;
        let bigValue = BigInt(0);
        let value = 0;
        let useBigInt = length > 31;
        while(remainingLength > 0){
            /* istanbul ignore next */ if (bufferIndex >= this.buffers.length) throw new Error(`Internal error: Buffer index out of range (index=${bufferIndex}, count=${this.buffers.length}), offset=${this.offset}, readLength=${length}, available=${this.available})`);
            let buffer = this.buffers[bufferIndex];
            let byteOffset = Math.floor(offset / 8);
            /* istanbul ignore next */ if (byteOffset >= buffer.length) throw new Error(`Internal error: Current buffer (index ${bufferIndex}) has length ${buffer.length} but our position within the buffer is ${byteOffset}! offset=${this.offset}, bufs=${this.buffers.length}`);
            let bitOffset = offset % 8;
            let bitContribution;
            let byte = buffer[byteOffset];
            bitContribution = Math.min(8 - bitOffset, remainingLength);
            if (useBigInt) bigValue = bigValue << BigInt(bitContribution) | BigInt(buffer[byteOffset]) >> BigInt(8) - BigInt(bitContribution) - BigInt(bitOffset) & BigInt(this.maskOf(bitContribution));
            else value = value << bitContribution | byte >> 8 - bitContribution - bitOffset & this.maskOf(bitContribution);
            // update counters
            offset += bitContribution;
            remainingLength -= bitContribution | 0;
            if (offset >= buffer.length * 8) {
                bufferIndex += 1;
                offset = 0;
            }
        }
        if (consume) this.consume(length);
        if (useBigInt) return Number(bigValue);
        else return value;
    }
    adjustSkip() {
        if (this.skippedLength <= 0) return;
        // First, remove any buffers that are completely skipped
        while(this.buffers && this.skippedLength > this.buffers[0].length * 8 - this._offsetIntoBuffer){
            this.skippedLength -= this.buffers[0].length * 8 - this._offsetIntoBuffer;
            this._offsetIntoBuffer = 0;
            this.buffers.shift();
        }
        // If any buffers are left, then the amount of remaining skipped bits is 
        // less than the full length of the buffer, so entirely consume the skipped length
        // by putting it into the offset.
        if (this.buffers.length > 0) {
            this._offsetIntoBuffer += this.skippedLength;
            this.skippedLength = 0;
        }
    }
    /**
     * Wait until the given number of bits is available
     * @param length The number of bits to wait for
     * @param optional When true, the returned promise will resolve even if the stream ends before all bits are
     *                 available. Otherwise, the promise will reject.
     * @returns A promise which will resolve when the requested number of bits are available. Rejects if the stream
     *          ends before the request is satisfied, unless optional parameter is true.
     */ assure(length, optional = false) {
        this.ensureNoReadPending();
        if (this.bufferedLength >= length) return Promise.resolve();
        return this.block({
            length: length,
            assure: true
        }).then((available)=>{
            if (available < length && !optional) throw this.endOfStreamError(length);
        });
    }
    /**
     * Read an unsigned integer with the given bit length, waiting until enough bits are
     * available for the operation.
     *
     * @param length The number of bits to read
     * @returns A promise which resolves to the unsigned integer once it is read
     */ read(length) {
        this.ensureNoReadPending();
        if (this.available >= length) return Promise.resolve(this.readSync(length));
        else return this.block({
            length: length
        });
    }
    /**
     * Read a two's complement signed integer with the given bit length, waiting until enough bits are
     * available for the operation.
     *
     * @param length The number of bits to read
     * @returns A promise which resolves to the signed integer value once it is read
     */ readSigned(length) {
        this.ensureNoReadPending();
        if (this.available >= length) return Promise.resolve(this.readSignedSync(length));
        else return this.block({
            length: length,
            signed: true
        });
    }
    promise() {
        let resolve;
        let reject;
        let promise = new Promise((rs, rj)=>(resolve = rs, reject = rj));
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    }
    block(request) {
        if (this._ended) {
            if (request.assure) return Promise.resolve(this.available);
            else return Promise.reject(this.endOfStreamError(request.length));
        }
        this.blockedRequest = Object.assign(Object.assign({}, request), this.promise());
        return this.blockedRequest.promise;
    }
    /**
     * Read an IEEE 754 floating point value with the given bit length, waiting until enough bits are
     * available for the operation.
     *
     * @param length The number of bits to read (must be 32 for 32-bit single-precision or
     *                  64 for 64-bit double-precision)
     * @returns A promise which resolves to the floating point value once it is read
     */ readFloat(length) {
        this.ensureNoReadPending();
        if (this.available >= length) return Promise.resolve(this.readFloatSync(length));
        else return this.block({
            length: length,
            float: true
        });
    }
    /**
     * Asynchronously read a number of the given bitlength without advancing the read head.
     * @param length The number of bits to read. If there are not enough bits available
     * to complete the operation, the operation is delayed until enough bits become available.
     * @returns A promise which resolves iwth the number read from the bitstream
     */ peek(length) {
        return $b02d5da943513c89$var$__awaiter(this, void 0, void 0, function*() {
            yield this.assure(length);
            return this.peekSync(length);
        });
    }
    /**
     * Add a buffer onto the end of the bitstream.
     * @param buffer The buffer to add to the bitstream
     */ addBuffer(buffer) {
        if (this._ended) throw new Error(`Cannot add buffers to a reader which has been marked as ended without calling reset() first`);
        this.buffers.push(buffer);
        this.bufferedLength += buffer.length * 8;
        if (this.blockedRequest && this.blockedRequest.length <= this.available) {
            let request = this.blockedRequest;
            this.blockedRequest = null;
            if (request.assure) request.resolve(request.length);
            else if (request.signed) request.resolve(this.readSignedSync(request.length));
            else if (request.float) request.resolve(this.readFloatSync(request.length));
            else request.resolve(this.readSync(request.length));
        }
    }
    get ended() {
        return this._ended;
    }
    reset() {
        if (this.blockedRequest) throw new Error(`Cannot reset while there is a blocked request!`);
        this.buffers = [];
        this.bufferedLength = 0;
        this.blockedRequest = null;
        this._offsetIntoBuffer = 0;
        this._bufferIndex = 0;
        this._offset = 0;
        this._spentBufferSize = 0;
        this._ended = false;
    }
    /**
     * Inform this reader that it will not receive any further buffers. Any requests to assure bits beyond the end of the
     * buffer will result ss
     */ end() {
        this._ended = true;
        if (this.blockedRequest) {
            let request = this.blockedRequest;
            this.blockedRequest = null;
            if (request.length <= this.available) throw new Error(`Internal inconsistency in @/bitstream: Should have granted request prior. Please report this bug.`);
            if (request.assure) request.resolve(this.available);
            else request.reject(this.endOfStreamError(request.length));
        }
    }
    endOfStreamError(length) {
        return new Error(`End of stream reached while reading ${length} bits, only ${this.available} bits are left in the stream`);
    }
}




/**
 * A class for writing numbers of varying bitlengths to a Node.js Writable.
 * All data is written in big-endian (network) byte order.
 */ 
var $c809b947cddc2a78$require$Buffer = $d7c85d362df61e1a$export$a143d493d941bafc;
class $c809b947cddc2a78$export$3fa3b5652b53dfc4 {
    /**
     * Create a new writer
     * @param stream The writable stream to write to
     * @param bufferSize The number of bytes to buffer before flushing onto the writable
     */ constructor(stream, bufferSize = 1){
        this.stream = stream;
        this.bufferSize = bufferSize;
        this.pendingByte = BigInt(0);
        this.pendingBits = 0;
        this.bufferedBytes = 0;
        this._offset = 0;
        this.textEncoder = new TextEncoder();
        this.buffer = new Uint8Array(bufferSize);
    }
    /**
     * How many bits have been written via this writer in total
     */ get offset() {
        return this._offset;
    }
    /**
     * How many bits into the current byte is the write cursor.
     * If this value is zero, then we are currently byte-aligned.
     * A value of 7 means we are 1 bit away from the byte boundary.
     */ get byteOffset() {
        return this.pendingBits;
    }
    /**
     * Finish the current byte (assuming zeros for the remaining bits, if necessary)
     * and flushes the output.
     */ end() {
        this.finishByte();
        this.flush();
    }
    /**
     * Reset the bit offset of this writer back to zero.
     */ reset() {
        this._offset = 0;
    }
    finishByte() {
        if (this.pendingBits > 0) {
            this.buffer[this.bufferedBytes++] = Number(this.pendingByte);
            this.pendingBits = 0;
            this.pendingByte = BigInt(0);
        }
    }
    flush() {
        if (this.bufferedBytes > 0) {
            this.stream.write($c809b947cddc2a78$require$Buffer.from(this.buffer.slice(0, this.bufferedBytes)));
            this.bufferedBytes = 0;
        }
    }
    /**
     * Decode a string into a set of bytes and write it to the bitstream, bounding the string
     * by the given number of bytes, optionally using the given encoding (or UTF-8 if not specified).
     * @param byteCount The number of bytes to bound the output to
     * @param value The string to decode and write
     * @param encoding The encoding to use when writing the string. Defaults to utf-8
     */ writeString(byteCount, value, encoding = 'utf-8') {
        if (encoding === 'utf-8') {
            let buffer = new Uint8Array(byteCount);
            let strBuf = this.textEncoder.encode(value);
            buffer.set(strBuf, 0);
            this.writeBytes(buffer);
        } else {
            if (typeof $c809b947cddc2a78$require$Buffer === 'undefined') throw new Error(`Encoding '${encoding}' is not supported: No Node.js Buffer implementation found, web standard TextEncoder only supports utf-8`);
            let buffer = $c809b947cddc2a78$require$Buffer.alloc(byteCount);
            $c809b947cddc2a78$require$Buffer.from(value, encoding).copy(buffer);
            this.writeBuffer(buffer);
        }
    }
    /**
     * Write the given buffer to the bitstream. This is done by treating each byte as an 8-bit write.
     * Note that the bitstream does not need to be byte-aligned to call this method, meaning you can write
     * a set of bytes at a non=zero bit offset if you wish.
     * @param buffer The buffer to write
     * @deprecated Use writeBytes() instead
     */ writeBuffer(buffer) {
        this.writeBytes(buffer);
    }
    /**
     * Write the given buffer to the bitstream. This is done by treating each byte as an 8-bit write.
     * Note that the bitstream does not need to be byte-aligned to call this method, meaning you can write
     * a set of bytes at a non=zero bit offset if you wish.
     * @param chunk The buffer to write
     */ writeBytes(chunk, offset = 0, length) {
        length !== null && length !== void 0 ? length : length = chunk.length - offset;
        // Fast path: Byte-aligned
        if (this.byteOffset === 0) {
            while(chunk.length > 0){
                let writableLength = Math.min(chunk.length, this.buffer.length - this.bufferedBytes);
                this.buffer.set(chunk.subarray(0, writableLength), this.bufferedBytes);
                this.bufferedBytes += writableLength;
                chunk = chunk.subarray(writableLength);
                if (this.bufferedBytes >= this.buffer.length) this.flush();
            }
            return;
        }
        for(let i = offset, max = Math.min(chunk.length, offset + length); i < max; ++i)this.write(8, chunk[i]);
    }
    min(a, b) {
        if (a < b) return a;
        else return b;
    }
    /**
     * Write the given number to the bitstream with the given bitlength. If the number is too large for the
     * number of bits specified, the lower-order bits are written and the higher-order bits are ignored.
     * @param length The number of bits to write
     * @param value The number to write
     */ write(length, value) {
        if (value === void 0 || value === null) value = 0;
        value = Number(value);
        if (Number.isNaN(value)) throw new Error(`Cannot write to bitstream: Value ${value} is not a number`);
        if (!Number.isFinite(value)) throw new Error(`Cannot write to bitstream: Value ${value} must be finite`);
        let valueN = BigInt(value % Math.pow(2, length));
        let remainingLength = length;
        while(remainingLength > 0){
            let shift = BigInt(8 - this.pendingBits - remainingLength);
            let contribution = shift >= 0 ? valueN << shift : valueN >> -shift;
            let writtenLength = Number(shift >= 0 ? remainingLength : this.min(-shift, BigInt(8 - this.pendingBits)));
            this.pendingByte = this.pendingByte | contribution;
            this.pendingBits += writtenLength;
            this._offset += writtenLength;
            remainingLength -= writtenLength;
            valueN = valueN % BigInt(Math.pow(2, remainingLength));
            if (this.pendingBits === 8) {
                this.finishByte();
                if (this.bufferedBytes >= this.buffer.length) this.flush();
            }
        }
    }
    writeSigned(length, value) {
        if (value === undefined || value === null) value = 0;
        const originalValue = value;
        const max = 2 ** (length - 1) - 1; // ie 127
        const min = -(2 ** (length - 1)); // ie -128
        value = Number(value);
        if (Number.isNaN(value)) throw new Error(`Cannot write to bitstream: Value ${originalValue} is not a number`);
        if (!Number.isFinite(value)) throw new Error(`Cannot write to bitstream: Value ${value} must be finite`);
        if (value > max) throw new TypeError(`Cannot represent ${value} in I${length} format: Value too large (min=${min}, max=${max})`);
        if (value < min) throw new TypeError(`Cannot represent ${value} in I${length} format: Negative value too small (min=${min}, max=${max})`);
        return this.write(length, value >= 0 ? value : ~-value + 1 >>> 0);
    }
    writeFloat(length, value) {
        if (length !== 32 && length !== 64) throw new TypeError(`Invalid length (${length} bits) Only 4-byte (32 bit / single-precision) and 8-byte (64 bit / double-precision) IEEE 754 values are supported`);
        let buf = new ArrayBuffer(length / 8);
        let view = new DataView(buf);
        if (length === 32) view.setFloat32(0, value);
        else if (length === 64) view.setFloat64(0, value);
        for(let i = 0, max = buf.byteLength; i < max; ++i)this.write(8, view.getUint8(i));
    }
}
class $c809b947cddc2a78$export$8af03bf62a626825 extends $c809b947cddc2a78$export$3fa3b5652b53dfc4 {
    constructor(){
        super(null, 1);
        this.bitLength = 0;
    }
    writeString(byteCount, value, encoding = 'utf-8') {
        this.bitLength += byteCount * 8;
    }
    writeBuffer(buffer) {
        this.bitLength += buffer.length * 8;
    }
    write(length, value) {
        this.bitLength += length;
    }
}






/**
 * Given a LengthDeterminant function, a BitstreamElement instance (the context), and a field definition,
 * this function returns the number of bits that should be read. This is used to determine the actual bitlength
 * of fields when reading and writing BitstreamElement via BitstreamReader and BitstreamWriter.
 * @param determinant The length determinant
 * @param parent The BitstreamElement instance for context
 * @param field The field definition for context
 * @returns The bitlength of the field in this context
 */ function $8f69e5c027caa70c$export$83b6dc3503c1fda6(determinant, parent, field) {
    if (typeof determinant === 'number') return determinant;
    if (!parent) throw new Error(`Cannot resolve length without an instance!`);
    let length = parent.runWithFieldBeingComputed(field, ()=>determinant(parent, field));
    if (typeof length !== 'number') throw new Error(`${field.containingType.name}#${String(field.name)}: Length determinant returned non-number value: ${length}`);
    if (length < 0) {
        let message = `${field.containingType.name}#${String(field.name)}: Length determinant returned negative value ${length} -- Value read so far: ${JSON.stringify(parent, undefined, 2)}`;
        console.error(message);
        console.error(`============= Item =============`);
        console.dir(parent);
        let debugParent = parent.parent;
        while(debugParent){
            console.error(`============= Parent =============`);
            console.dir(debugParent);
            debugParent = debugParent.parent;
        }
        throw new Error(message);
    }
    return length;
}


/**
 * Serializes BitstreamElement instances to/from bitstreams
 */ class $bdd572b9e10e9eb9$export$2cfc8a9f9c775914 {
    *read(reader, type, parent, field) {
        let g = type.read(reader, {
            parent: parent,
            field: field,
            context: parent.context
        });
        while(true){
            let result = g.next();
            if (result.done === false) yield result.value;
            else return result.value;
        }
    }
    write(writer, type, instance, field, value) {
        var _a;
        if (!value) throw new Error(`Cannot write ${field.type.name}#${String(field.name)}: Value is null/undefined`);
        value.write(writer, {
            skip: (_a = field.options) === null || _a === void 0 ? void 0 : _a.skip,
            context: instance === null || instance === void 0 ? void 0 : instance.context
        });
    }
}


function $49d974981e526d97$export$28a41e13b6ac6b17(field) {
    var _a;
    return `[${field.options.serializer.constructor.name || '<unknown serializer>'}] ${((_a = field.containingType) === null || _a === void 0 ? void 0 : _a.name) || '<unknown>'}#${String(field.name)}`;
}


class $599eb80637d86fa2$export$76e4ae84123ce86c {
    *read(reader, type, parent, field) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let count = 0;
        let elements = [];
        if ((_b = (_a = field === null || field === void 0 ? void 0 : field.options) === null || _a === void 0 ? void 0 : _a.array) === null || _b === void 0 ? void 0 : _b.countFieldLength) {
            if (!reader.isAvailable(field.options.array.countFieldLength)) yield {
                remaining: field.options.array.countFieldLength,
                contextHint: ()=>(0, $49d974981e526d97$export$28a41e13b6ac6b17)(field)
            };
            count = reader.readSync(field.options.array.countFieldLength);
        } else if ((_d = (_c = field === null || field === void 0 ? void 0 : field.options) === null || _c === void 0 ? void 0 : _c.array) === null || _d === void 0 ? void 0 : _d.count) count = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.options.array.count, parent, field);
        else if (field === null || field === void 0 ? void 0 : field.length) count = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field === null || field === void 0 ? void 0 : field.length, parent, field);
        if (parent) {
            parent.readFields.push(field.name);
            parent[field.name] = [];
        }
        if (((_f = (_e = field === null || field === void 0 ? void 0 : field.options) === null || _e === void 0 ? void 0 : _e.array) === null || _f === void 0 ? void 0 : _f.type) === Number) {
            // Array of numbers. Useful when the array holds a single number field, but the 
            // bit length of the element fields is not 8 (where you would probably use a single `Buffer` field instead).
            // For instance, in somes IETF RFCs 10 bit words are used instead of 8 bit words (ie bytes).
            let elementLength = field.options.array.elementLength;
            let format = (_j = (_h = (_g = field === null || field === void 0 ? void 0 : field.options) === null || _g === void 0 ? void 0 : _g.number) === null || _h === void 0 ? void 0 : _h.format) !== null && _j !== void 0 ? _j : 'unsigned';
            let readNumber = ()=>{
                if (format === 'signed') elements.push(reader.readSignedSync(elementLength));
                else if (format === 'float') elements.push(reader.readFloatSync(elementLength));
                else if (format === 'unsigned') elements.push(reader.readSync(elementLength));
                else throw new Error(`Unsupported number format '${format}'`);
            };
            if ((_l = (_k = field === null || field === void 0 ? void 0 : field.options) === null || _k === void 0 ? void 0 : _k.array) === null || _l === void 0 ? void 0 : _l.hasMore) do {
                let continued;
                try {
                    parent.runWithFieldBeingComputed(field, ()=>continued = field.options.array.hasMore(elements, parent, parent.parent), true);
                } catch (e) {
                    throw new Error(`${(parent === null || parent === void 0 ? void 0 : parent.constructor.name) || '<none>'}#${String((field === null || field === void 0 ? void 0 : field.name) || '<none>')} Failed to determine if array has more items via 'hasMore' discriminant: ${e.message}`);
                }
                if (!continued) break;
                if (!reader.isAvailable(elementLength)) yield {
                    remaining: elementLength,
                    contextHint: ()=>(0, $49d974981e526d97$export$28a41e13b6ac6b17)(field)
                };
                readNumber();
            }while (true);
            else for(let i = 0; i < count; ++i){
                if (!reader.isAvailable(elementLength)) yield {
                    remaining: elementLength,
                    contextHint: ()=>(0, $49d974981e526d97$export$28a41e13b6ac6b17)(field)
                };
                readNumber();
            }
        } else {
            if (field.options.array.hasMore) {
                let i = 0;
                do {
                    let continued;
                    try {
                        parent.runWithFieldBeingComputed(field, ()=>continued = field.options.array.hasMore(elements, parent, parent.parent), true);
                    } catch (e) {
                        throw new Error(`${(parent === null || parent === void 0 ? void 0 : parent.constructor.name) || '<none>'}#${String((field === null || field === void 0 ? void 0 : field.name) || '<none>')} Failed to determine if array has more items via 'hasMore' discriminant: ${e.message}`);
                    }
                    if (!continued) break;
                    let element;
                    let serializer = new (0, $bdd572b9e10e9eb9$export$2cfc8a9f9c775914)();
                    let gen = serializer.read(reader, field.options.array.type, parent, field);
                    while(true){
                        let result = gen.next();
                        if (result.done === false) yield result.value;
                        else {
                            element = result.value;
                            break;
                        }
                    }
                    elements.push(element);
                    parent[field.name].push(element);
                }while (true);
            } else for(let i = 0; i < count; ++i){
                let element;
                let serializer = new (0, $bdd572b9e10e9eb9$export$2cfc8a9f9c775914)();
                let g = serializer.read(reader, field.options.array.type, parent, field);
                while(true){
                    let result = g.next();
                    if (result.done === false) yield result.value;
                    else {
                        element = result.value;
                        break;
                    }
                }
                elements.push(element);
                parent[field.name].push(element);
            }
        }
        return elements;
    }
    write(writer, type, parent, field, value) {
        var _a, _b, _c, _d, _e;
        if (!value) throw new Error(`${(parent === null || parent === void 0 ? void 0 : parent.constructor.name) || '<none>'}#${String(field === null || field === void 0 ? void 0 : field.name) || '<none>'}: Cannot serialize a null array!`);
        let length = value.length;
        if (field.options.array.countFieldLength) {
            let countFieldLength = field.options.array.countFieldLength;
            if (length >= Math.pow(2, countFieldLength)) length = Math.pow(2, countFieldLength) - 1;
            writer.write(field.options.array.countFieldLength, value.length);
        } else if (field.options.array.count) {
            try {
                length = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.options.array.count, parent, field);
            } catch (e) {
                throw new Error(`Failed to resolve length for array via 'count': ${e.message}`);
            }
            if (length > value.length) throw new Error(`${field.containingType.name}#${String(field.name)}: ` + `Array field's count determinant specified ${length} elements should be written ` + `but array only contains ${value.length} elements. ` + `Ensure that the value of the count determinant is compatible with the number of elements in ` + `the provided array.`);
        }
        for(let i = 0; i < length; ++i)if (((_b = (_a = field === null || field === void 0 ? void 0 : field.options) === null || _a === void 0 ? void 0 : _a.array) === null || _b === void 0 ? void 0 : _b.type) === Number) {
            let type = (_e = (_d = (_c = field.options) === null || _c === void 0 ? void 0 : _c.number) === null || _d === void 0 ? void 0 : _d.format) !== null && _e !== void 0 ? _e : 'unsigned';
            if (type === 'unsigned') writer.write(field.options.array.elementLength, value[i]);
            else if (type === 'signed') writer.writeSigned(field.options.array.elementLength, value[i]);
            else if (type === 'float') writer.writeFloat(field.options.array.elementLength, value[i]);
        } else value[i].write(writer, {
            context: parent === null || parent === void 0 ? void 0 : parent.context
        });
    }
}






class $88d9d4087d5a861b$export$9a3a3a30e8af0985 {
    *read(reader, type, parent, field) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let length = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.length, parent, field);
        if (!reader.isAvailable(length)) yield {
            remaining: length,
            contextHint: ()=>(0, $49d974981e526d97$export$28a41e13b6ac6b17)(field)
        };
        const numericValue = reader.readSync(length);
        const trueValue = (_c = (_b = (_a = field === null || field === void 0 ? void 0 : field.options) === null || _a === void 0 ? void 0 : _a.boolean) === null || _b === void 0 ? void 0 : _b.true) !== null && _c !== void 0 ? _c : 1;
        const falseValue = (_f = (_e = (_d = field === null || field === void 0 ? void 0 : field.options) === null || _d === void 0 ? void 0 : _d.boolean) === null || _e === void 0 ? void 0 : _e.false) !== null && _f !== void 0 ? _f : 0;
        const mode = (_j = (_h = (_g = field === null || field === void 0 ? void 0 : field.options) === null || _g === void 0 ? void 0 : _g.boolean) === null || _h === void 0 ? void 0 : _h.mode) !== null && _j !== void 0 ? _j : 'true-unless';
        if (mode === 'true-unless') return numericValue !== falseValue;
        else if (mode === 'false-unless') return numericValue === trueValue;
        else if (mode === 'undefined') return numericValue === trueValue ? true : numericValue === falseValue ? false : undefined;
    }
    write(writer, type, instance, field, value) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const trueValue = (_c = (_b = (_a = field === null || field === void 0 ? void 0 : field.options) === null || _a === void 0 ? void 0 : _a.boolean) === null || _b === void 0 ? void 0 : _b.true) !== null && _c !== void 0 ? _c : 1;
        const falseValue = (_f = (_e = (_d = field === null || field === void 0 ? void 0 : field.options) === null || _d === void 0 ? void 0 : _d.boolean) === null || _e === void 0 ? void 0 : _e.false) !== null && _f !== void 0 ? _f : 0;
        const undefinedValue = (_j = (_h = (_g = field === null || field === void 0 ? void 0 : field.options) === null || _g === void 0 ? void 0 : _g.boolean) === null || _h === void 0 ? void 0 : _h.undefined) !== null && _j !== void 0 ? _j : 0;
        let numericValue;
        if (value === void 0) numericValue = undefinedValue;
        else if (value) numericValue = trueValue;
        else numericValue = falseValue;
        writer.write((0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.length, instance, field), numericValue);
    }
}







var $5d23e541cfb2edf9$require$Buffer = $d7c85d362df61e1a$export$a143d493d941bafc;
class $5d23e541cfb2edf9$export$de3bda2058911511 {
    *read(reader, type, parent, field) {
        let length;
        try {
            length = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.length, parent, field) / 8;
        } catch (e) {
            throw new Error(`Failed to resolve length for buffer via 'length': ${e.message}`);
        }
        let buffer;
        if (typeof $5d23e541cfb2edf9$require$Buffer !== 'undefined' && field.type === $5d23e541cfb2edf9$require$Buffer) buffer = $5d23e541cfb2edf9$require$Buffer.alloc(length);
        else buffer = new Uint8Array(length);
        let gen = reader.readBytes(buffer);
        while(true){
            let result = gen.next();
            if (result.done === false) yield {
                remaining: result.value * 8,
                contextHint: ()=>(0, $49d974981e526d97$export$28a41e13b6ac6b17)(field)
            };
            else break;
        }
        return buffer;
    }
    write(writer, type, parent, field, value) {
        var _a, _b, _c, _d, _e, _f;
        let length;
        try {
            length = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.length, parent, field) / 8;
        } catch (e) {
            throw new Error(`Failed to resolve length for buffer via 'length': ${e.message}`);
        }
        let fieldLength = Math.floor(length);
        let truncate = (_c = (_b = (_a = field.options) === null || _a === void 0 ? void 0 : _a.buffer) === null || _b === void 0 ? void 0 : _b.truncate) !== null && _c !== void 0 ? _c : true;
        let fill = (_f = (_e = (_d = field.options) === null || _d === void 0 ? void 0 : _d.buffer) === null || _e === void 0 ? void 0 : _e.fill) !== null && _f !== void 0 ? _f : truncate ? 0 : false;
        if (!value) throw new Error(`BufferSerializer: Field ${String(field.name)}: Cannot encode a null buffer`);
        if (value.length > fieldLength) {
            if (truncate) {
                writer.writeBuffer(value.subarray(0, fieldLength));
                return;
            }
        } else if (value.length < fieldLength) {
            if (fill !== false) {
                let filledBuffer = new Uint8Array(fieldLength).fill(fill);
                for(let i = 0, max = value.length; i < max; ++i)filledBuffer[i] = value[i];
                writer.writeBuffer(filledBuffer);
                return;
            }
        }
        writer.writeBuffer(value);
    }
}



class $f57820c469de17f4$export$968d3f2cc585a599 {
    constructor(){
        this.buffer = new Uint8Array(0);
    }
    write(chunk) {
        let buf = new Uint8Array(this.buffer.length + chunk.length);
        buf.set(this.buffer);
        buf.set(chunk, this.buffer.length);
        this.buffer = buf;
    }
}










var $58da134f34dd999c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $58da134f34dd999c$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $58da134f34dd999c$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $58da134f34dd999c$var$_BitstreamElement_parent, $58da134f34dd999c$var$_BitstreamElement_readFields, $58da134f34dd999c$var$_BitstreamElement_isBeingRead, $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputed, $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputedIntrospectable;
const $58da134f34dd999c$var$SERIALIZE_WRITERS = Symbol('Writers used by Bitstream#serialize() for this element type.');
class $58da134f34dd999c$export$3774ac7e5d401ad0 {
    constructor(){
        /**
         * The size of the write buffer when using the serialize() method. This is set to 1KB by default, but may need to
         * be tweaked for large objects.
         */ this.serializeBufferSize = 1024;
        $58da134f34dd999c$var$_BitstreamElement_parent.set(this, void 0);
        $58da134f34dd999c$var$_BitstreamElement_readFields.set(this, []);
        $58da134f34dd999c$var$_BitstreamElement_isBeingRead.set(this, void 0);
        $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputed.set(this, void 0);
        $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputedIntrospectable.set(this, void 0);
    }
    // Lifecycle events
    /**
     * Called when this object is created as part of an element parsing operation.
     * - For unvariated elements this is called before parsing begins.
     * - For variated elements this is called before the original element's fields are copied into this instance.
     *   The instance being variated is passed as 'variatingFrom' in this case.
     *
     * In either case, no fields have been populated within the instance before the lifecycle event is invoked.
     * To observe the values copied in when this object is the result of variation, see onVariationFrom().
     */ onParseStarted(variatingFrom) {}
    /**
     * Called when this object has completed parsing including all variation operations.
     *
     * Note that onParseFinished() may not be invoked if the bitstream is exhausted before
     * parsing is finished or if this instance is replaced via variation. To observe this process, use
     * onVariationTo/onVariationFrom. The final variation is the only one that has onParseFinished() invoked.
     */ onParseFinished() {}
    /**
     * Called when this object is undergoing variation. The 'replacement' parameter contains the newly variated
     * object. No further lifecycle events will occur for this instance, and all future lifecycle events occur on
     * the replacement object.
     *
     * @param replacement
     */ onVariationTo(replacement) {}
    /**
     * Called when this object is the result of a variation operation. The 'source' parameter contains the original
     * object. At this point all fields of the variation source have been copied into the new variant object.
     * @param source
     */ onVariationFrom(source) {}
    /**
     * Called when this object is about to be serialized to a BitstreamWriter.
     */ onSerializeStarted() {}
    /**
     * Called when this object has been completely serialized to a BitstreamWriter.
     */ onSerializeFinished() {}
    /**
     * Retrieve the "syntax" of this element, which is the list of fields defined on the element
     * in order of appearance within the bitstream.
     */ static get syntax() {
        let parentSyntax = Object.getPrototypeOf(this).syntax || [];
        let syntax = parentSyntax.slice();
        let ownSyntax = this.ownSyntax;
        let insertIndex = syntax.findIndex((x)=>x.options.isVariantMarker);
        if (insertIndex >= 0) syntax.splice(insertIndex, 0, ...ownSyntax);
        else syntax.push(...ownSyntax);
        return syntax;
    }
    determineVariantType(parent, variants) {
        var _a;
        let elementType = this.constructor;
        variants !== null && variants !== void 0 ? variants : variants = elementType['variants'] || [];
        let variantDefns = variants.map((typeOrVariant)=>typeof typeOrVariant === 'function' ? {
                type: typeOrVariant,
                discriminant: typeOrVariant.variantDiscriminant
            } : typeOrVariant);
        variantDefns = variantDefns.sort((a, b)=>{
            let aPriority = a.options.priority || 0;
            let bPriority = b.options.priority || 0;
            if (aPriority === 'first') aPriority = Number.MIN_SAFE_INTEGER;
            if (aPriority === 'last') aPriority = Number.MAX_SAFE_INTEGER;
            if (bPriority === 'first') bPriority = Number.MIN_SAFE_INTEGER;
            if (bPriority === 'last') bPriority = Number.MAX_SAFE_INTEGER;
            return aPriority - bPriority;
        });
        return (_a = variantDefns.find((v)=>v.discriminant(this, parent))) === null || _a === void 0 ? void 0 : _a.type;
    }
    /**
     * Create a copy of this element instance
     * @returns A new copy of this element
     */ clone() {
        let newInstance = new this.constructor();
        for (let field of this.syntax)newInstance[field.name] = this[field.name];
        return newInstance;
    }
    /**
     * Retrieve the field definition of a field as specified by the given field reference
     * @param ref The field being referenced
     * @returns The field definition
     */ selectField(ref) {
        if (typeof ref === 'string' || typeof ref === 'symbol') return this.syntax.find((x)=>x.name === ref);
        let selector = this.syntax.reduce((pv, cv)=>(pv[cv.name] = cv.name, pv), {});
        let selected = ref(selector);
        return this.syntax.find((x)=>x.name === selected);
    }
    /**
     * Serialize all fields or a subset of fields into a buffer.
     * @param fromRef The first field that should be serialized. If not specified, serialization begins at the start of
     *                  the element
     * @param toRef The last field that should be serialized. If not specified, serialization continues until the end of
     *                  the element
     * @param autoPad When true and the bitsize of a field is not a multiple of 8, the final byte will
     *                  contain zeros up to the next byte. When false (default), serialize() will throw
     *                  if the size is not a multiple of 8.
     */ serialize(fromRef, toRef, autoPad = false) {
        var _a;
        if (this.syntax.length === 0) return;
        if (!fromRef) fromRef = this.syntax[0].name;
        if (!toRef) {
            if (this.getFieldBeingComputed()) {
                let toIndex = this.syntax.findIndex((f)=>f.name === this.getFieldBeingComputed().name);
                if (!this.getFieldBeingComputedIntrospectable()) toIndex -= 1;
                if (toIndex < 0) return new Uint8Array(0);
                toRef = this.syntax[toIndex].name;
            } else if (this.isBeingRead) {
                let readFields = this.syntax.filter((x)=>this.readFields.includes(x.name)).map((x)=>x.name);
                toRef = readFields[readFields.length - 1];
            } else toRef = this.syntax[this.syntax.length - 1].name;
        }
        this.context = {};
        let from = this.selectField(fromRef);
        let to = this.selectField(toRef);
        let fromIndex = this.syntax.findIndex((x)=>x === from);
        let toIndex = this.syntax.findIndex((x)=>x === to);
        let stream = new (0, $f57820c469de17f4$export$968d3f2cc585a599)();
        // To reduce allocations during serialize(), we need to reuse writers.
        if (!this.constructor[$58da134f34dd999c$var$SERIALIZE_WRITERS]) this.constructor[$58da134f34dd999c$var$SERIALIZE_WRITERS] = [];
        let writer = (_a = this.constructor[$58da134f34dd999c$var$SERIALIZE_WRITERS].pop()) !== null && _a !== void 0 ? _a : new (0, $c809b947cddc2a78$export$3fa3b5652b53dfc4)(stream, this.serializeBufferSize);
        writer.stream = stream;
        try {
            if (fromIndex > toIndex) throw new Error(`Cannot measure from field ${fromIndex} (${String(from.name)}) to ${toIndex} (${String(to.name)}): First field comes after last field`);
            for(let i = fromIndex, max = toIndex; i <= max; ++i){
                let field = this.syntax[i];
                if (!this.isPresent(field, this)) continue;
                let writtenValue = this[field.name];
                if (field.options.writtenValue) {
                    if (typeof field.options.writtenValue === 'function') writtenValue = field.options.writtenValue(this, field);
                    else writtenValue = field.options.writtenValue;
                }
                try {
                    field.options.serializer.write(writer, field.type, this, field, writtenValue);
                } catch (e) {
                    if (globalThis.BITSTREAM_TRACE !== false) {
                        console.error(`Failed to write field ${field.type.name}#${String(field.name)} using ${field.options.serializer.constructor.name}: ${e.message}`);
                        console.error(e);
                    }
                    throw new Error(`Failed to write field ${String(field.name)} using ${field.options.serializer.constructor.name}: ${e.message}`);
                }
            }
            if (writer.byteOffset !== 0 && !autoPad) {
                let length = writer.offset;
                throw new Error(`${length} bits (${Math.floor(length / 8)} bytes + ${length % 8} bits) is not an even amount of bytes!`);
            }
            writer.end();
            return stream.buffer;
        } finally{
            writer.reset();
            this.constructor[$58da134f34dd999c$var$SERIALIZE_WRITERS].push(writer);
        }
    }
    /**
     * Measure the number of bits starting from the first field and continuing through the structure until the last
     * field.
     * @param fromRef The field to start measuring from (including the specified field). When not specified, measurement
     *                  starts from the first field
     * @param toRef The field to stop measuring at (including the specified field). When not specified, measurement
     *                  ends at the last field
     * @returns The number of bits occupied by the range of fields
     */ measure(fromRef, toRef) {
        if (!fromRef) fromRef = this.syntax[0].name;
        if (!toRef) {
            if (this.getFieldBeingComputed()) {
                let toIndex = this.syntax.findIndex((f)=>f.name === this.getFieldBeingComputed().name);
                if (!this.getFieldBeingComputedIntrospectable()) toIndex -= 1;
                if (toIndex < 0) return 0;
                toRef = this.syntax[toIndex].name;
            } else if (this.isBeingRead) {
                let readFields = this.syntax.filter((x)=>this.readFields.includes(x.name)).map((x)=>x.name);
                toRef = readFields[readFields.length - 1];
            } else toRef = this.syntax[this.syntax.length - 1].name;
        }
        let from = this.selectField(fromRef);
        let to = this.selectField(toRef);
        let fieldBeingRead = this.syntax.find((x)=>!this.readFields.includes(x.name));
        let fromIndex = this.syntax.findIndex((x)=>x === from);
        let toIndex = this.syntax.findIndex((x)=>x === to);
        let measurer = new (0, $c809b947cddc2a78$export$8af03bf62a626825)();
        if (fromIndex > toIndex) throw new Error(`Cannot measure from field ${fromIndex} (${String(from.name)}) to ${toIndex} (${String(to.name)}): First field comes after last field`);
        for(let i = fromIndex, max = toIndex; i <= max; ++i){
            let field = this.syntax[i];
            if (!this.isPresent(field, this)) continue;
            try {
                field.options.serializer.write(measurer, this.constructor, this, field, this[field.name]);
            } catch (e) {
                if (globalThis.BITSTREAM_TRACE === true) {
                    console.error(`Failed to measure field ${this.constructor.name}#${String(field.name)}:`);
                    console.error(e);
                }
                throw new Error(`${this.constructor.name}#${String(field.name)}: Cannot measure field: ${e.message}`);
            }
        }
        return measurer.bitLength;
    }
    /**
     * Measure from the beginning of the element to the given field
     * @param toRef The field to stop measuring at (including the specified field)
     * @returns The number of bits occupied by the set of fields
     */ measureTo(toRef) {
        return this.measure(undefined, toRef);
    }
    /**
     * Measure from the given field to the end of the element
     * @param fromRef The field to start measuing at (including the specified field)
     * @returns The number of bits occupied by the set of fields
     */ measureFrom(fromRef) {
        return this.measure(fromRef, undefined);
    }
    /**
     * Measure the size of a specific field
     * @param ref The field to measure
     * @returns The number of bits occupied by the field
     */ measureField(ref) {
        return this.measure(ref, ref);
    }
    /**
     * Check that this instance is one of a set of given subtypes. If it is,
     * this instance is returned with the more specific type.
     * If it is not, an error is thrown.
     *
     * @param typeChecks One or more subclasses to check
     * @returns This instance, but casted to the desired type
     */ as(...typeChecks) {
        if (!typeChecks.some((x)=>this instanceof x)) throw new Error(`Tried to cast to one of [${typeChecks.map((x)=>x.name).join(', ')}], but ${this.constructor.name} does not inherit from any of them`);
        return this;
    }
    /**
     * Check that this instance is one of a set of given subtypes.
     * @param typeChecks
     * @returns
     */ is(...typeChecks) {
        return typeChecks.some((x)=>this instanceof x);
    }
    /**
     * Retrieve the set of defined variants for this element class
     */ static get variants() {
        return this.hasOwnProperty('ownVariants') ? this.ownVariants : [];
    }
    /**
     * Retrieve the syntax defined for this specific class, excluding the syntax
     * defined by its superclasses
     */ static get ownSyntax() {
        let obj = this;
        if (!obj.hasOwnProperty('$ownSyntax')) Object.defineProperty(obj, '$ownSyntax', {
            writable: true,
            value: [],
            enumerable: false
        });
        return obj['$ownSyntax'];
    }
    static set ownSyntax(value) {
        this.ownSyntax.length; // causes property to be created
        this['$ownSyntax'] = value;
    }
    /**
     * Retrieve the element which contains this element, if any
     */ get parent() {
        return $58da134f34dd999c$var$__classPrivateFieldGet(this, $58da134f34dd999c$var$_BitstreamElement_parent, "f");
    }
    /**
     * Set the parent element of this element
     */ set parent(value) {
        $58da134f34dd999c$var$__classPrivateFieldSet(this, $58da134f34dd999c$var$_BitstreamElement_parent, value, "f");
    }
    /**
     * True when this element is currently being read, false otherwise
     */ get isBeingRead() {
        return $58da134f34dd999c$var$__classPrivateFieldGet(this, $58da134f34dd999c$var$_BitstreamElement_isBeingRead, "f");
    }
    /**
     * Set whether this element is currently being read
     */ set isBeingRead(value) {
        $58da134f34dd999c$var$__classPrivateFieldSet(this, $58da134f34dd999c$var$_BitstreamElement_isBeingRead, value, "f");
    }
    /**
     * Retrieve the set of field names which has been read so far
     */ get readFields() {
        return $58da134f34dd999c$var$__classPrivateFieldGet(this, $58da134f34dd999c$var$_BitstreamElement_readFields, "f");
    }
    /**
     * Determine if the field currently being computed is introspectable,
     * meaning that the bits it has read so far will be considered during measurement,
     * even though it possibly has not finished reading all bits it will read yet
     * @returns
     */ getFieldBeingComputedIntrospectable() {
        return $58da134f34dd999c$var$__classPrivateFieldGet(this, $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputedIntrospectable, "f");
    }
    /**
     * Get the definition of the field currently being computed, if any.
     * @returns
     */ getFieldBeingComputed() {
        return $58da134f34dd999c$var$__classPrivateFieldGet(this, $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputed, "f");
    }
    /**
     * Convert this element to a JSON-compatible representation which contains
     * only the fields defined on the element (aka its "syntax")
     */ toJSON() {
        return this.syntax.map((s)=>[
                s.name,
                this[s.name]
            ]).reduce((pv, [k, v])=>(pv[k] = v, pv), {});
    }
    /**
     * Run the given callback while in a state where the given field is considered to be the one "being computed",
     * which is primarily used to enable the current size of arrays as they are read in cases where the count of
     * items in the array is dependent on the overall bitlength of the previous elements that have been read. See
     * the `hasMore` option of ArrayOptions
     *
     * @param field The field being computed
     * @param callback The function to run
     * @param introspectable When true, the computed field is marked as introspectable
     */ runWithFieldBeingComputed(field, callback, introspectable) {
        let before = this.getFieldBeingComputed();
        let beforeIntrospectable = this.getFieldBeingComputedIntrospectable();
        try {
            $58da134f34dd999c$var$__classPrivateFieldSet(this, $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputed, field, "f");
            $58da134f34dd999c$var$__classPrivateFieldSet(this, $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputedIntrospectable, introspectable, "f");
            return callback();
        } finally{
            $58da134f34dd999c$var$__classPrivateFieldSet(this, $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputed, before, "f");
            $58da134f34dd999c$var$__classPrivateFieldSet(this, $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputedIntrospectable, beforeIntrospectable, "f");
        }
    }
    /**
     * Get the "syntax" of this element instance; this is the set of fields that compose the element, in order.
     */ get syntax() {
        return this.constructor.syntax;
    }
    /**
     * Get the "syntax" of this element instance excluding syntax defined by its superclasses; this is the
     * set of fields that compose the elemnet, in order.
     */ get ownSyntax() {
        return this.constructor.ownSyntax;
    }
    leftPad(num, digits = 4) {
        let str = `${num}`;
        while(str.length < digits)str = ` ${str}`;
        return str;
    }
    rightPad(num, digits = 4) {
        let str = `${num}`;
        while(str.length < digits)str = `${str} `;
        return str;
    }
    zeroPad(num, digits = 4) {
        let str = `${num}`;
        while(str.length < digits)str = `0${str}`;
        return str;
    }
    isPresent(element, instance, reader) {
        var _a, _b;
        if (element.options.presentWhen) {
            if (!instance.runWithFieldBeingComputed(element, ()=>element.options.presentWhen(instance))) return false;
        }
        if (element.options.excludedWhen) {
            if (instance.runWithFieldBeingComputed(element, ()=>element.options.excludedWhen(instance))) return false;
        }
        // Perform readahead checks. It is expected that the caller has already read the requisite number of bits 
        // ahead to allow the checks to occur.
        if (reader) {
            if ((_a = element.options.readAhead) === null || _a === void 0 ? void 0 : _a.presentWhen) {
                if (!reader.simulateSync(()=>element.options.readAhead.presentWhen(reader, instance))) return false;
            }
            if ((_b = element.options.readAhead) === null || _b === void 0 ? void 0 : _b.excludedWhen) {
                if (reader.simulateSync(()=>element.options.readAhead.excludedWhen(reader, instance))) return false;
            }
        }
        return true;
    }
    /**
     * Read a specific group of fields from the bitstream and serialize their values into this instance. This is called
     * by BitstreamElement for you, but can be used when overriding the default read behavior.
     * @param bitstream The bitstream reader to read from
     * @param name The name of the group to read. Some special values are accepted: '*' means all fields, '$*' means all
     *              fields defined directly on this class (excluding its superclasses). Other group specifiers starting
     *              with '$' match fields defined directly on this class which are part of the specified group (for
     *              instance '$foo' matches directly defined fields in the 'foo' group). Otherwise, the string is
     *              matched directly against the 'group' option of all fields.
     * @param variator A function which implements variation of this instance in the case where a `@VariantMarker` is
     *              encountered. The function should determine an appropriate variant and return it; when it does so,
     *              the group will continue to be read after the marker, but the results of reading the field will be
     *              applied to the returned instance instead of this instance
     * @param options Serialization options that modify how the group is read. Most notably this allows you to skip
     *              specific fields.
     * @returns A generator. When the read is complete (done=true), the result will be the current instance,
     *              unless the instance was variated into a subclass, in which case it will be the
     *              variated subclass instance. Because this process can occur, it is important to observe the result
     *              of this function. If the read buffer becomes exhausted, an IncompleteReadResult will be returned.
     */ *readGroup(bitstream, name, options) {
        let wasBeingRead = this.isBeingRead;
        let instance = this;
        instance.isBeingRead = true;
        try {
            let syntax;
            if (name === '*') syntax = this.syntax;
            else if (name === '$*') syntax = this.ownSyntax;
            else if (name.startsWith('$')) {
                // if (name !== '*' && element.options.group !== name)
                let group = name.slice(1);
                syntax = this.ownSyntax.filter((x)=>x.options.group === group);
            } else syntax = this.ownSyntax.filter((x)=>x.options.group === name);
            for (let element of syntax){
                // Preconditions 
                if (element.options.readAhead) {
                    let length = 0;
                    if (typeof element.options.readAhead.length === 'number') length = element.options.readAhead.length;
                    else if (typeof element.options.readAhead.length === 'function') length = element.options.readAhead.length(instance, element);
                    if (bitstream.available < length) yield {
                        remaining: length - bitstream.available,
                        contextHint: ()=>`[readAhead ${length} bits]`,
                        optional: true
                    };
                }
                if (!this.isPresent(element, instance, bitstream)) continue;
                if ((options === null || options === void 0 ? void 0 : options.skip) && options.skip.includes(element.name)) continue;
                // If this is a @VariantMarker(), perform marker variation.
                // This is one of two ways variation can occur- the other being 
                // "tail variation" which happens after all fields of this type are parsed
                // and none of them are marked with @VariantMarker().
                if (element.options.isVariantMarker) {
                    if (globalThis.BITSTREAM_TRACE) console.log(`Variating at marker...`);
                    let g = this.variate(bitstream, options.parent, options.field);
                    while(true){
                        let result = g.next();
                        if (result.done === false) {
                            let incompleteResult = result.value;
                            yield {
                                remaining: incompleteResult.remaining,
                                contextHint: ()=>this.summarizeElementField(element, incompleteResult.contextHint()),
                                optional: incompleteResult.optional
                            };
                        } else {
                            instance = result.value;
                            break;
                        }
                    }
                    if (!instance) throw new Error(`Variator did not return a value!`);
                    continue;
                }
                // Parsing 
                let traceTimeout;
                if (globalThis.BITSTREAM_TRACE === true) traceTimeout = setTimeout(()=>{
                    console.log(`[!!] ${element.containingType.name}#${String(element.name)}: Stuck reading!`);
                }, 5000);
                try {
                    let startOffset = bitstream.offset;
                    let g = element.options.serializer.read(bitstream, element.type, instance, element);
                    let readValue;
                    while(true){
                        let result = g.next();
                        if (result.done === false) {
                            let incompleteResult = result.value;
                            yield {
                                remaining: incompleteResult.remaining,
                                contextHint: ()=>this.summarizeElementField(element, incompleteResult.contextHint()),
                                optional: incompleteResult.optional
                            };
                        } else {
                            readValue = result.value;
                            break;
                        }
                    }
                    if (!element.options.isIgnored) instance[element.name] = readValue;
                    instance.readFields.push(element.name);
                    instance.bitsRead += bitstream.offset - startOffset;
                    let displayedValue = `${readValue}`;
                    if (typeof readValue === 'number') displayedValue = `0x${readValue.toString(16)} [${readValue}]`;
                    if (globalThis.BITSTREAM_TRACE === true) {
                        try {
                            console.log(`[ + ${this.leftPad(instance.measureField(element.name), 4)} bit(s) = ${this.leftPad(Math.floor(instance.measureTo(element.name) / 8), 4)} byte(s), ${this.leftPad(instance.measureTo(element.name) - Math.floor(instance.measureTo(element.name) / 8) * 8, 4)} bits = ${this.leftPad(instance.measureTo(element.name), 4)} bits total] ` + `   ${this.rightPad(`${element.containingType.name}#${String(element.name)}`, 50)} <= ${displayedValue}`);
                        } catch (e) {
                            console.log(`Error while tracing read operation for element ${String(element.name)}: ${e.message}`);
                            console.error(e);
                        }
                        clearTimeout(traceTimeout);
                    }
                } catch (thrown) {
                    let e = thrown;
                    if (e.message.startsWith('underrun:')) throw new Error(`Ran out of bits while deserializing field ${String(element.name)} ` + `in group '${name}' ` + `of element ${instance.constructor.name}`);
                    else throw e;
                }
            }
        } finally{
            this.isBeingRead = wasBeingRead;
        }
        return instance;
    }
    /**
     * Write a group of fields to the given bitstream writer. This is used by BitstreamElement internally, but it can
     * be called directly when overriding the default write behavior in a subclass, if desired.
     * @param bitstream The bitstream writer to write the fields to
     * @param name The name of the group to write.
     * @param options Options that modify how the group is written. Most notably this allows you to skip specific
     *                  fields.
     */ writeGroup(bitstream, name, options) {
        let syntax = this.syntax;
        for (let element of syntax){
            if (name !== '*' && element.options.group !== name) continue;
            if ((options === null || options === void 0 ? void 0 : options.skip) && options.skip.includes(element.name)) continue;
            // Preconditions 
            if (!this.isPresent(element, this)) continue;
            let writtenValue = this[element.name];
            if (element.options.writtenValue) {
                if (typeof element.options.writtenValue === 'function') writtenValue = element.options.writtenValue(this, element);
                else writtenValue = element.options.writtenValue;
            }
            if (globalThis.BITSTREAM_TRACE === true && !(bitstream instanceof (0, $c809b947cddc2a78$export$8af03bf62a626825))) {
                let displayedValue = `${writtenValue}`;
                if (typeof writtenValue === 'number') displayedValue = `0x${writtenValue.toString(16)} [${writtenValue}]`;
                try {
                    console.log(`[ + ${this.leftPad(this.measureField(element.name), 4)} bit(s) = ${this.leftPad(Math.floor(this.measureTo(element.name) / 8), 4)} byte(s), ${this.leftPad(this.measureTo(element.name) - Math.floor(this.measureTo(element.name) / 8) * 8, 4)} bits = ${this.leftPad(this.measureTo(element.name), 4)} bits total] ` + `   ${this.rightPad(`${element.containingType.name}#${String(element.name)}`, 50)} => ${displayedValue}`);
                } catch (e) {
                    console.log(`Error while tracing write operation for element ${String(element.name)}: ${e.message}`);
                    console.error(e);
                }
            }
            try {
                element.options.serializer.write(bitstream, element.type, this, element, writtenValue);
            } catch (e) {
                if (globalThis.BITSTREAM_TRACE !== false) {
                    console.error(`Failed to write field ${element.type.name}#${String(element.name)} using ${element.options.serializer.constructor.name}: ${e.message}`);
                    console.error(e);
                }
                throw new Error(`Failed to write field ${String(element.name)} using ${element.options.serializer.constructor.name}: ${e.message}`);
            }
        }
    }
    /**
     * Read this element from the given bitstream reader, applying the resulting values into this instance.
     * @param bitstream The reader to read from
     * @param variator A function which implements variation for this instance. The function should determine an
     *                  appropriate variant instance and return it; from there on out the rest of the fields read will
     *                  be applied to that instance instead of this instance.
     * @param options Options which modify how the element is read. Most notably this lets you skip specific fields
     * @returns The current instance, unless it was variated into a subclass instance, in which case it will be the
     *                  variated subclass instance. Thus it is important to observe the result of this method.
     */ *read(bitstream, options) {
        let g = this.readGroup(bitstream, '*', options);
        while(true){
            let result = g.next();
            if (result.done === false) {
                let incompleteResult = result.value;
                yield {
                    remaining: incompleteResult.remaining,
                    contextHint: ()=>this.summarizeElementOperation(`read()`, incompleteResult.contextHint()),
                    optional: incompleteResult.optional
                };
            } else return result.value;
        }
    }
    /**
     * Read just the fields that are part of this specific subclass, ignoring the fields that are defined on superclasses.
     * This is used by BitstreamElement during variation, and is equivalent to readGroup(bitstream, '$*', variator, options)
     * @param bitstream The reader to read from
     * @param variator A function which implements variation for this instance. The function should determine an
     *                  appropriate variant instance and return it; from there on out the rest of the fields read will
     *                  be applied to that instance instead of this instance.
     * @param options Options which modify how the element is read. Most notably this lets you skip specific fields
     * @returns A generator which will yield only one result. If the generator completes (done=true), then the result
     *          will be `this` the current instance, unless it was variated into a subclass instance, in which case
     *          it will be the variated subclass instance. Thus it is important to observe the result of this method.
     *          If the read buffer becomes exhausted, the result will be an IncompleteReadResult.
     */ *readOwn(bitstream, options) {
        let g = this.readGroup(bitstream, '$*', options);
        while(true){
            let result = g.next();
            if (result.done === false) {
                let incompleteResult = result.value;
                yield {
                    remaining: incompleteResult.remaining,
                    contextHint: ()=>this.summarizeElementOperation(`readOwn()`, incompleteResult.contextHint()),
                    optional: incompleteResult.optional
                };
            } else return result.value;
        }
    }
    /**
     * Apply variation rules to this element. If one is found, the new variated instance is returned, otherwise
     * the current instance is returned.
     *
     * @param reader The reader to read from
     * @param parent The parent element of this element
     * @param field The Bitstream field that this element is being parsed for when this is a subelement of a larger
     *     parse operation.
     * @returns
     */ *variate(reader, parent, field) {
        let variantType = this.determineVariantType(parent, field === null || field === void 0 ? void 0 : field.options.variants);
        if (variantType) {
            if (globalThis.BITSTREAM_TRACE) console.log(`Selected variant ${variantType.name}`);
            let g = variantType.read(reader, {
                parent: parent,
                field: field,
                elementBeingVariated: this,
                context: this.context
            });
            do {
                let result = g.next();
                if (result.done === false) {
                    let incompleteResult = result.value;
                    yield {
                        remaining: incompleteResult.remaining,
                        contextHint: ()=>this.summarizeElementOperation(`variate()`, incompleteResult.contextHint()),
                        optional: incompleteResult.optional
                    };
                } else return result.value;
            }while (true);
        }
        return this;
    }
    /**
     * Create a new instance of this BitstreamElement subclass by reading the necessary fields from the given
     * BitstreamReader.
     * @param this
     * @param reader The reader to read from
     * @param parent Specify a parent instance which the new instance is found within
     * @returns
     */ static readBlocking(reader, options = {}) {
        return $58da134f34dd999c$var$__awaiter(this, void 0, void 0, function*() {
            let iterator = this.read(reader, options);
            do {
                let result = iterator.next();
                if (result.done === false) {
                    yield reader.assure(result.value.remaining, result.value.optional);
                    continue;
                }
                return result.value;
            }while (true);
        });
    }
    /**
     * Deserialize an instance of this class from the given
     * data buffer. Will consider available variants, so the
     * result could be a subclass.
     * @param data
     * @returns
     */ static deserialize(data, options = {}) {
        let reader = new (0, $b02d5da943513c89$export$899fe4f7927c31a0)();
        reader.addBuffer(data);
        let gen = this.read(reader, options);
        while(true){
            let result = gen.next();
            if (result.done === false) throw new Error(`Buffer exhausted while reading ${result.value.remaining} bits ` + `at offset ${reader.offset}, ` + `context:\n     - ${result.value.contextHint().replace(/\n/g, "\n     - ")}\n\n`);
            else return result.value;
        }
    }
    /**
     * Write this instance to the given writer
     * @param bitstream The writer to write to
     * @param options Options which modify how the element is written. Most notably this lets you skip specific fields
     */ write(bitstream, options) {
        var _a;
        this.context = (_a = options === null || options === void 0 ? void 0 : options.context) !== null && _a !== void 0 ? _a : {};
        this.onSerializeStarted();
        this.writeGroup(bitstream, '*', options);
        this.onSerializeFinished();
    }
    /**
     * Apply the given properties to this object and return ourself.
     * @param this
     * @param changes The changes to apply
     */ with(changes) {
        Object.assign(this, changes);
        return this;
    }
    /**
     * Perform a synchronous read operation on the given reader with the given generator. If there are not enough bits available
     * to complete the operation, this method will throw an exception.
     *
     * @param reader
     * @param generator
     * @returns
     */ static readSync(reader, options = {}) {
        let iterator = this.read(reader, options);
        do {
            let result = iterator.next();
            if (result.done === false) {
                if (reader.ended && result.value.optional) continue;
                throw new Error(`Not enough bits: Reached end of buffer while trying to read ${result.value.remaining} bits! Context: ${result.value.contextHint()}`);
            }
            return result.value;
        }while (true);
    }
    /**
     * Try to read the bitstream using the given generator function synchronously, if there are not enough bits, abort
     * and return undefined.
     * @param reader The reader to read from
     * @returns The result of the read operation if successful, or undefined if there was not enough bits to complete the operation.
     */ static tryRead(reader, options = {}) {
        let previouslyRetaining = reader.retainBuffers;
        let startOffset = reader.offset;
        reader.retainBuffers = true;
        try {
            let iterator = this.read(reader, options);
            let result = iterator.next();
            if (result.done === false) {
                // we need more bits, fail
                reader.offset = startOffset;
                return undefined;
            }
            return result.value;
        } catch (e) {
            reader.offset = startOffset;
            throw e;
        } finally{
            reader.retainBuffers = previouslyRetaining;
        }
    }
    /**
     * Try to read the bitstream using the given generator function synchronously, if there are not enough bits, abort
     * and return undefined.
     * @param reader The reader to read from
     * @returns A generator which when called will result in exactly one result. The result will either be a number
     *      (in which case 'done' is false) indicating that more bits were required to complete the read operation but
     *      they were unavailable on the given stream. Otherwise it will be an instance of the expected element type (in which
     *      case 'done' is true). The stream will be left in the state where the partial data was read. If you want to
     *      undo the read of the partial data, you will need to use retainBuffers = true, take note of the reader's offset
     *      before the operation, and set the offset of the reader back to that value after the failed read. Note that
     *      retainBuffers requires you to manage the saved buffers manually (see BitstreamReader.clean()).
     */ static *read(reader, options = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        (_a = options.context) !== null && _a !== void 0 ? _a : options.context = {};
        let constructorParams = (_d = (_b = options.params) !== null && _b !== void 0 ? _b : (_c = options.elementBeingVariated) === null || _c === void 0 ? void 0 : _c.savedConstructorParams) !== null && _d !== void 0 ? _d : [];
        let element = new this(...constructorParams);
        if (options.initializer) options.initializer(element);
        if ((_f = (_e = options.field) === null || _e === void 0 ? void 0 : _e.options) === null || _f === void 0 ? void 0 : _f.initializer) options.field.options.initializer(element, options.parent);
        element.savedConstructorParams = constructorParams;
        let allowExhaustion = (_g = options.allowExhaustion) !== null && _g !== void 0 ? _g : false;
        element.context = options.context;
        element.onParseStarted(options.elementBeingVariated);
        element.parent = options.parent;
        let parentStillReading = (_j = (_h = options.elementBeingVariated) === null || _h === void 0 ? void 0 : _h.isBeingRead) !== null && _j !== void 0 ? _j : false;
        element.isBeingRead = true;
        element.bitsRead = 0;
        if (options.elementBeingVariated) {
            element.bitsRead = options.elementBeingVariated.bitsRead;
            element.syntax.forEach((f)=>{
                var _a, _b;
                if (((_b = (_a = options.field) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.skip) && options.field.options.skip.includes(f.name)) return;
                if (options.skip && options.skip.includes(f.name)) return;
                if (options.elementBeingVariated.syntax.some((x)=>x.name === f.name) && options.elementBeingVariated.readFields.includes(f.name)) {
                    if (!f.options.isIgnored) element[f.name] = options.elementBeingVariated[f.name];
                    element.readFields.push(f.name);
                }
            });
            options.elementBeingVariated.onVariationTo(element);
            element.onVariationFrom(options.elementBeingVariated);
            let g = element.readOwn(reader, {
                skip: (_l = (_k = options.field) === null || _k === void 0 ? void 0 : _k.options) === null || _l === void 0 ? void 0 : _l.skip
            });
            while(true){
                let result = g.next();
                if (result.done === false) {
                    if (allowExhaustion) return element;
                    let incompleteResult = result.value;
                    yield {
                        remaining: incompleteResult.remaining,
                        contextHint: ()=>element.summarizeElementOperation(`${this.name}.readVariant()`, incompleteResult.contextHint()),
                        optional: incompleteResult.optional
                    };
                } else {
                    element = result.value;
                    break;
                }
            }
        } else {
            let g = element.read(reader, {
                skip: [
                    ...(_m = options.skip) !== null && _m !== void 0 ? _m : [],
                    ...(_q = (_p = (_o = options.field) === null || _o === void 0 ? void 0 : _o.options) === null || _p === void 0 ? void 0 : _p.skip) !== null && _q !== void 0 ? _q : []
                ]
            });
            while(true){
                let result = g.next();
                if (result.done === false) {
                    if (allowExhaustion) return element;
                    let incompleteResult = result.value;
                    yield {
                        remaining: incompleteResult.remaining,
                        contextHint: ()=>element.summarizeElementOperation(`${this.name}.read()`, incompleteResult.contextHint()),
                        optional: incompleteResult.optional
                    };
                } else {
                    element = result.value;
                    break;
                }
            }
        }
        element.isBeingRead = parentStillReading;
        // Perform tail variation: Only used when there is no @VariantMarker() within the element.
        // For marker variation, see readGroup()'s use of variate()
        if (!element.ownSyntax.some((x)=>x.options.isVariantMarker)) {
            let g = element.variate(reader, options.parent, options.field);
            while(true){
                let result = g.next();
                if (result.done === false) {
                    if (allowExhaustion) return element;
                    let incompleteResult = result.value;
                    yield {
                        remaining: incompleteResult.remaining,
                        contextHint: ()=>element.summarizeElementOperation(`tail-variation`, incompleteResult.contextHint()),
                        optional: incompleteResult.optional
                    };
                } else {
                    element = result.value;
                    break;
                }
            }
        }
        delete element.savedConstructorParams;
        if (!(options === null || options === void 0 ? void 0 : options.elementBeingVariated)) element.onParseFinished();
        return element;
    }
    summarizeElementField(field, innerContext) {
        return `${innerContext}\n[readField()] ${this.constructor.name}#${String(field.name)}`;
    }
    summarizeElementOperation(operation, innerContext) {
        return `${innerContext}\n[${operation}] ${this.constructor.name}`;
    }
}
$58da134f34dd999c$var$_BitstreamElement_parent = new WeakMap(), $58da134f34dd999c$var$_BitstreamElement_readFields = new WeakMap(), $58da134f34dd999c$var$_BitstreamElement_isBeingRead = new WeakMap(), $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputed = new WeakMap(), $58da134f34dd999c$var$_BitstreamElement_fieldBeingComputedIntrospectable = new WeakMap();










/**
 * Serializes nothing to/from bitstreams. Used when the field is a no-op, such as for fields decorated with `@Marker`
 */ class $ce65df80b1656781$export$4d6fd9c9b36dfdf9 {
    *read(reader, type, parent, field) {}
    write(writer, type, instance, field, value) {}
}




class $2ad5fd2773f2e5ef$export$afc0094ae79b78f5 {
    *read(reader, type, parent, field) {
        var _a, _b, _c;
        let length;
        try {
            length = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.length, parent, field);
        } catch (e) {
            throw new Error(`Failed to resolve length of number via 'length' determinant: ${e.message}`);
        }
        if (!reader.isAvailable(length)) yield {
            remaining: length,
            contextHint: ()=>(0, $49d974981e526d97$export$28a41e13b6ac6b17)(field)
        };
        let format = (_c = (_b = (_a = field.options) === null || _a === void 0 ? void 0 : _a.number) === null || _b === void 0 ? void 0 : _b.format) !== null && _c !== void 0 ? _c : 'unsigned';
        if (format === 'unsigned') return reader.readSync(length);
        else if (format === 'signed') return reader.readSignedSync(length);
        else if (format === 'float') return reader.readFloatSync(length);
        else throw new TypeError(`Unsupported number format '${format}'`);
    }
    write(writer, type, instance, field, value) {
        var _a, _b, _c;
        if (value === undefined) value = 0;
        let length;
        try {
            length = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.length, instance, field);
        } catch (e) {
            throw new Error(`Failed to resolve length of number via 'length' determinant: ${e.message}`);
        }
        let format = (_c = (_b = (_a = field.options) === null || _a === void 0 ? void 0 : _a.number) === null || _b === void 0 ? void 0 : _b.format) !== null && _c !== void 0 ? _c : 'unsigned';
        if (format === 'unsigned') writer.write(length, value);
        else if (format === 'signed') writer.writeSigned(length, value);
        else if (format === 'float') writer.writeFloat(length, value);
        else throw new TypeError(`Unsupported number format '${format}'`);
    }
}




class $90bb157d0a0de04f$export$58fd17adb1de0ac8 {
    *read(reader, type, parent, field) {
        let length = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.length, parent, field);
        if (!reader.isAvailable(length * 8)) yield {
            remaining: length * 8,
            contextHint: ()=>(0, $49d974981e526d97$export$28a41e13b6ac6b17)(field)
        };
        return reader.readStringSync(length, field.options.string);
    }
    write(writer, type, parent, field, value) {
        var _a, _b;
        let length;
        try {
            length = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.length, parent, field);
        } catch (e) {
            throw new Error(`Failed to resolve length of string via 'length' determinant: ${e.message}`);
        }
        writer.writeString(length, `${value}`, ((_b = (_a = field === null || field === void 0 ? void 0 : field.options) === null || _a === void 0 ? void 0 : _a.string) === null || _b === void 0 ? void 0 : _b.encoding) || 'utf-8');
    }
}




var $d26d71a32f322040$require$Buffer = $d7c85d362df61e1a$export$a143d493d941bafc;
function $d26d71a32f322040$export$a455218a85c89869(...args) {
    let length = 0;
    let options = undefined;
    if ([
        'number',
        'function'
    ].includes(typeof args[0])) length = args.shift();
    if (typeof args[0] === 'object') options = args.shift();
    if (!options) options = {};
    return (target, fieldName)=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let containingType = target.constructor;
        let field = {
            name: fieldName,
            containingType: containingType,
            type: Reflect.getMetadata('design:type', target, fieldName),
            length: length,
            options: options
        };
        let fieldDesc = `${containingType.name}#${String(field.name)}`;
        let BufferT = typeof $d26d71a32f322040$require$Buffer !== 'undefined' ? $d26d71a32f322040$require$Buffer : undefined;
        if ((field.type === BufferT || field.type === Uint8Array) && typeof field.length === 'number' && field.length % 8 !== 0) throw new Error(`${fieldDesc}: Length (${field.length}) must be a multiple of 8 when field type is Buffer`);
        if (field.type === Array) {
            if (!((_a = field.options.array) === null || _a === void 0 ? void 0 : _a.type)) throw new Error(`${fieldDesc}: Array field must specify option array.type`);
            if (!(((_b = field.options.array) === null || _b === void 0 ? void 0 : _b.type.prototype) instanceof (0, $58da134f34dd999c$export$3774ac7e5d401ad0)) && ((_c = field.options.array) === null || _c === void 0 ? void 0 : _c.type) !== Number) throw new Error(`${fieldDesc}: Array fields can only be used with types which inherit from BitstreamElement`);
            if ((_d = field.options.array) === null || _d === void 0 ? void 0 : _d.countFieldLength) {
                if (typeof field.options.array.countFieldLength !== 'number' || field.options.array.countFieldLength <= 0) throw new Error(`${fieldDesc}: Invalid value provided for length of count field: ${field.options.array.countFieldLength}. Must be a positive number.`);
            }
            if ((_e = field.options.array) === null || _e === void 0 ? void 0 : _e.count) {
                if (typeof field.options.array.count !== 'number' && typeof field.options.array.count !== 'function') throw new Error(`${fieldDesc}: Invalid value provided for count determinant: ${field.options.array.count}. Must be a number or function`);
            }
        }
        if (field.options.readAhead) {
            if (field.options.readAhead === undefined) throw new Error(`${fieldDesc}: To use the readAhead option, you must specify readAhead.length`);
            if (![
                'number',
                'function'
            ].includes(typeof field.options.readAhead.length)) throw new Error(`${fieldDesc}: Invalid read-ahead length specified (must be a number or discriminant function)`);
        }
        if (field.type === Number) {
            if (typeof field.length === 'number' && field.length > 53 && ((_f = field.options.number) === null || _f === void 0 ? void 0 : _f.format) !== 'float' && !((_g = field.options.number) === null || _g === void 0 ? void 0 : _g.allowOversized)) throw new Error(`${fieldDesc}: It is not safe to use the 'number' type for fields larger than 53 bits. ` + `Consider using 'bigint' instead. ` + `If you are sure this is what you want, set option number.allowOversized.`);
        }
        if (!options.serializer) {
            if (field.type === Array) options.serializer = new (0, $599eb80637d86fa2$export$76e4ae84123ce86c)();
            else if (((_h = field.type) === null || _h === void 0 ? void 0 : _h.prototype) instanceof (0, $58da134f34dd999c$export$3774ac7e5d401ad0)) options.serializer = new (0, $bdd572b9e10e9eb9$export$2cfc8a9f9c775914)();
            else if (field.length === 0) options.serializer = new (0, $ce65df80b1656781$export$4d6fd9c9b36dfdf9)();
            else if (field.type === Object) options.serializer = new (0, $2ad5fd2773f2e5ef$export$afc0094ae79b78f5)();
            else if (field.type === Number) options.serializer = new (0, $2ad5fd2773f2e5ef$export$afc0094ae79b78f5)();
            else if (field.type === Boolean) options.serializer = new (0, $88d9d4087d5a861b$export$9a3a3a30e8af0985)();
            else if (typeof $d26d71a32f322040$require$Buffer !== 'undefined' && field.type === $d26d71a32f322040$require$Buffer) options.serializer = new (0, $5d23e541cfb2edf9$export$de3bda2058911511)();
            else if (field.type === Uint8Array) options.serializer = new (0, $5d23e541cfb2edf9$export$de3bda2058911511)();
            else if (field.type === String) options.serializer = new (0, $90bb157d0a0de04f$export$58fd17adb1de0ac8)();
            else throw new Error(`${containingType.name}#${String(field.name)}: No serializer available for type ${((_j = field.type) === null || _j === void 0 ? void 0 : _j.name) || '<unknown>'}`);
        }
        containingType.ownSyntax.push(field);
    };
}




















function $69e0a3fd1795d530$export$585dc7a4228aacca(discriminant, options) {
    return (type)=>{
        let parent = Object.getPrototypeOf(type.prototype).constructor;
        if (!parent.hasOwnProperty('ownVariants')) Object.defineProperty(parent, 'ownVariants', {
            value: []
        });
        if (!options) options = {};
        parent.ownVariants.push({
            type: type,
            discriminant: discriminant,
            options: options
        });
        type.variantDiscriminant = discriminant;
    };
}
function $69e0a3fd1795d530$export$93bda550d78f9611() {
    return $69e0a3fd1795d530$export$585dc7a4228aacca(()=>true, {
        priority: 'last'
    });
}
function $69e0a3fd1795d530$export$11075b2e85dbc7ba() {
    return (0, $d26d71a32f322040$export$a455218a85c89869)(0, {
        isVariantMarker: true
    });
}




function $daa0a5710c17c8f1$export$da9b5fe187a9aa1(length, options = {}) {
    return (target, fieldName)=>{
        fieldName = Symbol(`[reserved: ${typeof length === 'number' ? `${length} bits` : `dynamic`}]`);
        Reflect.defineMetadata('design:type', Number, target, fieldName);
        return (0, $d26d71a32f322040$export$a455218a85c89869)(length, Object.assign(Object.assign({}, options), {
            isIgnored: true,
            writtenValue: (instance, field)=>{
                if (field.type === Number) {
                    let currentLength = (0, $8f69e5c027caa70c$export$83b6dc3503c1fda6)(field.length, instance, field);
                    return Math.pow(2, currentLength) - 1;
                }
            }
        }))(target, fieldName);
    };
}



function $6aba746b08608a26$export$842e003d4a0dcf58(length, options = {}) {
    return (target, fieldName)=>{
        fieldName = Symbol(`[reserved: ${typeof length === 'number' ? `${length} bits` : `dynamic`}]`);
        Reflect.defineMetadata('design:type', Number, target, fieldName);
        return (0, $d26d71a32f322040$export$a455218a85c89869)(length, Object.assign(Object.assign({}, options), {
            isIgnored: true,
            writtenValue: (_, field)=>{
                if (field.type === Number) return 0;
            }
        }))(target, fieldName);
    };
}


/* istanbul ignore file */ 
function $b19584c0f8004ed2$export$e98856a975cab58e() {
    return (0, $d26d71a32f322040$export$a455218a85c89869)(0, {
        isIgnored: true
    });
}







var $9d953ef466da63be$exports = {};
"use strict";
var $af010d4e0a94fe12$exports = {};
$af010d4e0a94fe12$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $9d953ef466da63be$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $9d953ef466da63be$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $9d953ef466da63be$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $9d953ef466da63be$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $af010d4e0a94fe12$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $9d953ef466da63be$var$clipboardToIE11Formatting[options.format] || $9d953ef466da63be$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $9d953ef466da63be$var$format("message" in options ? options.message : $9d953ef466da63be$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$9d953ef466da63be$exports = $9d953ef466da63be$var$copy;



var $iDiRE = parcelRequire("iDiRE");
var $bc75e1c5e38f9520$export$882461b6382ed46c;
var $bc75e1c5e38f9520$export$757ceba2d55c277e;
'use strict';
var $a62a1f696aa80a71$exports = {};
'use strict';
function $a62a1f696aa80a71$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a62a1f696aa80a71$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a62a1f696aa80a71$var$checkDCE();

$a62a1f696aa80a71$exports = (parcelRequire("67aGM"));


var $bc75e1c5e38f9520$var$i;
$bc75e1c5e38f9520$export$882461b6382ed46c = $a62a1f696aa80a71$exports.createRoot;
$bc75e1c5e38f9520$export$757ceba2d55c277e = $a62a1f696aa80a71$exports.hydrateRoot;



var $c41220b8559f08aa$export$98431b20482834cd = /*#__PURE__*/ function(SkillFlag) {
    SkillFlag[SkillFlag["NONE"] = 0] = "NONE";
    SkillFlag[SkillFlag["SPELL"] = 1] = "SPELL";
    SkillFlag[SkillFlag["SUM"] = 2] = "SUM";
    SkillFlag[SkillFlag["MELEE"] = 4] = "MELEE";
    SkillFlag[SkillFlag["SELF"] = 8] = "SELF";
    SkillFlag[SkillFlag["FRIEND"] = 16] = "FRIEND"; // Can be used on others in group
    return SkillFlag;
}({});
var $c41220b8559f08aa$export$33faa6bef51889a9 = /*#__PURE__*/ function(Prof) {
    Prof["WARRIOR"] = "w";
    Prof["PALADIN"] = "p";
    Prof["DANCER"] = "b";
    Prof["MAGE"] = "m";
    Prof["HUNTER"] = "h";
    Prof["TRACKER"] = "t";
    return Prof;
}({});
const $c41220b8559f08aa$export$6f74767403981169 = 7;
const $c41220b8559f08aa$var$requiredRowLevels = [
    25,
    35,
    50,
    80,
    120,
    170,
    230
];
function $c41220b8559f08aa$export$82cfbb6d79d0ca20(lvl) {
    return lvl - 24;
}
function $c41220b8559f08aa$export$cfb4ffbd4f57cedb(levels) {
    let s = 0;
    for(const id in levels)s += levels[id];
    return s;
}
function $c41220b8559f08aa$export$d71c469e34232cb7(i) {
    return $c41220b8559f08aa$var$requiredRowLevels[i] ?? 0;
}
function $c41220b8559f08aa$export$f39e997b5c0d94e0(i) {
    const lvl = $c41220b8559f08aa$export$d71c469e34232cb7(i);
    return lvl - 25;
}
function $c41220b8559f08aa$export$78a615baad4f0e95(skill) {
    // TODO: support dynamic skill levels
    return 10;
}




var $iDiRE = parcelRequire("iDiRE");



var $iDiRE = parcelRequire("iDiRE");



var $iDiRE = parcelRequire("iDiRE");


function $171ead1b945467c3$var$isProbablyMobile() {
    return window.outerWidth <= 680;
}
class $171ead1b945467c3$export$846c7dfadd5c9ffa extends (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).Component {
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
        this.onContextMenu = this.onContextMenu.bind(this);
    }
    getCurrentLevel() {
        return this.props.levels[this.props.skill.id] ?? 0;
    }
    getMaxLevel() {
        return (0, $c41220b8559f08aa$export$78a615baad4f0e95)(this.props.skill);
    }
    onClick(e) {
        e.preventDefault();
        if (this.props.masteryOpen) {
            const skill = this.props.skill;
            const isActive = (skill.attrs & (0, $c41220b8559f08aa$export$98431b20482834cd).SPELL) != 0;
            const ownPoints = this.getCurrentLevel();
            if (isActive && ownPoints > 0 && this.props.onSkillMasteryAddRequest) this.props.onSkillMasteryAddRequest(this.props.skill.id);
            return;
        }
        if (e.ctrlKey || this.props.selected) {
            if (this.props.disabled) return;
            const max = this.getMaxLevel();
            const addLevel = e.ctrlKey ? max : 1;
            const newLevel = Math.min(max, this.getCurrentLevel() + addLevel);
            if (this.props.onLevelChange) this.props.onLevelChange(this.props.skill.id, newLevel);
        } else if (this.props.onSkillSelected) this.props.onSkillSelected(this.props.skill.id);
    }
    onContextMenu(e) {
        if (this.props.disabled || this.props.masteryOpen) return;
        e.preventDefault();
        const max = this.getMaxLevel();
        const subtractLevel = e.ctrlKey ? max : 1;
        const newLevel = Math.max(0, this.getCurrentLevel() - subtractLevel);
        if (this.props.onLevelChange) this.props.onLevelChange(this.props.skill.id, newLevel);
    }
    render() {
        const skill = this.props.skill;
        const isActive = (skill.attrs & (0, $c41220b8559f08aa$export$98431b20482834cd).SPELL) != 0;
        const ownPoints = this.getCurrentLevel();
        const maxPoints = this.getMaxLevel();
        const progress = Math.floor(ownPoints / maxPoints * 10);
        const masteryDisabled = (!isActive || ownPoints == 0) && this.props.masteryOpen && !this.props.disabled;
        const cl = `skill-simulator-option pts-${progress}${this.props.selected && !this.props.masteryOpen ? " selected" : ""}${masteryDisabled ? ` disabled` : ``}`;
        return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
            onClick: this.onClick,
            onContextMenu: this.onContextMenu,
            className: cl,
            children: [
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                    className: "skill-name",
                    children: this.props.skill.name
                }),
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                    className: "skill-bottom",
                    children: [
                        /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                            className: `skill-active${isActive ? " active" : ""}`
                        }),
                        /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                            className: "skill-pts",
                            children: [
                                ownPoints,
                                "/",
                                maxPoints
                            ]
                        })
                    ]
                })
            ]
        });
    }
}



class $85471f42ab5da1a0$export$646c9bd86cfacc66 extends (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).Component {
    constructor(props){
        super(props), // Used to pass temp value to renderSkillOption
        this.disabled = false;
        this.renderSkillOption = this.renderSkillOption.bind(this);
    }
    renderSkillOption(id) {
        const skill = this.props.skills.find((s)=>s.id == id);
        if (!skill) return `[missing-skill:${id}]`;
        else return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)((0, $171ead1b945467c3$export$846c7dfadd5c9ffa), {
            onSkillSelected: this.props.onSkillSelected,
            onLevelChange: this.props.onLevelChange,
            levels: this.props.levels,
            skill: skill,
            selected: id == this.props.selectedSkill,
            disabled: this.disabled,
            masteryOpen: this.props.masteryOpen,
            onSkillMasteryAddRequest: this.props.onSkillMasteryAddRequest
        }, id);
    }
    render() {
        const firstHalf = this.props.skillsIDs.slice(0, Math.floor(this.props.skillsIDs.length / 2));
        const secondHalf = this.props.skillsIDs.slice(firstHalf.length);
        const spentPoints = (0, $c41220b8559f08aa$export$cfb4ffbd4f57cedb)(this.props.levels);
        const selfRequiredPoints = (0, $c41220b8559f08aa$export$f39e997b5c0d94e0)(this.props.rowIndex);
        const disabled = spentPoints < selfRequiredPoints;
        this.disabled = disabled;
        const cl = `skill-simulator-row${disabled ? " disabled" : ""}`;
        return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
            className: cl,
            children: [
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                    className: "skill-simulator-row-inner",
                    children: firstHalf.map(this.renderSkillOption)
                }),
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                    className: "skill-simulator-row-inner",
                    children: secondHalf.map(this.renderSkillOption)
                })
            ]
        });
    }
}





var $iDiRE = parcelRequire("iDiRE");


parcelRequire("iDiRE");
/**
 * Created by Michnik on 2015-08-31.
 */ let $e30c0f8b2db4782a$var$_t2 = window._t;
let $e30c0f8b2db4782a$var$_t = function(key, params, cat) {
    for(const param in params)params[param] = `<span class="param">${params[param]}</span>`;
    return $e30c0f8b2db4782a$var$_t2(key, params, cat);
};
// let ProfData = require('@core/characters/ProfData');
const $e30c0f8b2db4782a$var$ProfData = {
    WARRIOR: 'w',
    PALADIN: 'p',
    MAGE: 'm',
    HUNTER: 'h',
    TRACKER: 't',
    BLADE_DANCER: 'b'
};
// var SkillTip = require('@core/skills/SkillTip');
var $e30c0f8b2db4782a$var$weapon = {
    'sw': [
        'weapon'
    ],
    '1h': [
        1
    ],
    '2h': [
        2
    ],
    'bs': [
        3
    ],
    'dis': [
        4
    ],
    'fire': [
        'fire'
    ],
    'light': [
        'light'
    ],
    'frost': [
        'frost'
    ],
    'sh': [
        14
    ],
    'orb': [
        2
    ],
    'h': [
        5
    ],
    'poison': [
        'poison'
    ],
    'phydis': [
        'phydis'
    ],
    'wound': [
        'wound'
    ]
};
const $e30c0f8b2db4782a$var$skillsUsingByTrans = [
    "en-regen",
    "lightshield_per",
    "resfire_per",
    "resfrost_per",
    "reslight_per",
    "antidote",
    "dmg_evade_hpp-target_light",
    "dmg_evade_hpp-target_light",
    "energyout",
    "immunity_to_dmg"
];
function $e30c0f8b2db4782a$var$getRoundLang(v) {
    if (v > 4) return $e30c0f8b2db4782a$var$_t('five_round');
    if (v > 1) return $e30c0f8b2db4782a$var$_t('two_round');
    return $e30c0f8b2db4782a$var$_t('one_round');
}
function $e30c0f8b2db4782a$var$getPercentPointsLabel(value) {
    const val = parseInt(value);
    if (val === 1) return $e30c0f8b2db4782a$var$_t('percentPoints1');
    if (val === 0 || val > 4) return $e30c0f8b2db4782a$var$_t('percentPoints3');
    return $e30c0f8b2db4782a$var$_t('percentPoints2');
}
function $e30c0f8b2db4782a$var$getRound(value, second, first, stat) {
    if (!isset(value) || !isset(second)) return [
        value,
        second,
        ''
    ];
    var index1 = value.search('@');
    var index2 = second.search('@');
    if (!(index1 > -1 || index2 > -1)) return [
        value,
        second,
        ''
    ]; //nima @
    const prefix = $e30c0f8b2db4782a$var$skillsUsingByTrans.includes(stat) ? $e30c0f8b2db4782a$var$_t('by') : $e30c0f8b2db4782a$var$_t('on');
    if (first == '') {
        var s = second.slice(0, index2);
        var v1 = value.slice(0, index1);
        var curentLvl = second.slice(index2 + 1, second.length);
        var desc = prefix + curentLvl + $e30c0f8b2db4782a$var$getRoundLang(curentLvl);
        return [
            v1,
            s,
            desc
        ];
    }
    if (index1 > -1 && index2 > -1) {
        var curentLvl = value.slice(index1 + 1, value.length);
        var v1 = value.slice(0, index1);
        var amountRound = prefix + curentLvl;
        var nextLvl = second.slice(index2 + 1, second.length);
        var v2 = second.slice(0, index2);
        amountRound = amountRound + '<span> (' + nextLvl + ') </span> ' + $e30c0f8b2db4782a$var$getRoundLang(curentLvl);
        return [
            v1,
            v2,
            amountRound
        ];
    }
    if (index1 > -1 && index2 < 0) {
        var f = value.slice(0, index1);
        var curentLvl = value.slice(index1 + 1, value.length);
        var desc = prefix + curentLvl + $e30c0f8b2db4782a$var$getRoundLang(curentLvl);
        return [
            f,
            second,
            desc
        ];
    }
}
function $e30c0f8b2db4782a$var$checkPerLevel(value, second) {
    const isValueHasC = value.search('/*cplvl') > -1;
    var index1 = value.search('/*c?plvl');
    var str = !isValueHasC ? $e30c0f8b2db4782a$var$_t('value_increase_per_player') : $e30c0f8b2db4782a$var$_t('value_increase_per_player_max');
    var v1 = value.replace(/\*c?plvl/, '');
    if (!isset(second)) {
        var a1 = [
            v1,
            second,
            str
        ];
        var a2 = [
            value,
            second,
            ''
        ];
        return index1 > -1 ? a1 : a2;
    }
    var index2 = second.search('/*c?plvl');
    if (!(index1 > -1 || index2 > -1)) return [
        value,
        second,
        ''
    ];
    var v2 = second.replace(/\*c?plvl/, '');
    return [
        v1,
        v2,
        str
    ];
}
function $e30c0f8b2db4782a$export$e79cceffa77a99de(stat, first, second) {
    var text = "";
    var b, c, i;
    var value = first == '' ? second : first;
    var spanClass = first == '' ? 'first' : second == '' ? 'normal' : 'compare';
    var transCat = 'default';
    var roundArray = $e30c0f8b2db4782a$var$getRound(value, second, first, stat);
    var amountRound = roundArray[2];
    value = roundArray[0];
    second = roundArray[1];
    var perLevelArray = $e30c0f8b2db4782a$var$checkPerLevel(value, second, first);
    var perLevel = perLevelArray[2];
    value = perLevelArray[0];
    second = perLevelArray[1];
    if (first != '' && isset(second) && second != '') transCat = 'new_skills';
    switch(stat){
        /*basic */ case 'step':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat);
            break;
        case 'norm-atack':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat);
            break;
        /*item_*/ case 'acshield_per':
        case 'perdmg':
        case 'ac_per':
        case 'pdmg':
        case 'ac':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('item_' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        /*skills_*/ case 'decevade_per':
        case 'active_decevade_per':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skills_' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second,
                '%val3%': $e30c0f8b2db4782a$var$getPercentPointsLabel(value)
            }, transCat);
            break;
        case 'dmgmul':
        case 'dmgmulphysical':
        case 'dmgmulpoison':
        case 'dmgmulwound':
        case 'dmgmulabsolute':
        case 'dmgmulfire':
        case 'dmgmulfrost':
        case 'dmgmullight':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skills_' + stat + ' %val%', {
                '%val%': mp(value),
                '%val2%': mp(second),
                '%val3%': $e30c0f8b2db4782a$var$getPercentPointsLabel(value)
            }, transCat);
            break;
        case 'decevade':
            var str = value > 4 ? '' : '2';
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skills_' + str + stat + ' %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'agi':
        case 'firebon':
        case 'lightbon':
        case 'frostbon':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skills_' + stat + ' %val%', {
                '%val%': mp(Math.floor(parseFloat(value) * 100)),
                '%val2%': mp(Math.floor(parseFloat(second) * 100))
            }, transCat);
            break;
        case 'critslow_per':
        case 'critslow':
        case 'critsa_per':
        case 'critsa':
        case 'immobilize':
        case 'lastcrit':
        //case 'decevade_per':
        //case 'decevade':
        case 'redslow':
        case 'woundred':
        case 'healpower':
        case 'engback':
        case 'sa-clothes':
        case 'red-sa':
        case 'footshoot':
        case 'critwound':
        case 'swing':
        case 'distract':
        case 'injure':
        case 'reusearrows':
        case 'pcontra':
        case 'fastarrow':
        case 'bandage_per':
        case 'bandage':
        case 'set':
        case 'resfrost_per':
        case 'resfire_per':
        case 'longfireshield':
        case 'longfrostshield':
        case 'longlightshield':
        case 'soullink':
        case 'poisonbon':
        case 'of-thirdatt':
        case 'woundchance':
        case 'wounddmgbon_perw':
        case 'wounddmgbon':
        case 'arrowrain':
        case 'insult':
        case 'frostpunch':
        case 'redstun':
        case 'active_redstun':
        case 'lightmindmg':
        case 'actdmg':
        case 'hpsa':
        case 'mresdmg':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skills_' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        /*skill_*/ case 'disturbshoot':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat + ' %val%', {
                '%val%': value,
                '%val2%': value == 6 ? 12 : value == 15 ? 30 : second,
                '%val3%': value * 2,
                '%val4%': second * 2
            }, transCat);
            break;
        case 'str':
        //case 'of-str':
        //case 'footshoot2':
        case 'stepslow_per':
        //case 'poisonbon_perw':		!!!!
        case 'poisonbon_poison-perw':
        //case 'arrowrain_perw':	!!!!
        case 'arrowrain_all-perw':
        case 'manarestore_per':
        case 'rime_per':
        //case 'firepunch_perw':	!!!!
        case 'firepunch_fire-perw':
        case 'heal1_per':
        //case 'pdmg_perw':	!!!!
        case 'pdmg_physical-perw':
        case 'energyrestore_per':
        case 'allcritval':
        case 'vamp':
        case 'reddest_per':
        //case 'rotatingblade':
        //case 'daggerthrow':
        case 'poisonstab_perw':
        case 'woundextend':
        //case 'blackout':
        case 'energyout':
        case 'adrenalin_per':
        case 'adrenalin_sa_per':
        case 'adrenalin_sa_threshold_per':
        case 'adrenalin_evade_per':
        case 'adrenalin_evade_threshold_per':
        case 'critpoison_per':
        case 'slowfreeze_per':
        case 'absorb_per':
        case 'absorbm_per':
        case 'heal_per':
        case 'distractshoot':
        case 'blind_per':
        case 'alllowdmg':
        //case 'blesswords_perw':
        case 'aura-adddmg2_per-meele':
        //case 'firedmg_perw':	!!!!
        case 'firedmg_fire-perw':
        case 'chainlightning_perw':
        case 'absagain_per':
        case 'stealmana_per':
        case 'allcritmval':
        //case 'mlightshiled':
        case 'reslight_per':
        case 'mcurse':
        case 'weakness_per':
        //case 'disturbshoot':
        case 'antidote':
        case 'lowtension':
        case 'vulture_perw':
        case 'of-wounddmgbon_perw':
        case 'act':
        case 'rage_3turns':
        case 'critrage_perw':
        case 'resfire':
        case 'reslight':
        case 'resfrost':
        case 'adddmg_physical-perw':
        case 'active_acdmg_physical-perw':
        case 'adddmg_fire-perw':
        case 'active_acdmg_per':
        case 'active_absorbdest_per':
        case 'active_block_per':
        case 'decblock_per':
        case 'active_decblock_per':
        case 'active_decblock_per-enemies':
        case 'ac2_per':
        case 'active_add_light_cumulaction':
        case 'redacdmg_per':
        case 'active_wound_per':
        case 'active_resall_per':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'aura-adddmg2_per-meele_physical':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_aura-adddmg2_per-meele %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'trickyknife':
            break;
        case 'blackout':
            break;
        /*skill_ mp()*/ case 'str1h':
        case 'str2h':
        case 'of-str':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat + ' %val%', {
                '%val%': mp(Math.floor(parseFloat(value) * 100)),
                '%val2%': mp(Math.floor(parseFloat(second) * 100))
            }, transCat);
            break;
        /*bonus_*/ case 'runes':
        case 'goldpack':
        case 'perheal':
        case 'crit':
        case 'active_crit':
        case 'of-crit':
        case 'critval':
        case 'of-critval':
        case 'critmval':
        case 'critmval_f':
        case 'critmval_c':
        case 'critmval_l':
        case 'heal':
        case 'pierce':
        case 'pierceb':
        case 'contra':
        case 'parry':
        case 'fire':
        case 'light':
        case 'adest':
        case 'absorb':
        case 'absorbm':
        case 'hpbon':
        case 'acdmg_per':
        //case 'acdmg_perw':	!!!!
        case 'acdmg_physical-perw':
        //case 'acdmg':
        case 'resdmg':
        case 'en-regen':
        case 'manastr':
        case 'manarestore':
        case 'manatransfer':
        case 'stun':
        case 'freeze':
        case 'hpcost':
        case 'cover':
        case 'allslow':
        case 'allslow_per':
        //case 'firearrow_perw':	!!!!
        //case 'firearrow_fire-perw':
        case 'dmg_evade-target_fire-perw':
        case 'dmg-target_fire-perw':
        case 'firewall_perw':
        //case 'firewall':
        case 'thunder':
        case 'storm':
        case 'lowdmg':
        case 'lowdmg_self':
        case 'lowdmg_enemy':
        case 'blizzard':
        case 'sunshield_per':
        case 'sunreduction':
        case 'healall_per':
        case 'healall':
        case 'heal1':
        case 'absorbd':
        case 'abdest':
        case 'endest':
        case 'manadest':
        case 'lowevade':
        case 'lowcrit':
        case 'arrowblock':
        //case 'evade_per':
        case 'redabdest_per':
        case 'sa_per':
        case 'sa2_per':
        case 'aura-resall':
        case 'aura-sa_per':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'evade_per':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second,
                '%val3%': $e30c0f8b2db4782a$var$getPercentPointsLabel(value)
            }, transCat);
            break;
        /*bonus_ mp()*/ case 'hp':
        case 'ds':
        case 'dz':
        case 'di':
        case 'da':
        case 'gold':
        case 'blok_per':
        case 'blok':
        case 'evade':
        case 'energybon':
        case 'energygain':
        case 'manabon':
        case 'managain':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_' + stat + ' %val%', {
                '%val%': mp(value),
                '%val2%': mp(second)
            }, transCat);
            break;
        case 'dmg_evade_hpp-target':
        case 'dmg_evade_hpp-target_light':
        case 'lightshield2_per':
        case 'lightshield_per':
        case 'lightshield':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skills_' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'rage':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skills_rage %val% %turn%', {
                '%val%': value,
                '%turn%': parseInt(value) > 1 ? parseInt(value) > 4 ? $e30c0f8b2db4782a$var$_t('five_round') : $e30c0f8b2db4782a$var$_t('two_round') : ' ' + $e30c0f8b2db4782a$var$_t('turn'),
                '%val2%': second
            }, transCat);
            break;
        case 'doubleshoot':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_doubleshoot');
            break;
        case 'disturb':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skills_disturb %val%', {
                '%val%': value,
                '%val2%': parseInt(value) * 2,
                '%val3%': second,
                '%val4%': parseInt(second) * 2
            }, transCat);
            break;
        case 'shout':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skills_shout %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat) + ' ' + (value > 1 ? $e30c0f8b2db4782a$var$_t('moreenemy') : $e30c0f8b2db4782a$var$_t('oneenemy'));
            break;
        case 'sa1':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_sa1 %val%', {
                '%val%': value / 100,
                '%val2%': second / 100
            }, transCat);
            break;
        case 'leczy':
            if (value > 0) text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_leczy %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            else text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_truje %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'fullheal':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_fullheal %val%', {
                '%val%': round(value, 2),
                '%val2%': round(second, 2)
            }, transCat);
            break;
        case 'creditsbon':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_creditsbon');
            break;
        case 'revive':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('revive %amount%', {
                '%amount%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'frost':
            b = value.split(',');
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_frost %val% %slow%', {
                '%val%': b[1],
                '%slow%': b[0] / 100
            }, transCat);
            break;
        case 'poison':
            b = value.split(',');
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_poison %val% %slow%', {
                '%val%': b[1],
                '%slow%': b[0] / 100
            }, transCat);
            break;
        case 'slow':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_slow %val%', {
                '%val%': mp(value / 100),
                '%val2%': mp(second / 100)
            }, transCat);
            break;
        case 'wound':
            b = value.split(',');
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_wound %val% %dmg%', {
                '%val%': b[0],
                '%dmg%': b[1]
            }, transCat);
            break;
        case 'energy':
            if (value > 0) text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_energy1 %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            else text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_energy2 %val%', {
                '%val%': Math.abs(value),
                '%val2%': Math.abs(second)
            }, transCat);
            break;
        case 'energyp':
            if (value > 0) text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_energyp1 %val%', {
                '%val%': mp(value),
                '%val2%': mp(second)
            }, transCat);
            else text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_energyp2 %val%', {
                '%val%': Math.abs(value),
                '%val2%': Math.abs(second)
            }, transCat);
            break;
        case 'mana':
            if (value > 0) text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_mana1 %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            else text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_mana2 %val%', {
                '%val%': Math.abs(value),
                '%val2%': Math.abs(second)
            }, transCat);
            break;
        case 'firearrow':
        case 'firepunch':
        case 'firebolt':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_firebolt %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'sunshield':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_sunshield %val%', {
                '%val%': value,
                '%val2%': value / 2
            }, transCat);
            break;
        case 'aura-ac_per':
        case 'aura-ac':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_aura-ac %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'aura-sa':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_aura-sa %val%', {
                '%val%': mp(value / 100),
                '%val2%': mp(second / 100)
            }, transCat);
            break;
        case 'removedot':
        case 'removedot-allies':
        case 'removestun':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat, null, transCat);
            break;
        case 'stinkbomb':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('bonus_stinkbomb %val% %crit%', {
                '%val%': parseInt(value) * 2,
                '%crit%': value,
                '%val2%': parseInt(second) * 2,
                '%crit2%': second
            }, transCat);
            break;
        case 'reqp':
            for(i = 0; i < value.length; i++)text += '<div class="cl-icon icon-' + value.charAt(i) + '"></div>';
            break;
        case 'reqw':
            b = value.split(',');
            var iconNumber = 0;
            for(i = 0; i < b.length; i++)for(var j = 0; j < $e30c0f8b2db4782a$var$weapon[b[i]].length; j++){
                iconNumber = $e30c0f8b2db4782a$var$weapon[b[i]][j];
                // if (Engine.hero.d.prof == 'm') {
                if (Engine.hero.d.prof == $e30c0f8b2db4782a$var$ProfData.MAGE) {
                    if ($e30c0f8b2db4782a$var$weapon[b[i]][j] == 1) iconNumber = 6;
                    else if ($e30c0f8b2db4782a$var$weapon[b[i]][j] == 2) iconNumber = 7;
                }
                text += '<div data-icon="icon-' + iconNumber + '" class="cl-icon icon-' + iconNumber + '"></div>';
            }
            break;
        case 'add_attacks':
            var str = value > 1 ? 'add_moreAttacks %val%' : 'add_attacks %val%';
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t(str, {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        // eng game
        //warto�� z %
        //1. common
        case 'dmg_to_npc_per':
        case 'dmg_from_npc_per':
        case 'dmg_to_player_per':
        case 'dmg_from_player_per':
        case 'chest_armor_per':
        //2. Wojownik:
        //case 'critval_enemies': 								// - "Si�a krytyka fizycznego przeciwnik�w: val%"
        case 'critval-enemies':
        //case 'critval_allies': 									// - "Si�a krytyka fizycznego sojusznik�w: val%"
        case 'critval-allies':
        //case 'critmval_enemies': 								// - "Si�a krytyka magicznego przeciwnik�w: val%"
        case 'critmval-enemies':
        //case 'critmval_allies': 								// - "Si�a krytyka magicznego sojusznik�w: val%"
        case 'critmval-allies':
        case 'crush_threshold_per':
        case 'crush_dmg_per':
        //3. Tancerz ostrzy:
        case 'vamp_time_per':
        case 'dmg-swing_physical-perw':
        //4. �owca:
        case 'taken_dmg_per':
        case 'critpierce_per':
        //5. Mag:
        case 'dmg-row_fire-perw':
        case 'dmg-force-4_light-perw':
        //6. Paladyn:
        case 'hp_per-allies':
        case 'hp_per-enemies':
        //7. Tropiciel:
        case 'heal_per-allies':
        case 'heal_per-enemies':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('end-game-percent' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        //warto�� bez %
        //3. Tancerz ostrzy:
        case 'acdmg':
        case 'active_acdmg':
        case 'dmg-line_physical':
        //5. Mag:
        case 'immunity_to_dmg':
        //6. Paladyn:
        case 'dmg-target_physical':
        //7. Tropiciel:
        case 'distortion':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('end-game-without-percent' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        //dwie warto�ci w stacie
        //6. Paladyn:
        case 'manaendest':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('end-game-more-val' + stat + ' %val% %val2% %val3% %val4%', {
                '%val%': value,
                '%val2%': second,
                '%val3%': Math.round(value / 3),
                '%val4%': Math.round(second / 3)
            }, transCat);
            break;
        case 'crush_dmg_physical':
        case 'crush_dmg_light':
        case 'crush_dmg_fire':
        case 'crush_dmg_frost':
            const val = value.split('/');
            const sec = second.split('/');
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat + ' %val% %val2% %val3% %val4%', {
                '%val%': val[0],
                '%val2%': val[1],
                '%val3%': sec[0],
                '%val4%': sec[1]
            }, transCat);
            break;
        //do ukrycia
        //3. Tancerz ostrzy:
        case 'rotatingblade':
        case 'daggerthrow':
        //5. Mag:
        case 'chainlightning':
        case 'firewall':
        //6. Paladyn:
        case 'balloflight':
            break;
        //new stats
        case 'doublecastcost_per':
        case 'combo-crit':
        case 'combo-block':
        case 'combo-evade':
        case 'combo-wound':
        case 'combo-pierce':
        case 'combo-skill':
        case 'combo-max':
        case 'combo_perdmg':
        case 'combo_resfire_per':
        case 'combo_resfrost_per':
        case 'combo_reslight_per':
        case 'combo_dmg_hpp-target':
        case 'dmg_hpp-target':
        case 'combo_dmg_hpp-target_fire':
        case 'dmg_hpp-target_fire':
        case 'combo_dmg_hpp-target_frost':
        case 'dmg_hpp-target_frost':
        case 'combo_dmg_hpp-target_light':
        case 'dmg_hpp-target_light':
        case 'combo_heal_per':
        case 'combo_energyrestore_per':
        case 'combo_manarestore_per':
        case 'combo_lowdmg_enemy':
        case 'dmg_hpp-row_fire':
        case 'dmg_hpp-row_frost':
        case 'dmg_hpp-row_light':
        case 'lowheal_per-enemies':
        case 'achpp_per':
        case 'adrenalin_reddest_threshold_per':
        case 'adrenalin_reddest_per_sum':
        case 'poisonspread':
        case 'taken_dmg_per-row':
        case 'taken_dmg_per-all':
        case 'perdmg-allies':
        case 'active_crit-allies':
        case 'disturb_crit':
        case 'disturb_pierce':
        case 'stinkbomb_crit':
        case 'stinkbomb_pierce':
        case 'dmg-swing_absolute-perw':
        case 'dmg-target_absolute':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat + ' %val%', {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'removeslow-allies':
        case 'removestun-allies':
        case 'of-woundstart':
        case 'poison_lowdmg_per-enemies':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat, {
                '%val%': value,
                '%val2%': second
            }, transCat);
            break;
        case 'cooldown':
            text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('skill_' + stat, {
                '%val%': value,
                '%val2%': second
            }, transCat);
            text += value == 1 ? $e30c0f8b2db4782a$var$_t('turn') : value > 4 ? $e30c0f8b2db4782a$var$_t('turn5') : $e30c0f8b2db4782a$var$_t('turns');
            break;
        case 'reqarrows':
            //console.log(value);
            var str = value > 4 ? '5arrow' : value > 1 ? '2arrow' : 'arrow';
            text += value + ' ' + $e30c0f8b2db4782a$var$_t(str);
            break;
        default:
            if (stat != '') text += '<span class=' + spanClass + '>' + $e30c0f8b2db4782a$var$_t('unknown_stat %val%', {
                '%val%': stat
            }, transCat); //'Nieznany stat: '+stat+'<br>'
            break;
    }
    return text + perLevel + amountRound;
}
var $e30c0f8b2db4782a$var$toRemove = [
    'reqp',
    'reqw',
    'lvl',
    'reqarrows'
];
function $e30c0f8b2db4782a$var$removeUnnecessaryStats(tab) {
    for(var i in $e30c0f8b2db4782a$var$toRemove)for(var j in tab){
        var index = tab[j].indexOf($e30c0f8b2db4782a$var$toRemove[i]); // <-- Not supported in <IE9
        if (index !== -1) tab.splice(index, 1);
    }
    return tab;
}
const $e30c0f8b2db4782a$export$c1527037bad5e293 = {
    getSections: function(skillId, skill) {
        let tmp;
        let regs;
        let sections = {
            attr: {
                0: [],
                1: [],
                2: []
            },
            cost: [],
            regs: [],
            lvl: null
        };
        // let skill  = Engine.battle.getBattleSkill(skillId)
        // let skill  = Engine.battle.getBattleSkill(skillId)
        sections.lvl = skill.lvl;
        if (!skill.regs) {
            if (skill['kind'] == '') regs = [];
            else {
                tmp = skill['kind'].split('|')[0];
                regs = this.getRegs(tmp);
            }
        } else regs = this.getRegs(skill.regs);
        for(let k in regs){
            let reg = regs[k];
            let newReg = Engine.battle.changeIconRegToTextReg(reg);
            sections.regs.push(newReg);
        }
        let stats = SkillTip.getStats(skill);
        let parseStats = this.getStats(stats, 10);
        for(let k in parseStats){
            let section = 0;
            let text = parseStats[k];
            if (text.search('(passive effect)') > -1 || text.search('(efekt pasywny)') > -1) section = 1;
            if (text.search('combination points') > -1 || text.search('pkt kombinacji') > -1) section = 2;
            if (text.search(' cost: ') > -1 || text.search('Koszt ') > -1) section = 'cost';
            switch(section){
                case 0:
                    sections['attr'][section].push(text);
                    break;
                case 1:
                    sections['attr'][section].push(text);
                    break;
                case 2:
                    sections['attr'][section].push(text);
                    break;
                case 'cost':
                    sections[section].push(text);
                    break;
            }
        }
        return sections;
    },
    getStats: function(i, lvl, maxLvl = 10) {
        var splitted = i.split('&');
        if (splitted[0] == '' && splitted[1] == '') return [];
        var fSplit = splitted[0].split(';');
        var sSplit = splitted[1].split(';');
        var stats = [];
        var a, b, stat;
        fSplit = $e30c0f8b2db4782a$var$removeUnnecessaryStats(fSplit);
        sSplit = $e30c0f8b2db4782a$var$removeUnnecessaryStats(sSplit);
        var length = sSplit.length > fSplit.length ? sSplit.length : fSplit.length;
        for(var j = 0; j < length; j++){
            a = !isset(fSplit[j]) ? [
                '',
                ''
            ] : fSplit[j].split('=');
            b = !isset(sSplit[j]) ? [
                '',
                ''
            ] : sSplit[j].split('=');
            a[0] = a[0] == '' ? b[0] : a[0];
            if (!isset(a[1])) a[1] = '';
            if (a[1] == b[1] && lvl == maxLvl) b[1] = '';
            if (lvl == 0) a[1] = '';
            var statTxt = $e30c0f8b2db4782a$export$e79cceffa77a99de(a[0], a[1], b[1]);
            if (statTxt) {
                stat = '<div class="skill-stat">' + statTxt + '</div>';
                stats.push(stat);
            }
        }
        return stats;
    },
    prepareFormattedHtmlStatsArrayFromSections: (sections)=>{
        let htmlArray = [];
        for(let k in sections){
            let oneSection = sections[k];
            if (oneSection.length) oneSection.push('<div class="line"></div>div>');
            else delete sections[k];
        }
        for(let k in sections){
            let oneSection = sections[k];
            for(let kk in oneSection)htmlArray.push(oneSection[kk]);
        }
        return htmlArray;
    },
    getStatsForTips: function(i, lvl) {
        var fSplit = i.split('+');
        var stats = [];
        var a, stat;
        fSplit = $e30c0f8b2db4782a$var$removeUnnecessaryStats(fSplit);
        var length = fSplit.length;
        for(var j = 0; j < length; j++){
            a = !isset(fSplit[j]) ? [
                '',
                ''
            ] : fSplit[j].split(':');
            if (!isset(a[1])) a[1] = '';
            if (lvl == 0) a[1] = '';
            var statTxt = $e30c0f8b2db4782a$export$e79cceffa77a99de(a[0], a[1], a[1]);
            if (statTxt) {
                stat = '<span class="tip-skill-stat">- ' + statTxt + '</span>';
                stats.push(stat);
            }
        }
        return stats;
    },
    getRegs: function(i) {
        const splitted = i.split(';');
        const regs = [];
        for (const segment of splitted){
            const [key, value] = segment.split('=');
            if (key === 'reqp' || key === 'lvl') continue;
            const values = value.includes(',') ? value.split(',') : [
                value
            ];
            values.forEach((req)=>{
                const statTxt = $e30c0f8b2db4782a$export$e79cceffa77a99de(key, req);
                regs.push(statTxt);
            });
        }
        return regs;
    },
    getObjStats: function(i) {
        var splitted = i.split(';');
        var stats = {};
        for(var j in splitted){
            var a = splitted[j].split('=');
            var key = a[0];
            var val = a.length > 1 ? a[1].replace(/\*c?plvl/, '') : true;
            stats[key] = val;
        }
        return stats;
    }
};
const $e30c0f8b2db4782a$export$e26c50acc981fa26 = $e30c0f8b2db4782a$export$e79cceffa77a99de;


if (window.MargoSkillsParser) // Their code is still garbage.
window.Engine = {
    hero: {
        d: {
            prof: "w",
            lvl: 300
        }
    }
};
const $d614c5f7bf20fa47$var$weaponNames = {
    "sw": "Bro\u0144 bia\u0142a",
    "1h": "Bro\u0144 jednor\u0119czna",
    "2h": "Bro\u0144 dwur\u0119czna",
    "bs": "Bro\u0144 p\xf3\u0142torar\u0119czna",
    "h": "Bro\u0144 pomocnicza",
    "dis": "Bro\u0144 dystansowa",
    "fire": "Bro\u0144 zadaj\u0105ca obra\u017Cenia od ognia",
    "light": "Bro\u0144 zadaj\u0105ca obra\u017Cenia od b\u0142yskawic",
    "frost": "Bro\u0144 zadaj\u0105ca obra\u017Cenia od zimna",
    "sh": "Tarcza",
    "poison": "Bro\u0144 zadaj\u0105ca obra\u017Cenia od trucizny",
    "phydis": "Bro\u0144 dystansowa zadaj\u0105ca obra\u017Cenia w pe\u0142ni fizyczne",
    "wound": "Bro\u0144 zadaj\u0105ca obra\u017Cenia od g\u0142\u0119bokiej rany"
};
function $d614c5f7bf20fa47$export$cc3b587f948c6cc8(name, value) {
    // MargoSkillsParser getreqs sucks ASS
    switch(name){
        case "reqw":
            {
                let res = [];
                const spl = value.split(",");
                for (const wpn of spl)res.push($d614c5f7bf20fa47$var$weaponNames[wpn] ?? `Nieznany typ broni: ${value}`);
                return res.join(", ");
            }
        case "reqp":
        default:
            return "";
    }
}
function $d614c5f7bf20fa47$var$parseLevelScaling(value, lvl) {
    return value.replace(/([0-9]+(\.[0-9]+)?)\*(c?plvl)/g, (match, val, _, scalingType)=>{
        const v = Number(val) * (scalingType == "cplvl" ? Math.min(lvl, 300) : lvl);
        return String(Math.round(v)) + `*${scalingType}`; // TODO: verify rounding
    });
}
const $d614c5f7bf20fa47$var$abhorrentRegex = /([+-])?<span class="damage">(.*?)(punktów procentowych)?<\/span>(%)?/g;
function $d614c5f7bf20fa47$export$d6d92dde746a30b6(name, value, playerLvl) {
    const scaledValue = $d614c5f7bf20fa47$var$parseLevelScaling(value, playerLvl);
    return `- ` + (0, $e30c0f8b2db4782a$export$e26c50acc981fa26)(name, scaledValue, ""); // + ` (${name}=${value})`;
// if (window.MargoSkillsParser?.getStats) {
// const t = window._t;
// window._t = window._t2;
// const html = window.MargoSkillsParser.getStats(`${name}=${scaledValue}&`).join("");
// window._t = t;
// return html.replace(abhorrentRegex, (match, optionalSign, content, perPointsString, optionalPercent) => {
// const sign = optionalSign ?? "";
// const per = optionalPercent ? "%" : "";
// const perPoints = perPointsString ?? "";
// return `<span class="damage">${sign}${content}${per}</span>${perPoints}`;
// });
// } else {
// return `${name}=${scaledValue}`;
// }
}




var $iDiRE = parcelRequire("iDiRE");


var $iDiRE = parcelRequire("iDiRE");
function $6f8b81481b9501ea$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $iDiRE.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $6f8b81481b9501ea$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $6f8b81481b9501ea$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $6f8b81481b9501ea$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $6f8b81481b9501ea$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($6f8b81481b9501ea$export$5a096129d439f843(target)) return target;
    if (!$6f8b81481b9501ea$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $6f8b81481b9501ea$export$62858bae88b53fd0(node) {
    const { Document: Document } = $6f8b81481b9501ea$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $6f8b81481b9501ea$export$1b3bfaa9684536aa(node) {
    if ($6f8b81481b9501ea$export$5a096129d439f843(node)) return false;
    return node instanceof $6f8b81481b9501ea$export$38b2d434cce3ea22(node).HTMLElement;
}
function $6f8b81481b9501ea$export$17eda790a720ec57(node) {
    return node instanceof $6f8b81481b9501ea$export$38b2d434cce3ea22(node).SVGElement;
}
function $6f8b81481b9501ea$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($6f8b81481b9501ea$export$5a096129d439f843(target)) return target.document;
    if (!$6f8b81481b9501ea$export$8ee0fc9ee280b4ee(target)) return document;
    if ($6f8b81481b9501ea$export$62858bae88b53fd0(target)) return target;
    if ($6f8b81481b9501ea$export$1b3bfaa9684536aa(target) || $6f8b81481b9501ea$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $6f8b81481b9501ea$export$700979bc83e7db82 = $6f8b81481b9501ea$export$71594e8a50f746f4 ? (0, $iDiRE.useLayoutEffect) : (0, $iDiRE.useEffect);
function $6f8b81481b9501ea$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $iDiRE.useRef)(handler);
    $6f8b81481b9501ea$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $iDiRE.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $6f8b81481b9501ea$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $iDiRE.useRef)(null);
    const set = (0, $iDiRE.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $iDiRE.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $6f8b81481b9501ea$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $iDiRE.useRef)(value);
    $6f8b81481b9501ea$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $6f8b81481b9501ea$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $iDiRE.useRef)();
    return (0, $iDiRE.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $6f8b81481b9501ea$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $6f8b81481b9501ea$export$90fc3a17d93f704c(onChange);
    const node = (0, $iDiRE.useRef)(null);
    const setNodeRef = (0, $iDiRE.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $6f8b81481b9501ea$export$5cae361ad82dce8b(value) {
    const ref = (0, $iDiRE.useRef)();
    (0, $iDiRE.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $6f8b81481b9501ea$var$ids = {};
function $6f8b81481b9501ea$export$c485849f2e393253(prefix, value) {
    return (0, $iDiRE.useMemo)(()=>{
        if (value) return value;
        const id = $6f8b81481b9501ea$var$ids[prefix] == null ? 0 : $6f8b81481b9501ea$var$ids[prefix] + 1;
        $6f8b81481b9501ea$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $6f8b81481b9501ea$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $6f8b81481b9501ea$export$e16d8520af44a096 = /*#__PURE__*/ $6f8b81481b9501ea$var$createAdjustmentFn(1);
const $6f8b81481b9501ea$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $6f8b81481b9501ea$var$createAdjustmentFn(-1);
function $6f8b81481b9501ea$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $6f8b81481b9501ea$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $6f8b81481b9501ea$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $6f8b81481b9501ea$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $6f8b81481b9501ea$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $6f8b81481b9501ea$export$36195c8aa1517e04(event) {
    if ($6f8b81481b9501ea$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($6f8b81481b9501ea$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $6f8b81481b9501ea$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $6f8b81481b9501ea$export$c4ffa16951855e28.Translate.toString(transform),
                $6f8b81481b9501ea$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $6f8b81481b9501ea$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $6f8b81481b9501ea$export$44f71d798fd0a62b(element) {
    if (element.matches($6f8b81481b9501ea$var$SELECTOR)) return element;
    return element.querySelector($6f8b81481b9501ea$var$SELECTOR);
}



var $iDiRE = parcelRequire("iDiRE");
const $ecc35538bd704204$var$hiddenStyles = {
    display: 'none'
};
function $ecc35538bd704204$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement("div", {
        id: id,
        style: $ecc35538bd704204$var$hiddenStyles
    }, value);
}
function $ecc35538bd704204$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $ecc35538bd704204$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $iDiRE.useState)('');
    const announce = (0, $iDiRE.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $60c8260c6697d4fd$var$DndMonitorContext = /*#__PURE__*/ (0, $iDiRE.createContext)(null);
function $60c8260c6697d4fd$export$1182af90218a7b81(listener) {
    const registerListener = (0, $iDiRE.useContext)($60c8260c6697d4fd$var$DndMonitorContext);
    (0, $iDiRE.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $60c8260c6697d4fd$var$useDndMonitorProvider() {
    const [listeners] = (0, $iDiRE.useState)(()=>new Set());
    const registerListener = (0, $iDiRE.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $iDiRE.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $60c8260c6697d4fd$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $60c8260c6697d4fd$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $60c8260c6697d4fd$var$Accessibility(_ref) {
    let { announcements: announcements = $60c8260c6697d4fd$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $60c8260c6697d4fd$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $ecc35538bd704204$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $6f8b81481b9501ea$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $iDiRE.useState)(false);
    (0, $iDiRE.useEffect)(()=>{
        setMounted(true);
    }, []);
    $60c8260c6697d4fd$export$1182af90218a7b81((0, $iDiRE.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement((0, $ecc35538bd704204$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement((0, $ecc35538bd704204$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $a62a1f696aa80a71$exports.createPortal)(markup, container) : markup;
}
var $60c8260c6697d4fd$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($60c8260c6697d4fd$var$Action || ($60c8260c6697d4fd$var$Action = {}));
function $60c8260c6697d4fd$var$noop() {}
function $60c8260c6697d4fd$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $iDiRE.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $60c8260c6697d4fd$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $iDiRE.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $60c8260c6697d4fd$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $60c8260c6697d4fd$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $60c8260c6697d4fd$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $6f8b81481b9501ea$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $60c8260c6697d4fd$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $60c8260c6697d4fd$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $60c8260c6697d4fd$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $60c8260c6697d4fd$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $60c8260c6697d4fd$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $60c8260c6697d4fd$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $60c8260c6697d4fd$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $60c8260c6697d4fd$var$distanceBetween($60c8260c6697d4fd$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($60c8260c6697d4fd$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $60c8260c6697d4fd$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $60c8260c6697d4fd$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $60c8260c6697d4fd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $60c8260c6697d4fd$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($60c8260c6697d4fd$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $60c8260c6697d4fd$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $60c8260c6697d4fd$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $60c8260c6697d4fd$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($60c8260c6697d4fd$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $60c8260c6697d4fd$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $60c8260c6697d4fd$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $60c8260c6697d4fd$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $60c8260c6697d4fd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $60c8260c6697d4fd$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($60c8260c6697d4fd$var$sortCollisionsAsc);
};
function $60c8260c6697d4fd$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $60c8260c6697d4fd$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $60c8260c6697d4fd$export$597cbd7bbd10deb4;
}
function $60c8260c6697d4fd$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $60c8260c6697d4fd$var$getAdjustedRect = /*#__PURE__*/ $60c8260c6697d4fd$var$createRectAdjustmentFn(1);
function $60c8260c6697d4fd$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $60c8260c6697d4fd$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $60c8260c6697d4fd$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $60c8260c6697d4fd$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $60c8260c6697d4fd$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $60c8260c6697d4fd$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $60c8260c6697d4fd$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $60c8260c6697d4fd$var$getTransformAgnosticClientRect(element) {
    return $60c8260c6697d4fd$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $60c8260c6697d4fd$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $60c8260c6697d4fd$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $60c8260c6697d4fd$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $60c8260c6697d4fd$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $6f8b81481b9501ea$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $6f8b81481b9501ea$export$1b3bfaa9684536aa)(node) || (0, $6f8b81481b9501ea$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($60c8260c6697d4fd$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($60c8260c6697d4fd$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $60c8260c6697d4fd$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $60c8260c6697d4fd$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $60c8260c6697d4fd$var$getScrollableElement(element) {
    if (!(0, $6f8b81481b9501ea$export$71594e8a50f746f4) || !element) return null;
    if ((0, $6f8b81481b9501ea$export$5a096129d439f843)(element)) return element;
    if (!(0, $6f8b81481b9501ea$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $6f8b81481b9501ea$export$62858bae88b53fd0)(element) || element === (0, $6f8b81481b9501ea$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $6f8b81481b9501ea$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $60c8260c6697d4fd$var$getScrollXCoordinate(element) {
    if ((0, $6f8b81481b9501ea$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $60c8260c6697d4fd$var$getScrollYCoordinate(element) {
    if ((0, $6f8b81481b9501ea$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $60c8260c6697d4fd$var$getScrollCoordinates(element) {
    return {
        x: $60c8260c6697d4fd$var$getScrollXCoordinate(element),
        y: $60c8260c6697d4fd$var$getScrollYCoordinate(element)
    };
}
var $60c8260c6697d4fd$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($60c8260c6697d4fd$var$Direction || ($60c8260c6697d4fd$var$Direction = {}));
function $60c8260c6697d4fd$var$isDocumentScrollingElement(element) {
    if (!(0, $6f8b81481b9501ea$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $60c8260c6697d4fd$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $60c8260c6697d4fd$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $60c8260c6697d4fd$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $60c8260c6697d4fd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $60c8260c6697d4fd$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $60c8260c6697d4fd$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $60c8260c6697d4fd$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $60c8260c6697d4fd$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $60c8260c6697d4fd$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $60c8260c6697d4fd$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $60c8260c6697d4fd$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $60c8260c6697d4fd$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $6f8b81481b9501ea$export$e16d8520af44a096)(acc, $60c8260c6697d4fd$var$getScrollCoordinates(node));
    }, $60c8260c6697d4fd$export$597cbd7bbd10deb4);
}
function $60c8260c6697d4fd$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $60c8260c6697d4fd$var$getScrollXCoordinate(node);
    }, 0);
}
function $60c8260c6697d4fd$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $60c8260c6697d4fd$var$getScrollYCoordinate(node);
    }, 0);
}
function $60c8260c6697d4fd$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $60c8260c6697d4fd$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $60c8260c6697d4fd$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $60c8260c6697d4fd$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $60c8260c6697d4fd$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $60c8260c6697d4fd$var$getScrollYOffset
    ]
];
class $60c8260c6697d4fd$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $60c8260c6697d4fd$export$e4864aa91b5ed091(element);
        const scrollOffsets = $60c8260c6697d4fd$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $60c8260c6697d4fd$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $60c8260c6697d4fd$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $60c8260c6697d4fd$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $6f8b81481b9501ea$export$b204af158042fbac)(target);
}
function $60c8260c6697d4fd$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $60c8260c6697d4fd$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($60c8260c6697d4fd$var$EventName || ($60c8260c6697d4fd$var$EventName = {}));
function $60c8260c6697d4fd$var$preventDefault(event) {
    event.preventDefault();
}
function $60c8260c6697d4fd$var$stopPropagation(event) {
    event.stopPropagation();
}
var $60c8260c6697d4fd$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($60c8260c6697d4fd$export$a8b1916dba3ae88b || ($60c8260c6697d4fd$export$a8b1916dba3ae88b = {}));
const $60c8260c6697d4fd$var$defaultKeyboardCodes = {
    start: [
        $60c8260c6697d4fd$export$a8b1916dba3ae88b.Space,
        $60c8260c6697d4fd$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $60c8260c6697d4fd$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $60c8260c6697d4fd$export$a8b1916dba3ae88b.Space,
        $60c8260c6697d4fd$export$a8b1916dba3ae88b.Enter,
        $60c8260c6697d4fd$export$a8b1916dba3ae88b.Tab
    ]
};
const $60c8260c6697d4fd$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $60c8260c6697d4fd$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $60c8260c6697d4fd$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $60c8260c6697d4fd$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $60c8260c6697d4fd$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $60c8260c6697d4fd$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $60c8260c6697d4fd$var$Listeners((0, $6f8b81481b9501ea$export$b204af158042fbac)(target));
        this.windowListeners = new $60c8260c6697d4fd$var$Listeners((0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($60c8260c6697d4fd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($60c8260c6697d4fd$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($60c8260c6697d4fd$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $60c8260c6697d4fd$var$scrollIntoViewIfNeeded(node);
        onStart($60c8260c6697d4fd$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $6f8b81481b9501ea$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $60c8260c6697d4fd$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $60c8260c6697d4fd$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $60c8260c6697d4fd$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $6f8b81481b9501ea$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $60c8260c6697d4fd$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $60c8260c6697d4fd$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Right && !isRight || direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Down && !isBottom || direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $6f8b81481b9501ea$export$e16d8520af44a096)((0, $6f8b81481b9501ea$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$60c8260c6697d4fd$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $60c8260c6697d4fd$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $60c8260c6697d4fd$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $60c8260c6697d4fd$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $60c8260c6697d4fd$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $60c8260c6697d4fd$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $6f8b81481b9501ea$export$b204af158042fbac)(target);
        this.documentListeners = new $60c8260c6697d4fd$var$Listeners(this.document);
        this.listeners = new $60c8260c6697d4fd$var$Listeners(listenerTarget);
        this.windowListeners = new $60c8260c6697d4fd$var$Listeners((0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $6f8b81481b9501ea$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $60c8260c6697d4fd$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($60c8260c6697d4fd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($60c8260c6697d4fd$var$EventName.DragStart, $60c8260c6697d4fd$var$preventDefault);
        this.windowListeners.add($60c8260c6697d4fd$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($60c8260c6697d4fd$var$EventName.ContextMenu, $60c8260c6697d4fd$var$preventDefault);
        this.documentListeners.add($60c8260c6697d4fd$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($60c8260c6697d4fd$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($60c8260c6697d4fd$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($60c8260c6697d4fd$var$EventName.Click, $60c8260c6697d4fd$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($60c8260c6697d4fd$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $6f8b81481b9501ea$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $60c8260c6697d4fd$export$597cbd7bbd10deb4;
        const delta = (0, $6f8b81481b9501ea$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($60c8260c6697d4fd$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $60c8260c6697d4fd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($60c8260c6697d4fd$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($60c8260c6697d4fd$var$isDelayConstraint(activationConstraint)) {
                if ($60c8260c6697d4fd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $60c8260c6697d4fd$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $60c8260c6697d4fd$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $60c8260c6697d4fd$export$b26af955418d6638 extends $60c8260c6697d4fd$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $6f8b81481b9501ea$export$b204af158042fbac)(event.target);
        super(props, $60c8260c6697d4fd$var$events, listenerTarget);
    }
}
$60c8260c6697d4fd$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $60c8260c6697d4fd$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $60c8260c6697d4fd$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($60c8260c6697d4fd$var$MouseButton || ($60c8260c6697d4fd$var$MouseButton = {}));
class $60c8260c6697d4fd$export$b28554b50bf7f273 extends $60c8260c6697d4fd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $60c8260c6697d4fd$var$events$1, (0, $6f8b81481b9501ea$export$b204af158042fbac)(props.event.target));
    }
}
$60c8260c6697d4fd$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $60c8260c6697d4fd$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $60c8260c6697d4fd$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $60c8260c6697d4fd$export$19b41baf2e1bcdc0 extends $60c8260c6697d4fd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $60c8260c6697d4fd$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($60c8260c6697d4fd$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($60c8260c6697d4fd$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$60c8260c6697d4fd$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $60c8260c6697d4fd$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($60c8260c6697d4fd$export$eefe60e26f04c318 || ($60c8260c6697d4fd$export$eefe60e26f04c318 = {}));
var $60c8260c6697d4fd$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($60c8260c6697d4fd$export$f93aa492a37e1b0e || ($60c8260c6697d4fd$export$f93aa492a37e1b0e = {}));
function $60c8260c6697d4fd$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $60c8260c6697d4fd$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $60c8260c6697d4fd$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $60c8260c6697d4fd$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $6f8b81481b9501ea$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $iDiRE.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $iDiRE.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $iDiRE.useMemo)(()=>{
        switch(activator){
            case $60c8260c6697d4fd$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $60c8260c6697d4fd$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $iDiRE.useRef)(null);
    const autoScroll = (0, $iDiRE.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $iDiRE.useMemo)(()=>order === $60c8260c6697d4fd$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $iDiRE.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $60c8260c6697d4fd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $60c8260c6697d4fd$var$defaultScrollIntent = {
    x: {
        [$60c8260c6697d4fd$var$Direction.Backward]: false,
        [$60c8260c6697d4fd$var$Direction.Forward]: false
    },
    y: {
        [$60c8260c6697d4fd$var$Direction.Backward]: false,
        [$60c8260c6697d4fd$var$Direction.Forward]: false
    }
};
function $60c8260c6697d4fd$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $6f8b81481b9501ea$export$5cae361ad82dce8b)(delta);
    return (0, $6f8b81481b9501ea$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $60c8260c6697d4fd$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$60c8260c6697d4fd$var$Direction.Backward]: previousIntent.x[$60c8260c6697d4fd$var$Direction.Backward] || direction.x === -1,
                [$60c8260c6697d4fd$var$Direction.Forward]: previousIntent.x[$60c8260c6697d4fd$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$60c8260c6697d4fd$var$Direction.Backward]: previousIntent.y[$60c8260c6697d4fd$var$Direction.Backward] || direction.y === -1,
                [$60c8260c6697d4fd$var$Direction.Forward]: previousIntent.y[$60c8260c6697d4fd$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $60c8260c6697d4fd$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $6f8b81481b9501ea$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $60c8260c6697d4fd$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $iDiRE.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $60c8260c6697d4fd$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($60c8260c6697d4fd$export$571c10ffffe014ab || ($60c8260c6697d4fd$export$571c10ffffe014ab = {}));
var $60c8260c6697d4fd$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($60c8260c6697d4fd$export$8e062c3160beefd5 || ($60c8260c6697d4fd$export$8e062c3160beefd5 = {}));
const $60c8260c6697d4fd$var$defaultValue = /*#__PURE__*/ new Map();
function $60c8260c6697d4fd$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $iDiRE.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $iDiRE.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $6f8b81481b9501ea$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $iDiRE.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $iDiRE.useRef)(null);
    const droppableRects = (0, $6f8b81481b9501ea$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $60c8260c6697d4fd$var$defaultValue;
        if (!previousValue || previousValue === $60c8260c6697d4fd$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $60c8260c6697d4fd$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $iDiRE.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $iDiRE.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $iDiRE.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $iDiRE.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $60c8260c6697d4fd$export$571c10ffffe014ab.Always:
                return false;
            case $60c8260c6697d4fd$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $60c8260c6697d4fd$var$useInitialValue(value, computeFn) {
    return (0, $6f8b81481b9501ea$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $60c8260c6697d4fd$var$useInitialRect(node, measure) {
    return $60c8260c6697d4fd$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $60c8260c6697d4fd$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $6f8b81481b9501ea$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $iDiRE.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $iDiRE.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $60c8260c6697d4fd$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $6f8b81481b9501ea$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $iDiRE.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $iDiRE.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $60c8260c6697d4fd$var$defaultMeasure(element) {
    return new $60c8260c6697d4fd$var$Rect($60c8260c6697d4fd$export$b6aa1f30c53d7454(element), element);
}
function $60c8260c6697d4fd$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $60c8260c6697d4fd$var$defaultMeasure;
    const [rect, setRect] = (0, $iDiRE.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $60c8260c6697d4fd$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $60c8260c6697d4fd$var$useResizeObserver({
        callback: measureRect
    });
    (0, $6f8b81481b9501ea$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $60c8260c6697d4fd$var$useRectDelta(rect) {
    const initialRect = $60c8260c6697d4fd$var$useInitialValue(rect);
    return $60c8260c6697d4fd$var$getRectDelta(rect, initialRect);
}
const $60c8260c6697d4fd$var$defaultValue$1 = [];
function $60c8260c6697d4fd$var$useScrollableAncestors(node) {
    const previousNode = (0, $iDiRE.useRef)(node);
    const ancestors = (0, $6f8b81481b9501ea$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $60c8260c6697d4fd$var$defaultValue$1;
        if (previousValue && previousValue !== $60c8260c6697d4fd$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $60c8260c6697d4fd$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $iDiRE.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $60c8260c6697d4fd$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $iDiRE.useState)(null);
    const prevElements = (0, $iDiRE.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $iDiRE.useCallback)((event)=>{
        const scrollingElement = $60c8260c6697d4fd$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $60c8260c6697d4fd$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $iDiRE.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $60c8260c6697d4fd$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $60c8260c6697d4fd$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $60c8260c6697d4fd$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $iDiRE.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $6f8b81481b9501ea$export$e16d8520af44a096)(acc, coordinates), $60c8260c6697d4fd$export$597cbd7bbd10deb4) : $60c8260c6697d4fd$var$getScrollOffsets(elements);
        return $60c8260c6697d4fd$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $60c8260c6697d4fd$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $iDiRE.useRef)(null);
    (0, $iDiRE.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $iDiRE.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $60c8260c6697d4fd$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $6f8b81481b9501ea$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $60c8260c6697d4fd$export$597cbd7bbd10deb4;
}
function $60c8260c6697d4fd$var$useSensorSetup(sensors) {
    (0, $iDiRE.useEffect)(()=>{
        if (!(0, $6f8b81481b9501ea$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $60c8260c6697d4fd$var$useSyntheticListeners(listeners, id) {
    return (0, $iDiRE.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $60c8260c6697d4fd$var$useWindowRect(element) {
    return (0, $iDiRE.useMemo)(()=>element ? $60c8260c6697d4fd$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $60c8260c6697d4fd$var$defaultValue$2 = [];
function $60c8260c6697d4fd$var$useRects(elements, measure) {
    if (measure === void 0) measure = $60c8260c6697d4fd$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $60c8260c6697d4fd$var$useWindowRect(firstElement ? (0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, setRects] = (0, $iDiRE.useState)($60c8260c6697d4fd$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $60c8260c6697d4fd$var$defaultValue$2;
            return elements.map((element)=>$60c8260c6697d4fd$var$isDocumentScrollingElement(element) ? windowRect : new $60c8260c6697d4fd$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $60c8260c6697d4fd$var$useResizeObserver({
        callback: measureRects
    });
    (0, $6f8b81481b9501ea$export$700979bc83e7db82)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $60c8260c6697d4fd$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $6f8b81481b9501ea$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $60c8260c6697d4fd$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $iDiRE.useState)(null);
    const handleResize = (0, $iDiRE.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $6f8b81481b9501ea$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $60c8260c6697d4fd$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $iDiRE.useCallback)((element)=>{
        const node = $60c8260c6697d4fd$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $6f8b81481b9501ea$export$bc23c270f170c912)(handleNodeChange);
    return (0, $iDiRE.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $60c8260c6697d4fd$var$defaultSensors = [
    {
        sensor: $60c8260c6697d4fd$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $60c8260c6697d4fd$export$44d67f2a438aeba9,
        options: {}
    }
];
const $60c8260c6697d4fd$var$defaultData = {
    current: {}
};
const $60c8260c6697d4fd$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $60c8260c6697d4fd$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $60c8260c6697d4fd$var$getTransformAgnosticClientRect,
        strategy: $60c8260c6697d4fd$export$571c10ffffe014ab.WhileDragging,
        frequency: $60c8260c6697d4fd$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $60c8260c6697d4fd$export$b6aa1f30c53d7454
    }
};
class $60c8260c6697d4fd$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $60c8260c6697d4fd$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $60c8260c6697d4fd$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $60c8260c6697d4fd$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $60c8260c6697d4fd$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $60c8260c6697d4fd$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $60c8260c6697d4fd$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $60c8260c6697d4fd$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $60c8260c6697d4fd$var$noop
};
const $60c8260c6697d4fd$var$InternalContext = /*#__PURE__*/ (0, $iDiRE.createContext)($60c8260c6697d4fd$var$defaultInternalContext);
const $60c8260c6697d4fd$var$PublicContext = /*#__PURE__*/ (0, $iDiRE.createContext)($60c8260c6697d4fd$var$defaultPublicContext);
function $60c8260c6697d4fd$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $60c8260c6697d4fd$var$DroppableContainersMap()
        }
    };
}
function $60c8260c6697d4fd$var$reducer(state, action) {
    switch(action.type){
        case $60c8260c6697d4fd$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $60c8260c6697d4fd$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $60c8260c6697d4fd$var$Action.DragEnd:
        case $60c8260c6697d4fd$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $60c8260c6697d4fd$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $60c8260c6697d4fd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $60c8260c6697d4fd$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $60c8260c6697d4fd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $60c8260c6697d4fd$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $60c8260c6697d4fd$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $60c8260c6697d4fd$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $iDiRE.useContext)($60c8260c6697d4fd$var$InternalContext);
    const previousActivatorEvent = (0, $6f8b81481b9501ea$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $6f8b81481b9501ea$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $iDiRE.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $6f8b81481b9501ea$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $6f8b81481b9501ea$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $60c8260c6697d4fd$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $60c8260c6697d4fd$var$useMeasuringConfiguration(config) {
    return (0, $iDiRE.useMemo)(()=>({
            draggable: {
                ...$60c8260c6697d4fd$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$60c8260c6697d4fd$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$60c8260c6697d4fd$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $60c8260c6697d4fd$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $iDiRE.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $6f8b81481b9501ea$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $60c8260c6697d4fd$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $60c8260c6697d4fd$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $60c8260c6697d4fd$var$ActiveDraggableContext = /*#__PURE__*/ (0, $iDiRE.createContext)({
    ...$60c8260c6697d4fd$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $60c8260c6697d4fd$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($60c8260c6697d4fd$var$Status || ($60c8260c6697d4fd$var$Status = {}));
const $60c8260c6697d4fd$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $iDiRE.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $60c8260c6697d4fd$var$defaultSensors, collisionDetection: collisionDetection = $60c8260c6697d4fd$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $iDiRE.useReducer)($60c8260c6697d4fd$var$reducer, undefined, $60c8260c6697d4fd$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $60c8260c6697d4fd$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $iDiRE.useState)($60c8260c6697d4fd$var$Status.Uninitialized);
    const isInitialized = status === $60c8260c6697d4fd$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $iDiRE.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $iDiRE.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $60c8260c6697d4fd$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $iDiRE.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $iDiRE.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $iDiRE.useState)(null);
    const latestProps = (0, $6f8b81481b9501ea$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $6f8b81481b9501ea$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $iDiRE.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $60c8260c6697d4fd$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $60c8260c6697d4fd$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $60c8260c6697d4fd$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $iDiRE.useMemo)(()=>activatorEvent ? (0, $6f8b81481b9501ea$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $60c8260c6697d4fd$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $60c8260c6697d4fd$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $60c8260c6697d4fd$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $60c8260c6697d4fd$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $iDiRE.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $60c8260c6697d4fd$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $60c8260c6697d4fd$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $60c8260c6697d4fd$var$useWindowRect(draggingNode ? (0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $60c8260c6697d4fd$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $60c8260c6697d4fd$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $60c8260c6697d4fd$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $6f8b81481b9501ea$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $60c8260c6697d4fd$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $60c8260c6697d4fd$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $60c8260c6697d4fd$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $6f8b81481b9501ea$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $60c8260c6697d4fd$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $60c8260c6697d4fd$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $iDiRE.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $6f8b81481b9501ea$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $60c8260c6697d4fd$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $iDiRE.useRef)(null);
    const instantiateSensor = (0, $iDiRE.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $a62a1f696aa80a71$exports.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($60c8260c6697d4fd$var$Status.Initializing);
                    dispatch({
                        type: $60c8260c6697d4fd$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $60c8260c6697d4fd$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($60c8260c6697d4fd$var$Action.DragEnd),
            onCancel: createHandler($60c8260c6697d4fd$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $60c8260c6697d4fd$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $60c8260c6697d4fd$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $a62a1f696aa80a71$exports.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($60c8260c6697d4fd$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $60c8260c6697d4fd$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $iDiRE.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $60c8260c6697d4fd$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $60c8260c6697d4fd$var$useSensorSetup(sensors);
    (0, $6f8b81481b9501ea$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $60c8260c6697d4fd$var$Status.Initializing) setStatus($60c8260c6697d4fd$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $iDiRE.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $a62a1f696aa80a71$exports.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $iDiRE.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $a62a1f696aa80a71$exports.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $6f8b81481b9501ea$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $60c8260c6697d4fd$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $iDiRE.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $iDiRE.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $60c8260c6697d4fd$var$NullContext = /*#__PURE__*/ (0, $iDiRE.createContext)(null);
const $60c8260c6697d4fd$var$defaultRole = 'button';
const $60c8260c6697d4fd$var$ID_PREFIX = 'Draggable';
function $60c8260c6697d4fd$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $6f8b81481b9501ea$export$c485849f2e393253)($60c8260c6697d4fd$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $iDiRE.useContext)($60c8260c6697d4fd$var$InternalContext);
    const { role: role = $60c8260c6697d4fd$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $iDiRE.useContext)(isDragging ? $60c8260c6697d4fd$var$ActiveDraggableContext : $60c8260c6697d4fd$var$NullContext);
    const [node, setNodeRef] = (0, $6f8b81481b9501ea$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $6f8b81481b9501ea$export$bc23c270f170c912)();
    const listeners = $60c8260c6697d4fd$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $6f8b81481b9501ea$export$86c4283a11f23f95)(data);
    (0, $6f8b81481b9501ea$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $iDiRE.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $60c8260c6697d4fd$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $60c8260c6697d4fd$export$4930f6bf413be70e() {
    return (0, $iDiRE.useContext)($60c8260c6697d4fd$var$PublicContext);
}
const $60c8260c6697d4fd$var$ID_PREFIX$1 = 'Droppable';
const $60c8260c6697d4fd$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $60c8260c6697d4fd$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $6f8b81481b9501ea$export$c485849f2e393253)($60c8260c6697d4fd$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $iDiRE.useContext)($60c8260c6697d4fd$var$InternalContext);
    const previous = (0, $iDiRE.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $iDiRE.useRef)(false);
    const rect = (0, $iDiRE.useRef)(null);
    const callbackId = (0, $iDiRE.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$60c8260c6697d4fd$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $6f8b81481b9501ea$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $iDiRE.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $60c8260c6697d4fd$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $iDiRE.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $6f8b81481b9501ea$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $6f8b81481b9501ea$export$86c4283a11f23f95)(data);
    (0, $iDiRE.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $iDiRE.useEffect)(()=>{
        dispatch({
            type: $60c8260c6697d4fd$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $60c8260c6697d4fd$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $iDiRE.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $60c8260c6697d4fd$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $60c8260c6697d4fd$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $iDiRE.useState)(null);
    const [element, setElement] = (0, $iDiRE.useState)(null);
    const previousChildren = (0, $6f8b81481b9501ea$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $6f8b81481b9501ea$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).Fragment, null, children, clonedChildren ? (0, $iDiRE.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $60c8260c6697d4fd$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $60c8260c6697d4fd$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$InternalContext.Provider, {
        value: $60c8260c6697d4fd$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$ActiveDraggableContext.Provider, {
        value: $60c8260c6697d4fd$var$defaultTransform
    }, children));
}
const $60c8260c6697d4fd$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $60c8260c6697d4fd$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $6f8b81481b9501ea$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $60c8260c6697d4fd$var$PositionedOverlay = /*#__PURE__*/ (0, $iDiRE.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $60c8260c6697d4fd$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$60c8260c6697d4fd$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $6f8b81481b9501ea$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $60c8260c6697d4fd$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $60c8260c6697d4fd$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $60c8260c6697d4fd$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $6f8b81481b9501ea$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $6f8b81481b9501ea$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $60c8260c6697d4fd$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $60c8260c6697d4fd$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $60c8260c6697d4fd$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $60c8260c6697d4fd$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $6f8b81481b9501ea$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $60c8260c6697d4fd$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $6f8b81481b9501ea$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $60c8260c6697d4fd$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $60c8260c6697d4fd$var$createDefaultDropAnimation(config);
        $60c8260c6697d4fd$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $60c8260c6697d4fd$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$60c8260c6697d4fd$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $60c8260c6697d4fd$var$key = 0;
function $60c8260c6697d4fd$var$useKey(id) {
    return (0, $iDiRE.useMemo)(()=>{
        if (id == null) return;
        $60c8260c6697d4fd$var$key++;
        return $60c8260c6697d4fd$var$key;
    }, [
        id
    ]);
}
const $60c8260c6697d4fd$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $60c8260c6697d4fd$export$4930f6bf413be70e();
    const transform = (0, $iDiRE.useContext)($60c8260c6697d4fd$var$ActiveDraggableContext);
    const key = $60c8260c6697d4fd$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $60c8260c6697d4fd$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $60c8260c6697d4fd$var$useInitialValue(activeNodeRect);
    const dropAnimation = $60c8260c6697d4fd$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($60c8260c6697d4fd$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});


parcelRequire("iDiRE");
function $64b21defd61df8e2$export$7d15b64cf5a3a4c4(min, v, max) {
    return Math.max(min, Math.min(max, v));
}
function $64b21defd61df8e2$export$f2a139e5d18b9882(props) {
    const { setNodeRef: setNodeRef, transform: transform, listeners: listeners } = (0, $60c8260c6697d4fd$export$df30c81f5aa01ff7)({
        id: props.name,
        disabled: props.disabled
    });
    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`
    } : undefined;
    console.log(style);
    return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
        ...listeners,
        ...props,
        style: style,
        ref: setNodeRef
    });
}


class $11f63a17106808cb$export$3b781931848ef3db extends (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).Component {
    getActualReqs(skill) {
        const actualReqs = {};
        for(const req in skill.reqs)if (req != "reqp") actualReqs[req] = skill.reqs[req];
        return actualReqs;
    }
    shouldRenderReqs(skill) {
        return Object.keys(this.getActualReqs(skill)).length > 0;
    }
    renderSkillRequirements(skill) {
        const actualReqs = this.getActualReqs(skill);
        if (Object.keys(actualReqs).length == 0) return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
            className: "skill-no-requirements",
            children: "Brak"
        });
        else {
            const list = [];
            for(const req in actualReqs)list.push(/*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                className: "skill-requirement",
                dangerouslySetInnerHTML: {
                    __html: (0, $d614c5f7bf20fa47$export$cc3b587f948c6cc8)(req, skill.reqs[req])
                }
            }, req));
            return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                className: "skill-requirement-list",
                children: list
            });
        }
    }
    renderSkillEffects(skill) {
        const list = [];
        for(const stat in skill.stats){
            const spl = skill.stats[stat].split(",");
            const indexFromSkillLevel = Math.max(0, (this.props.levels[skill.id] ?? 0) - 1);
            const currentValue = spl[Math.min(indexFromSkillLevel, spl.length - 1)];
            list.push(/*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                className: "skill-effect extern-content",
                dangerouslySetInnerHTML: {
                    __html: (0, $d614c5f7bf20fa47$export$d6d92dde746a30b6)(stat, currentValue, this.props.lvl)
                }
            }, stat));
        }
        return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
            className: "skill-effect-list",
            children: list
        });
    }
    renderSkillDetails(disabled) {
        const selectedSkill = this.props.skills.find((s)=>s.id == this.props.selectedSkill);
        if (selectedSkill) {
            const maxSkillLevel = (0, $c41220b8559f08aa$export$78a615baad4f0e95)(selectedSkill);
            const currentSkillLevel = this.props.levels[selectedSkill.id] ?? 0;
            const isActive = currentSkillLevel > 0;
            return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                className: "skill-data",
                children: [
                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                        className: "skill-name",
                        children: selectedSkill.name
                    }),
                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                        className: "skill-level",
                        children: [
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                                className: "skill-level-text",
                                children: "Poziom umiej\u0119tno\u015Bci:"
                            }),
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                                className: "skill-level-slider-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("input", {
                                        disabled: disabled,
                                        min: 0,
                                        max: 10,
                                        value: currentSkillLevel,
                                        onChange: (e)=>{
                                            const newVal = Number(e.target.value);
                                            if (this.props.onLevelChange) this.props.onLevelChange(selectedSkill.id, newVal);
                                        },
                                        onWheel: (e)=>{
                                            const newVal = (0, $64b21defd61df8e2$export$7d15b64cf5a3a4c4)(0, currentSkillLevel + -Math.sign(e.deltaY + e.deltaX), maxSkillLevel);
                                            if (this.props.onLevelChange) this.props.onLevelChange(selectedSkill.id, newVal);
                                        },
                                        type: "range"
                                    }),
                                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("strong", {
                                        children: [
                                            currentSkillLevel,
                                            "/",
                                            maxSkillLevel
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                        className: "skill-description",
                        children: selectedSkill.desc.split("#")[0]
                    }),
                    this.shouldRenderReqs(selectedSkill) ? /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                        className: "skill-requirements",
                        children: [
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                                className: "skill-requirements-title",
                                children: "Wymagania"
                            }),
                            this.renderSkillRequirements(selectedSkill)
                        ]
                    }) : "",
                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                        className: `skill-effects${isActive ? "" : " disabled"}`,
                        children: [
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                                className: "skill-effects-title",
                                children: "Dzia\u0142anie umiej\u0119tno\u015Bci"
                            }),
                            this.renderSkillEffects(selectedSkill)
                        ]
                    })
                ]
            });
        } else return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
            className: "skill-not-selected",
            children: "Po wybraniu umiej\u0119tno\u015Bci, w tym miejscu pokazane b\u0119d\u0105 jej parametry."
        });
    }
    render() {
        const usedPoints = (0, $c41220b8559f08aa$export$cfb4ffbd4f57cedb)(this.props.levels);
        const totalPoints = (0, $c41220b8559f08aa$export$82cfbb6d79d0ca20)(this.props.lvl);
        const selectedRow = this.props.skillTree.findIndex((row)=>row.includes(this.props.selectedSkill));
        const disabled = usedPoints < (0, $c41220b8559f08aa$export$f39e997b5c0d94e0)(selectedRow);
        return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
            className: "skill-simulator-preview-pane",
            children: [
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                    className: "remaining-points",
                    children: [
                        "Wykorzystane punkty: ",
                        usedPoints,
                        " / ",
                        totalPoints
                    ]
                }),
                this.renderSkillDetails(disabled),
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                    onClick: this.props.onMasteryBtnClicked,
                    className: "mastery-btn",
                    children: "Edytuj mistrzostwo walk"
                })
            ]
        });
    }
}




var $iDiRE = parcelRequire("iDiRE");

var $iDiRE = parcelRequire("iDiRE");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $2f807d6c49cffd6f$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $2f807d6c49cffd6f$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $2f807d6c49cffd6f$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $2f807d6c49cffd6f$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $2f807d6c49cffd6f$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $2f807d6c49cffd6f$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $2f807d6c49cffd6f$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $2f807d6c49cffd6f$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $2f807d6c49cffd6f$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$2f807d6c49cffd6f$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$2f807d6c49cffd6f$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$2f807d6c49cffd6f$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$2f807d6c49cffd6f$var$defaultScale
    };
};
function $2f807d6c49cffd6f$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $2f807d6c49cffd6f$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $2f807d6c49cffd6f$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $2f807d6c49cffd6f$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $2f807d6c49cffd6f$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $2f807d6c49cffd6f$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$2f807d6c49cffd6f$var$defaultScale$1
        };
    }
    const itemGap = $2f807d6c49cffd6f$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$2f807d6c49cffd6f$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$2f807d6c49cffd6f$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$2f807d6c49cffd6f$var$defaultScale$1
    };
};
function $2f807d6c49cffd6f$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $2f807d6c49cffd6f$var$ID_PREFIX = 'Sortable';
const $2f807d6c49cffd6f$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createContext({
    activeIndex: -1,
    containerId: $2f807d6c49cffd6f$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $2f807d6c49cffd6f$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $2f807d6c49cffd6f$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $2f807d6c49cffd6f$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $60c8260c6697d4fd$export$4930f6bf413be70e)();
    const containerId = (0, $6f8b81481b9501ea$export$c485849f2e393253)($2f807d6c49cffd6f$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $iDiRE.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $iDiRE.useRef)(items);
    const itemsHaveChanged = !$2f807d6c49cffd6f$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $2f807d6c49cffd6f$var$normalizeDisabled(disabledProp);
    (0, $6f8b81481b9501ea$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $iDiRE.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $iDiRE.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $2f807d6c49cffd6f$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).createElement($2f807d6c49cffd6f$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $2f807d6c49cffd6f$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $2f807d6c49cffd6f$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $2f807d6c49cffd6f$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $2f807d6c49cffd6f$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $2f807d6c49cffd6f$var$transitionProperty = 'transform';
const $2f807d6c49cffd6f$var$disabledTransition = /*#__PURE__*/ (0, $6f8b81481b9501ea$export$c4ffa16951855e28).Transition.toString({
    property: $2f807d6c49cffd6f$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $2f807d6c49cffd6f$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $2f807d6c49cffd6f$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $iDiRE.useState)(null);
    const previousIndex = (0, $iDiRE.useRef)(index);
    (0, $6f8b81481b9501ea$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $60c8260c6697d4fd$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $iDiRE.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $2f807d6c49cffd6f$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $2f807d6c49cffd6f$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $2f807d6c49cffd6f$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $2f807d6c49cffd6f$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $iDiRE.useContext)($2f807d6c49cffd6f$var$Context);
    const disabled = $2f807d6c49cffd6f$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $iDiRE.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $iDiRE.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $60c8260c6697d4fd$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $60c8260c6697d4fd$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$2f807d6c49cffd6f$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $6f8b81481b9501ea$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $2f807d6c49cffd6f$var$isValidIndex(activeIndex) && $2f807d6c49cffd6f$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $2f807d6c49cffd6f$var$isValidIndex(activeIndex) && $2f807d6c49cffd6f$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $iDiRE.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $2f807d6c49cffd6f$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $iDiRE.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $iDiRE.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId && !previous.current.activeId) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $2f807d6c49cffd6f$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $6f8b81481b9501ea$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $6f8b81481b9501ea$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $2f807d6c49cffd6f$var$transitionProperty
        });
        return undefined;
    }
}
function $2f807d6c49cffd6f$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $2f807d6c49cffd6f$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $2f807d6c49cffd6f$var$directions = [
    (0, $60c8260c6697d4fd$export$a8b1916dba3ae88b).Down,
    (0, $60c8260c6697d4fd$export$a8b1916dba3ae88b).Right,
    (0, $60c8260c6697d4fd$export$a8b1916dba3ae88b).Up,
    (0, $60c8260c6697d4fd$export$a8b1916dba3ae88b).Left
];
const $2f807d6c49cffd6f$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($2f807d6c49cffd6f$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $60c8260c6697d4fd$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $60c8260c6697d4fd$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $60c8260c6697d4fd$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $60c8260c6697d4fd$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $60c8260c6697d4fd$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $60c8260c6697d4fd$export$ef1beab6d7287295)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $60c8260c6697d4fd$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $2f807d6c49cffd6f$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $2f807d6c49cffd6f$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $6f8b81481b9501ea$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $2f807d6c49cffd6f$var$isSameContainer(a, b) {
    if (!$2f807d6c49cffd6f$export$6424ec8a0d450b09(a) || !$2f807d6c49cffd6f$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $2f807d6c49cffd6f$var$isAfter(a, b) {
    if (!$2f807d6c49cffd6f$export$6424ec8a0d450b09(a) || !$2f807d6c49cffd6f$export$6424ec8a0d450b09(b)) return false;
    if (!$2f807d6c49cffd6f$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}






var $a0f99efa3837998a$export$96a634ac3b428936 = /*#__PURE__*/ function(SpecialSkills) {
    SpecialSkills[SpecialSkills["STRIKE"] = -1] = "STRIKE";
    SpecialSkills[SpecialSkills["STEP"] = -2] = "STEP";
    return SpecialSkills;
}({});
function $a0f99efa3837998a$export$321eb00a4bf59da7(id) {
    return -1 == id || -2 == id;
}
const $a0f99efa3837998a$var$specialSkillNames = {
    [-2]: "Krok do przodu",
    [-1]: "Zwyk\u0142y atak"
};
function $a0f99efa3837998a$var$MasteryEntry(props) {
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition } = (0, $2f807d6c49cffd6f$export$4ebcb6201122185a)({
        id: props.id
    });
    if (transform) transform.x = 0;
    const style = {
        transform: (0, $6f8b81481b9501ea$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition
    };
    const skillName = $a0f99efa3837998a$var$specialSkillNames[props.skill] ?? (0, $ccaec58fcce19e27$export$36521b62f192612d)()?.skills.find((s)=>s.id == props.skill)?.name;
    return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
        className: "mastery-skill",
        children: [
            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                className: "mastery-skill-id",
                children: [
                    props.idx + 1,
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                className: "mastery-skill-inner",
                ref: setNodeRef,
                style: style,
                ...attributes,
                children: [
                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("span", {
                        ...listeners,
                        className: "mastery-skill-name",
                        children: skillName ?? "Error:skill-name"
                    }),
                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("span", {
                        onClick: props.onDeleteBtnClicked,
                        className: "mastery-skill-delete",
                        children: "\u2A2F"
                    })
                ]
            })
        ]
    });
}
class $a0f99efa3837998a$export$a56145c5d5dd1927 extends (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).Component {
    constructor(props){
        super(props);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.onRepeatChange = this.onRepeatChange.bind(this);
    }
    onDragEnd(ev) {
        if (ev.active && ev.over && ev.active.id != ev.over.id) {
            const mastery = [
                ...this.props.skills
            ];
            const ind2 = mastery.findIndex((skill)=>skill.id == ev.active.id);
            const ind1 = mastery.findIndex((skill)=>skill.id == ev.over.id);
            const [skill] = mastery.splice(ind2, 1);
            mastery.splice(ind1, 0, skill);
            this.props.onSkillsChange?.(mastery);
        }
    }
    onRepeatChange() {
        this.props.onRepeatChange?.(!this.props.repeat);
    }
    addSkill(id) {
        this.props.onSkillAddRequest?.(id);
    }
    render() {
        return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
            className: "skill-simulator-mastery",
            children: [
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                    className: "mastery-header",
                    children: [
                        "Mistrzostwo walk (",
                        this.props.skills.length,
                        " / 20)"
                    ]
                }),
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                    className: "mastery-info",
                    children: [
                        /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                            children: "Kliknij umiej\u0119tno\u015Bci, aby doda\u0107 je do mistrzostwa."
                        }),
                        /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                            children: "Elementy listy mo\u017Cna przeci\u0105ga\u0107 aby zmieni\u0107 kolejno\u015B\u0107."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                    className: "mastery-skills",
                    children: /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)((0, $60c8260c6697d4fd$export$2d5c5ceac203fc1e), {
                        onDragEnd: this.onDragEnd,
                        children: /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)((0, $2f807d6c49cffd6f$export$86155fde54f06e6a), {
                            items: this.props.skills.map((s)=>s.id),
                            strategy: (0, $2f807d6c49cffd6f$export$fe2be640df2ffb9e),
                            children: this.props.skills.map((skill, idx)=>/*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)($a0f99efa3837998a$var$MasteryEntry, {
                                    idx: idx,
                                    skill: skill.skill,
                                    id: skill.id,
                                    onDeleteBtnClicked: ()=>{
                                        const mastery = [
                                            ...this.props.skills
                                        ];
                                        mastery.splice(idx, 1);
                                        this.props.onSkillsChange?.(mastery);
                                    }
                                }, skill.id))
                        })
                    })
                }),
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                    className: "mastery-repeat",
                    children: [
                        /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("label", {
                            htmlFor: "mastery-repeat",
                            children: "Powtarzaj"
                        }),
                        /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("input", {
                            onChange: this.onRepeatChange,
                            id: "mastery-repeat",
                            type: "checkbox",
                            checked: this.props.repeat
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                    className: "mastery-pseudoskills",
                    children: [
                        /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                            onClick: ()=>this.addSkill(-1),
                            className: "btnlike",
                            children: "Dodaj zwyk\u0142y atak"
                        }),
                        /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                            onClick: ()=>this.addSkill(-2),
                            className: "btnlike",
                            children: "Dodaj krok do przodu"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                    onClick: this.props.onCloseBtnClicked,
                    className: "mastery-btn",
                    children: "Zamknij"
                })
            ]
        });
    }
}
function $a0f99efa3837998a$export$e0969da9b8fb378d() {}


let $ccaec58fcce19e27$var$globalSkillData = null;
function $ccaec58fcce19e27$export$bd9e47baa8220665(skills) {
    $ccaec58fcce19e27$var$globalSkillData = skills;
}
function $ccaec58fcce19e27$export$36521b62f192612d() {
    return $ccaec58fcce19e27$var$globalSkillData;
}
function $ccaec58fcce19e27$var$skillLevelsIdentical(a, b) {
    if (Object.keys(a).length != Object.keys(b).length) return false;
    for(const id in a){
        if (b[id] != a[id]) return false;
    }
    return true;
}
let $ccaec58fcce19e27$var$masterySkillID = 1;
function $ccaec58fcce19e27$export$27f8950178278c76() {
    return $ccaec58fcce19e27$var$masterySkillID++;
}
class $ccaec58fcce19e27$export$3d14641e2872f1b2 extends (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).Component {
    constructor(props){
        super(props);
        this.state = {
            selectedSkill: -1,
            masteryOpen: false
        };
        if ($ccaec58fcce19e27$var$globalSkillData == null) throw new Error("skills must be loaded with loadGlobalSkillData before creating a SkillSimulator");
        this.onSkillLevelChange = this.onSkillLevelChange.bind(this);
        this.onSkillSelected = this.onSkillSelected.bind(this);
        this.onSkillMasteryAddRequest = this.onSkillMasteryAddRequest.bind(this);
        this.onMasterySkillsChange = this.onMasterySkillsChange.bind(this);
        this.onMasteryRepeatChange = this.onMasteryRepeatChange.bind(this);
        this.toggleMastery = this.toggleMastery.bind(this);
    // this.onLvlChange = this.onLvlChange.bind(this);
    // this.onProfChange = this.onProfChange.bind(this);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lvl != this.props.lvl || prevProps.prof != this.props.prof) {
            const legalLevels = this.getLegalSkillLevels(this.props.skillLevels, this.props.lvl, this.props.prof);
            if (!$ccaec58fcce19e27$var$skillLevelsIdentical(legalLevels, this.props.skillLevels)) {
                this.props.onChange?.(legalLevels);
                const legalMastery = this.getLegalMastery(legalLevels);
                if (legalMastery.length != this.props.masterySkills.length) this.props.onMasterySkillsChange?.(legalMastery);
            }
        }
    }
    getSkillRows(prof) {
        return $ccaec58fcce19e27$var$globalSkillData.skillTrees[prof ?? this.props.prof];
    }
    onSkillSelected(skillID) {
        this.setState({
            selectedSkill: skillID
        });
    }
    onSkillMasteryAddRequest(skillID) {
        if (this.props.masterySkills.length >= 20) return;
        const mastery = [
            ...this.props.masterySkills
        ];
        mastery.push({
            id: $ccaec58fcce19e27$export$27f8950178278c76(),
            skill: skillID
        });
        this.props.onMasterySkillsChange?.(mastery);
    }
    onMasterySkillsChange(mastery) {
        this.props?.onMasterySkillsChange?.(mastery);
    }
    onMasteryRepeatChange(repeat) {
        this.props.onMasteryRepeatChange?.(repeat);
    }
    getLegalMastery(levels) {
        const legalEntries = [];
        for (const masteryEntry of this.props.masterySkills)if (levels[masteryEntry.skill] || (0, $a0f99efa3837998a$export$321eb00a4bf59da7)(masteryEntry.skill)) legalEntries.push(masteryEntry);
        return legalEntries;
    }
    getLegalSkillLevels(levels, lvl, prof) {
        const allowedLevels = {};
        const skillRows = this.getSkillRows(prof);
        const availablePoints = (0, $c41220b8559f08aa$export$82cfbb6d79d0ca20)(lvl);
        let learnedCount = 0;
        let i = 0;
        outer: for(i = 0; i < skillRows.length; ++i){
            const row = skillRows[i];
            for (const id of row){
                if (learnedCount < (0, $c41220b8559f08aa$export$f39e997b5c0d94e0)(i) || learnedCount >= availablePoints) break outer;
                const pts = Math.min(levels[id] ?? 0, availablePoints - learnedCount);
                learnedCount += pts;
                allowedLevels[id] = pts;
            }
        }
        return allowedLevels;
    }
    // onLvlChange(lvl: number) {
    //     const legalLevels = this.ensureSkillLevelsLegal(this.props.skillLevels, lvl, this.props.prof);
    //     this.props.onChange?.(legalLevels);
    // }
    // onProfChange(prof: Prof) {
    //     const legalLevels = this.ensureSkillLevelsLegal(this.props.skillLevels, this.props.lvl, prof);
    //     this.props.onChange?.(legalLevels);
    // }
    onSkillLevelChange(skillID, level) {
        const levels = this.props.skillLevels;
        const currLevel = levels[skillID] ?? 0;
        const maxUpgrade = (0, $c41220b8559f08aa$export$82cfbb6d79d0ca20)(this.props.lvl) - (0, $c41220b8559f08aa$export$cfb4ffbd4f57cedb)(levels);
        const newLevel = currLevel + Math.min(maxUpgrade, level - currLevel);
        if (newLevel != currLevel) {
            levels[skillID] = level;
            const legalLevels = this.getLegalSkillLevels(levels, this.props.lvl, this.props.prof);
            this.props.onChange?.(legalLevels);
        }
    }
    renderSkillRows(skillRows) {
        const res = [];
        for(let i = 0; i < (0, $c41220b8559f08aa$export$6f74767403981169); ++i){
            const requiredLvl = (0, $c41220b8559f08aa$export$d71c469e34232cb7)(i);
            const requiredPtsString = i > 0 ? ` i ${(0, $c41220b8559f08aa$export$f39e997b5c0d94e0)(i)} pkt umiej\u{119}tno\u{15B}ci` : "";
            res.push(/*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                className: "skill-simulator-row-separator",
                children: [
                    "Wymagania: ",
                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("strong", {
                        children: requiredLvl
                    }),
                    " poziom",
                    requiredPtsString
                ]
            }, (0, $c41220b8559f08aa$export$6f74767403981169) + i));
            res.push(/*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)((0, $85471f42ab5da1a0$export$646c9bd86cfacc66), {
                onSkillSelected: this.onSkillSelected,
                onLevelChange: this.onSkillLevelChange,
                levels: this.props.skillLevels,
                skills: $ccaec58fcce19e27$var$globalSkillData.skills,
                skillsIDs: skillRows[i],
                selectedSkill: this.state.selectedSkill,
                rowIndex: i,
                masteryOpen: this.state.masteryOpen,
                onSkillMasteryAddRequest: this.onSkillMasteryAddRequest
            }, i));
        }
        return res;
    }
    toggleMastery() {
        this.setState({
            masteryOpen: !this.state.masteryOpen
        });
    }
    render() {
        const skillRows = this.getSkillRows();
        return /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
            className: "skill-simulator-wrapper",
            children: [
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                    className: "skill-simulator",
                    children: [
                        /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                            className: "skill-simulator-skills",
                            children: this.renderSkillRows(skillRows)
                        }),
                        this.state.masteryOpen ? /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)((0, $a0f99efa3837998a$export$a56145c5d5dd1927), {
                            onCloseBtnClicked: this.toggleMastery,
                            skills: this.props.masterySkills,
                            repeat: this.props.masteryRepeat,
                            onSkillsChange: this.onMasterySkillsChange,
                            onRepeatChange: this.onMasteryRepeatChange,
                            onSkillAddRequest: this.onSkillMasteryAddRequest
                        }) : /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)((0, $11f63a17106808cb$export$3b781931848ef3db), {
                            lvl: this.props.lvl,
                            selectedSkill: this.state.selectedSkill,
                            levels: this.props.skillLevels,
                            skills: $ccaec58fcce19e27$var$globalSkillData.skills,
                            onLevelChange: this.onSkillLevelChange,
                            skillTree: skillRows,
                            onMasteryBtnClicked: this.toggleMastery
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("div", {
                    onClick: this.toggleMastery,
                    className: "mastery-btn",
                    children: "Edytuj mistrzostwo walk"
                })
            ]
        });
    }
}


function $7dd1d89bc09eec73$export$701dd7dbe5ada16() {
    const parent = document.querySelector(".mw-skill-simulator");
    if (!parent) return;
    $7dd1d89bc09eec73$var$loadSimulator(parent);
}
const $7dd1d89bc09eec73$var$profIds = {
    [(0, $c41220b8559f08aa$export$33faa6bef51889a9).WARRIOR]: 0,
    [(0, $c41220b8559f08aa$export$33faa6bef51889a9).PALADIN]: 1,
    [(0, $c41220b8559f08aa$export$33faa6bef51889a9).DANCER]: 2,
    [(0, $c41220b8559f08aa$export$33faa6bef51889a9).MAGE]: 3,
    [(0, $c41220b8559f08aa$export$33faa6bef51889a9).HUNTER]: 4,
    [(0, $c41220b8559f08aa$export$33faa6bef51889a9).TRACKER]: 5
};
const $7dd1d89bc09eec73$var$profIdsReverse = {
    [0]: (0, $c41220b8559f08aa$export$33faa6bef51889a9).WARRIOR,
    [1]: (0, $c41220b8559f08aa$export$33faa6bef51889a9).PALADIN,
    [2]: (0, $c41220b8559f08aa$export$33faa6bef51889a9).DANCER,
    [3]: (0, $c41220b8559f08aa$export$33faa6bef51889a9).MAGE,
    [4]: (0, $c41220b8559f08aa$export$33faa6bef51889a9).HUNTER,
    [5]: (0, $c41220b8559f08aa$export$33faa6bef51889a9).TRACKER
};
var $7dd1d89bc09eec73$var$BlockType = /*#__PURE__*/ function(BlockType) {
    BlockType[BlockType["SkillLevels"] = 0] = "SkillLevels";
    BlockType[BlockType["Mastery"] = 1] = "Mastery";
    BlockType[BlockType["_Reserved"] = 2] = "_Reserved";
    BlockType[BlockType["Version"] = 3] = "Version";
    return BlockType;
}($7dd1d89bc09eec73$var$BlockType || {});
function $7dd1d89bc09eec73$var$skillLevelsByRows(prof, levels) {
    const data = (0, $ccaec58fcce19e27$export$36521b62f192612d)();
    const tree = data.skillTrees[prof];
    const res = [];
    for (const row of tree){
        let ind = res.length;
        res.push({});
        for (const id of row)if (levels[id]) res[ind][id] = levels[id];
    }
    return res;
}
class $7dd1d89bc09eec73$var$BufferSink {
    constructor(initialSize){
        this.offset = 0;
        this.result = null;
        this.resultAwaiters = [];
        this.allocationSize = initialSize;
        this.buffer = new Uint8Array(initialSize);
    }
    start() {
        this.buffer = new Uint8Array(this.allocationSize);
        this.offset = 0;
    }
    write(chunk) {
        if (this.buffer.byteLength < chunk.byteLength + this.offset) {
            const newBuffer = new Uint8Array(chunk.byteLength + this.offset + this.allocationSize);
            newBuffer.set(this.buffer);
            this.buffer = newBuffer;
        }
        this.buffer.set(chunk, this.offset);
        this.offset += chunk.byteLength;
    }
    abort() {
        this.close();
    }
    close() {
        this.result = this.buffer.slice(0, this.offset);
        for (const awaiter of this.resultAwaiters)awaiter(this.result);
    }
    async getResult() {
        if (this.result) return this.result;
        else return new Promise((resolve)=>{
            this.resultAwaiters.push(resolve);
        });
    }
}
// The encoded state format is as follows:
// - 3 bits for profession ID
// - 9 bits for level
// - Array of:
//   - 2 bits indicating the Block Type
//   - The Block
//
// Block Types:
// 00: Skill Levels
// - Array of variable-length skill levels (in order specified by the skill tree)
//   - If 1st bit is 0, skill level is 0
//   - If 1st bit is 1, the next 4 bits indicate the level
// - 5 bit block terminator: 0b11111 (as if the skill level was 15)
// 01: Mastery
// - 1 bit for the repeat flag
// - list of short 6-bit skill IDs (indicating position in the skill tree rather than their actual ID)
// - terminated by a sentinel = 63
// 10: TBD
// 11: Version (no cap on bit count, increment size as needed)
const $7dd1d89bc09eec73$var$VersionBlockSize = 4;
var $7dd1d89bc09eec73$var$PackedMasterySkillID = /*#__PURE__*/ function(PackedMasterySkillID) {
    PackedMasterySkillID[PackedMasterySkillID["SENTINEL"] = 63] = "SENTINEL";
    PackedMasterySkillID[PackedMasterySkillID["STEP"] = 62] = "STEP";
    PackedMasterySkillID[PackedMasterySkillID["STRIKE"] = 61] = "STRIKE";
    return PackedMasterySkillID;
}($7dd1d89bc09eec73$var$PackedMasterySkillID || {});
function $7dd1d89bc09eec73$var$findMasterySkillShortID(prof, id) {
    if (id == -1) return 61;
    if (id == -2) return 62;
    const tree = (0, $ccaec58fcce19e27$export$36521b62f192612d)().skillTrees[prof];
    for(let row = 0; row < tree.length; ++row)for(let i = 0; i < tree[row].length; ++i){
        if (tree[row][i] == id) return row * 6 + i;
    }
    return 61;
}
async function $7dd1d89bc09eec73$var$encodeSimulatorState(state, version) {
    const sink = new $7dd1d89bc09eec73$var$BufferSink(40);
    const stream = new WritableStream(sink);
    const writer = stream.getWriter();
    const bitWriter = new (0, $c809b947cddc2a78$export$3fa3b5652b53dfc4)(writer);
    // Header
    bitWriter.write(3, $7dd1d89bc09eec73$var$profIds[state.prof]);
    bitWriter.write(9, state.lvl);
    // Write Skill Levels block
    bitWriter.write(2, 0);
    const data = (0, $ccaec58fcce19e27$export$36521b62f192612d)();
    const ownTree = data.skillTrees[state.prof];
    const investedPts = (0, $c41220b8559f08aa$export$cfb4ffbd4f57cedb)(state.skillLevels);
    for(let row = 0; row < ownTree.length; ++row){
        const requiredPts = (0, $c41220b8559f08aa$export$f39e997b5c0d94e0)(row);
        if (requiredPts > investedPts) break;
        const set = ownTree[row];
        for (const id of set){
            const lvl = state.skillLevels[id] ?? 0;
            if (lvl == 0) bitWriter.write(1, 0);
            else {
                bitWriter.write(1, 1);
                bitWriter.write(4, lvl);
            }
        }
    }
    // Write Skill Levels Block terminator
    bitWriter.write(1, 1);
    bitWriter.write(4, 15);
    if (state.masterySkills.length) {
        // Write Mastery Block
        bitWriter.write(2, 1);
        bitWriter.write(1, state.masteryRepeat ? 1 : 0);
        for (const { skill: skill } of state.masterySkills){
            const id = $7dd1d89bc09eec73$var$findMasterySkillShortID(state.prof, skill);
            bitWriter.write(6, id);
        }
        bitWriter.write(6, 63);
    }
    // Write Version Block
    bitWriter.write(2, 3);
    bitWriter.write($7dd1d89bc09eec73$var$VersionBlockSize, version);
    bitWriter.end();
    writer.close();
    const res = await sink.getResult();
    // @ts-expect-error This works typescript is stupid
    const blob = new Blob([
        res
    ]);
    const reader = new FileReader();
    return new Promise((resolve)=>{
        reader.addEventListener("load", ()=>{
            resolve(reader.result.split(",")[1]);
        });
        reader.readAsDataURL(blob);
    });
}
function $7dd1d89bc09eec73$var$importRawJsonState(stateString) {
    const gargonemState = JSON.parse(decodeURIComponent(stateString));
    if (!gargonemState || typeof gargonemState != "object") throw new Error(`Invalid state`);
    if (typeof $7dd1d89bc09eec73$var$profIds[gargonemState.prof] == "undefined") throw new Error(`Invalid prof`);
    if (typeof gargonemState.level != "number") throw new Error(`Invalid lvl`);
    const mappedSkillLevels = {};
    if (!Array.isArray(gargonemState.skills)) throw new Error(`Invalid skills`);
    for (const entry of gargonemState.skills){
        if (!entry || typeof entry != "object") throw new Error(`Invalid skills entry #1`);
        if (Object.keys(entry).some((k)=>isNaN(Number(k))) || Object.values(entry).some((v)=>isNaN(v))) throw new Error(`Invalid skills entry #2`);
        for(const key in entry)mappedSkillLevels[Number(key)] = entry[key];
    }
    if (!Array.isArray(gargonemState.mastery?.skills)) throw new Error(`Invalid mastery`);
    if (gargonemState.mastery.skills.some((v)=>isNaN(Number(v)))) throw new Error(`Invalid mastery entry`);
    const mappedMasterySkills = gargonemState.mastery.skills.map((s, idx)=>({
            skill: s,
            id: idx
        }));
    const lvl = Math.max(Math.min(300, gargonemState.level), 1);
    return {
        prof: gargonemState.prof,
        lvl: lvl,
        visualLvl: String(lvl),
        skillLevels: mappedSkillLevels,
        masterySkills: mappedMasterySkills,
        masteryRepeat: !!gargonemState.mastery?.repeat
    };
}
async function $7dd1d89bc09eec73$var$decodeSimulatorState(encoded) {
    if (encoded.startsWith("import:")) return $7dd1d89bc09eec73$var$importRawJsonState(encoded.substring(7));
    const res = await fetch(`data:application/octet-stream;base64,${encoded}`);
    const buffer = await res.arrayBuffer();
    const reader = new (0, $b02d5da943513c89$export$899fe4f7927c31a0)();
    reader.addBuffer(new Uint8Array(buffer));
    const profId = reader.readSync(3);
    const lvl = reader.readSync(9);
    const state = {
        prof: $7dd1d89bc09eec73$var$profIdsReverse[profId],
        lvl: lvl,
        skillLevels: {},
        masterySkills: [],
        masteryRepeat: true
    };
    const data = (0, $ccaec58fcce19e27$export$36521b62f192612d)();
    const tree = data.skillTrees[state.prof];
    // Read blocks
    while(reader.available >= 2){
        const blockType = reader.readSync(2);
        if (blockType == 0) {
            let row = 0;
            let idx = 0;
            while(reader.available){
                if (idx >= tree[row].length) {
                    idx = 0;
                    ++row;
                }
                const id = tree[row]?.[idx++];
                const hasLvl = reader.readSync(1);
                if (hasLvl) {
                    const lvl = reader.readSync(4);
                    if (lvl == 15) break;
                    else state.skillLevels[id] = lvl;
                }
            }
        } else if (blockType == 1) {
            const masterySkills = [];
            state.masteryRepeat = !!reader.readSync(1);
            while(reader.available){
                const shortID = reader.readSync(6);
                if (shortID == 63) break;
                let id = 0;
                if (shortID == 62) id = -2;
                else if (shortID == 61) id = -1;
                else {
                    const row = Math.floor(shortID / 6);
                    const idx = shortID % 6;
                    const tree = data.skillTrees[state.prof];
                    id = tree[row][idx] ?? -1;
                }
                masterySkills.push({
                    id: (0, $ccaec58fcce19e27$export$27f8950178278c76)(),
                    skill: id
                });
            }
            state.masterySkills = masterySkills;
        } else if (blockType == 3) state.version = reader.readSync($7dd1d89bc09eec73$var$VersionBlockSize);
        else throw new Error(`Unknown Block type: ${blockType}`);
    }
    return state;
}
class $7dd1d89bc09eec73$var$SkillSimulatorWrapper extends (0, (/*@__PURE__*/$parcel$interopDefault($iDiRE))).Component {
    constructor(props){
        super(props), this.lastHash = "", this.skillsCopyTimeout = -1, this.linkCopyTimeout = -1, this.enforceVisualLevelTimeout = -1;
        this.state = {
            prof: (0, $c41220b8559f08aa$export$33faa6bef51889a9).WARRIOR,
            lvl: 50,
            visualLvl: "50",
            skillLevels: {},
            masterySkills: [],
            masteryRepeat: true
        };
        this.onSkillLevelChange = this.onSkillLevelChange.bind(this);
        this.onHashChange = this.onHashChange.bind(this);
        this.onLvlInputUpdate = this.onLvlInputUpdate.bind(this);
        this.onProfInputUpdate = this.onProfInputUpdate.bind(this);
        this.onSkillResetRequest = this.onSkillResetRequest.bind(this);
        this.onLinkCopyRequest = this.onLinkCopyRequest.bind(this);
        this.onSkillsCopyRequest = this.onSkillsCopyRequest.bind(this);
        this.onMasteryRepeatChange = this.onMasteryRepeatChange.bind(this);
        this.onMasterySkillsChange = this.onMasterySkillsChange.bind(this);
        this.onLvlInputBlur = this.onLvlInputBlur.bind(this);
        window.addEventListener("hashchange", this.onHashChange);
    }
    componentDidMount() {
        this.loadFromPageHash();
    }
    componentWillUnmount() {
        window.removeEventListener("hashchange", this.onHashChange);
    }
    componentDidUpdate() {
        this.updatePageHash();
    }
    enforceVisualLevel() {
        const n = Number(this.state.visualLvl);
        if (!isNaN(n)) this.setState({
            lvl: Math.min(Math.max(24, n), 500)
        });
    }
    onHashChange() {
        if (location.hash.substring(1) != this.lastHash) this.loadFromPageHash();
    }
    async loadFromPageHash() {
        console.log(`loadFromPageHash`);
        const hash = location.hash.substring(1);
        if (hash.length == 0) return;
        try {
            const state = await $7dd1d89bc09eec73$var$decodeSimulatorState(hash);
            if (typeof state.version != "undefined" && state.version != this.props.version) (0, $ed1a45b1fdbc7633$export$d7e8d4d4450c819c)({
                title: "Stare umiej\u0119tno\u015Bci",
                content: "Wczytany zestaw umiej\u0119tno\u015Bci zosta\u0142 utworzony przed ostatni\u0105 aktualizacj\u0105 - mo\u017Ce nie dzia\u0142a\u0107 poprawnie!"
            });
            this.lastHash = hash;
            state.visualLvl = String(state.lvl);
            this.setState(state);
        } catch (e) {
            console.error(`SkillSimulatorWrapper: loadFromPageHash: parse error:`, e);
        }
    }
    async updatePageHash() {
        const hash = await $7dd1d89bc09eec73$var$encodeSimulatorState(this.state, this.props.version);
        this.lastHash = hash;
        // Using replaceState in order to not fill the entire history with all the different hashes
        // @ts-expect-error TODO does this have to be like this? lol
        history.replaceState(undefined, undefined, `#${hash}`);
    }
    onSkillLevelChange(skillLevels) {
        this.setState({
            skillLevels: skillLevels
        });
    }
    onMasterySkillsChange(skills) {
        this.setState({
            masterySkills: skills
        });
    }
    onMasteryRepeatChange(repeat) {
        this.setState({
            masteryRepeat: repeat
        });
    }
    onLvlInputUpdate(e) {
        const n = Number(e.target.value);
        if (!isNaN(n)) {
            if (this.enforceVisualLevelTimeout != -1) clearTimeout(this.enforceVisualLevelTimeout);
            this.enforceVisualLevelTimeout = setTimeout(()=>{
                this.enforceVisualLevel();
                this.enforceVisualLevelTimeout = -1;
            }, 1500);
        }
        this.setState({
            visualLvl: e.target.value
        });
    }
    onLvlInputBlur() {
        if (this.enforceVisualLevelTimeout != -1) clearTimeout(this.enforceVisualLevelTimeout);
        this.enforceVisualLevel();
    }
    onProfInputUpdate(e) {
        this.setState({
            prof: e.target.value
        });
    }
    onSkillsCopyRequest() {
        if (this.skillsCopyTimeout != -1) clearTimeout(this.skillsCopyTimeout);
        this.skillsCopyTimeout = setTimeout(()=>{
            this.setState({
                skillsJustCopied: false
            });
            this.skillsCopyTimeout = -1;
        }, 3000);
        this.setState({
            skillsJustCopied: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9d953ef466da63be$exports)))(JSON.stringify({
            level: this.state.lvl,
            prof: this.state.prof,
            skills: $7dd1d89bc09eec73$var$skillLevelsByRows(this.state.prof, this.state.skillLevels),
            mastery: {
                skills: this.state.masterySkills.map((s)=>s.skill),
                repeat: this.state.masteryRepeat
            }
        }));
    }
    onLinkCopyRequest() {
        if (this.linkCopyTimeout != -1) clearTimeout(this.linkCopyTimeout);
        this.linkCopyTimeout = setTimeout(()=>{
            this.setState({
                linkJustCopied: false
            });
            this.linkCopyTimeout = -1;
        }, 3000);
        this.setState({
            linkJustCopied: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9d953ef466da63be$exports)))(location.href);
    }
    onSkillResetRequest() {
        (0, $ed1a45b1fdbc7633$export$d7e8d4d4450c819c)({
            title: "Resetowanie umiej\u0119tno\u015Bci",
            content: "Czy na pewno chcesz zresetowa\u0107 wszystkie umiej\u0119tno\u015Bci?",
            type: (0, $ed1a45b1fdbc7633$export$23344047f1eff04b).CONFIRM,
            confirmClb: ()=>{
                this.setState({
                    skillLevels: {},
                    masteryRepeat: true,
                    masterySkills: []
                });
            }
        });
    }
    render() {
        return [
            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                className: "skill-simulator-controls",
                children: [
                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                        className: "p1 input-group controls",
                        children: [
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("label", {
                                className: "input-group-text",
                                htmlFor: "prof",
                                children: "Profesja"
                            }),
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("select", {
                                value: this.state.prof,
                                onChange: this.onProfInputUpdate,
                                className: "form-select",
                                id: "prof",
                                children: [
                                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("option", {
                                        value: (0, $c41220b8559f08aa$export$33faa6bef51889a9).WARRIOR,
                                        children: "Wojownik"
                                    }),
                                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("option", {
                                        value: (0, $c41220b8559f08aa$export$33faa6bef51889a9).PALADIN,
                                        children: "Paladyn"
                                    }),
                                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("option", {
                                        value: (0, $c41220b8559f08aa$export$33faa6bef51889a9).DANCER,
                                        children: "Tancerz ostrzy"
                                    }),
                                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("option", {
                                        value: (0, $c41220b8559f08aa$export$33faa6bef51889a9).MAGE,
                                        children: "Mag"
                                    }),
                                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("option", {
                                        value: (0, $c41220b8559f08aa$export$33faa6bef51889a9).HUNTER,
                                        children: "\u0141owca"
                                    }),
                                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("option", {
                                        value: (0, $c41220b8559f08aa$export$33faa6bef51889a9).TRACKER,
                                        children: "Tropiciel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("label", {
                                className: "input-group-text",
                                htmlFor: "lvl",
                                children: "Poziom"
                            }),
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("input", {
                                onBlur: this.onLvlInputBlur,
                                value: this.state.visualLvl ?? this.state.lvl,
                                type: "number",
                                onChange: this.onLvlInputUpdate,
                                className: "form-control",
                                id: "lvl",
                                onKeyDown: (e)=>{
                                    if (e.key == "Enter") this.onLvlInputBlur();
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsxs)("div", {
                        className: "p1 input-group buttons",
                        children: [
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("button", {
                                onClick: this.onSkillsCopyRequest,
                                "data-tip": "Kopiuje umiej\u0119tno\u015Bci w formacie kt\xf3ry mo\u017Cna wklei\u0107 do dodatku z zestawu Gargonem.",
                                className: "btn btn-secondary",
                                children: this.state.skillsJustCopied ? "Skopiowano!" : "Kopiuj do dodatku"
                            }),
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("button", {
                                onClick: this.onLinkCopyRequest,
                                className: "btn btn-primary",
                                children: this.state.linkJustCopied ? "Skopiowano!" : "Kopiuj link"
                            }),
                            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)("button", {
                                onClick: this.onSkillResetRequest,
                                "data-tip": "Resetuj umiej\u0119tno\u015Bci",
                                className: "btn btn-danger",
                                children: "\u2A2F"
                            })
                        ]
                    })
                ]
            }, 0),
            /*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)((0, $ccaec58fcce19e27$export$3d14641e2872f1b2), {
                prof: this.state.prof,
                lvl: this.state.lvl,
                skillLevels: this.state.skillLevels,
                onChange: this.onSkillLevelChange,
                masterySkills: this.state.masterySkills,
                masteryRepeat: this.state.masteryRepeat,
                onMasterySkillsChange: this.onMasterySkillsChange,
                onMasteryRepeatChange: this.onMasteryRepeatChange
            }, 1)
        ];
    }
}
async function $7dd1d89bc09eec73$var$loadSimulator(parent) {
    const res = await fetch("/tools/skills/data");
    const json = await res.json();
    (0, $ccaec58fcce19e27$export$bd9e47baa8220665)(json);
    const root = (0, $bc75e1c5e38f9520$export$882461b6382ed46c)(parent);
    root.render(/*#__PURE__*/ (0, $905ae7e1acf3a472$exports.jsx)($7dd1d89bc09eec73$var$SkillSimulatorWrapper, {
        version: json.version
    }));
}


//@ts-nocheck
async function $8bca77f8cc03d323$export$75846793aded97b() {
    /* Naprawa zepsutego garmorskiego API od tipów xD */ // WHY CAN'T YOU PROPERLY CHECK IF ENGINE EXISTS
    window.Engine = void 0;
    // Wait for load
    while(!window.margonem)await new Promise((resolve)=>setTimeout(resolve, 1000));
    window.margonem.convertItemValue = (a)=>a;
    window.margonem.getItemRarity = function(item) {
        const st = parseItemStat(item.stat);
        return st.rarity ?? "common";
    };
    // Gosh dang it
    window.$.inArray = function(value, array, fromIndex) {
        return Array.isArray(array) && array.includes(value, fromIndex);
    };
}




function $f347f4825963ab17$var$parseWater(water) {
    if (!water) return [];
    const spl = water.split("|");
    const res = [];
    for (const entry of spl){
        const ww = entry.split(",").map(parseInt);
        for(let j = 1 * ww[0]; j <= 1 * ww[1]; ++j)res[j + 256 * ww[2]] = 4 * ww[3];
    }
    return res;
}
function $f347f4825963ab17$var$initWorldFrame(focus, waterData) {
    try {
        if (focus) {
            const focusEl = document.querySelector(`#${focus}`);
            if (focusEl && focusEl instanceof HTMLElement) {
                const s = document.scrollingElement;
                s.scrollLeft = focusEl.offsetLeft - s.clientWidth / 2;
                s.scrollTop = focusEl.offsetTop - s.clientHeight / 2;
            }
        }
    } catch (e) {
        console.warn(e);
    }
    const water = $f347f4825963ab17$var$parseWater(waterData);
    const objects = document.querySelectorAll(".object.npc");
    for (const obj of Array.from(objects)){
        if (!(obj instanceof HTMLElement)) continue;
        const img = new Image();
        const clb = ()=>{
            const imgX = img.width;
            const imgY = img.height;
            const x = parseInt(obj.dataset.x);
            const y = parseInt(obj.dataset.y);
            // Adapted from SI code (what kinda garbage)
            const tmpLeft = x * 32 + 16 - Math.round(imgX / 2) + (parseInt(obj.dataset.type) > 3 && !(imgX % 64) ? -16 : 0);
            const wpos = x + y * 256;
            let wat = water[wpos] ? water[wpos] / 4 : 0;
            const destinationX = tmpLeft;
            const destinationY = y * 32 + 32 - imgY;
            const h = imgY - (wat > 8 ? (wat - 8) * 4 : 0);
            obj.style.left = `${destinationX}px`;
            obj.style.top = `${destinationY}px`;
            obj.style.width = `${imgX}px`;
            obj.style.height = `${h}px`;
            obj.style.background = `url(${(0, $c2bdc760a1d746cf$export$2cc7ae7d4fb97c35).npcPath}${obj.dataset.icon})`;
            if (obj.dataset.type == "4") obj.style.pointerEvents = "none";
        };
        img.addEventListener("load", clb);
        img.src = (0, $c2bdc760a1d746cf$export$2cc7ae7d4fb97c35).npcPath + obj.dataset.icon;
    }
}
function $f347f4825963ab17$export$34231796b5b05131() {
    // Page scrolling
    const scrollData = {
        top: 0,
        left: 0,
        x: 0,
        y: 0
    };
    const mouseup = (_e)=>{
        document.scrollingElement.removeEventListener("mouseup", mouseup);
        document.scrollingElement.removeEventListener("mousemove", mousemove);
    };
    const mousemove = (e)=>{
        const dx = e.clientX - scrollData.x;
        const dy = e.clientY - scrollData.y;
        document.scrollingElement.scrollTop = scrollData.top - dy;
        document.scrollingElement.scrollLeft = scrollData.left - dx;
    };
    const mousedown = (e)=>{
        document.scrollingElement.addEventListener("mouseup", mouseup);
        document.scrollingElement.addEventListener("mousemove", mousemove);
        scrollData.left = document.scrollingElement.scrollLeft;
        scrollData.top = document.scrollingElement.scrollTop;
        scrollData.x = e.clientX;
        scrollData.y = e.clientY;
    };
    document.scrollingElement.addEventListener("mousedown", mousedown);
    // @ts-ignore
    window.initWorldFrame = $f347f4825963ab17$var$initWorldFrame;
}



// Needed by garmory tip api
// @ts-ignore
window.items = {};
(0, $0cc6883c437a790b$export$608e2009510d032b)();
(0, $8bca77f8cc03d323$export$75846793aded97b)();
(0, $af478be0a72c5018$export$45bbcd859c8e601f)();
(0, $09054ec50e638aa9$export$793750adf3040f02)();
(0, $ae0fe12872f74041$export$bec289829c0e6530)();
(0, $7dd1d89bc09eec73$export$701dd7dbe5ada16)();
(0, $85e05e42af88da43$export$53266e3b62621cca)();
if (location.pathname.startsWith("/world-frame")) (0, $f347f4825963ab17$export$34231796b5b05131)();
if (location.pathname.startsWith("/admin/conditional-updater/selector")) (0, $b2661322620170b6$export$785798112f409e83)();
if (location.pathname.startsWith("/admin/mdContent/edit")) (0, $958a0f03abf1ab62$export$3db423af1e2d51d0)();

})();
//# sourceMappingURL=main.js.map
